var _defs, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 692.19 422.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f5f5f5;}.cls-2{fill:#ebebeb;}.cls-3{fill:#e0e0e0;}.cls-4{fill:#fafafa;}.cls-16,.cls-17,.cls-5{fill:#fff;}.cls-6{fill:#263238;}.cls-7{fill:#ff725e;}.cls-8{fill:#ae7461;}.cls-9{fill:#6f4439;}.cls-10,.cls-15{opacity:0.2;}.cls-11{fill:#455a64;}.cls-12,.cls-13,.cls-17{opacity:0.3;}.cls-14,.cls-16{opacity:0.1;}.cls-18{opacity:0.15;}.cls-19{fill:#ff9a6c;}.cls-20{opacity:0.4;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 247.29,
    y: 93.04,
    width: 67.93,
    height: 215.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 281.26,
    y: 93.04,
    width: 33.96,
    height: 214.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 255.05,
    y: 71.91,
    width: 23.99,
    height: 21.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 273.32,
    y: 71.91,
    width: 5.72,
    height: 21.13
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "241.63 93.04 241.63 91.81 317.21 91.81 317.21 93.04"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 260.7,
    y: 102.26,
    width: 5.75,
    height: 12.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M317.13,166.61c0,.13-7.61.23-17,.23s-17-.1-17-.23,7.61-.23,17-.23S317.13,166.48,317.13,166.61Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 294.96,
    y: 102.26,
    width: 5.75,
    height: 12.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M351.38,166.61c0,.13-7.6.23-17,.23s-17-.1-17-.23,7.6-.23,17-.23S351.38,166.48,351.38,166.61Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 294.96,
    y: 126.33,
    width: 5.75,
    height: 12.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M351.38,190.68c0,.13-7.6.23-17,.23s-17-.1-17-.23,7.6-.23,17-.23S351.38,190.55,351.38,190.68Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 294.96,
    y: 151.12,
    width: 5.75,
    height: 12.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M351.38,215.48c0,.13-7.6.23-17,.23s-17-.1-17-.23,7.6-.23,17-.23S351.38,215.35,351.38,215.48Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 294.96,
    y: 175.92,
    width: 5.75,
    height: 12.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M351.38,240.27c0,.13-7.6.23-17,.23s-17-.1-17-.23,7.6-.23,17-.23S351.38,240.15,351.38,240.27Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 294.96,
    y: 200.01,
    width: 5.75,
    height: 12.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M351.38,264.36c0,.13-7.6.23-17,.23s-17-.1-17-.23,7.6-.23,17-.23S351.38,264.23,351.38,264.36Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 294.96,
    y: 224.19,
    width: 5.75,
    height: 12.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 294.96,
    y: 248.69,
    width: 5.75,
    height: 12.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M351.38,288.54c0,.13-7.6.24-17,.24s-17-.11-17-.24,7.6-.23,17-.23S351.38,288.42,351.38,288.54Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 260.7,
    y: 126.7,
    width: 5.75,
    height: 12.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M317.13,191.05c0,.13-7.61.23-17,.23s-17-.1-17-.23,7.61-.23,17-.23S317.13,190.92,317.13,191.05Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 260.7,
    y: 151.13,
    width: 5.75,
    height: 12.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M317.13,215.49c0,.12-7.61.23-17,.23s-17-.11-17-.23,7.61-.24,17-.24S317.13,215.36,317.13,215.49Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 260.7,
    y: 175.57,
    width: 5.75,
    height: 12.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M317.13,239.92c0,.13-7.61.23-17,.23s-17-.1-17-.23,7.61-.23,17-.23S317.13,239.8,317.13,239.92Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 260.7,
    y: 200.01,
    width: 5.75,
    height: 12.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M317.13,264.36c0,.13-7.61.23-17,.23s-17-.1-17-.23,7.61-.23,17-.23S317.13,264.23,317.13,264.36Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 260.7,
    y: 224.44,
    width: 5.75,
    height: 12.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M317.13,288.8c0,.13-7.61.23-17,.23s-17-.1-17-.23,7.61-.23,17-.23S317.13,288.67,317.13,288.8Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 260.7,
    y: 248.88,
    width: 5.75,
    height: 12.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 199.24,
    y: 154.08,
    width: 48.8,
    height: 154.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 223.65,
    y: 154.08,
    width: 24.4,
    height: 154.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 204.82,
    y: 138.9,
    width: 17.23,
    height: 15.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 217.94,
    y: 138.9,
    width: 4.11,
    height: 15.18
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "195.18 154.08 195.18 153.2 249.48 153.2 249.48 154.08"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 208.88,
    y: 160.71,
    width: 4.13,
    height: 8.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M259.52,220.31c0,.09-5.47.16-12.21.16s-12.2-.07-12.2-.16,5.46-.17,12.2-.17S259.52,220.22,259.52,220.31Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 233.49,
    y: 160.71,
    width: 4.13,
    height: 8.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M284.13,220.31c0,.09-5.46.16-12.2.16s-12.2-.07-12.2-.16,5.46-.17,12.2-.17S284.13,220.22,284.13,220.31Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 233.49,
    y: 178,
    width: 4.13,
    height: 8.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M284.13,237.6c0,.09-5.46.17-12.2.17s-12.2-.08-12.2-.17,5.46-.16,12.2-.16S284.13,237.51,284.13,237.6Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 233.49,
    y: 195.82,
    width: 4.13,
    height: 8.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M284.13,255.42c0,.09-5.46.17-12.2.17s-12.2-.08-12.2-.17,5.46-.17,12.2-.17S284.13,255.33,284.13,255.42Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 233.49,
    y: 213.63,
    width: 4.13,
    height: 8.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M284.13,273.24c0,.09-5.46.16-12.2.16s-12.2-.07-12.2-.16,5.46-.17,12.2-.17S284.13,273.14,284.13,273.24Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 233.49,
    y: 230.94,
    width: 4.13,
    height: 8.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M284.13,290.54c0,.09-5.46.17-12.2.17s-12.2-.08-12.2-.17,5.46-.16,12.2-.16S284.13,290.45,284.13,290.54Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 233.49,
    y: 248.32,
    width: 4.13,
    height: 8.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 233.49,
    y: 265.92,
    width: 4.13,
    height: 8.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M284.13,307.92c0,.09-5.46.17-12.2.17s-12.2-.08-12.2-.17,5.46-.17,12.2-.17S284.13,307.83,284.13,307.92Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 208.88,
    y: 178.27,
    width: 4.13,
    height: 8.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M259.52,237.87c0,.09-5.47.16-12.21.16s-12.2-.07-12.2-.16,5.46-.17,12.2-.17S259.52,237.77,259.52,237.87Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 208.88,
    y: 195.82,
    width: 4.13,
    height: 8.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M259.52,255.43c0,.09-5.47.16-12.21.16s-12.2-.07-12.2-.16,5.46-.17,12.2-.17S259.52,255.33,259.52,255.43Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 208.88,
    y: 213.38,
    width: 4.13,
    height: 8.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M259.52,273c0,.1-5.47.17-12.21.17s-12.2-.07-12.2-.17,5.46-.16,12.2-.16S259.52,272.89,259.52,273Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 208.88,
    y: 230.94,
    width: 4.13,
    height: 8.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M259.52,290.54c0,.09-5.47.17-12.21.17s-12.2-.08-12.2-.17,5.46-.16,12.2-.16S259.52,290.45,259.52,290.54Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 208.88,
    y: 248.5,
    width: 4.13,
    height: 8.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M259.52,308.1c0,.09-5.47.17-12.21.17s-12.2-.08-12.2-.17,5.46-.17,12.2-.17S259.52,308,259.52,308.1Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 208.88,
    y: 266.06,
    width: 4.13,
    height: 8.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 471.39,
    y: 17.37,
    width: 55.63,
    height: 146.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 499.21,
    y: 17.37,
    width: 27.82,
    height: 146.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 477.75,
    width: 19.65,
    height: 17.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 492.71,
    width: 4.68,
    height: 17.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 466.76,
    y: 16.35,
    width: 61.9,
    height: 1.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 482.38,
    y: 24.94,
    width: 4.71,
    height: 9.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M535.08,86.28c0,.11-6.23.19-13.91.19s-13.91-.08-13.91-.19,6.23-.19,13.91-.19S535.08,86.18,535.08,86.28Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 510.43,
    y: 24.94,
    width: 4.71,
    height: 9.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M563.14,86.28c0,.11-6.23.19-13.91.19s-13.91-.08-13.91-.19,6.23-.19,13.91-.19S563.14,86.18,563.14,86.28Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 510.43,
    y: 44.72,
    width: 4.71,
    height: 9.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M563.14,106.06c0,.11-6.23.19-13.91.19s-13.91-.08-13.91-.19,6.23-.19,13.91-.19S563.14,106,563.14,106.06Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 510.43,
    y: 65.09,
    width: 4.71,
    height: 9.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M563.14,126.43c0,.11-6.23.19-13.91.19s-13.91-.08-13.91-.19,6.23-.19,13.91-.19S563.14,126.33,563.14,126.43Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 510.43,
    y: 85.47,
    width: 4.71,
    height: 9.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M563.14,146.81c0,.1-6.23.19-13.91.19s-13.91-.09-13.91-.19,6.23-.19,13.91-.19S563.14,146.7,563.14,146.81Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 510.43,
    y: 105.26,
    width: 4.71,
    height: 9.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M563.14,166.6c0,.11-6.23.19-13.91.19s-13.91-.08-13.91-.19,6.23-.19,13.91-.19S563.14,166.5,563.14,166.6Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 510.43,
    y: 125.13,
    width: 4.71,
    height: 9.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 510.43,
    y: 145.26,
    width: 4.71,
    height: 9.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M563.14,186.47c0,.11-6.23.19-13.91.19s-13.91-.08-13.91-.19,6.23-.19,13.91-.19S563.14,186.37,563.14,186.47Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 482.38,
    y: 45.02,
    width: 4.71,
    height: 9.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M535.08,106.36c0,.11-6.23.19-13.91.19s-13.91-.08-13.91-.19,6.23-.19,13.91-.19S535.08,106.26,535.08,106.36Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 482.38,
    y: 65.1,
    width: 4.71,
    height: 9.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M535.08,126.44c0,.11-6.23.19-13.91.19s-13.91-.08-13.91-.19,6.23-.19,13.91-.19S535.08,126.34,535.08,126.44Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 482.38,
    y: 85.18,
    width: 4.71,
    height: 9.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M535.08,146.52c0,.11-6.23.19-13.91.19s-13.91-.08-13.91-.19,6.23-.19,13.91-.19S535.08,146.42,535.08,146.52Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 482.38,
    y: 105.26,
    width: 4.71,
    height: 9.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M535.08,166.6c0,.11-6.23.19-13.91.19s-13.91-.08-13.91-.19,6.23-.19,13.91-.19S535.08,166.5,535.08,166.6Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 482.38,
    y: 125.34,
    width: 4.71,
    height: 9.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M535.08,186.68c0,.11-6.23.19-13.91.19s-13.91-.08-13.91-.19,6.23-.19,13.91-.19S535.08,186.58,535.08,186.68Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 482.38,
    y: 145.42,
    width: 4.71,
    height: 9.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 328.39,
    y: 182.69,
    width: 65.69,
    height: 125.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 363.28,
    y: 182.69,
    width: 30.8,
    height: 125.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 342.16,
    y: 194.45,
    width: 5.91,
    height: 14.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 342.16,
    y: 250.8,
    width: 5.91,
    height: 14.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M399.15,262c0,.13-7.81.23-17.45.23s-17.44-.1-17.44-.23,7.81-.22,17.44-.22S399.15,261.85,399.15,262Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 342.16,
    y: 222.84,
    width: 5.91,
    height: 14.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M399.15,290.36c0,.12-7.81.22-17.45.22s-17.44-.1-17.44-.22,7.81-.23,17.44-.23S399.15,290.23,399.15,290.36Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 369.82,
    y: 194.45,
    width: 5.91,
    height: 14.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 382.63,
    y: 194.45,
    width: 5.91,
    height: 14.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 369.82,
    y: 221.77,
    width: 5.91,
    height: 14.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 382.63,
    y: 221.77,
    width: 5.91,
    height: 14.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 369.82,
    y: 249.09,
    width: 5.91,
    height: 14.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 382.63,
    y: 249.09,
    width: 5.91,
    height: 14.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 323.45,
    y: 179.66,
    width: 75.56,
    height: 3.13
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M430.41,230.56c0,.13-14.69.23-32.79.23s-32.8-.1-32.8-.23,14.68-.22,32.8-.22S430.41,230.44,430.41,230.56Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 584.36,
    y: 92.59,
    width: 56.17,
    height: 178.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 612.45,
    y: 92.59,
    width: 28.08,
    height: 178.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 590.78,
    y: 75.06,
    width: 19.83,
    height: 17.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 605.88,
    y: 75.06,
    width: 4.73,
    height: 17.53
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "579.68 92.59 579.68 91.57 642.17 91.57 642.17 92.59"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 595.45,
    y: 100.24,
    width: 4.75,
    height: 10.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M648.32,161.71c0,.11-6.29.2-14,.2s-14-.09-14-.2,6.29-.19,14-.19S648.32,161.61,648.32,161.71Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 623.78,
    y: 100.24,
    width: 4.75,
    height: 10.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M676.65,161.71c0,.11-6.29.2-14,.2s-14-.09-14-.2,6.29-.19,14-.19S676.65,161.61,676.65,161.71Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 623.78,
    y: 120.2,
    width: 4.75,
    height: 10.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M676.65,181.68c0,.11-6.29.19-14,.19s-14-.08-14-.19,6.29-.19,14-.19S676.65,181.57,676.65,181.68Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 623.78,
    y: 140.77,
    width: 4.75,
    height: 10.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M676.65,202.25c0,.11-6.29.19-14,.19s-14-.08-14-.19,6.29-.19,14-.19S676.65,202.14,676.65,202.25Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 623.78,
    y: 161.34,
    width: 4.75,
    height: 10.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M676.65,222.82c0,.11-6.29.19-14,.19s-14-.08-14-.19,6.29-.19,14-.19S676.65,222.71,676.65,222.82Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 623.78,
    y: 181.33,
    width: 4.75,
    height: 10.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M676.65,242.8c0,.11-6.29.19-14,.19s-14-.08-14-.19,6.29-.19,14-.19S676.65,242.7,676.65,242.8Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 623.78,
    y: 201.39,
    width: 4.75,
    height: 10.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 623.78,
    y: 221.71,
    width: 4.75,
    height: 10.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M676.65,262.86c0,.11-6.29.2-14,.2s-14-.09-14-.2,6.29-.19,14-.19S676.65,262.76,676.65,262.86Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 595.45,
    y: 120.51,
    width: 4.75,
    height: 10.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M648.32,182c0,.1-6.29.19-14,.19s-14-.09-14-.19,6.29-.2,14-.2S648.32,181.88,648.32,182Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 595.45,
    y: 140.78,
    width: 4.75,
    height: 10.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M648.32,202.26c0,.1-6.29.19-14,.19s-14-.09-14-.19,6.29-.19,14-.19S648.32,202.15,648.32,202.26Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 595.45,
    y: 161.05,
    width: 4.75,
    height: 10.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M648.32,222.53c0,.11-6.29.19-14,.19s-14-.08-14-.19,6.29-.19,14-.19S648.32,222.42,648.32,222.53Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 595.45,
    y: 181.33,
    width: 4.75,
    height: 10.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M648.32,242.8c0,.11-6.29.19-14,.19s-14-.08-14-.19,6.29-.19,14-.19S648.32,242.7,648.32,242.8Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 595.45,
    y: 201.6,
    width: 4.75,
    height: 10.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M648.32,263.07c0,.11-6.29.2-14,.2s-14-.09-14-.2,6.29-.19,14-.19S648.32,263,648.32,263.07Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 595.45,
    y: 221.87,
    width: 4.75,
    height: 10.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 584.61,
    y: 187.01,
    width: 92.18,
    height: 121.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 633.57,
    y: 187.01,
    width: 43.22,
    height: 121.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 603.94,
    y: 203.53,
    width: 8.29,
    height: 20.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 603.94,
    y: 282.59,
    width: 8.29,
    height: 20.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M669.44,279.13c0,.22-11,.41-24.48.41s-24.48-.19-24.48-.41,11-.41,24.48-.41S669.44,278.9,669.44,279.13Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 603.94,
    y: 243.36,
    width: 8.29,
    height: 20.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M669.44,319c0,.23-11,.41-24.48.41s-24.48-.18-24.48-.41,11-.41,24.48-.41S669.44,318.73,669.44,319Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 642.75,
    y: 203.53,
    width: 8.29,
    height: 20.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 660.73,
    y: 203.53,
    width: 8.29,
    height: 20.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 642.75,
    y: 241.86,
    width: 8.29,
    height: 20.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 660.73,
    y: 241.86,
    width: 8.29,
    height: 20.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 642.75,
    y: 280.19,
    width: 8.29,
    height: 20.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 660.73,
    y: 280.19,
    width: 8.29,
    height: 20.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 577.68,
    y: 182.77,
    width: 106.04,
    height: 4.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M713.31,235.05c0,.23-20.61.41-46,.41s-46-.18-46-.41,20.59-.41,46-.41S713.31,234.82,713.31,235.05Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "580.42 308.34 487.5 308.34 487.1 161.02 580.01 161.02 580.42 308.34"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 533.56,
    y: 161.02,
    width: 46.46,
    height: 147.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 497.71,
    y: 132.01,
    width: 32.81,
    height: 29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 522.7,
    y: 132.01,
    width: 7.82,
    height: 29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 479.35,
    y: 159.32,
    width: 103.38,
    height: 1.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 505.44,
    y: 173.66,
    width: 7.86,
    height: 16.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M569.43,244.3c0,.18-10.41.32-23.23.32S523,244.48,523,244.3s10.4-.31,23.23-.31S569.43,244.13,569.43,244.3Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 552.3,
    y: 173.66,
    width: 7.86,
    height: 16.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M616.29,244.3c0,.18-10.4.32-23.23.32s-23.23-.14-23.23-.32,10.4-.31,23.23-.31S616.29,244.13,616.29,244.3Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 552.3,
    y: 206.7,
    width: 7.86,
    height: 16.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M616.29,277.34c0,.17-10.4.31-23.23.31s-23.23-.14-23.23-.31,10.4-.32,23.23-.32S616.29,277.16,616.29,277.34Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 552.3,
    y: 240.72,
    width: 7.86,
    height: 16.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M616.29,311.36c0,.18-10.4.32-23.23.32s-23.23-.14-23.23-.32,10.4-.31,23.23-.31S616.29,311.19,616.29,311.36Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 552.3,
    y: 274.75,
    width: 7.86,
    height: 16.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M616.29,345.39c0,.18-10.4.32-23.23.32s-23.23-.14-23.23-.32,10.4-.32,23.23-.32S616.29,345.22,616.29,345.39Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 505.44,
    y: 207.2,
    width: 7.86,
    height: 16.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M569.43,277.84c0,.17-10.41.32-23.23.32S523,278,523,277.84s10.4-.32,23.23-.32S569.43,277.66,569.43,277.84Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 505.44,
    y: 240.74,
    width: 7.86,
    height: 16.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M569.43,311.38c0,.17-10.41.31-23.23.31s-23.23-.14-23.23-.31,10.4-.32,23.23-.32S569.43,311.2,569.43,311.38Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 505.44,
    y: 274.27,
    width: 7.86,
    height: 16.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M569.43,344.91c0,.18-10.41.32-23.23.32s-23.23-.14-23.23-.32,10.4-.32,23.23-.32S569.43,344.74,569.43,344.91Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 389.79,
    y: 36.49,
    width: 76.24,
    height: 270.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 395.98,
    y: 45.83,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 410.25,
    y: 45.83,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 424.52,
    y: 45.83,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 438.79,
    y: 45.83,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 453.05,
    y: 45.83,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 395.98,
    y: 65.85,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 410.25,
    y: 65.85,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 424.52,
    y: 65.85,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 438.79,
    y: 65.85,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 453.05,
    y: 65.85,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 395.98,
    y: 85.88,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 410.25,
    y: 85.88,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 424.52,
    y: 85.88,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 438.79,
    y: 85.88,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 453.05,
    y: 85.88,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 395.98,
    y: 105.9,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 410.25,
    y: 105.9,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 424.52,
    y: 105.9,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 438.79,
    y: 105.9,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 453.05,
    y: 105.9,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 395.98,
    y: 125.92,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 410.25,
    y: 125.92,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 424.52,
    y: 125.92,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 438.79,
    y: 125.92,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 453.05,
    y: 125.92,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 395.98,
    y: 145.94,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 410.25,
    y: 145.94,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 424.52,
    y: 145.94,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 438.79,
    y: 145.94,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 453.05,
    y: 145.94,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 395.98,
    y: 165.96,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 410.25,
    y: 165.96,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 424.52,
    y: 165.96,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 438.79,
    y: 165.96,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 453.05,
    y: 165.96,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 395.98,
    y: 185.98,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 410.25,
    y: 185.98,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 424.52,
    y: 185.98,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 438.79,
    y: 185.98,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 453.05,
    y: 185.98,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 395.98,
    y: 206.01,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 410.25,
    y: 206.01,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 424.52,
    y: 206.01,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 438.79,
    y: 206.01,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 453.05,
    y: 206.01,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 395.98,
    y: 226.03,
    width: 6.79,
    height: 14.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 410.25,
    y: 226.03,
    width: 6.79,
    height: 14.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 424.52,
    y: 226.03,
    width: 6.79,
    height: 14.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 438.79,
    y: 226.03,
    width: 6.79,
    height: 14.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 453.05,
    y: 226.03,
    width: 6.79,
    height: 14.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 395.98,
    y: 246.05,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 410.25,
    y: 246.05,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 424.52,
    y: 246.05,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 438.79,
    y: 246.05,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 453.05,
    y: 246.05,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 395.98,
    y: 266.07,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 410.25,
    y: 266.07,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 424.52,
    y: 266.07,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 438.79,
    y: 266.07,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 453.05,
    y: 266.07,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 395.98,
    y: 284.99,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 410.25,
    y: 284.99,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 424.52,
    y: 284.99,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 438.79,
    y: 284.99,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 453.05,
    y: 284.99,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 466.03,
    y: 36.49,
    width: 33.3,
    height: 270.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 424.52,
    y: 45.83,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 438.79,
    y: 45.83,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 453.05,
    y: 45.83,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 424.52,
    y: 65.85,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 438.79,
    y: 65.85,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 453.05,
    y: 65.85,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 424.52,
    y: 85.88,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 438.79,
    y: 85.88,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 453.05,
    y: 85.88,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 424.52,
    y: 105.9,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 438.79,
    y: 105.9,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 453.05,
    y: 105.9,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 424.52,
    y: 125.92,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 438.79,
    y: 125.92,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 453.05,
    y: 125.92,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 424.52,
    y: 145.94,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 438.79,
    y: 145.94,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 453.05,
    y: 145.94,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 424.52,
    y: 165.96,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 438.79,
    y: 165.96,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 453.05,
    y: 165.96,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 424.52,
    y: 185.98,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 438.79,
    y: 185.98,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 453.05,
    y: 185.98,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 424.52,
    y: 206.01,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 438.79,
    y: 206.01,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 453.05,
    y: 206.01,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 424.52,
    y: 226.03,
    width: 6.79,
    height: 14.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 438.79,
    y: 226.03,
    width: 6.79,
    height: 14.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 453.05,
    y: 226.03,
    width: 6.79,
    height: 14.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 424.52,
    y: 246.05,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 438.79,
    y: 246.05,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 453.05,
    y: 246.05,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 424.52,
    y: 266.07,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 438.79,
    y: 266.07,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 453.05,
    y: 266.07,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 424.52,
    y: 284.99,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 438.79,
    y: 284.99,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 453.05,
    y: 284.99,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 473.57,
    y: 45.83,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 487.83,
    y: 45.83,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 473.57,
    y: 65.85,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 487.83,
    y: 65.85,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 473.57,
    y: 85.88,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 487.83,
    y: 85.88,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 473.57,
    y: 105.9,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 487.83,
    y: 105.9,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 473.57,
    y: 125.92,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 487.83,
    y: 125.92,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 473.57,
    y: 145.94,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 487.83,
    y: 145.94,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 473.57,
    y: 165.96,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 487.83,
    y: 165.96,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 473.57,
    y: 185.98,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 487.83,
    y: 185.98,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 473.57,
    y: 206.01,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 487.83,
    y: 206.01,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 473.57,
    y: 226.03,
    width: 6.79,
    height: 14.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 487.83,
    y: 226.03,
    width: 6.79,
    height: 14.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 473.57,
    y: 246.05,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 487.83,
    y: 246.05,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 473.57,
    y: 266.07,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 487.83,
    y: 266.07,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 473.57,
    y: 284.99,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 487.83,
    y: 284.99,
    width: 6.79,
    height: 14.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M598.47,147.89c.31,0,.56,6.42.56,14.33s-.25,14.33-.56,14.33-.56-6.41-.56-14.33S598.17,147.89,598.47,147.89Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "591.1 131.31 511.19 153.99 511.19 307.68 591.1 307.68 591.1 131.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "523.17 150.5 523.17 123.25 572.37 123.25 572.37 136.54 523.17 150.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "517.28 155.52 517.91 296.85 582.92 296.85 582.92 136.88 517.28 155.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M570.72,347.54c-.31,0-.56-33.92-.56-75.74s.25-75.75.56-75.75.56,33.91.56,75.75S571,347.54,570.72,347.54Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M598.05,347.54c-.31,0-.56-35.81-.56-80s.25-80,.56-80,.56,35.8.56,80S598.35,347.54,598.05,347.54Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M623.27,224.57c0,.31-16.19.56-36.15.56s-36.16-.25-36.16-.56,16.19-.56,36.16-.56S623.27,224.26,623.27,224.57Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M622.6,267.82c0,.3-16.19.55-36.16.55s-36.15-.25-36.15-.55,16.18-.56,36.15-.56S622.6,267.51,622.6,267.82Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M626.65,311.4c0,.31-16.79.56-37.5.56s-37.51-.25-37.51-.56,16.79-.56,37.51-.56S626.65,311.09,626.65,311.4Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M626.67,178.78c.08.3-17.6,5.58-39.5,11.79s-39.73,11-39.81,10.72,17.6-5.58,39.5-11.79S626.59,178.48,626.67,178.78Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M574.38,256.87c-.22-.22,3.71-4.51,8.77-9.57s9.36-9,9.57-8.78-3.71,4.5-8.78,9.57S574.59,257.08,574.38,256.87Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M586.59,239.47c.22.22-1.2,1.91-3.16,3.78s-3.72,3.19-3.93,3,1.2-1.92,3.16-3.78S586.38,239.25,586.59,239.47Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M591.1,288.4c.22.21-3.14,4-7.5,8.43s-8.07,7.86-8.29,7.64,3.14-4,7.5-8.43S590.88,288.18,591.1,288.4Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M585,290.31c.22.21-.89,1.82-2.49,3.59s-3.09,3.05-3.32,2.84.88-1.81,2.49-3.59S584.74,290.11,585,290.31Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M612.57,203c.24.2-1.43,2.54-3.72,5.22s-4.34,4.7-4.58,4.49,1.43-2.53,3.73-5.22S612.34,202.82,612.57,203Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M610.71,200.18c.23.21-1,1.89-2.65,3.75s-3.24,3.21-3.47,3,.95-1.88,2.65-3.75S610.48,200,610.71,200.18Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M564.72,326.71c.25.18-.77,2.06-2.28,4.19s-2.94,3.72-3.19,3.54.77-2.05,2.28-4.19S564.47,326.54,564.72,326.71Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M562.79,324.14c.22.21-.67,1.54-2,3s-2.59,2.4-2.82,2.19.67-1.54,2-3S562.56,323.93,562.79,324.14Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 90.47,
    y: 323.28,
    width: 9.28,
    height: 31.91,
    transform: "translate(154.36 631) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M133.7,324.26s-.46-.3.55-1.62a1.28,1.28,0,0,0-.55-2c-4.39,2.54-10.51,0-10.51,0s7.22-2.23,8.13-4.35c.69-1.59-.52-1.77-1.17-1.75.74-.08,2.33-.34,2.82-1.19.64-1.11-1.87-2.43-1.87-2.43a2,2,0,0,0,0-1.72c-.41-1.12-9.83-2.74-9.83-2.74C124,306.74,125,304,125,304s4.66.1,5.76-1.72-.73-2.33-3.84-3.85-10-7.19-10-7.19,4.29-.4,5.48-1.42.09-1.21.09-1.21c5.12.5,3.38-2.23,3.38-2.23a22.93,22.93,0,0,1-10.51-6.79,12.57,12.57,0,0,0,4.85-2.22c1.64-1.52-1.37-1.93-1.37-1.93s6-.81,2.56-3c-2.64-1.69-6.87-4-8.18-4.65,1.44.53,4.7-.11,4.7-.11,3.84-1.72,0-4.25,0-4.25-4.47-2.53-11-8.91-11-8.91s3.29,1.72,4.93,1.21-1.83-2.53-1.83-2.53,1.74.51,2.47,0-1.92-2.83-1.92-2.83c-3.94-2.56-8.79-9.28-10.82-12.17-2,2.89-6.89,9.61-10.83,12.17,0,0-2.65,2.32-1.92,2.83s2.47,0,2.47,0-3.47,2-1.83,2.53,4.93-1.21,4.93-1.21-6.57,6.38-11,8.91c0,0-3.84,2.53,0,4.25,0,0,3.26.64,4.7.11-1.31.68-5.54,3-8.17,4.65-3.48,2.23,2.55,3,2.55,3s-3,.41-1.37,1.93a12.57,12.57,0,0,0,4.85,2.22,22.93,22.93,0,0,1-10.51,6.79s-1.74,2.73,3.38,2.23c0,0-1.1.2.09,1.21s5.48,1.42,5.48,1.42-6.85,5.67-10,7.19-4.93,2-3.83,3.85S74.49,304,74.49,304s1,2.74,3.75,2.43c0,0-9.41,1.62-9.83,2.74a2,2,0,0,0,0,1.72s-2.51,1.32-1.87,2.43c.49.85,2.08,1.11,2.82,1.19-.65,0-1.86.16-1.17,1.75.91,2.12,8.13,4.35,8.13,4.35s-6.12,2.54-10.51,0a1.28,1.28,0,0,0-.55,2c1,1.32.55,1.62.55,1.62s-2.28-1.72-1.28.91,6.31,4.25,6.31,4.25-3,.51-2.1,2.13,4.75,3.55,9,3.95,9.87-1.11,9.87-1.11-3.84,2-1.19,3.14S92,336.11,92,336.11s-.55,2.59,1.64,1.7a15,15,0,0,0,4-2.61s.69,3.82,2.06,2.9c1.37.92,2-2.9,2-2.9a15,15,0,0,0,4,2.61c2.19.89,1.65-1.7,1.65-1.7s3,2.53,5.66,1.42-1.19-3.14-1.19-3.14,5.67,1.52,9.87,1.11,8-2.33,9-3.95-2.11-2.13-2.11-2.13,5.3-1.62,6.31-4.25S133.7,324.26,133.7,324.26Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.72,262.62l-.15-.07Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 180.59,
    y: 332.05,
    width: 6.73,
    height: 23.14,
    transform: "translate(332.05 639.77) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.94,332.76s-.33-.22.4-1.18a.93.93,0,0,0-.4-1.47c-3.18,1.84-7.62,0-7.62,0s5.24-1.61,5.9-3.16c.5-1.15-.38-1.28-.85-1.27.53-.05,1.69-.24,2-.86.47-.81-1.36-1.76-1.36-1.76a1.42,1.42,0,0,0,0-1.25c-.29-.81-7.12-2-7.12-2a2.71,2.71,0,0,0,2.72-1.77s3.38.08,4.17-1.24-.53-1.69-2.78-2.8-7.23-5.21-7.23-5.21,3.12-.3,4-1,.07-.88.07-.88c3.71.37,2.45-1.62,2.45-1.62a16.57,16.57,0,0,1-7.62-4.92,9.1,9.1,0,0,0,3.51-1.61c1.19-1.11-1-1.4-1-1.4s4.37-.59,1.85-2.2c-1.91-1.23-5-2.89-5.93-3.38a9.17,9.17,0,0,0,3.41-.08c2.79-1.25,0-3.08,0-3.08-3.24-1.84-8-6.47-8-6.47s2.39,1.25,3.58.89-1.32-1.84-1.32-1.84,1.26.37,1.79,0-1.39-2.06-1.39-2.06c-2.86-1.85-6.38-6.73-7.86-8.82-1.47,2.09-5,7-7.85,8.82,0,0-1.92,1.69-1.39,2.06s1.79,0,1.79,0-2.52,1.47-1.33,1.84,3.58-.89,3.58-.89-4.77,4.63-8,6.47c0,0-2.78,1.83,0,3.08a9.18,9.18,0,0,0,3.41.08c-.95.49-4,2.15-5.93,3.38-2.51,1.61,1.86,2.2,1.86,2.2s-2.19.29-1,1.4a9.1,9.1,0,0,0,3.51,1.61,16.57,16.57,0,0,1-7.62,4.92s-1.26,2,2.45,1.62c0,0-.8.15.07.88s4,1,4,1-5,4.11-7.22,5.21-3.58,1.47-2.79,2.8,4.18,1.24,4.18,1.24a2.71,2.71,0,0,0,2.72,1.77s-6.83,1.17-7.13,2a1.42,1.42,0,0,0,0,1.25s-1.82.95-1.36,1.76c.36.62,1.51.81,2.05.86-.48,0-1.35.12-.85,1.27.66,1.55,5.9,3.16,5.9,3.16s-4.45,1.84-7.63,0a.93.93,0,0,0-.39,1.47c.72,1,.39,1.18.39,1.18s-1.65-1.25-.92.66,4.57,3.08,4.57,3.08-2.19.37-1.53,1.54,3.45,2.58,6.5,2.87a24.9,24.9,0,0,0,7.16-.81s-2.79,1.47-.86,2.28,4.1-1,4.1-1-.39,1.88,1.2,1.23a10.66,10.66,0,0,0,2.91-1.89s.5,2.77,1.49,2.11c1,.66,1.49-2.11,1.49-2.11a10.8,10.8,0,0,0,2.92,1.89c1.59.65,1.19-1.23,1.19-1.23s2.19,1.84,4.11,1-.86-2.28-.86-2.28a24.9,24.9,0,0,0,7.16.81c3-.29,5.83-1.69,6.49-2.87s-1.52-1.54-1.52-1.54,3.84-1.17,4.57-3.08S211.94,332.76,211.94,332.76Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.55,288.05l-.11-.05Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 138.21,
    y: 311.96,
    width: 12.58,
    height: 43.23,
    transform: "translate(253.12 619.68) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M192.18,311.82s-.61-.42.75-2.2-.75-2.74-.75-2.74c-5.94,3.43-14.23,0-14.23,0s9.78-3,11-5.91c.92-2.15-.71-2.39-1.6-2.37,1-.1,3.17-.46,3.82-1.61.87-1.51-2.53-3.29-2.53-3.29a2.68,2.68,0,0,0,0-2.33c-.56-1.51-13.31-3.71-13.31-3.71,3.71.41,5.07-3.29,5.07-3.29s6.32.14,7.8-2.33-1-3.16-5.2-5.22-13.49-9.74-13.49-9.74,5.82-.55,7.43-1.92.12-1.65.12-1.65c6.93.69,4.58-3,4.58-3a31,31,0,0,1-14.24-9.19s4.34-1,6.56-3-1.85-2.61-1.85-2.61,8.17-1.1,3.46-4.12c-3.57-2.29-9.29-5.38-11.07-6.31,1.95.72,6.37-.14,6.37-.14,5.2-2.33,0-5.76,0-5.76-6.07-3.43-15-12.08-15-12.08s4.45,2.34,6.68,1.65-2.47-3.43-2.47-3.43,2.35.68,3.34,0-2.6-3.84-2.6-3.84c-5.34-3.47-11.92-12.57-14.67-16.48-2.75,3.91-9.33,13-14.67,16.48,0,0-3.59,3.15-2.6,3.84s3.34,0,3.34,0-4.7,2.74-2.47,3.43,6.68-1.65,6.68-1.65-8.91,8.65-15,12.08c0,0-5.2,3.43,0,5.76,0,0,4.42.86,6.37.14-1.78.93-7.5,4-11.07,6.31-4.71,3,3.46,4.12,3.46,4.12s-4.08.55-1.85,2.61,6.56,3,6.56,3a31,31,0,0,1-14.24,9.19s-2.35,3.71,4.58,3c0,0-1.49.27.12,1.65s7.43,1.92,7.43,1.92-9.28,7.68-13.49,9.74-6.69,2.75-5.2,5.22,7.8,2.33,7.8,2.33,1.36,3.7,5.07,3.29c0,0-12.75,2.2-13.31,3.71a2.68,2.68,0,0,0,0,2.33s-3.4,1.78-2.53,3.29c.65,1.15,2.82,1.51,3.81,1.61-.88,0-2.51.22-1.59,2.37,1.24,2.89,11,5.91,11,5.91s-8.29,3.43-14.24,0c0,0-2.1,1-.74,2.74s.74,2.2.74,2.2-3.09-2.34-1.73,1.23,8.54,5.76,8.54,5.76-4.47,1-2.84,2.89c2.2,2.6,7.48,5.24,12.13,5.35a70.62,70.62,0,0,0,13.37-1.51s-5.2,2.74-1.61,4.25,7.68-1.92,7.68-1.92-.74,3.51,2.23,2.31a20.41,20.41,0,0,0,5.45-3.54s.92,5.17,2.78,3.93c1.86,1.24,2.78-3.93,2.78-3.93a20.41,20.41,0,0,0,5.45,3.54c3,1.2,2.23-2.31,2.23-2.31s4.09,3.43,7.68,1.92-1.61-4.25-1.61-4.25,7.67,2.06,13.37,1.51,10.89-3.16,12.13-5.35-2.85-2.89-2.85-2.89,7.19-2.19,8.55-5.76S192.18,311.82,192.18,311.82Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.28,229.76a.82.82,0,0,0-.19-.09A.48.48,0,0,1,164.28,229.76Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M164.43,159.43c.45-3.25-4.13-5.91-7.57-6.19-1.64-.13-3.35.12-4.9-.43-3.37-1.17-4.72-5.52-8-6.91-2.46-1-5.29-.11-7.67,1.09s-4.74,2.71-7.4,2.88c-2.31.14-4.83-.71-6.85.42-1.51.84-2.3,2.58-3.69,3.6a8.75,8.75,0,0,1-4.83,1.31,13.45,13.45,0,0,0-5,.82c-1.54.7-2.81,2.32-2.49,4Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.79,191.87c.44-3.25-4.13-5.91-7.58-6.19-1.64-.13-3.34.12-4.9-.43-3.36-1.17-4.71-5.52-8-6.91-2.45-1-5.28-.11-7.66,1.09s-4.74,2.71-7.4,2.88c-2.31.14-4.83-.71-6.85.42-1.51.84-2.3,2.58-3.69,3.6a8.77,8.77,0,0,1-4.83,1.31,13.38,13.38,0,0,0-5,.82c-1.54.7-2.81,2.32-2.49,4Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M661.21,93.05c.44-3.24-4.14-5.91-7.58-6.19-1.64-.13-3.34.12-4.9-.42-3.37-1.17-4.71-5.53-8-6.91-2.45-1-5.28-.12-7.67,1.08s-4.73,2.71-7.39,2.88c-2.32.15-4.83-.71-6.86.42-1.51.84-2.3,2.58-3.69,3.61a8.8,8.8,0,0,1-4.82,1.31,13.67,13.67,0,0,0-5,.81c-1.53.7-2.8,2.33-2.49,4Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M142.42,117.41c.72-5.26-6.7-9.58-12.27-10-2.66-.22-5.42.19-7.94-.69-5.46-1.9-7.64-9-13-11.2-4-1.68-8.57-.18-12.43,1.76s-7.67,4.39-12,4.66c-3.75.24-7.82-1.15-11.11.68-2.44,1.37-3.72,4.19-6,5.85s-5.08,2-7.81,2.12-5.57.17-8.06,1.32-4.55,3.77-4,6.46Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M371.43,77.46c.73-5.26-6.69-9.58-12.27-10-2.66-.22-5.42.19-7.94-.69-5.45-1.9-7.63-8.95-13-11.2-4-1.68-8.56-.18-12.42,1.76s-7.67,4.39-12,4.66c-3.75.24-7.82-1.15-11.1.68-2.45,1.37-3.73,4.19-6,5.85s-5.08,2-7.82,2.12-5.56.17-8.06,1.32-4.55,3.77-4,6.46Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M728.06,355.19c0,.14-155,.26-346.08.26s-346.11-.12-346.11-.26,154.93-.26,346.11-.26S728.06,355.05,728.06,355.19Z",
    transform: "translate(-35.87 -47.47)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M687.53,469.32c0,.14-142.65.26-318.59.26s-318.62-.12-318.62-.26,142.63-.26,318.62-.26S687.53,469.17,687.53,469.32Z",
    transform: "translate(-35.87 -47.47)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble",
    "data-name": "Speech Bubble"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M228.38,130.94l-7.91.33a25.48,25.48,0,1,1,4.7-7.83h0Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M228.38,130.94l-.22-.49-.62-1.44-2.41-5.56h.08l-.21.28.12-.33A25.64,25.64,0,0,0,226.5,118a25.08,25.08,0,0,0,0-6.93,25.73,25.73,0,0,0-2.37-7.76,25.35,25.35,0,0,0-44.42-2,25.72,25.72,0,0,0-2.55,5.64,26.07,26.07,0,0,0-1.1,6,25.37,25.37,0,0,0,8.3,20.37,25.44,25.44,0,0,0,8.73,5.16,25.12,25.12,0,0,0,9.1,1.38,26.84,26.84,0,0,0,4.19-.48,28,28,0,0,0,3.79-1.07,25.75,25.75,0,0,0,6.12-3.26,25.44,25.44,0,0,0,4.14-3.76h0l5.88-.21,1.52-.06h.52l-.5,0-1.51.07-5.9.28,0,0a25.12,25.12,0,0,1-4.14,3.8,25.57,25.57,0,0,1-6.14,3.3,26.49,26.49,0,0,1-3.81,1.09,26.93,26.93,0,0,1-4.22.5,25.25,25.25,0,0,1-9.16-1.38,25.53,25.53,0,0,1-17.19-25.72,25.45,25.45,0,0,1,3.67-11.71,25.56,25.56,0,0,1,44.78,2,26.12,26.12,0,0,1,2.36,7.82,25.3,25.3,0,0,1,0,7,25.76,25.76,0,0,1-1.41,5.46l-.08,0h0l.06-.07,0,.08,2.37,5.62c.26.63.46,1.1.6,1.43Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M213.33,112.8a7.42,7.42,0,0,0-1.83-4,7,7,0,0,0-3.65-2.33,5.71,5.71,0,0,0-6.35,2.84,5.65,5.65,0,0,0-1.67-1.87,5.77,5.77,0,0,0-4.45-1,7.09,7.09,0,0,0-3.74,2.21,7.38,7.38,0,0,0-1.95,4,8.91,8.91,0,0,0,1,5.53,12.74,12.74,0,0,0,4.31,4.17c2.83,1.77,6.56,4,6.56,4s3.22-2.33,6.1-4a12.74,12.74,0,0,0,4.44-4A9,9,0,0,0,213.33,112.8Z",
    transform: "translate(-35.87 -47.47)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M348.75,156.68c-.54,1,.19,28.44-1,27.26s-24.22-7.64-28.8-9.08c-6.69-2.1-17.37-2.76-24.49,4.29l23.82,13.6s29.52,10.12,34.4,9.47c7.44-1,10.22-7.19,11.62-14s-5.66-32.84-5.66-32.84Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M358.77,142.47c-2-1-2.28.24-2.28.24-.71-1.73-3.08-.88-3.08-.88a3,3,0,0,0-1.64-1.34,9.25,9.25,0,0,0-3.73,4.93c-1.23-.19-.8-1.83-.47-4.31s-1.35-2.35-2-1.8a5.65,5.65,0,0,0-1.05,2.24s-.78,4.85-.3,6.22,4.65,9.22,4.65,9.22l9.95.09s2.45-7.14,2.57-9.56S360.74,143.44,358.77,142.47Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M349,150.3s-.15.14-.51.13a1.79,1.79,0,0,1-1.26-.72,2.52,2.52,0,0,1-.39-2.1,16,16,0,0,1,.71-2.43,10.27,10.27,0,0,1,2.53-3.82c.87-.83,1.68-1,1.68-.87a10.33,10.33,0,0,0-1.36,1.2,11.62,11.62,0,0,0-2.34,3.69c-.55,1.6-1.2,3.23-.52,4.1a1.79,1.79,0,0,0,1,.74C348.82,150.29,349,150.25,349,150.3Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M353.28,149s0,.21-.08.55a2.3,2.3,0,0,1-1,1.19,1.79,1.79,0,0,1-2.26-.36,2,2,0,0,1-.38-1.37,6.08,6.08,0,0,1,.28-1.41,14.31,14.31,0,0,1,2.29-4.28,7,7,0,0,1,1.33-1.5,7.91,7.91,0,0,1-1,1.72,18,18,0,0,0-2.08,4.22,2.73,2.73,0,0,0,0,2.31,1.38,1.38,0,0,0,1.67.32,2.26,2.26,0,0,0,1-.93C353.17,149.18,353.24,149,353.28,149Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M357.11,146.29a4.12,4.12,0,0,1-.65,2.05,8.27,8.27,0,0,1-.59.92,3.62,3.62,0,0,1-.94.93,1.45,1.45,0,0,1-.77.22,1.09,1.09,0,0,1-.8-.4,1.83,1.83,0,0,1-.2-1.64,14.2,14.2,0,0,1,2.31-4.64A5.58,5.58,0,0,1,357,142.2a22.81,22.81,0,0,0-3.27,6.31,1.3,1.3,0,0,0,.09,1.16.65.65,0,0,0,.89.08,5.32,5.32,0,0,0,1.45-1.61C356.8,147.05,357,146.26,357.11,146.29Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M351.7,188.59a6.39,6.39,0,0,1-2.45-2.19,6.7,6.7,0,0,1-1.59-2.89,18.74,18.74,0,0,1,2,2.54A21.88,21.88,0,0,1,351.7,188.59Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M358.88,179.51a5.38,5.38,0,0,1,3.68-4.65,6.73,6.73,0,0,1,6,1.07,9.11,9.11,0,0,1,3.35,5.19,10.51,10.51,0,0,1-1.76,8.84,9.24,9.24,0,0,1-8.19,3.53,8.28,8.28,0,0,1-6.82-5.58,7.6,7.6,0,0,1,1.79-7.34,3.77,3.77,0,0,1,2-1.06Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M358.88,179.51l-.14,0a2.92,2.92,0,0,0-.41.13,3.76,3.76,0,0,0-1.38.88,7.36,7.36,0,0,0-1.44,2.17,7.75,7.75,0,0,0-.64,3.36,7.21,7.21,0,0,0,1.34,3.9,8.42,8.42,0,0,0,3.73,2.91,8.18,8.18,0,0,0,2.52.56,8.76,8.76,0,0,0,2.68-.3,9.23,9.23,0,0,0,6.19-5.49A10,10,0,0,0,372,185a10.54,10.54,0,0,0-.68-5.21,8.78,8.78,0,0,0-2.86-3.77,7,7,0,0,0-3.9-1.35,5.54,5.54,0,0,0-5,2.77,4.74,4.74,0,0,0-.57,1.53c-.08.38-.08.58-.09.58s0,0,0-.15a2.82,2.82,0,0,1,0-.43,4.67,4.67,0,0,1,.56-1.57,5.63,5.63,0,0,1,1.78-1.92,5.79,5.79,0,0,1,3.33-.93,7.2,7.2,0,0,1,4,1.35,8.84,8.84,0,0,1,2.92,3.84,10.46,10.46,0,0,1,.7,5.28,10.3,10.3,0,0,1-.7,2.75,9.32,9.32,0,0,1-3.71,4.45,9.4,9.4,0,0,1-2.6,1.14,8.48,8.48,0,0,1-2.73.29,8,8,0,0,1-2.56-.57,8.53,8.53,0,0,1-3.79-3,7.42,7.42,0,0,1-1.35-4,7.92,7.92,0,0,1,.68-3.41,7.27,7.27,0,0,1,1.48-2.17,3.83,3.83,0,0,1,1.41-.88A2.36,2.36,0,0,1,358.88,179.51Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M357.74,183.41a1.9,1.9,0,0,0-1.52,1.28,6.18,6.18,0,0,0,.16,3.87,5,5,0,0,0,2.33,2.72,3.59,3.59,0,0,0,3.51-.11,2.85,2.85,0,0,0,1.2-3.18c-.42-1.21-1.65-1.9-2.59-2.76-.46-.42-.87-.89-1.37-1.27A2.38,2.38,0,0,0,357.74,183.41Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M356,177.48a13.22,13.22,0,0,0,2.39,2.38c-2.27.59-4.75,2.61-4.27,2.8s4.41-1.49,4.41-1.49a8.18,8.18,0,0,0,0,4.11,9.88,9.88,0,0,0,1-4.44,2.75,2.75,0,0,0,1.69.69,8.31,8.31,0,0,0,1.86-.11c.24,0,.55-.14.54-.39s-.26-.32-.47-.37l-3.12-.81a11.65,11.65,0,0,0,1.73-3.56.43.43,0,0,0,0-.25.26.26,0,0,0-.33-.09.68.68,0,0,0-.27.24,31.87,31.87,0,0,0-2.22,3.19",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M364.34,191.94l-.13.05a3.48,3.48,0,0,1-.4.12,6.25,6.25,0,0,1-1.52.17,6.9,6.9,0,0,1-2.23-.39,6.46,6.46,0,0,1-3.93-3.74,6.92,6.92,0,0,1-.5-2.21,6,6,0,0,1,.1-1.53c0-.18.07-.31.09-.4l.05-.14a9.08,9.08,0,0,0-.12,2.06,6.88,6.88,0,0,0,.52,2.16,6.45,6.45,0,0,0,3.84,3.65,6.73,6.73,0,0,0,2.18.42A9.56,9.56,0,0,0,364.34,191.94Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M342.09,170a5.36,5.36,0,0,1,5.9-.58,6.75,6.75,0,0,1,3.38,5,9.14,9.14,0,0,1-1.41,6,10.49,10.49,0,0,1-7.58,4.88,9.24,9.24,0,0,1-8.23-3.43,8.27,8.27,0,0,1-.73-8.79,7.61,7.61,0,0,1,6.52-3.81,3.77,3.77,0,0,1,2.15.69Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M342.09,170,342,170l-.38-.2a3.76,3.76,0,0,0-1.59-.38,7.51,7.51,0,0,0-2.56.47,7.62,7.62,0,0,0-2.86,1.88,7.2,7.2,0,0,0-1.88,3.67,8.39,8.39,0,0,0,.5,4.7,8,8,0,0,0,1.35,2.2,8.62,8.62,0,0,0,2.07,1.72,8.94,8.94,0,0,0,2.59,1.06,8.83,8.83,0,0,0,2.86.24,9.45,9.45,0,0,0,2.8-.65,10.06,10.06,0,0,0,2.44-1.38,10.47,10.47,0,0,0,3.27-4.11,8.67,8.67,0,0,0,.73-4.68,7,7,0,0,0-1.74-3.74,5.51,5.51,0,0,0-2.91-1.73,5.42,5.42,0,0,0-2.58,0,4.64,4.64,0,0,0-1.51.65c-.32.21-.46.35-.47.34a.59.59,0,0,1,.11-.1,2.49,2.49,0,0,1,.34-.27,4.77,4.77,0,0,1,1.51-.69,5.68,5.68,0,0,1,2.62,0,5.77,5.77,0,0,1,3,1.75,7.22,7.22,0,0,1,1.79,3.8,8.94,8.94,0,0,1-.73,4.76,10.69,10.69,0,0,1-3.31,4.18,10.58,10.58,0,0,1-2.48,1.4,9.42,9.42,0,0,1-2.85.67,9.14,9.14,0,0,1-2.91-.25,9,9,0,0,1-2.63-1.08,8.75,8.75,0,0,1-2.11-1.75,8.09,8.09,0,0,1-1.37-2.25,8.51,8.51,0,0,1-.49-4.79,7.36,7.36,0,0,1,1.92-3.73,7.8,7.8,0,0,1,2.92-1.88,7.35,7.35,0,0,1,2.59-.44,3.77,3.77,0,0,1,1.61.41A2.25,2.25,0,0,1,342.09,170Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M338.49,171.92a1.91,1.91,0,0,0-2-.2,6.23,6.23,0,0,0-2.69,2.8,5,5,0,0,0-.33,3.57,3.62,3.62,0,0,0,2.51,2.45,2.85,2.85,0,0,0,3.13-1.35c.58-1.14.22-2.5.18-3.78,0-.62,0-1.24,0-1.86A2.44,2.44,0,0,0,338.49,171.92Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M343.57,162.28a8.29,8.29,0,0,0-2.07,7.66c-2-1.22-5.18-1.61-5-1.13s4.13,2.13,4.13,2.13a8.17,8.17,0,0,0-2.94,2.87,10,10,0,0,0,3.86-2.38,2.75,2.75,0,0,0,.68,1.69,8.14,8.14,0,0,0,1.37,1.25c.19.16.49.3.66.13s0-.41-.06-.6l-1.59-2.8a11.62,11.62,0,0,0,3.76-1.23.39.39,0,0,0,.19-.17.26.26,0,0,0-.16-.3.63.63,0,0,0-.36,0,29.23,29.23,0,0,0-3.84.61s-.52-4.11,2-6.27",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M336.94,182.6l-.13-.06a3.41,3.41,0,0,1-.36-.21,5.66,5.66,0,0,1-1.18-1,6.78,6.78,0,0,1-1.27-1.88,6.62,6.62,0,0,1-.62-2.7,6.71,6.71,0,0,1,.58-2.72,7,7,0,0,1,1.24-1.89,5.88,5.88,0,0,1,1.17-1,1.87,1.87,0,0,1,.36-.21l.13-.07a8.88,8.88,0,0,0-1.57,1.34,7.15,7.15,0,0,0-1.19,1.88,6.82,6.82,0,0,0-.55,2.66,6.56,6.56,0,0,0,.59,2.64,6.88,6.88,0,0,0,1.21,1.86A9.58,9.58,0,0,0,336.94,182.6Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M352.56,152.4a5.36,5.36,0,0,1,4.27-4.11,6.75,6.75,0,0,1,5.78,1.85,9.15,9.15,0,0,1,2.62,5.59,10.53,10.53,0,0,1-2.92,8.53,9.23,9.23,0,0,1-8.59,2.4,8.26,8.26,0,0,1-6-6.44,7.61,7.61,0,0,1,2.75-7,3.8,3.8,0,0,1,2.11-.79Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M352.56,152.4l-.14,0-.43.07a3.89,3.89,0,0,0-1.48.7,7.33,7.33,0,0,0-1.71,1.95,7.71,7.71,0,0,0-1.09,3.25,7.21,7.21,0,0,0,.81,4,8.32,8.32,0,0,0,3.31,3.38,8.15,8.15,0,0,0,2.42.89,8.35,8.35,0,0,0,2.69.06,9.06,9.06,0,0,0,2.69-.77A8.75,8.75,0,0,0,362,164.4a9,9,0,0,0,1.79-2.25,10.17,10.17,0,0,0,1.06-2.59,10.61,10.61,0,0,0,0-5.25,8.7,8.7,0,0,0-2.34-4.13,6.92,6.92,0,0,0-3.67-1.85,5.58,5.58,0,0,0-3.36.44,5.71,5.71,0,0,0-2,1.62,5.12,5.12,0,0,0-.78,1.45c-.12.36-.14.56-.16.56l0-.15a3.35,3.35,0,0,1,.1-.42,5,5,0,0,1,.76-1.48,5.64,5.64,0,0,1,5.45-2.14,7.18,7.18,0,0,1,3.75,1.87,8.89,8.89,0,0,1,2.39,4.19,10.69,10.69,0,0,1,0,5.33,10.53,10.53,0,0,1-1.07,2.64,9.29,9.29,0,0,1-4.26,3.9,9.32,9.32,0,0,1-2.74.79,9,9,0,0,1-2.74-.07,8.07,8.07,0,0,1-2.47-.92,8.4,8.4,0,0,1-3.35-3.45,7.27,7.27,0,0,1-.81-4.11,7.72,7.72,0,0,1,1.13-3.29,7.09,7.09,0,0,1,1.75-2,3.82,3.82,0,0,1,1.52-.68A2.7,2.7,0,0,1,352.56,152.4Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M350.91,156.11a1.88,1.88,0,0,0-1.67,1.07,6.23,6.23,0,0,0-.37,3.86,5,5,0,0,0,2,3,3.59,3.59,0,0,0,3.48.37,2.86,2.86,0,0,0,1.62-3c-.25-1.26-1.38-2.1-2.2-3.08-.4-.48-.74-1-1.18-1.44A2.47,2.47,0,0,0,350.91,156.11Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M344.39,149.6c3.49.22,7.65,3.09,7.65,3.09-2.32.28-5.06,1.95-4.61,2.19S352,154,352,154a8.09,8.09,0,0,0-.53,4.07,9.89,9.89,0,0,0,1.55-4.26,2.85,2.85,0,0,0,1.58.91,8.91,8.91,0,0,0,1.86.13c.24,0,.56-.07.59-.31s-.22-.35-.42-.43l-3-1.22a11.33,11.33,0,0,0,2.19-3.29.38.38,0,0,0,.05-.25.26.26,0,0,0-.31-.14.69.69,0,0,0-.3.21,30.94,30.94,0,0,0-2.63,2.86s-4.11-4.13-7.75-3.95",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M356.32,165.44l-.14,0c-.1,0-.23.05-.41.06a6.17,6.17,0,0,1-1.53,0,7.12,7.12,0,0,1-2.16-.68,6.68,6.68,0,0,1-2.17-1.75,6.78,6.78,0,0,1-1.23-2.48,7.12,7.12,0,0,1-.2-2.26,6.41,6.41,0,0,1,.3-1.5c.06-.18.12-.3.15-.39s.06-.13.07-.13a8.82,8.82,0,0,0-.4,2,6.93,6.93,0,0,0,.23,2.22,6.7,6.7,0,0,0,5.43,4.83A8,8,0,0,0,356.32,165.44Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M337,150.35a5.35,5.35,0,0,1,5.14,3,6.74,6.74,0,0,1-.16,6.06,9.17,9.17,0,0,1-4.64,4.08,10.51,10.51,0,0,1-9-.42,9.27,9.27,0,0,1-4.72-7.57,8.27,8.27,0,0,1,4.51-7.58,7.59,7.59,0,0,1,7.52.67,3.81,3.81,0,0,1,1.35,1.81Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M337,150.35l-.06-.14c0-.09-.1-.22-.19-.38a3.78,3.78,0,0,0-1.08-1.23,7.31,7.31,0,0,0-2.36-1.11,7.87,7.87,0,0,0-3.42-.13,7.12,7.12,0,0,0-3.65,1.91,8.37,8.37,0,0,0-2.33,4.12,8.2,8.2,0,0,0-.17,2.58,8.36,8.36,0,0,0,.69,2.6,9.2,9.2,0,0,0,1.49,2.36,9,9,0,0,0,2.2,1.86,9.33,9.33,0,0,0,2.66,1.09,10.11,10.11,0,0,0,2.78.28,10.44,10.44,0,0,0,5.05-1.45,8.67,8.67,0,0,0,3.31-3.39,7,7,0,0,0,.75-4,5.62,5.62,0,0,0-1.37-3.1,5.44,5.44,0,0,0-2.12-1.48,4.76,4.76,0,0,0-1.6-.34c-.38,0-.58,0-.58,0l.15,0a2.44,2.44,0,0,1,.43,0,4.59,4.59,0,0,1,1.63.32,5.58,5.58,0,0,1,2.16,1.47,5.72,5.72,0,0,1,1.42,3.16,7.17,7.17,0,0,1-.75,4.12,8.74,8.74,0,0,1-3.35,3.46,10.6,10.6,0,0,1-5.12,1.49,10.48,10.48,0,0,1-2.83-.29,9.51,9.51,0,0,1-2.71-1.11A9.24,9.24,0,0,1,325.8,161a9.14,9.14,0,0,1-1.52-2.41,8.6,8.6,0,0,1-.7-2.65,8.43,8.43,0,0,1,.18-2.62,8.58,8.58,0,0,1,2.38-4.19,7.26,7.26,0,0,1,3.73-1.92,7.92,7.92,0,0,1,3.47.15,7.48,7.48,0,0,1,2.37,1.15,3.85,3.85,0,0,1,1.07,1.26A3,3,0,0,1,337,150.35Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M333,149.8a1.89,1.89,0,0,0-1.49-1.31,6.17,6.17,0,0,0-3.81.73,5,5,0,0,0-2.34,2.71,3.65,3.65,0,0,0,.63,3.46,2.86,2.86,0,0,0,3.33.71c1.14-.59,1.63-1.91,2.34-3,.34-.51.75-1,1.05-1.53A2.42,2.42,0,0,0,333,149.8Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M344.33,143c-7.15,1.06-7.76,6.93-7.76,6.93-.92-2.15-3.28-4.31-3.39-3.8s2.12,4.13,2.12,4.13a8.22,8.22,0,0,0-4.06.63,9.93,9.93,0,0,0,4.53.3,2.81,2.81,0,0,0-.43,1.77,8.82,8.82,0,0,0,.39,1.82c.07.23.23.52.47.48s.27-.3.29-.52l.33-3.21a11.48,11.48,0,0,0,3.78,1.18.35.35,0,0,0,.25,0,.25.25,0,0,0,0-.33.79.79,0,0,0-.28-.23,30.52,30.52,0,0,0-3.49-1.72s2.65-6.46,7-5.54",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M325.52,157.6a.73.73,0,0,1-.07-.13c0-.08-.11-.2-.18-.37a6.17,6.17,0,0,1-.39-1.48,6.58,6.58,0,0,1,3.16-6.71,7.08,7.08,0,0,1,2.12-.82,6,6,0,0,1,1.52-.13c.18,0,.32,0,.41,0l.14,0a9.06,9.06,0,0,0-2.05.19,6.89,6.89,0,0,0-2.06.84,6.41,6.41,0,0,0-3,4.33,7.16,7.16,0,0,0-.09,2.23A8.52,8.52,0,0,0,325.52,157.6Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M358.4,179.86c-29.63-16.41-9.5-45.49-9.5-45.49l2,1.08s-20.34,28.1,9.29,44.52",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M351.33,137.85c-1-.39-8.58,2.16-7.47,3.77a3,3,0,0,0,3.22,1l2.6-.86c.64-.56,1.29-1.23,2-1.29C351.64,140.46,352.34,138.23,351.33,137.85Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "276.15 122.94 295.38 129.69 289.25 148.68 277.28 146.08 276.15 122.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M267.62,160.79a6.12,6.12,0,0,0-4.3-6l-3.7-20.59a11.93,11.93,0,0,0-13,7.7c-1,3-.83,6.43-2.81,8.85-2.13,2.61-5.91,3-9,4.38-2.71,1.23-5.08,3.57-5.62,6.5s1.3,6.31,4.23,6.85a7.93,7.93,0,0,0,9.54,11.48,7.33,7.33,0,1,0,14.58-1.46c2.66,1.91,6.8-.07,7.82-3.18s-.4-6.59-2.64-9A6.12,6.12,0,0,0,267.62,160.79Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M310.65,114.45s4.26,1.37,2.47,6c-2.05,5.26-15.7,7.31-15.7,7.31l-.72-5.24Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310.65,114.45s4.26,1.37,2.47,6c-2.05,5.26-15.7,7.31-15.7,7.31l-.72-5.24Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M297.62,125.45a24.94,24.94,0,0,0-5.9-14.23c-3.46-3.91-7.35-4.31-12.57-4.37s-9.32,2.06-13.27,5.54-6.51,6.15-7.75,11.27a21.88,21.88,0,0,0,1.21,15c2.23,5.08,5,11,10.24,12.79,7.15,2.51,15.56.18,20.94-5.15S298.33,133,297.62,125.45Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M273,166.92l-8.09-44.22a3.86,3.86,0,0,1,3.08-4.23l20-7.09c6.48-1.31,11.59,6.34,12.63,12.87,1.14,7.25,2.26,16.16,1.91,21.68-.71,11.12-9,13.3-9,13.3s-.1,5.21.23,9.2c0,0,.05,6.34-9.23,6.66C278.5,175.29,273,166.92,273,166.92Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M296.86,133.64a1.41,1.41,0,0,1-1.22,1.54,1.35,1.35,0,0,1-1.57-1.13,1.4,1.4,0,0,1,1.22-1.54A1.35,1.35,0,0,1,296.86,133.64Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M299.1,129.07c-.16.2-1.3-.48-2.81-.34s-2.54,1-2.73.84.06-.42.51-.82a3.86,3.86,0,0,1,2.16-.89,3.62,3.62,0,0,1,2.26.5C299,128.67,299.18,129,299.1,129.07Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M283.15,134.47a1.41,1.41,0,0,1-1.22,1.54,1.35,1.35,0,0,1-1.57-1.13,1.41,1.41,0,0,1,1.22-1.54A1.35,1.35,0,0,1,283.15,134.47Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M284.52,129.93c-.15.2-1.29-.49-2.8-.34s-2.55,1-2.73.83.06-.42.51-.82a3.86,3.86,0,0,1,2.16-.89,3.71,3.71,0,0,1,2.26.5C284.41,129.52,284.6,129.84,284.52,129.93Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M290.81,141.45a9.64,9.64,0,0,1,2.41-.68c.38-.07.74-.18.78-.45a1.91,1.91,0,0,0-.36-1.12c-.45-.9-.92-1.85-1.42-2.83-2-4-3.45-7.37-3.29-7.45s1.9,3.13,3.88,7.16c.48,1,.94,1.95,1.37,2.86a2.22,2.22,0,0,1,.35,1.49,1,1,0,0,1-.59.63,3.06,3.06,0,0,1-.64.15A10.12,10.12,0,0,1,290.81,141.45Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M293.54,159.23a28,28,0,0,1-15-2.53s4.16,7.45,15,5.39Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M290.51,145.15a2.72,2.72,0,0,0-2.53-.78,2.49,2.49,0,0,0-1.63,1.08,1.58,1.58,0,0,0,0,1.81,1.83,1.83,0,0,0,2,.32,5.92,5.92,0,0,0,1.82-1.34,1.69,1.69,0,0,0,.39-.49.52.52,0,0,0-.06-.56",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M286.46,142.91c.25,0,.4,1.6,1.92,2.64s3.24.68,3.27.91-.36.36-1.09.45a4.1,4.1,0,0,1-2.73-.68,3.58,3.58,0,0,1-1.5-2.22C286.2,143.34,286.35,142.91,286.46,142.91Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M284.42,123.8c-.12.42-1.64.37-3.39.75s-3.15,1-3.42.65c-.12-.16.09-.57.64-1a5.64,5.64,0,0,1,2.46-1.14,5.91,5.91,0,0,1,2.72.06C284.1,123.31,284.46,123.6,284.42,123.8Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M298,122.51c-.24.37-1.31.11-2.56.21s-2.29.45-2.57.11c-.13-.16,0-.52.44-.89a3.6,3.6,0,0,1,2-.76,3.55,3.55,0,0,1,2.1.5C298,122,298.14,122.33,298,122.51Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M261.51,121.44c1.29-6.54,11-14.31,17.64-14.59l9.73,3.14a10.24,10.24,0,0,1-6,8.57c-1.8.78-4,1.19-5,2.92s0,4.07-.88,5.88c-1.19,2.51-5.2,2.85-6,5.51a5.83,5.83,0,0,0-.32,3.6c3,8.33-3.6,4.57-5.58,3.5-1.42-.77-1.89-2.92-2.54-4.23a7.22,7.22,0,0,1-.77-4.82C262.11,127.76,260.89,124.56,261.51,121.44Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M269.77,140.75c-.08-.81-1.2-2.65-2-2.7-2.18-.13-6,.41-5.56,5.87.65,7.47,8,5.28,8,5.06S270,143.57,269.77,140.75Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M267.67,146.35s-.12.1-.33.22a1.3,1.3,0,0,1-1,.11,3.22,3.22,0,0,1-1.74-2.76,4.23,4.23,0,0,1,.2-1.9,1.5,1.5,0,0,1,.89-1.08.66.66,0,0,1,.8.29c.12.2.08.35.12.36s.15-.14.06-.44a.75.75,0,0,0-.33-.44,1,1,0,0,0-.74-.13,1.81,1.81,0,0,0-1.25,1.28,4.33,4.33,0,0,0-.27,2.12c.18,1.5,1.07,2.84,2.18,3.06a1.42,1.42,0,0,0,1.17-.3C267.68,146.53,267.7,146.36,267.67,146.35Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M286.42,108c1.09,2.93,6.2,6.2,8.53,8.28,4.45,4,5.41,5.37,6.71,15.41,1.36-3.71,2.3-7.29,1.63-11.18s-3.24-6.44-6.33-8.89-6.74-4.7-10.54-3.62",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M257.71,121.85a7.31,7.31,0,0,0,1.3.14c.42,0,.94.07,1.54.07s1.29,0,2,0a35.68,35.68,0,0,0,5.27-.65,39.59,39.59,0,0,0,6.25-1.82,41.26,41.26,0,0,0,5.84-2.88,36.76,36.76,0,0,0,4.32-3.09c.6-.47,1.08-1,1.53-1.35s.8-.78,1.09-1.09a7.4,7.4,0,0,0,.86-1,7.74,7.74,0,0,0-1,.87c-.31.29-.68.64-1.14,1s-.95.85-1.56,1.29a40.09,40.09,0,0,1-4.33,3,39.45,39.45,0,0,1-12,4.66,40.83,40.83,0,0,1-5.21.74c-.75.08-1.42.07-2,.1s-1.11,0-1.53,0A7.45,7.45,0,0,0,257.71,121.85Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M257.65,127.28a3.38,3.38,0,0,0,.88.09,22.1,22.1,0,0,0,2.44,0,30,30,0,0,0,15.08-5.1,20.56,20.56,0,0,0,1.94-1.47,3.42,3.42,0,0,0,.65-.61c-.05-.06-1,.73-2.76,1.82a35.29,35.29,0,0,1-7.17,3.4A34.69,34.69,0,0,1,261,127C258.92,127.23,257.65,127.2,257.65,127.28Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M301,115.45s-13-18.5-32.14-6.89c-18,10.91-9.47,30.07-9.47,30.07s7.51-10.51,13.12-13.94,16.12-4.88,22.64-6.62S301,115.45,301,115.45Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M301,115.45l-23.33,6.73,6.35-.37s13.62-.94,18.42-2.32a17.85,17.85,0,0,0,8.26-5Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M300.47,115.3a4.55,4.55,0,0,1-1,.14c-.66,0-1.61.15-2.78.31a48.66,48.66,0,0,0-17.39,5.75c-1,.57-1.86,1-2.42,1.4a4.17,4.17,0,0,1-.9.5,4.79,4.79,0,0,1,.81-.64c.53-.39,1.34-.92,2.35-1.53a43.31,43.31,0,0,1,17.51-5.79c1.18-.12,2.14-.17,2.81-.17A4.62,4.62,0,0,1,300.47,115.3Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M269.79,127.66a2.49,2.49,0,0,1-.28-.74c-.16-.48-.36-1.19-.56-2.08a38.17,38.17,0,0,1-.93-7.06,38.59,38.59,0,0,1,.39-7.1c.14-.9.28-1.62.4-2.12a2.78,2.78,0,0,1,.23-.76c.06,0-.13,1.12-.33,2.92a49.25,49.25,0,0,0-.25,7,47.38,47.38,0,0,0,.79,7C269.58,126.55,269.86,127.64,269.79,127.66Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M315.11,250.87c.63.64,10.87,23.44,10.21,39.28s-10.21,71-10.21,71l-15.26,85.26H277.7s0-54.51,2-69.43,4.3-23.14,5-34.1.85-34,1.51-33.11S235,443.31,235,443.31l-21.78-1.44s7.89-45.54,9.55-54.17,8.27-35.13,13.23-48.53,6.7-46.81,13.56-61.19,6.91-18.89,6.91-18.89Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M298.56,427.17l-1.16,21.18s21.14,8.3,21.31,12.23l-41.16-.77.46-33.08Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M277.55,459.81l.05-3.2,39.52,1.86s1.82.83,1.59,2.11Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M298.07,448.16c0,.2-1,.27-2,.9s-1.54,1.46-1.73,1.38.14-1.24,1.37-2S298.11,448,298.07,448.16Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M302.35,450c0,.2-.83.53-1.53,1.36s-.92,1.74-1.12,1.72-.3-1.15.59-2.17S302.35,449.83,302.35,450Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M304.7,455.24c-.18,0-.44-1,.1-2.06s1.48-1.51,1.56-1.35-.51.75-.93,1.65S304.91,455.22,304.7,455.24Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M217.39,427.07,214,448.35s-21.14,8.3-21.3,12.23l41.15-.77L235.79,428Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M233.84,459.81l0-3.2-39.53,1.86s-1.82.83-1.58,2.11Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M213.32,448.16c0,.2,1,.27,2,.9s1.55,1.46,1.73,1.38-.14-1.24-1.36-2S213.28,448,213.32,448.16Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M209,450c0,.2.84.53,1.53,1.36s.92,1.74,1.12,1.72.3-1.15-.59-2.17S209,449.83,209,450Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M206.69,455.24c.18,0,.44-1-.1-2.06s-1.48-1.51-1.56-1.35.51.75.93,1.65S206.49,455.22,206.69,455.24Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M315.11,207.45s0-21.85-1-29.4c-.83-6.27,1.15-6.39-2.1-7.64s-18.25-4.83-18.25-4.83-1.58,7.08-7.35,6.94a17.19,17.19,0,0,1-13.8-7.82s-16.35,2.07-22.26,4.84l-4.52,33.85s7.93,51.1,11.37,55.46,29,14.19,41.65,10.24S321,255.62,317.31,252c-5.09-4.94-6.45-25.26-4.3-31.93C313.2,219.24,315.11,207.45,315.11,207.45Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M314,252.11l-7.11-57.27-46,2.53,3.91,57-9,1.71L253,269.75l.92.31h0S241,370.8,242.49,373.78s79.16.91,79.16.91,5.37-77.33,4.48-92.86a63.56,63.56,0,0,0-7.29-26.32Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M308.47,169.5s.94,30.21-2.72,31.62c-4.84,1.86-4.49-4-4.49-8.57s1.59-24.66,1.59-24.66A13.33,13.33,0,0,1,308.47,169.5Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M266,165.71s4.23,32,3,34.43-5.08,2.64-5.79,0-4.47-33.08-4.47-33.08S263.68,165.09,266,165.71Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M269.11,195.24a4.38,4.38,0,0,1,.44,2.27,15,15,0,0,1-.07,2.54,3.08,3.08,0,0,1-2,2.49,3.3,3.3,0,0,1-3.07-.91,5,5,0,0,1-1.25-2.26,6,6,0,0,1-.3-2.3,17.44,17.44,0,0,1,.69,2.17,5,5,0,0,0,1.23,2,2.81,2.81,0,0,0,2.53.74,2.59,2.59,0,0,0,1.63-2,22.65,22.65,0,0,0,.18-2.43C269.2,196.11,269.05,195.27,269.11,195.24Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M307.9,196.17a3.42,3.42,0,0,1-.74,1.75,4.44,4.44,0,0,1-1.55,1.44,3.38,3.38,0,0,1-2.62.29,3.18,3.18,0,0,1-1.88-1.85,5,5,0,0,1-.38-2.07,4.44,4.44,0,0,1,.28-1.87,8.78,8.78,0,0,1,.14,1.85,5.3,5.3,0,0,0,.45,1.87,2.81,2.81,0,0,0,1.57,1.51,3,3,0,0,0,2.19-.22,4.48,4.48,0,0,0,1.47-1.2C307.52,196.8,307.81,196.13,307.9,196.17Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M266.73,270.36a6.9,6.9,0,0,1-.5-2.17,34.36,34.36,0,0,1,.2-10.71,7.51,7.51,0,0,1,.57-2.15c.18,0-.43,3.36-.5,7.51S266.91,270.33,266.73,270.36Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M276,279c-.15,0-1.56-5.79-3.14-13s-2.72-13.09-2.56-13.13,1.57,5.79,3.14,13S276.17,279,276,279Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M306.28,225.9a.78.78,0,0,1,.07.27c0,.19.09.46.14.82a6.22,6.22,0,0,1-.24,3.18,4.4,4.4,0,0,1-1.47,1.82,8.77,8.77,0,0,1-2.5,1.19,58.12,58.12,0,0,1-6.55,1.35,73.53,73.53,0,0,1-8,.83c-1.46.08-3,.11-4.51.1a25.64,25.64,0,0,1-4.8-.38,8.76,8.76,0,0,1-4.56-2.28,9.35,9.35,0,0,1-2.28-4.8c-.35-1.77-.47-3.58-.65-5.4s-.34-3.68-.51-5.55l-.13-1.4a4.91,4.91,0,0,1,0-1.48,4.38,4.38,0,0,1,1.44-2.53,4.62,4.62,0,0,1,2.64-1.09l2.66-.32c3.53-.44,6.93-.88,10.17-1.22s6.35-.6,9.26-.71c1.45,0,2.86-.07,4.21,0a5.91,5.91,0,0,1,2,.26,2.27,2.27,0,0,1,1.3,1.53,11.3,11.3,0,0,1,.35,1.81c.08.58.17,1.14.25,1.69l.45,3.11c.27,1.93.51,3.59.71,5s.32,2.38.42,3.15c0,.33.07.6.1.82a.86.86,0,0,1,0,.28,1.23,1.23,0,0,1-.07-.27l-.15-.82c-.13-.76-.31-1.81-.54-3.13s-.49-3-.81-5c-.15-1-.32-2-.49-3.1s-.3-2.3-.62-3.43a1.87,1.87,0,0,0-1.07-1.25,5.66,5.66,0,0,0-1.88-.21c-1.34,0-2.74,0-4.18.06-2.89.13-6,.4-9.22.76s-6.63.8-10.15,1.25l-2.67.33a3.92,3.92,0,0,0-2.32,1,3.8,3.8,0,0,0-1.25,2.19A11.5,11.5,0,0,0,271,217q.25,2.81.51,5.55a53.06,53.06,0,0,0,.63,5.34,8.83,8.83,0,0,0,2.11,4.52,8.15,8.15,0,0,0,4.27,2.13,24.16,24.16,0,0,0,4.69.4c1.54,0,3,0,4.48-.07a76.47,76.47,0,0,0,8-.75,59.93,59.93,0,0,0,6.51-1.26,5.56,5.56,0,0,0,3.85-2.78,6.28,6.28,0,0,0,.34-3.08C306.31,226.28,306.26,225.9,306.28,225.9Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M249.21,186.36s-1.24-17.15-4.61-13.27-25.82,32.79-30,41.28,2.4,14.82,2.4,14.82l33.54,28.58,7.33-7.94L230.59,220.2,253,197Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M220.05,220.4a56,56,0,0,1,5.72-.52,54.38,54.38,0,0,1,5.71.58,4.91,4.91,0,0,0-1.61-.56,17.67,17.67,0,0,0-4.1-.5,18.58,18.58,0,0,0-4.1.45A5.21,5.21,0,0,0,220.05,220.4Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M256.9,250.2c3-.7,11-9.37,13.81-11.1s8,0,8,0c-.16,3.32-2.31,1.73-4.16,2a12.76,12.76,0,0,0-4.32,2.16l3.55.43,6.93,3.18a4.08,4.08,0,0,1-2,3.17c-2,1.3-7.4-.68-7.4-.68l-3.08,1,3.24.58s4.31.72,5.39,1.73a1.39,1.39,0,0,1,.15,2l-6.47-1.59-3.85.72s-6.24,5.65-9.4,6.49-7.09-2.84-7.09-2.84Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M266.26,246.91a5.18,5.18,0,0,0,2.06-.37,10.08,10.08,0,0,1,2.16-.46,9.28,9.28,0,0,1,2.66.35,40.73,40.73,0,0,1,4.71,1.61,10.13,10.13,0,0,0,2,.69,8.94,8.94,0,0,0-1.84-1,29.06,29.06,0,0,0-4.73-1.76,9.24,9.24,0,0,0-2.81-.32,8.94,8.94,0,0,0-2.22.57C267,246.69,266.25,246.85,266.26,246.91Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M250.36,169.54s-2,.08-6.32,3.14-19.38,22.43-19.38,22.43L242.74,212l10.9-12.9s5.69-24.67,5.08-24.6S250.36,169.54,250.36,169.54Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M253.63,198.94a9.63,9.63,0,0,1-1.25,2.1c-.85,1.25-2.09,2.92-3.55,4.7s-2.87,3.3-3.93,4.37a9.82,9.82,0,0,1-1.82,1.63c-.12-.12,2.39-2.85,5.3-6.38S253.48,198.85,253.63,198.94Z",
    transform: "translate(-35.87 -47.47)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Stand"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 286.37,
    y: 167.25,
    width: 77.67,
    height: 52.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M391.9,260.91s0-.18,0-.5,0-.82,0-1.43c0-1.26,0-3.09-.05-5.43,0-4.71-.05-11.49-.1-19.85l.19.19-61.52.07c-.24.23.31-.32.25-.26h0v14c0,4.55,0,9,0,13.19l-.25-.25,44.1.12,12.79.07,3.43,0h.9a1.92,1.92,0,0,1,.31,0h-.28l-.87,0-3.38,0-12.73.07-44.27.12h-.25v-.25c0-4.23,0-8.64,0-13.19v-14h0l.27-.26,61.52.07h.19v.19c0,8.41-.08,15.22-.1,20,0,2.33,0,4.14-.05,5.4,0,.59,0,1.05,0,1.39S391.9,260.91,391.9,260.91Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "286.37 156.31 310.6 164.33 322.46 164.33 345.14 156.31 286.37 156.31"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 308.16,
    y: 164.33,
    width: 16.22,
    height: 2.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 340.24,
    y: 123.56,
    width: 35.83,
    height: 18.22,
    rx: 2.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 344.46,
    y: 126.97,
    width: 27.58,
    height: 11.2,
    rx: 1.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 355.11,
    y: 141.78,
    width: 5.09,
    height: 25.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M395.29,222.55a1.76,1.76,0,1,1-1.76-1.73A1.74,1.74,0,0,1,395.29,222.55Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M330.6,222.44a1.76,1.76,0,1,1-1.76-1.72A1.74,1.74,0,0,1,330.6,222.44Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M400,228.72c0,.2-17.39.36-38.85.36s-38.86-.16-38.86-.36,17.39-.36,38.86-.36S400,228.52,400,228.72Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M400,214.72c0,.2-17.39.37-38.85.37s-38.86-.17-38.86-.37,17.39-.36,38.86-.36S400,214.52,400,214.72Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 283.53,
    y: 153.04,
    width: 63.22,
    height: 3.27
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.4,203.78h62.83c-.27,0-20.75,2.75-32.77,1.95C340.31,205.11,319.4,203.78,319.4,203.78Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M165.38,469.32V376.54s381.16,1.81,381.16,0-.31,92.78-.31,92.78Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "116.45 320.64 119.69 335.02 531.21 335.02 531.21 320.4 116.45 320.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M152.32,368.11S186.49,266,187.57,266.31s348.57,0,348.57,0l30.94,101.56Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M167.38,360.52l27.49-84.68,74.95-.3c-.37.37-10.72,85.23-11,85S167.38,360.52,167.38,360.52Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M194.79,275.54c-.53.92-3.39,10.82-3.39,10.82l76.54,1,1.88-11.85Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "233.95 313.05 241.48 228.07 320.09 228.07 323.83 313.05 233.95 313.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "241.48 228.07 240.56 238.42 320.55 238.43 320.09 228.07 241.48 228.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M363.1,275.55c-.25-.24,3.19,84,3.19,84H457l-15-84Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M452.15,275.55c-.25-.24,14.07,84,14.07,84h90.66l-25.15-84Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 131.51,
    y: 312.09,
    width: 391.2,
    height: 13.69
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M564.73,382.5c0,.15-91.53.27-204.42.27s-204.43-.12-204.43-.27,91.51-.28,204.43-.28S564.73,382.35,564.73,382.5Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M566.86,368c0,.15-92.8.29-207.26.31s-207.28-.09-207.28-.24,92.79-.29,207.28-.31S566.86,367.89,566.86,368Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 129.51,
    y: 335.02,
    width: 381.16,
    height: 7.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M265,286.17a9.42,9.42,0,0,0-12.56-12.36,7.68,7.68,0,0,0-10.54-.09,6.72,6.72,0,0,0-9.38,5.57l12.37,10Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265,286.17a9.42,9.42,0,0,0-12.56-12.36,7.68,7.68,0,0,0-10.54-.09,6.72,6.72,0,0,0-9.38,5.57l12.37,10Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M243.38,278.84a37.24,37.24,0,0,0,3.83-1.6s1.82-3,1.16-5a16.25,16.25,0,0,0-2.57-4.21s.47-3.2,3.11-2.53c0,0,4.17,4.65,3.55,8.05s-1.16,5.32-1.16,5.32l2.75,2.12-2.75,2.76-4.92-.82-3.48-1.2Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M260.25,277.18s-5.4-.89-7.85,2.48c0,0-5-2.12-8.58-.23a8.35,8.35,0,0,0-5.24-2.81c-3.21-.39-7.39.53-7.52,7.9-.21,12,1.53,22.21,10.27,24.36,0,0,4.15,1.28,5.47-1.69,0,0,.9,2.39,4.62,2.77s7-2.62,10.8-10.38S270.21,278.35,260.25,277.18Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M247.34,277.63a6,6,0,0,1-.68-.77,11.36,11.36,0,0,0-1.78-1.7,10.3,10.3,0,0,0-3.14-1.47,3.29,3.29,0,0,1,1,.17A6.85,6.85,0,0,1,245,275a8.9,8.9,0,0,1,1.77,1.78A3.71,3.71,0,0,1,247.34,277.63Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M253.5,280.88l.23.18a5.21,5.21,0,0,1,.6.62,7.45,7.45,0,0,1,1.39,2.81,10.76,10.76,0,0,1,.09,4.66,29.56,29.56,0,0,1-1.71,5.45,49.57,49.57,0,0,1-4.85,9.16c-.74,1.1-1.39,2-1.85,2.54l-.54.66c-.12.15-.19.23-.2.22a2.48,2.48,0,0,1,.17-.25l.5-.68c.44-.6,1.06-1.47,1.79-2.58a53.46,53.46,0,0,0,4.77-9.15,30.49,30.49,0,0,0,1.71-5.41,10.78,10.78,0,0,0,0-4.58,7.72,7.72,0,0,0-1.31-2.79C253.8,281.16,253.48,280.9,253.5,280.88Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.18,295a37.36,37.36,0,0,1-5.15,2.35,7,7,0,0,1-2.37.53,2.68,2.68,0,0,1-2.16-.94c-.74-1-.49-2.32-.21-3.5-2.91,3.46-6.56,8.22-11,8.91-4.07.63-8.85-2.74-11.43-5.88,1.18,6.33,3.91,11,9.5,12.38,0,0,4.15,1.28,5.47-1.69,0,0,.9,2.39,4.62,2.77s7-2.62,10.8-10.38C262.89,298.21,263.56,296.66,264.18,295Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M249.54,281.12a5.23,5.23,0,0,0-2.18-.31,25.29,25.29,0,0,0-5.31,1.16,8.26,8.26,0,0,0-4.22,3.28,3.17,3.17,0,0,0-.55,1.83,1.75,1.75,0,0,0,1,1.55,2.79,2.79,0,0,0,2.17-.39l8.6-4.16c.52-.25,1.08-.56,1.23-1.11A1.68,1.68,0,0,0,249.54,281.12Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M239.07,280.19a2,2,0,0,0-1.06-1.26,4,4,0,0,0-1.22-.35,4.9,4.9,0,0,0-1.53.25,1.93,1.93,0,0,0-1.14,1.08,1.73,1.73,0,0,0,.4,1.66,2.86,2.86,0,0,0,1.56.82,2.92,2.92,0,0,0,2.13-.32A1.84,1.84,0,0,0,239.07,280.19Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M236.37,278.53l.42.05h.06Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M260.25,321.62a9.43,9.43,0,0,0-11.9-13,7.69,7.69,0,0,0-10.52-.63,6.71,6.71,0,0,0-9.66,5.07L240,323.68Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.25,321.62a9.43,9.43,0,0,0-11.9-13,7.69,7.69,0,0,0-10.52-.63,6.71,6.71,0,0,0-9.66,5.07L240,323.68Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M239,313.17a38,38,0,0,0,3.91-1.41s2-2.93,1.42-4.9a16.49,16.49,0,0,0-2.36-4.35s.64-3.16,3.25-2.36c0,0,3.92,4.86,3.12,8.22s-1.44,5.26-1.44,5.26l2.64,2.25-2.89,2.62-4.87-1.07-3.41-1.38Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M255.94,312.38s-5.35-1.17-8,2.08c0,0-4.85-2.38-8.56-.68a8.37,8.37,0,0,0-5.09-3.08c-3.18-.55-7.41.15-7.92,7.5-.83,12,.37,22.26,9,24.86,0,0,4.09,1.49,5.56-1.41,0,0,.78,2.44,4.47,3s7.17-2.25,11.33-9.8S265.83,314.07,255.94,312.38Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M255.94,312.38s-5.35-1.17-8,2.08c0,0-4.85-2.38-8.56-.68a8.37,8.37,0,0,0-5.09-3.08c-3.18-.55-7.41.15-7.92,7.5-.83,12,.37,22.26,9,24.86,0,0,4.09,1.49,5.56-1.41,0,0,.78,2.44,4.47,3s7.17-2.25,11.33-9.8S265.83,314.07,255.94,312.38Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M243,312.16a5.78,5.78,0,0,1-.65-.8,11.21,11.21,0,0,0-1.69-1.79,10.3,10.3,0,0,0-3.05-1.63,3.3,3.3,0,0,1,1,.22,7,7,0,0,1,2.19,1.23,9.25,9.25,0,0,1,1.67,1.87A4.13,4.13,0,0,1,243,312.16Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M249,315.73s.09.06.23.2a5.22,5.22,0,0,1,.56.64,7.42,7.42,0,0,1,1.25,2.89,10.61,10.61,0,0,1-.16,4.65,28.7,28.7,0,0,1-2,5.36,49.68,49.68,0,0,1-5.31,8.89c-.8,1.06-1.5,1.88-2,2.44l-.57.63c-.14.15-.21.22-.22.21l.18-.24.54-.66c.46-.57,1.13-1.41,1.92-2.48a53.24,53.24,0,0,0,5.24-8.89,30.86,30.86,0,0,0,2-5.31,10.61,10.61,0,0,0,.2-4.57,7.77,7.77,0,0,0-1.16-2.87A11.14,11.14,0,0,0,249,315.73Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.93,330.41a36.23,36.23,0,0,1-5.26,2.09,7.29,7.29,0,0,1-2.4.41,2.73,2.73,0,0,1-2.1-1.06c-.69-1-.37-2.34,0-3.5-3.1,3.3-7,7.87-11.49,8.32-4.1.42-8.69-3.19-11.1-6.47.85,6.39,3.32,11.2,8.83,12.86,0,0,4.09,1.49,5.56-1.41,0,0,.78,2.44,4.47,3s7.17-2.25,11.33-9.8C257.48,333.52,258.24,332,258.93,330.41Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M245,315.77a5,5,0,0,0-2.16-.42,24.2,24.2,0,0,0-5.36.88,8.17,8.17,0,0,0-4.39,3,3.28,3.28,0,0,0-.64,1.8,1.73,1.73,0,0,0,.92,1.6,2.8,2.8,0,0,0,2.19-.28l8.8-3.71c.53-.22,1.11-.5,1.28-1A1.68,1.68,0,0,0,245,315.77Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M234.63,314.29a1.93,1.93,0,0,0-1-1.31,3.65,3.65,0,0,0-1.2-.42,5,5,0,0,0-1.54.18,1.9,1.9,0,0,0-1.19,1,1.72,1.72,0,0,0,.31,1.67,2.77,2.77,0,0,0,1.51.9,2.93,2.93,0,0,0,2.14-.2A1.85,1.85,0,0,0,234.63,314.29Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M232,312.5l.42.06h.06Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M215.36,306.4a9.43,9.43,0,0,0,9.71-14.71,7.68,7.68,0,0,0-1.94-10.36,6.72,6.72,0,0,0-7.28-8.13l-7.42,14.07Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.36,306.4a9.43,9.43,0,0,0,9.71-14.71,7.68,7.68,0,0,0-1.94-10.36,6.72,6.72,0,0,0-7.28-8.13l-7.42,14.07Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M218.38,283.75a38.68,38.68,0,0,0,2.31,3.44s3.33,1.2,5.11.19a16.44,16.44,0,0,0,3.64-3.34s3.22-.16,3.08,2.57c0,0-3.76,5-7.21,5s-5.45-.12-5.45-.12l-1.55,3.11-3.24-2.17-.15-5,.51-3.64Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M223.26,300s-.16-5.47-3.95-7.22c0,0,1.13-5.28-1.42-8.47a8.37,8.37,0,0,0,1.74-5.68c-.23-3.23-1.94-7.15-9.2-5.86-11.82,2.11-21.5,5.78-21.92,14.76,0,0-.45,4.33,2.71,5.05,0,0-2.17,1.35-1.82,5.07s3.92,6.4,12.26,8.6S224,310,223.26,300Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M220.34,287.4a4.88,4.88,0,0,1,.62-.82,11.08,11.08,0,0,0,1.32-2.08,10.42,10.42,0,0,0,.84-3.36,3.24,3.24,0,0,1,0,1,6.74,6.74,0,0,1-.66,2.42,9.1,9.1,0,0,1-1.41,2.08A3.86,3.86,0,0,1,220.34,287.4Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M218.33,294.06a1,1,0,0,1-.14.27,4.39,4.39,0,0,1-.49.7,7.23,7.23,0,0,1-2.49,1.91,10.48,10.48,0,0,1-4.55,1,29.15,29.15,0,0,1-5.68-.62,48.93,48.93,0,0,1-9.92-3c-1.22-.51-2.19-1-2.85-1.32l-.75-.4-.26-.15a1.09,1.09,0,0,1,.28.11l.77.36c.67.31,1.65.76,2.87,1.25a51.87,51.87,0,0,0,9.9,2.92,29.72,29.72,0,0,0,5.63.64,10.67,10.67,0,0,0,4.49-.91,7.71,7.71,0,0,0,2.5-1.83C218.12,294.42,218.31,294.05,218.33,294.06Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.51,307.27a36.46,36.46,0,0,1-3.31-4.6,7.21,7.21,0,0,1-1-2.22,2.74,2.74,0,0,1,.51-2.31c.8-.9,2.19-.92,3.4-.87-4-2.2-9.34-4.86-10.87-9.11-1.41-3.87,1-9.21,3.57-12.35-6,2.38-10.05,6-10.32,11.7,0,0-.45,4.33,2.71,5.05,0,0-2.17,1.35-1.82,5.07s3.92,6.4,12.26,8.6C203.13,306.61,204.79,307,206.51,307.27Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M217.33,290.22a5.06,5.06,0,0,0-.12-2.19,24.52,24.52,0,0,0-2.16-5,8.27,8.27,0,0,0-4-3.51,3.3,3.3,0,0,0-1.91-.19,1.74,1.74,0,0,0-1.32,1.28,2.81,2.81,0,0,0,.79,2.06l5.75,7.64a2,2,0,0,0,1.32,1A1.68,1.68,0,0,0,217.33,290.22Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M216.23,279.77a2,2,0,0,0,1-1.28,3.86,3.86,0,0,0,.11-1.27,5,5,0,0,0-.55-1.45,1.88,1.88,0,0,0-1.27-.9,1.71,1.71,0,0,0-1.55.71,2.83,2.83,0,0,0-.51,1.68,3,3,0,0,0,.72,2A1.86,1.86,0,0,0,216.23,279.77Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M217.33,276.8c0,.14,0,.28,0,.42v.06Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M222.3,319a9.43,9.43,0,0,0-12.24-12.68,7.71,7.71,0,0,0-10.54-.35,6.72,6.72,0,0,0-9.52,5.33l12.12,10.31Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.3,319a9.43,9.43,0,0,0-12.24-12.68,7.71,7.71,0,0,0-10.54-.35,6.72,6.72,0,0,0-9.52,5.33l12.12,10.31Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M200.85,311.08a38.5,38.5,0,0,0,3.86-1.51s1.9-3,1.29-4.94a16,16,0,0,0-2.47-4.28s.55-3.18,3.18-2.45c0,0,4,4.75,3.35,8.14s-1.3,5.28-1.3,5.28l2.7,2.19-2.82,2.69-4.9-.93L200.3,314Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M217.75,309.84s-5.38-1-7.91,2.29c0,0-4.9-2.25-8.57-.46a8.38,8.38,0,0,0-5.17-2.93c-3.2-.47-7.4.34-7.72,7.7-.51,12,1,22.25,9.65,24.62,0,0,4.12,1.38,5.52-1.56,0,0,.84,2.42,4.54,2.89s7.11-2.44,11.07-10.1S227.68,311.26,217.75,309.84Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M204.83,310a6.94,6.94,0,0,1-.66-.78,11.34,11.34,0,0,0-1.74-1.75,10.27,10.27,0,0,0-3.1-1.54,3.31,3.31,0,0,1,1,.19,7.09,7.09,0,0,1,2.23,1.17,9.69,9.69,0,0,1,1.72,1.83A3.47,3.47,0,0,1,204.83,310Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M210.9,313.37s.09.06.24.19a6.85,6.85,0,0,1,.58.63A7.58,7.58,0,0,1,213,317a10.61,10.61,0,0,1,0,4.66,30.17,30.17,0,0,1-1.85,5.41,48.91,48.91,0,0,1-5.08,9c-.77,1.08-1.44,1.92-1.91,2.49-.23.29-.42.5-.55.65s-.2.22-.21.21a1.54,1.54,0,0,1,.17-.24l.52-.68c.45-.58,1.1-1.44,1.85-2.53a52.67,52.67,0,0,0,5-9,30.27,30.27,0,0,0,1.85-5.36,10.63,10.63,0,0,0,.08-4.58,7.54,7.54,0,0,0-1.24-2.83C211.2,313.66,210.89,313.39,210.9,313.37Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.23,327.78A35.66,35.66,0,0,1,216,330a7,7,0,0,1-2.39.47,2.7,2.7,0,0,1-2.13-1c-.71-1-.43-2.33-.12-3.5-3,3.38-6.77,8-11.25,8.63-4.09.53-8.77-3-11.28-6.17,1,6.36,3.63,11.1,9.18,12.62,0,0,4.12,1.38,5.52-1.56,0,0,.84,2.42,4.54,2.89s7.11-2.44,11.07-10.1C219.85,330.93,220.57,329.4,221.23,327.78Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M206.94,313.51a5.18,5.18,0,0,0-2.16-.36,24.59,24.59,0,0,0-5.34,1,8.35,8.35,0,0,0-4.31,3.17,3.35,3.35,0,0,0-.6,1.82,1.75,1.75,0,0,0,1,1.57,2.79,2.79,0,0,0,2.18-.33l8.7-3.95a2.05,2.05,0,0,0,1.26-1.07A1.7,1.7,0,0,0,206.94,313.51Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M196.5,312.32a2,2,0,0,0-1-1.29,3.88,3.88,0,0,0-1.21-.38,4.61,4.61,0,0,0-1.53.22,1.89,1.89,0,0,0-1.17,1,1.73,1.73,0,0,0,.36,1.67,2.83,2.83,0,0,0,1.53.86,2.93,2.93,0,0,0,2.14-.26A1.86,1.86,0,0,0,196.5,312.32Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M193.84,310.59l.42.06h.06Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M227.74,347.56a9.43,9.43,0,0,0,12.89,12,7.68,7.68,0,0,0,10.54-.19,6.71,6.71,0,0,0,9.23-5.81l-12.63-9.67Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.74,347.56a9.43,9.43,0,0,0,12.89,12,7.68,7.68,0,0,0,10.54-.19,6.71,6.71,0,0,0,9.23-5.81l-12.63-9.67Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M249.58,354.32A37.74,37.74,0,0,0,245.8,356s-1.74,3.07-1,5a16.4,16.4,0,0,0,2.69,4.15s-.39,3.2-3,2.61c0,0-4.29-4.54-3.76-8s1-5.35,1-5.35l-2.8-2,2.68-2.83,4.93.68L250,351.4Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M232.76,356.43s5.42.75,7.78-2.69c0,0,5,2,8.58,0a8.41,8.41,0,0,0,5.32,2.66c3.22.31,7.37-.72,7.31-8.09-.11-12-2.11-22.16-10.9-24.08,0,0-4.19-1.17-5.43,1.83,0,0-1-2.36-4.69-2.64s-7,2.8-10.53,10.66S222.77,355.52,232.76,356.43Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M245.65,355.64a6.07,6.07,0,0,1,.71.75,11.37,11.37,0,0,0,1.82,1.65,10,10,0,0,0,3.18,1.38,2.82,2.82,0,0,1-1-.13,7.11,7.11,0,0,1-2.28-1.06,8.93,8.93,0,0,1-1.81-1.73A3.86,3.86,0,0,1,245.65,355.64Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M239.42,352.55s-.09-.06-.24-.18a4.64,4.64,0,0,1-.62-.6A7.46,7.46,0,0,1,237.1,349a10.55,10.55,0,0,1-.21-4.65,29.17,29.17,0,0,1,1.56-5.49,49.27,49.27,0,0,1,4.61-9.28c.71-1.12,1.34-2,1.78-2.59.22-.3.4-.53.52-.68s.19-.23.2-.22-.05.09-.16.25l-.49.7c-.42.61-1,1.5-1.71,2.62a52.91,52.91,0,0,0-4.53,9.28,29.23,29.23,0,0,0-1.57,5.44,10.61,10.61,0,0,0,.15,4.58,7.64,7.64,0,0,0,1.38,2.76C239.1,352.28,239.43,352.53,239.42,352.55Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.37,338.69a35.66,35.66,0,0,1,5.08-2.49,7,7,0,0,1,2.36-.6,2.72,2.72,0,0,1,2.18.89c.77.94.55,2.31.3,3.49,2.82-3.53,6.35-8.39,10.8-9.2,4-.73,8.91,2.51,11.57,5.59-1.35-6.3-4.19-10.9-9.81-12.13,0,0-4.19-1.17-5.43,1.83,0,0-1-2.36-4.69-2.64s-7,2.8-10.53,10.66C229.57,335.47,228.94,337,228.37,338.69Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M243.37,352.2a5,5,0,0,0,2.18.25,24.39,24.39,0,0,0,5.28-1.29,8.23,8.23,0,0,0,4.13-3.39,3.3,3.3,0,0,0,.51-1.85,1.74,1.74,0,0,0-1.05-1.51,2.75,2.75,0,0,0-2.16.44l-8.49,4.39c-.5.26-1.06.58-1.19,1.14A1.65,1.65,0,0,0,243.37,352.2Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M253.85,352.86a2,2,0,0,0,1.1,1.23,3.66,3.66,0,0,0,1.23.32,4.89,4.89,0,0,0,1.52-.3,1.88,1.88,0,0,0,1.11-1.1,1.77,1.77,0,0,0-.44-1.65,2.81,2.81,0,0,0-1.58-.77,2.85,2.85,0,0,0-2.12.37A1.85,1.85,0,0,0,253.85,352.86Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M256.6,354.45l-.42,0h-.06Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M236.73,345.75a9.43,9.43,0,0,0-10.84-13.9,7.68,7.68,0,0,0-10.44-1.47,6.71,6.71,0,0,0-10,4.3l11,11.53Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.73,345.75a9.43,9.43,0,0,0-10.84-13.9,7.68,7.68,0,0,0-10.44-1.47,6.71,6.71,0,0,0-10,4.3l11,11.53Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M216.23,335.65a36.27,36.27,0,0,0,4-1.09s2.2-2.77,1.8-4.78a16.14,16.14,0,0,0-2-4.52s.88-3.1,3.42-2.1c0,0,3.53,5.16,2.47,8.45s-1.85,5.12-1.85,5.12l2.45,2.46-3.09,2.38-4.77-1.45-3.29-1.65Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M233.17,336.2s-5.24-1.59-8.11,1.44c0,0-4.64-2.75-8.47-1.35a8.39,8.39,0,0,0-4.84-3.47c-3.13-.8-7.39-.44-8.48,6.85-1.78,11.88-1.38,22.22,7,25.5,0,0,3.95,1.8,5.64-1,0,0,.59,2.49,4.22,3.35s7.33-1.68,12.07-8.88S242.89,338.66,233.17,336.2Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M233.17,336.2s-5.24-1.59-8.11,1.44c0,0-4.64-2.75-8.47-1.35a8.39,8.39,0,0,0-4.84-3.47c-3.13-.8-7.39-.44-8.48,6.85-1.78,11.88-1.38,22.22,7,25.5,0,0,3.95,1.8,5.64-1,0,0,.59,2.49,4.22,3.35s7.33-1.68,12.07-8.88S242.89,338.66,233.17,336.2Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M220.31,335a6.09,6.09,0,0,1-.58-.85,12.26,12.26,0,0,0-1.54-1.92,10.59,10.59,0,0,0-2.92-1.86,3.22,3.22,0,0,1,1,.3,6.92,6.92,0,0,1,2.09,1.4,9.57,9.57,0,0,1,1.52,2A4.32,4.32,0,0,1,220.31,335Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M226,339l.21.21a7.79,7.79,0,0,1,.51.69,7.34,7.34,0,0,1,1,3,10.58,10.58,0,0,1-.52,4.62,29.18,29.18,0,0,1-2.41,5.19,49,49,0,0,1-6,8.44c-.88,1-1.63,1.76-2.16,2.28L216,364l-.23.19s.06-.08.2-.23l.59-.61c.5-.54,1.24-1.32,2.1-2.33a51.68,51.68,0,0,0,5.92-8.45,30.13,30.13,0,0,0,2.41-5.13,10.61,10.61,0,0,0,.56-4.54,7.63,7.63,0,0,0-.93-2.95C226.25,339.31,226,339,226,339Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.73,354.41a35.55,35.55,0,0,1-5.41,1.66,6.87,6.87,0,0,1-2.42.22,2.69,2.69,0,0,1-2-1.22c-.61-1-.18-2.36.25-3.49-3.34,3.05-7.58,7.29-12.1,7.4-4.12.09-8.41-3.88-10.56-7.33.35,6.43,2.43,11.42,7.8,13.52,0,0,3.95,1.8,5.64-1,0,0,.59,2.49,4.22,3.35s7.33-1.68,12.07-8.88C233,357.4,233.91,356,234.73,354.41Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M222,338.71a5.2,5.2,0,0,0-2.12-.58,23.93,23.93,0,0,0-5.41.45,8.21,8.21,0,0,0-4.62,2.7,3.29,3.29,0,0,0-.78,1.74,1.75,1.75,0,0,0,.79,1.67,2.78,2.78,0,0,0,2.2-.1l9.07-3c.54-.18,1.15-.41,1.36-.94A1.69,1.69,0,0,0,222,338.71Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M211.77,336.42a2,2,0,0,0-.88-1.38,3.82,3.82,0,0,0-1.17-.51,5,5,0,0,0-1.55.05,1.9,1.9,0,0,0-1.26.92,1.73,1.73,0,0,0,.17,1.7,2.8,2.8,0,0,0,1.44,1,2.9,2.9,0,0,0,2.15,0A1.84,1.84,0,0,0,211.77,336.42Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M209.31,334.43l.41.1h.06Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M209.33,344.61a9.43,9.43,0,0,0-10.84-13.9,7.69,7.69,0,0,0-10.44-1.46,6.71,6.71,0,0,0-10,4.3l11,11.53Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.33,344.61a9.43,9.43,0,0,0-10.84-13.9,7.69,7.69,0,0,0-10.44-1.46,6.71,6.71,0,0,0-10,4.3l11,11.53Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M188.83,334.52a38.62,38.62,0,0,0,4-1.09s2.2-2.77,1.8-4.78a16.14,16.14,0,0,0-2-4.52s.88-3.1,3.42-2.1c0,0,3.53,5.16,2.47,8.45s-1.85,5.12-1.85,5.12l2.45,2.46L196,340.44,191.26,339,188,337.34Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M205.77,335.07s-5.24-1.59-8.11,1.44c0,0-4.64-2.75-8.47-1.35a8.39,8.39,0,0,0-4.84-3.47c-3.13-.8-7.39-.44-8.48,6.85-1.78,11.88-1.38,22.22,7,25.5,0,0,3.95,1.8,5.64-1,0,0,.59,2.49,4.22,3.35s7.33-1.68,12.07-8.88S215.49,337.53,205.77,335.07Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M192.91,333.83a6.09,6.09,0,0,1-.58-.85,12.26,12.26,0,0,0-1.54-1.92,10.59,10.59,0,0,0-2.92-1.86,3.22,3.22,0,0,1,1,.3,6.92,6.92,0,0,1,2.09,1.4,9.57,9.57,0,0,1,1.52,2A4.32,4.32,0,0,1,192.91,333.83Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M198.59,337.86l.21.21a7.79,7.79,0,0,1,.51.69,7.34,7.34,0,0,1,1,3,10.58,10.58,0,0,1-.52,4.62,29.18,29.18,0,0,1-2.41,5.19,49,49,0,0,1-6,8.44c-.88,1-1.63,1.76-2.16,2.28l-.62.59-.23.19s.06-.09.2-.23l.59-.61c.5-.54,1.24-1.32,2.1-2.33a51.68,51.68,0,0,0,5.92-8.45,29.38,29.38,0,0,0,2.41-5.13,10.64,10.64,0,0,0,.56-4.55,7.63,7.63,0,0,0-.93-2.94C198.85,338.17,198.57,337.88,198.59,337.86Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.33,353.28a36.72,36.72,0,0,1-5.41,1.66,6.87,6.87,0,0,1-2.42.22,2.69,2.69,0,0,1-2-1.22c-.61-1-.18-2.36.25-3.49-3.34,3-7.58,7.29-12.1,7.39-4.12.1-8.41-3.87-10.56-7.32.35,6.43,2.43,11.42,7.8,13.52,0,0,3.95,1.8,5.64-1,0,0,.59,2.49,4.22,3.35s7.33-1.68,12.07-8.88C205.64,356.27,206.51,354.82,207.33,353.28Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M194.63,337.58a5,5,0,0,0-2.12-.58,23.93,23.93,0,0,0-5.41.45,8.25,8.25,0,0,0-4.62,2.69,3.35,3.35,0,0,0-.78,1.75,1.75,1.75,0,0,0,.79,1.67,2.82,2.82,0,0,0,2.2-.1l9.07-3c.54-.18,1.15-.41,1.36-.94A1.69,1.69,0,0,0,194.63,337.58Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M184.37,335.29a2,2,0,0,0-.88-1.38,3.59,3.59,0,0,0-1.17-.51,5,5,0,0,0-1.55.05,1.9,1.9,0,0,0-1.26.92,1.73,1.73,0,0,0,.17,1.7,2.84,2.84,0,0,0,1.44,1,2.9,2.9,0,0,0,2.15,0A1.84,1.84,0,0,0,184.37,335.29Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M181.91,333.3l.41.1h.06Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 131.78,
    y: 312.09,
    width: 90.7,
    height: 8.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M342.49,290a5.94,5.94,0,0,1,6.46,1.1,7.45,7.45,0,0,1,2.15,6.37,10.12,10.12,0,0,1-3.26,6,11.61,11.61,0,0,1-9.52,3,10.23,10.23,0,0,1-7.79-6.07,9.13,9.13,0,0,1,1.79-9.6,8.38,8.38,0,0,1,8.07-2.17,4.27,4.27,0,0,1,2.1,1.36Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M342.49,290l-.12-.12a3.71,3.71,0,0,0-.34-.33,4.23,4.23,0,0,0-1.6-.86,8.08,8.08,0,0,0-2.86-.25A8.52,8.52,0,0,0,334,289.6a7.93,7.93,0,0,0-3.07,3.38,9.18,9.18,0,0,0-.84,5.17,8.51,8.51,0,0,0,.8,2.74,9.44,9.44,0,0,0,1.71,2.44,10.14,10.14,0,0,0,2.45,1.89,10,10,0,0,0,3,1.09,10.32,10.32,0,0,0,3.18.12,11.29,11.29,0,0,0,3-.77,11.71,11.71,0,0,0,4.69-3.43,9.68,9.68,0,0,0,2.15-4.79,7.83,7.83,0,0,0-.77-4.5,6.15,6.15,0,0,0-2.61-2.7,6.06,6.06,0,0,0-2.76-.73,5.23,5.23,0,0,0-1.8.26c-.4.12-.6.23-.6.22l.14-.08a3.8,3.8,0,0,1,.44-.18,5.44,5.44,0,0,1,1.82-.3,6.27,6.27,0,0,1,5.49,3.45,8,8,0,0,1,.8,4.58,9.75,9.75,0,0,1-2.17,4.87,11.73,11.73,0,0,1-4.75,3.5,11.59,11.59,0,0,1-3.05.78,10.44,10.44,0,0,1-6.29-1.23,10.28,10.28,0,0,1-2.49-1.92,9.56,9.56,0,0,1-1.74-2.49,9,9,0,0,1-.81-2.8,9.41,9.41,0,0,1,.87-5.26,8.06,8.06,0,0,1,3.14-3.42,8.6,8.6,0,0,1,3.67-1.16,7.94,7.94,0,0,1,2.89.28,4.18,4.18,0,0,1,1.6.9A3.32,3.32,0,0,1,342.49,290Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.49,290l-.12-.12a3.71,3.71,0,0,0-.34-.33,4.23,4.23,0,0,0-1.6-.86,8.08,8.08,0,0,0-2.86-.25A8.52,8.52,0,0,0,334,289.6a7.93,7.93,0,0,0-3.07,3.38,9.18,9.18,0,0,0-.84,5.17,8.51,8.51,0,0,0,.8,2.74,9.44,9.44,0,0,0,1.71,2.44,10.14,10.14,0,0,0,2.45,1.89,10,10,0,0,0,3,1.09,10.32,10.32,0,0,0,3.18.12,11.29,11.29,0,0,0,3-.77,11.71,11.71,0,0,0,4.69-3.43,9.68,9.68,0,0,0,2.15-4.79,7.83,7.83,0,0,0-.77-4.5,6.15,6.15,0,0,0-2.61-2.7,6.06,6.06,0,0,0-2.76-.73,5.23,5.23,0,0,0-1.8.26c-.4.12-.6.23-.6.22l.14-.08a3.8,3.8,0,0,1,.44-.18,5.44,5.44,0,0,1,1.82-.3,6.27,6.27,0,0,1,5.49,3.45,8,8,0,0,1,.8,4.58,9.75,9.75,0,0,1-2.17,4.87,11.73,11.73,0,0,1-4.75,3.5,11.59,11.59,0,0,1-3.05.78,10.44,10.44,0,0,1-6.29-1.23,10.28,10.28,0,0,1-2.49-1.92,9.56,9.56,0,0,1-1.74-2.49,9,9,0,0,1-.81-2.8,9.41,9.41,0,0,1,.87-5.26,8.06,8.06,0,0,1,3.14-3.42,8.6,8.6,0,0,1,3.67-1.16,7.94,7.94,0,0,1,2.89.28,4.18,4.18,0,0,1,1.6.9A3.32,3.32,0,0,1,342.49,290Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M338.09,291a2.08,2.08,0,0,0-2-.78,6.79,6.79,0,0,0-3.68,2.21,5.5,5.5,0,0,0-1.4,3.71,4,4,0,0,0,2,3.35,3.16,3.16,0,0,0,3.74-.53c.95-1.05,1-2.61,1.29-4,.16-.67.41-1.31.51-2A2.73,2.73,0,0,0,338.09,291Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M347.3,290.57a.86.86,0,0,0-.38-.13,34.14,34.14,0,0,0-4.28-.46s2.06-2.24-.49-5.36l-1.46.38c2.1,3.26,1.19,4.71,1.19,4.71-1.78-1.89-5.06-3.23-5-2.66s3.79,3.49,3.79,3.49a9,9,0,0,0-4,2.2,10.91,10.91,0,0,0,4.82-1.42,3,3,0,0,0,.23,2,8.8,8.8,0,0,0,1.1,1.74c.16.22.43.46.66.32s.17-.42.11-.65c-.29-1.15-.58-2.31-.88-3.46a12.89,12.89,0,0,0,4.38-.22.45.45,0,0,0,.25-.12A.29.29,0,0,0,347.3,290.57Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M333.32,301.91l-.12-.1c-.08-.08-.2-.18-.33-.33a6.75,6.75,0,0,1-1-1.38,7.59,7.59,0,0,1-.68-5.45,7.44,7.44,0,0,1,1.41-2.73,7.66,7.66,0,0,1,1.88-1.67,6.71,6.71,0,0,1,1.53-.71,2.81,2.81,0,0,1,.45-.12l.15,0a9.41,9.41,0,0,0-2.06,1,8.09,8.09,0,0,0-1.82,1.66,7.45,7.45,0,0,0-1.36,2.68,7.29,7.29,0,0,0-.14,3A7.83,7.83,0,0,0,332,300,9.77,9.77,0,0,0,333.32,301.91Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M335.22,312a5.94,5.94,0,0,1,6.47,1.1,7.47,7.47,0,0,1,2.14,6.37,10.06,10.06,0,0,1-3.26,6,11.62,11.62,0,0,1-9.52,3,10.22,10.22,0,0,1-7.79-6.08,9.16,9.16,0,0,1,1.79-9.59,8.4,8.4,0,0,1,8.08-2.17,4.29,4.29,0,0,1,2.09,1.36Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M335.22,312l-.11-.12c-.08-.08-.19-.19-.35-.33a4.25,4.25,0,0,0-1.59-.86,7.93,7.93,0,0,0-2.87-.25,8.52,8.52,0,0,0-3.61,1.17,8,8,0,0,0-3.07,3.37,9.31,9.31,0,0,0-.84,5.18,8.85,8.85,0,0,0,.8,2.74,9.44,9.44,0,0,0,1.71,2.44,10,10,0,0,0,2.46,1.89,9.86,9.86,0,0,0,3,1.09,10.37,10.37,0,0,0,3.19.12,11.22,11.22,0,0,0,3-.77,11.57,11.57,0,0,0,4.69-3.43,9.59,9.59,0,0,0,2.15-4.79,7.83,7.83,0,0,0-.76-4.5,6.21,6.21,0,0,0-2.61-2.7,6.13,6.13,0,0,0-2.77-.73,5.36,5.36,0,0,0-1.8.25c-.4.13-.59.24-.6.23l.15-.08a3.16,3.16,0,0,1,.44-.18,5.38,5.38,0,0,1,1.81-.3,6.19,6.19,0,0,1,5.49,3.45,7.83,7.83,0,0,1,.8,4.57,9.73,9.73,0,0,1-2.16,4.88,11.84,11.84,0,0,1-4.76,3.5,11.59,11.59,0,0,1-3.05.78,10.4,10.4,0,0,1-3.24-.12,10,10,0,0,1-3-1.11,10.33,10.33,0,0,1-2.5-1.92,9.81,9.81,0,0,1-1.74-2.49,9.22,9.22,0,0,1-.81-2.8,9.47,9.47,0,0,1,.87-5.26,8.06,8.06,0,0,1,3.14-3.42,8.68,8.68,0,0,1,3.67-1.16,8,8,0,0,1,2.9.28,4.07,4.07,0,0,1,1.59.9A2.68,2.68,0,0,1,335.22,312Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.22,312l-.11-.12c-.08-.08-.19-.19-.35-.33a4.25,4.25,0,0,0-1.59-.86,7.93,7.93,0,0,0-2.87-.25,8.52,8.52,0,0,0-3.61,1.17,8,8,0,0,0-3.07,3.37,9.31,9.31,0,0,0-.84,5.18,8.85,8.85,0,0,0,.8,2.74,9.44,9.44,0,0,0,1.71,2.44,10,10,0,0,0,2.46,1.89,9.86,9.86,0,0,0,3,1.09,10.37,10.37,0,0,0,3.19.12,11.22,11.22,0,0,0,3-.77,11.57,11.57,0,0,0,4.69-3.43,9.59,9.59,0,0,0,2.15-4.79,7.83,7.83,0,0,0-.76-4.5,6.21,6.21,0,0,0-2.61-2.7,6.13,6.13,0,0,0-2.77-.73,5.36,5.36,0,0,0-1.8.25c-.4.13-.59.24-.6.23l.15-.08a3.16,3.16,0,0,1,.44-.18,5.38,5.38,0,0,1,1.81-.3,6.19,6.19,0,0,1,5.49,3.45,7.83,7.83,0,0,1,.8,4.57,9.73,9.73,0,0,1-2.16,4.88,11.84,11.84,0,0,1-4.76,3.5,11.59,11.59,0,0,1-3.05.78,10.4,10.4,0,0,1-3.24-.12,10,10,0,0,1-3-1.11,10.33,10.33,0,0,1-2.5-1.92,9.81,9.81,0,0,1-1.74-2.49,9.22,9.22,0,0,1-.81-2.8,9.47,9.47,0,0,1,.87-5.26,8.06,8.06,0,0,1,3.14-3.42,8.68,8.68,0,0,1,3.67-1.16,8,8,0,0,1,2.9.28,4.07,4.07,0,0,1,1.59.9A2.68,2.68,0,0,1,335.22,312Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M330.82,312.93a2.11,2.11,0,0,0-2.05-.79,6.92,6.92,0,0,0-3.68,2.21,5.53,5.53,0,0,0-1.39,3.72,4,4,0,0,0,2,3.35,3.16,3.16,0,0,0,3.73-.53c1-1.05,1-2.61,1.3-4,.16-.67.4-1.32.5-2A2.69,2.69,0,0,0,330.82,312.93Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M340,312.55a.78.78,0,0,0-.38-.13,34.14,34.14,0,0,0-4.28-.46s2.07-2.24-.49-5.37l-1.45.39c2.09,3.26,1.19,4.71,1.19,4.71-1.78-1.89-5.07-3.23-5-2.66s3.79,3.49,3.79,3.49a9,9,0,0,0-4,2.2,10.88,10.88,0,0,0,4.82-1.42,3,3,0,0,0,.23,2,9.28,9.28,0,0,0,1.1,1.74c.16.22.43.46.67.32s.17-.42.11-.65c-.3-1.15-.59-2.31-.88-3.46a12.85,12.85,0,0,0,4.37-.22.4.4,0,0,0,.25-.12A.29.29,0,0,0,340,312.55Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M326.06,323.89l-.13-.1c-.07-.08-.19-.18-.32-.33a6.72,6.72,0,0,1-1-1.38,7.81,7.81,0,0,1-.81-2.38,7.13,7.13,0,0,1,1.54-5.8,7.66,7.66,0,0,1,1.88-1.67,6.56,6.56,0,0,1,1.54-.71,2.5,2.5,0,0,1,.44-.12c.1,0,.16,0,.16,0a9.34,9.34,0,0,0-2.07,1,8.3,8.3,0,0,0-1.82,1.66,7.45,7.45,0,0,0-1.36,2.68,7.28,7.28,0,0,0-.14,3,7.55,7.55,0,0,0,.76,2.35A9.77,9.77,0,0,0,326.06,323.89Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M347.17,332.13a6,6,0,0,1,6.47,1.1,7.48,7.48,0,0,1,2.14,6.37,10.12,10.12,0,0,1-3.26,6,11.63,11.63,0,0,1-9.52,3,10.23,10.23,0,0,1-7.79-6.07,9.17,9.17,0,0,1,1.79-9.6,8.39,8.39,0,0,1,8.07-2.17,4.27,4.27,0,0,1,2.1,1.36Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M347.17,332.13l-.12-.12a3.71,3.71,0,0,0-.34-.33,4.4,4.4,0,0,0-1.59-.86,8.16,8.16,0,0,0-2.87-.25,8.52,8.52,0,0,0-3.61,1.17,8,8,0,0,0-3.07,3.38,9.26,9.26,0,0,0-.84,5.17,8.77,8.77,0,0,0,.8,2.74,9.44,9.44,0,0,0,1.71,2.44,10.14,10.14,0,0,0,2.45,1.89,10,10,0,0,0,3,1.09,10.37,10.37,0,0,0,3.19.12,11.22,11.22,0,0,0,3-.77,11.64,11.64,0,0,0,4.69-3.43,9.59,9.59,0,0,0,2.15-4.79,7.83,7.83,0,0,0-.76-4.5,6.26,6.26,0,0,0-2.61-2.7,6.13,6.13,0,0,0-2.77-.73,5.32,5.32,0,0,0-1.8.26c-.4.12-.6.23-.6.22l.14-.08a4.12,4.12,0,0,1,.45-.18,5.38,5.38,0,0,1,1.81-.3,6.24,6.24,0,0,1,5.49,3.45,7.85,7.85,0,0,1,.8,4.58,9.73,9.73,0,0,1-2.16,4.87,11.74,11.74,0,0,1-4.76,3.5,11.59,11.59,0,0,1-3.05.78,10.1,10.1,0,0,1-3.24-.12,10,10,0,0,1-3-1.11,10.33,10.33,0,0,1-2.5-1.92,9.81,9.81,0,0,1-1.74-2.49,9,9,0,0,1-.81-2.8,9.41,9.41,0,0,1,.87-5.26,8.06,8.06,0,0,1,3.14-3.42,8.68,8.68,0,0,1,3.67-1.16,8,8,0,0,1,2.9.28,4.07,4.07,0,0,1,1.59.91A3,3,0,0,1,347.17,332.13Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.17,332.13l-.12-.12a3.71,3.71,0,0,0-.34-.33,4.4,4.4,0,0,0-1.59-.86,8.16,8.16,0,0,0-2.87-.25,8.52,8.52,0,0,0-3.61,1.17,8,8,0,0,0-3.07,3.38,9.26,9.26,0,0,0-.84,5.17,8.77,8.77,0,0,0,.8,2.74,9.44,9.44,0,0,0,1.71,2.44,10.14,10.14,0,0,0,2.45,1.89,10,10,0,0,0,3,1.09,10.37,10.37,0,0,0,3.19.12,11.22,11.22,0,0,0,3-.77,11.64,11.64,0,0,0,4.69-3.43,9.59,9.59,0,0,0,2.15-4.79,7.83,7.83,0,0,0-.76-4.5,6.26,6.26,0,0,0-2.61-2.7,6.13,6.13,0,0,0-2.77-.73,5.32,5.32,0,0,0-1.8.26c-.4.12-.6.23-.6.22l.14-.08a4.12,4.12,0,0,1,.45-.18,5.38,5.38,0,0,1,1.81-.3,6.24,6.24,0,0,1,5.49,3.45,7.85,7.85,0,0,1,.8,4.58,9.73,9.73,0,0,1-2.16,4.87,11.74,11.74,0,0,1-4.76,3.5,11.59,11.59,0,0,1-3.05.78,10.1,10.1,0,0,1-3.24-.12,10,10,0,0,1-3-1.11,10.33,10.33,0,0,1-2.5-1.92,9.81,9.81,0,0,1-1.74-2.49,9,9,0,0,1-.81-2.8,9.41,9.41,0,0,1,.87-5.26,8.06,8.06,0,0,1,3.14-3.42,8.68,8.68,0,0,1,3.67-1.16,8,8,0,0,1,2.9.28,4.07,4.07,0,0,1,1.59.91A3,3,0,0,1,347.17,332.13Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M342.77,333.1a2.07,2.07,0,0,0-2-.79,6.79,6.79,0,0,0-3.68,2.21,5.51,5.51,0,0,0-1.39,3.71,4,4,0,0,0,2,3.35,3.14,3.14,0,0,0,3.73-.53c1-1.05,1-2.61,1.3-4,.16-.66.4-1.31.5-2A2.65,2.65,0,0,0,342.77,333.1Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M352,332.71a.78.78,0,0,0-.38-.13,34.14,34.14,0,0,0-4.28-.46s2.07-2.24-.49-5.36l-1.45.38c2.09,3.26,1.19,4.71,1.19,4.71-1.78-1.88-5.07-3.22-5-2.66s3.79,3.49,3.79,3.49a9,9,0,0,0-4,2.2,10.88,10.88,0,0,0,4.82-1.42,3,3,0,0,0,.23,2,9.28,9.28,0,0,0,1.1,1.74c.16.22.43.46.67.32s.17-.42.11-.65c-.3-1.15-.59-2.31-.88-3.46a12.6,12.6,0,0,0,4.37-.22.4.4,0,0,0,.25-.12A.29.29,0,0,0,352,332.71Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M338,344.05l-.13-.1c-.07-.08-.19-.18-.32-.33a6.72,6.72,0,0,1-1-1.38,7.81,7.81,0,0,1-.81-2.38,7.13,7.13,0,0,1,1.54-5.8,7.4,7.4,0,0,1,1.88-1.66,6.67,6.67,0,0,1,1.54-.72,2.5,2.5,0,0,1,.44-.12c.1,0,.16,0,.16,0a9.74,9.74,0,0,0-2.07,1,7.79,7.79,0,0,0-1.82,1.65,7.45,7.45,0,0,0-1.36,2.68,7.29,7.29,0,0,0-.14,3,7.55,7.55,0,0,0,.76,2.35A9.77,9.77,0,0,0,338,344.05Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M314,331.13a5.94,5.94,0,0,1,6.46,1.1,7.46,7.46,0,0,1,2.15,6.37,10.2,10.2,0,0,1-3.26,6,11.6,11.6,0,0,1-9.52,3,10.23,10.23,0,0,1-7.79-6.07,9.13,9.13,0,0,1,1.79-9.6,8.38,8.38,0,0,1,8.07-2.17,4.27,4.27,0,0,1,2.1,1.36Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M309.62,332.1a2.09,2.09,0,0,0-2.05-.79,6.79,6.79,0,0,0-3.68,2.21,5.52,5.52,0,0,0-1.4,3.71,4,4,0,0,0,2,3.35,3.16,3.16,0,0,0,3.74-.53c.95-1.05,1-2.61,1.29-4,.16-.66.41-1.31.51-2A2.7,2.7,0,0,0,309.62,332.1Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M318.83,331.71a.86.86,0,0,0-.38-.13,34.14,34.14,0,0,0-4.28-.46s2.06-2.24-.49-5.36l-1.46.39c2.1,3.25,1.19,4.7,1.19,4.7-1.78-1.88-5.06-3.22-5-2.66s3.79,3.49,3.79,3.49a9,9,0,0,0-4,2.2,10.91,10.91,0,0,0,4.82-1.42,3,3,0,0,0,.23,2,8.8,8.8,0,0,0,1.1,1.74c.16.22.43.46.66.32s.17-.42.11-.65c-.29-1.15-.58-2.31-.88-3.46a12.65,12.65,0,0,0,4.38-.22.45.45,0,0,0,.25-.12A.29.29,0,0,0,318.83,331.71Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M304.85,343.05l-.12-.1c-.08-.08-.2-.18-.33-.33a6.75,6.75,0,0,1-1-1.38,7.26,7.26,0,0,1,.73-8.18A7.4,7.4,0,0,1,306,331.4a6.83,6.83,0,0,1,1.53-.72,3.93,3.93,0,0,1,.45-.12l.15,0a9.82,9.82,0,0,0-2.06,1,7.64,7.64,0,0,0-1.82,1.66,7.12,7.12,0,0,0-1.5,5.67,7.76,7.76,0,0,0,.75,2.34A9.77,9.77,0,0,0,304.85,343.05Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M339.72,342.18a6,6,0,0,0-6.5.88,7.46,7.46,0,0,0-2.36,6.29,10.11,10.11,0,0,0,3.05,6.12,11.58,11.58,0,0,0,9.41,3.32,10.22,10.22,0,0,0,8-5.79,9.17,9.17,0,0,0-1.45-9.66,8.42,8.42,0,0,0-8-2.44,4.26,4.26,0,0,0-2.14,1.28Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M339.72,342.18a.58.58,0,0,0,.12-.11c.08-.07.19-.19.36-.32a4.38,4.38,0,0,1,1.62-.81,8.4,8.4,0,0,1,2.87-.15,8.55,8.55,0,0,1,3.57,1.3,7.91,7.91,0,0,1,2.95,3.48,9.22,9.22,0,0,1,.66,5.2,8.8,8.8,0,0,1-.89,2.71,9.53,9.53,0,0,1-1.79,2.38,10.36,10.36,0,0,1-5.55,2.79,10.28,10.28,0,0,1-3.18,0,11.51,11.51,0,0,1-3-.87,11.71,11.71,0,0,1-4.57-3.6,9.62,9.62,0,0,1-2-4.86,7.76,7.76,0,0,1,.92-4.46,6.21,6.21,0,0,1,2.7-2.62,6.11,6.11,0,0,1,2.79-.63,5.47,5.47,0,0,1,1.79.32c.39.14.59.25.59.24l-.14-.08c-.1-.05-.24-.12-.44-.2a5.3,5.3,0,0,0-1.8-.35,6.18,6.18,0,0,0-2.84.61,6.33,6.33,0,0,0-2.76,2.64,7.88,7.88,0,0,0-1,4.55,9.75,9.75,0,0,0,2,4.95,11.66,11.66,0,0,0,4.64,3.65,11.33,11.33,0,0,0,3,.89,10.36,10.36,0,0,0,3.24,0,10.14,10.14,0,0,0,3.08-1,10,10,0,0,0,2.56-1.83,9.52,9.52,0,0,0,1.83-2.43,8.82,8.82,0,0,0,.9-2.77,9.31,9.31,0,0,0-.69-5.28,8,8,0,0,0-3-3.53,8.68,8.68,0,0,0-3.62-1.29,8.3,8.3,0,0,0-2.91.18,4.33,4.33,0,0,0-1.63.85A3.18,3.18,0,0,0,339.72,342.18Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M344.08,343.3a2.11,2.11,0,0,1,2.08-.72,6.87,6.87,0,0,1,3.6,2.34,5.47,5.47,0,0,1,1.27,3.76,4,4,0,0,1-2.09,3.28,3.16,3.16,0,0,1-3.71-.66c-.92-1.08-.88-2.64-1.16-4-.13-.67-.36-1.33-.43-2A2.68,2.68,0,0,1,344.08,343.3Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M339.42,338.3a14.83,14.83,0,0,1,.91,3.63c1.85-1.83,5.18-3.05,5.08-2.49s-3.91,3.35-3.91,3.35a9.08,9.08,0,0,1,3.9,2.34,11,11,0,0,1-4.77-1.58,3.09,3.09,0,0,1-.29,2,9.29,9.29,0,0,1-1.16,1.7c-.17.21-.45.44-.68.3s-.16-.43-.09-.66c.33-1.14.67-2.28,1-3.43a12.63,12.63,0,0,1-4.37-.37.36.36,0,0,1-.24-.13.28.28,0,0,1,.09-.36.85.85,0,0,1,.39-.12,32.33,32.33,0,0,1,4.29-.31",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M348.47,354.41l.13-.1a3.86,3.86,0,0,0,.33-.31,6.63,6.63,0,0,0,1-1.35,7.74,7.74,0,0,0,.89-2.35,7.4,7.4,0,0,0,0-3.07,7.31,7.31,0,0,0-1.31-2.78,7.69,7.69,0,0,0-1.83-1.73,6.9,6.9,0,0,0-1.5-.77c-.19-.07-.34-.1-.44-.13s-.16,0-.16,0a9.32,9.32,0,0,1,2,1,7.66,7.66,0,0,1,1.76,1.72,7.14,7.14,0,0,1,1.31,5.72,7.86,7.86,0,0,1-.84,2.32A9.89,9.89,0,0,1,348.47,354.41Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M340.2,320.84a5.94,5.94,0,0,0-3.88,5.29,7.46,7.46,0,0,0,2.88,6.07,10.15,10.15,0,0,0,6.52,2.05,11.63,11.63,0,0,0,8.93-4.46A10.21,10.21,0,0,0,356,320a9.14,9.14,0,0,0-8-5.66,8.41,8.41,0,0,0-7.31,4.06,4.2,4.2,0,0,0-.56,2.43Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M340.2,320.84v-.17a4.67,4.67,0,0,1,0-.47,4.2,4.2,0,0,1,.55-1.73,8.07,8.07,0,0,1,1.89-2.17,8.53,8.53,0,0,1,3.4-1.67,8,8,0,0,1,4.56.29,9.33,9.33,0,0,1,4.2,3.14,8.85,8.85,0,0,1,1.33,2.53,9.23,9.23,0,0,1,.46,2.94,10.24,10.24,0,0,1-4.05,8.22,11.28,11.28,0,0,1-2.69,1.54,11.6,11.6,0,0,1-5.76.79,9.64,9.64,0,0,1-4.87-1.95,7.78,7.78,0,0,1-2.58-3.76,6.17,6.17,0,0,1,1.48-6.21,5.46,5.46,0,0,1,1.47-1.06c.38-.19.6-.25.59-.26l-.16.05a3.07,3.07,0,0,0-.44.17,5.38,5.38,0,0,0-1.51,1.05,6.19,6.19,0,0,0-1.53,2.47,6.27,6.27,0,0,0,0,3.82,7.92,7.92,0,0,0,2.6,3.85,9.84,9.84,0,0,0,4.95,2,11.72,11.72,0,0,0,5.85-.79,11.87,11.87,0,0,0,2.74-1.56,10.18,10.18,0,0,0,2.24-2.34,10,10,0,0,0,1.42-2.92,10.37,10.37,0,0,0,.46-3.11,10,10,0,0,0-.48-3A9,9,0,0,0,355,318a9.41,9.41,0,0,0-4.28-3.17,8.1,8.1,0,0,0-4.64-.28,8.56,8.56,0,0,0-3.44,1.72,8.32,8.32,0,0,0-1.89,2.21,4.25,4.25,0,0,0-.52,1.77A3.14,3.14,0,0,0,340.2,320.84Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M344,318.48a2.13,2.13,0,0,1,.93-2,6.75,6.75,0,0,1,4.18-1,5.48,5.48,0,0,1,3.59,1.7,4,4,0,0,1,.91,3.77,3.15,3.15,0,0,1-3.06,2.21c-1.41-.08-2.5-1.2-3.7-2-.58-.37-1.2-.66-1.75-1.08A2.69,2.69,0,0,1,344,318.48Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M332,317.86a9.18,9.18,0,0,1,8.46,2.36c0-2.59,1.4-5.84,1.74-5.38s-.3,5.15-.3,5.15a8.89,8.89,0,0,1,4.39-1.19,11,11,0,0,1-4.46,2.33,3,3,0,0,1,1.24,1.6,9.3,9.3,0,0,1,.42,2c0,.27,0,.63-.26.69s-.41-.18-.53-.39l-1.77-3.1a13,13,0,0,1-3.3,2.89.38.38,0,0,1-.27.08.27.27,0,0,1-.19-.31.76.76,0,0,1,.18-.37,36.15,36.15,0,0,1,2.75-3.3s-3.62-2.82-7.1-1.64",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M355.07,323s0-.06,0-.16,0-.26,0-.46a7,7,0,0,0-.26-1.67,7.72,7.72,0,0,0-1.07-2.28,7.37,7.37,0,0,0-7.65-3,6.34,6.34,0,0,0-1.6.55,4,4,0,0,0-.4.22c-.09.05-.14.08-.14.09a10,10,0,0,1,2.17-.74,7.87,7.87,0,0,1,2.46-.07,7.53,7.53,0,0,1,2.84,1,7.42,7.42,0,0,1,2.18,2.05,7.6,7.6,0,0,1,1.08,2.21A9.78,9.78,0,0,1,355.07,323Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M317.48,320.84a6,6,0,0,0-6.33,1.74,7.51,7.51,0,0,0-1.5,6.55,10.17,10.17,0,0,0,3.84,5.65,11.57,11.57,0,0,0,9.77,2,10.21,10.21,0,0,0,7.15-6.81,9.12,9.12,0,0,0-2.73-9.37,8.39,8.39,0,0,0-8.25-1.36,4.27,4.27,0,0,0-1.95,1.56Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M317.48,320.84a.93.93,0,0,0,.1-.13c.07-.08.17-.21.31-.36a4.28,4.28,0,0,1,1.5-1,8.44,8.44,0,0,1,2.83-.53,8.63,8.63,0,0,1,3.71.81,7.93,7.93,0,0,1,3.39,3.05,9.26,9.26,0,0,1,1.35,5.06,8.88,8.88,0,0,1-.52,2.81,9.84,9.84,0,0,1-1.46,2.6,10.47,10.47,0,0,1-5.12,3.51,10.39,10.39,0,0,1-3.16.43,11.5,11.5,0,0,1-3.06-.46,11.73,11.73,0,0,1-5-3,9.68,9.68,0,0,1-2.61-4.55,7.79,7.79,0,0,1,.32-4.55,6.12,6.12,0,0,1,5-3.95,5.54,5.54,0,0,1,1.82.08c.41.09.62.17.62.16l-.15-.06c-.1,0-.25-.09-.46-.14a5.21,5.21,0,0,0-1.84-.11,6.13,6.13,0,0,0-2.72,1,6.21,6.21,0,0,0-2.39,3,7.88,7.88,0,0,0-.35,4.63,9.75,9.75,0,0,0,2.64,4.64,11.81,11.81,0,0,0,5.09,3,11.1,11.1,0,0,0,3.11.47,10.37,10.37,0,0,0,3.21-.44,10.47,10.47,0,0,0,5.21-3.57,9.26,9.26,0,0,0,1.48-2.65,9,9,0,0,0,.53-2.86,9.46,9.46,0,0,0-1.39-5.15,8,8,0,0,0-3.47-3.09,8.4,8.4,0,0,0-3.76-.79,8,8,0,0,0-2.85.57,4.1,4.1,0,0,0-1.5,1.06A3.09,3.09,0,0,0,317.48,320.84Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M322,321.36a2.12,2.12,0,0,1,2-1,6.77,6.77,0,0,1,3.88,1.83,5.5,5.5,0,0,1,1.76,3.56,4,4,0,0,1-1.62,3.53,3.17,3.17,0,0,1-3.77-.16c-1.06-.95-1.22-2.5-1.69-3.84-.22-.65-.53-1.27-.7-1.94A2.71,2.71,0,0,1,322,321.36Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M319.44,311.48c-1.77,3.45-1.39,9-1.39,9,1.59-2.05,4.72-3.71,4.7-3.14s-3.43,3.85-3.43,3.85A9,9,0,0,1,323.5,323a10.93,10.93,0,0,1-4.94-.93,3,3,0,0,1,0,2,9,9,0,0,1-.92,1.84c-.14.24-.39.5-.63.39s-.22-.4-.18-.64c.18-1.17.36-2.35.53-3.53a12.85,12.85,0,0,1-4.37.22.38.38,0,0,1-.26-.1.27.27,0,0,1,0-.37.7.7,0,0,1,.37-.17,33.51,33.51,0,0,1,4.21-.89s-1.61-6.25.62-9.61",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M327.78,331.79l.12-.11c.06-.08.17-.2.29-.36a7.06,7.06,0,0,0,.83-1.47,7.55,7.55,0,0,0,.57-2.45,7.31,7.31,0,0,0-.43-3,7.54,7.54,0,0,0-1.68-2.58,7.32,7.32,0,0,0-2-1.47,7,7,0,0,0-1.59-.56c-.2-.05-.35-.06-.46-.08h-.16a10.08,10.08,0,0,1,2.15.77,7.55,7.55,0,0,1,2,1.47,7.12,7.12,0,0,1,2.06,5.49,7.74,7.74,0,0,1-.52,2.41A9.52,9.52,0,0,1,327.78,331.79Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M324.33,304.86a6,6,0,0,0-.1,6.56,7.46,7.46,0,0,0,5.87,3.27,10.11,10.11,0,0,0,6.5-2.1,11.61,11.61,0,0,0,4.69-8.81,10.23,10.23,0,0,0-4.54-8.77,9.15,9.15,0,0,0-9.76,0,8.38,8.38,0,0,0-3.61,7.54,4.2,4.2,0,0,0,.95,2.31Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M326.08,300.71a2.1,2.1,0,0,1-.4-2.15,6.87,6.87,0,0,1,2.85-3.22,5.49,5.49,0,0,1,3.91-.69,4,4,0,0,1,2.93,2.55,3.15,3.15,0,0,1-1.21,3.57c-1.2.75-2.74.47-4.15.55-.69,0-1.37.15-2.06.12A2.62,2.62,0,0,1,326.08,300.71Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M313.17,307.68c5.06-6.21,11-3.46,11-3.46-1.53-2.1-2.25-5.57-1.71-5.39s2.74,4.36,2.74,4.36a9,9,0,0,1,2.89-3.51,11,11,0,0,1-2.27,4.48,3.15,3.15,0,0,1,1.93.59,9.54,9.54,0,0,1,1.51,1.4c.18.2.37.51.19.72s-.44.09-.66,0l-3.24-1.5a12.82,12.82,0,0,1-1,4.26.43.43,0,0,1-.17.22.29.29,0,0,1-.35-.14.89.89,0,0,1-.06-.4,34.13,34.13,0,0,1,.33-4.29s-7.65-1.13-9.22,3.52",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M337.72,298s0,0-.07-.14-.14-.22-.26-.38a7.15,7.15,0,0,0-1.18-1.21,7.67,7.67,0,0,0-2.19-1.23,7.5,7.5,0,0,0-3-.44,7.59,7.59,0,0,0-4.92,2.44,6.68,6.68,0,0,0-1,1.37,4,4,0,0,0-.21.42c0,.09-.06.14-.05.15a9.14,9.14,0,0,1,1.34-1.85,7.26,7.26,0,0,1,7.81-1.93,7.67,7.67,0,0,1,2.16,1.17A9.33,9.33,0,0,1,337.72,298Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M340.33,341.93c1.13-37.5-37.94-34.78-37.94-34.78l-.09,2.73s38.27-3.72,37.14,33.77",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M323.6,299.71c0,.16-.07.31-.1.47a4.34,4.34,0,0,0-1-1.35c-.44-.15,0,2.13,1,4.11a4,4,0,0,0,.38,1.13c-1.36-.47-6.3-1.69-10.62,3.61l1.14.51a48.16,48.16,0,0,0-11.92-1l-.09,2.73a46.37,46.37,0,0,1,15.49,1.63c-1.85,3.2-.65,8.58-.48,9.26a3.65,3.65,0,0,0-.44-.13,5.21,5.21,0,0,0-1.84-.11,6.13,6.13,0,0,0-2.72,1,6.21,6.21,0,0,0-2.39,3,7.88,7.88,0,0,0-.35,4.63,9.75,9.75,0,0,0,2.64,4.64,11.81,11.81,0,0,0,5.09,3,11.1,11.1,0,0,0,3.11.47,10.37,10.37,0,0,0,3.21-.44,10.47,10.47,0,0,0,5.21-3.57,9.26,9.26,0,0,0,1.48-2.65,9,9,0,0,0,.53-2.86,9.46,9.46,0,0,0-1.39-5.15,8,8,0,0,0-3.47-3.09,8.4,8.4,0,0,0-3.76-.79c-.16,0-.32,0-.47,0a4.7,4.7,0,0,0,1-1.37c0-.46-2.06.55-3.69,2.06a4.07,4.07,0,0,0-1,.73c-.05-1.19-.1-5.27,1.18-8.19,6.47,2.13,13.2,6.29,17,14.31a6.69,6.69,0,0,0,.28,2.13,7.74,7.74,0,0,0,1.57,2.83,40.27,40.27,0,0,1,1.36,10.82,2.1,2.1,0,0,0-.33-.15,5.3,5.3,0,0,0-1.8-.35,6.18,6.18,0,0,0-2.84.61,6.33,6.33,0,0,0-2.76,2.64,7.88,7.88,0,0,0-1,4.55,9.75,9.75,0,0,0,2,4.95,11.66,11.66,0,0,0,4.64,3.65,11.33,11.33,0,0,0,3,.89,10.36,10.36,0,0,0,3.24,0,10.14,10.14,0,0,0,3.08-1,10,10,0,0,0,2.56-1.83,9.52,9.52,0,0,0,1.83-2.43,8.82,8.82,0,0,0,.9-2.77,9.31,9.31,0,0,0-.69-5.28,8,8,0,0,0-3-3.53,8.68,8.68,0,0,0-3.62-1.29l-.48,0c.64-.54,1.15-1,1.18-1.22.08-.46-2.12.27-3.93,1.54a4.17,4.17,0,0,0-1.15.62,44.22,44.22,0,0,0-.64-9,9.89,9.89,0,0,0,4.4,1.63,11.72,11.72,0,0,0,5.85-.79,11.87,11.87,0,0,0,2.74-1.56,10.18,10.18,0,0,0,2.24-2.34,10,10,0,0,0,1.42-2.92,10.37,10.37,0,0,0,.46-3.11,10,10,0,0,0-.48-3A9,9,0,0,0,355,318a9.41,9.41,0,0,0-4.28-3.17,8.1,8.1,0,0,0-4.64-.28,8.56,8.56,0,0,0-3.44,1.72,3.59,3.59,0,0,0-.35.32,4.62,4.62,0,0,0-.06-1.7c-.28-.37-1.28,1.71-1.62,3.9a4,4,0,0,0-.35,1.26,9.16,9.16,0,0,0-7.72-2.24,27.42,27.42,0,0,0-3.45-3.14,7.24,7.24,0,0,0,1,.15,9.68,9.68,0,0,0,5.19-1.24,11.89,11.89,0,0,0,5.64-6.89,10.44,10.44,0,0,0,.47-3.21,10.58,10.58,0,0,0-2-6,9.3,9.3,0,0,0-2.13-2.16,9.93,9.93,0,0,0-2.77-1.28,8.85,8.85,0,0,0-5.16-.13,8,8,0,0,0-3.94,2.46m-8.29,24.42.08,0Zm7-15.56.05-.07Zm.09-.18c-.06.09-.15.21-.25.39a5.25,5.25,0,0,0-.62,1.73,6.11,6.11,0,0,0,1,4.56,39.75,39.75,0,0,0-9.2-3.3C316.75,304.15,323.53,304.91,324.22,305Zm15.63,16,.08,0Zm.17-.1a4.09,4.09,0,0,0-.42.17,5.38,5.38,0,0,0-1.51,1.05,6.08,6.08,0,0,0-1.28,1.84,26.7,26.7,0,0,0-3.12-4.83C336.69,318.54,339.59,320.57,340,320.89ZM339.38,342s0,0,.07,0Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M286.47,325a6,6,0,0,1,6.47,1.1,7.48,7.48,0,0,1,2.14,6.37,10.06,10.06,0,0,1-3.26,6,11.57,11.57,0,0,1-9.51,3,10.25,10.25,0,0,1-7.8-6.07,9.18,9.18,0,0,1,1.79-9.6,8.45,8.45,0,0,1,8.08-2.17,4.24,4.24,0,0,1,2.09,1.36Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M286.47,325l-.11-.12c-.08-.07-.19-.19-.35-.32a4.25,4.25,0,0,0-1.59-.87,8.41,8.41,0,0,0-2.87-.25,8.67,8.67,0,0,0-3.61,1.17,8,8,0,0,0-3.07,3.38,9.26,9.26,0,0,0-.84,5.17,9,9,0,0,0,.8,2.74,9.49,9.49,0,0,0,1.71,2.45,10,10,0,0,0,2.46,1.88,9.82,9.82,0,0,0,3,1.09,10.3,10.3,0,0,0,3.18.12,11.67,11.67,0,0,0,7.69-4.2,9.59,9.59,0,0,0,2.15-4.79,7.8,7.8,0,0,0-.76-4.49,6.23,6.23,0,0,0-2.61-2.71,6.13,6.13,0,0,0-2.77-.73,5.58,5.58,0,0,0-1.8.26c-.4.13-.59.23-.6.22l.15-.07a3,3,0,0,1,.44-.19,5.42,5.42,0,0,1,1.81-.29,6.16,6.16,0,0,1,2.82.71,6.32,6.32,0,0,1,2.67,2.74,7.8,7.8,0,0,1,.8,4.57,9.8,9.8,0,0,1-2.16,4.88,11.81,11.81,0,0,1-4.76,3.49,11.21,11.21,0,0,1-3.05.78,10.39,10.39,0,0,1-3.24-.11,10.27,10.27,0,0,1-3-1.12,10.16,10.16,0,0,1-4.24-4.41,9.14,9.14,0,0,1-.81-2.8,9.5,9.5,0,0,1,.87-5.26,8.12,8.12,0,0,1,3.14-3.42,8.68,8.68,0,0,1,3.67-1.16,8.23,8.23,0,0,1,2.9.28,4.34,4.34,0,0,1,1.6.91A3.09,3.09,0,0,1,286.47,325Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.47,325a6,6,0,0,1,6.47,1.1,7.48,7.48,0,0,1,2.14,6.37,10.06,10.06,0,0,1-3.26,6,11.57,11.57,0,0,1-9.51,3,10.25,10.25,0,0,1-7.8-6.07,9.18,9.18,0,0,1,1.79-9.6,8.45,8.45,0,0,1,8.08-2.17,4.24,4.24,0,0,1,2.09,1.36Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.47,325l-.11-.12c-.08-.07-.19-.19-.35-.32a4.25,4.25,0,0,0-1.59-.87,8.41,8.41,0,0,0-2.87-.25,8.67,8.67,0,0,0-3.61,1.17,8,8,0,0,0-3.07,3.38,9.26,9.26,0,0,0-.84,5.17,9,9,0,0,0,.8,2.74,9.49,9.49,0,0,0,1.71,2.45,10,10,0,0,0,2.46,1.88,9.82,9.82,0,0,0,3,1.09,10.3,10.3,0,0,0,3.18.12,11.67,11.67,0,0,0,7.69-4.2,9.59,9.59,0,0,0,2.15-4.79,7.8,7.8,0,0,0-.76-4.49,6.23,6.23,0,0,0-2.61-2.71,6.13,6.13,0,0,0-2.77-.73,5.58,5.58,0,0,0-1.8.26c-.4.13-.59.23-.6.22l.15-.07a3,3,0,0,1,.44-.19,5.42,5.42,0,0,1,1.81-.29,6.16,6.16,0,0,1,2.82.71,6.32,6.32,0,0,1,2.67,2.74,7.8,7.8,0,0,1,.8,4.57,9.8,9.8,0,0,1-2.16,4.88,11.81,11.81,0,0,1-4.76,3.49,11.21,11.21,0,0,1-3.05.78,10.39,10.39,0,0,1-3.24-.11,10.27,10.27,0,0,1-3-1.12,10.16,10.16,0,0,1-4.24-4.41,9.14,9.14,0,0,1-.81-2.8,9.5,9.5,0,0,1,.87-5.26,8.12,8.12,0,0,1,3.14-3.42,8.68,8.68,0,0,1,3.67-1.16,8.23,8.23,0,0,1,2.9.28,4.34,4.34,0,0,1,1.6.91A3.09,3.09,0,0,1,286.47,325Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M282.07,326a2.1,2.1,0,0,0-2-.79,6.78,6.78,0,0,0-3.69,2.21,5.51,5.51,0,0,0-1.39,3.72,4,4,0,0,0,2,3.34,3.14,3.14,0,0,0,3.73-.53c1-1,1-2.61,1.3-4,.16-.67.4-1.32.5-2A2.65,2.65,0,0,0,282.07,326Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M291.28,325.62a.7.7,0,0,0-.38-.14,34.14,34.14,0,0,0-4.28-.46s2.07-2.24-.49-5.36l-1.45.39c2.09,3.26,1.19,4.71,1.19,4.71-1.78-1.89-5.07-3.23-5-2.67s3.79,3.49,3.79,3.49a9.15,9.15,0,0,0-4,2.2,10.88,10.88,0,0,0,4.82-1.42,3,3,0,0,0,.23,2,9.28,9.28,0,0,0,1.1,1.74c.16.22.43.46.67.32s.17-.42.11-.65c-.29-1.15-.59-2.3-.88-3.46a12.6,12.6,0,0,0,4.37-.22.35.35,0,0,0,.25-.12A.27.27,0,0,0,291.28,325.62Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M277.31,337s-.05,0-.13-.1a3.49,3.49,0,0,1-.32-.33,6.72,6.72,0,0,1-1-1.38,7.81,7.81,0,0,1-.81-2.38,7.13,7.13,0,0,1,1.54-5.8,7.4,7.4,0,0,1,1.88-1.66,7.07,7.07,0,0,1,1.54-.72,4.53,4.53,0,0,1,.44-.12l.16,0a10.41,10.41,0,0,0-2.07,1,7.83,7.83,0,0,0-1.82,1.66,7.42,7.42,0,0,0-.74,8A9.77,9.77,0,0,0,277.31,337Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M289.94,289.67a5.94,5.94,0,0,1,6.47,1.11,7.45,7.45,0,0,1,2.14,6.36,10.11,10.11,0,0,1-3.26,6,11.6,11.6,0,0,1-9.52,3,10.23,10.23,0,0,1-7.79-6.07,9.14,9.14,0,0,1,1.79-9.6,8.43,8.43,0,0,1,8.07-2.17,4.27,4.27,0,0,1,2.1,1.36Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M289.94,289.67l-.12-.11a2.73,2.73,0,0,0-.34-.33,4.22,4.22,0,0,0-1.6-.87,8.1,8.1,0,0,0-2.86-.24,8.5,8.5,0,0,0-3.61,1.16,8,8,0,0,0-3.07,3.38,9.26,9.26,0,0,0-.84,5.17,8.64,8.64,0,0,0,.8,2.75A9.61,9.61,0,0,0,280,303a9.86,9.86,0,0,0,2.45,1.88,10.07,10.07,0,0,0,6.18,1.21,11.67,11.67,0,0,0,7.69-4.2,9.68,9.68,0,0,0,2.15-4.79,7.8,7.8,0,0,0-.77-4.49,6.18,6.18,0,0,0-2.61-2.71,6.06,6.06,0,0,0-2.76-.73,5.49,5.49,0,0,0-1.8.26c-.4.13-.6.23-.6.22l.14-.07a2.58,2.58,0,0,1,.44-.18,5.2,5.2,0,0,1,1.82-.3,6.1,6.1,0,0,1,2.81.71,6.28,6.28,0,0,1,2.68,2.74,8,8,0,0,1,.8,4.57,9.82,9.82,0,0,1-2.17,4.88,11.83,11.83,0,0,1-4.75,3.5,11.58,11.58,0,0,1-3,.77,10.25,10.25,0,0,1-6.29-1.23,10,10,0,0,1-2.49-1.92,9.56,9.56,0,0,1-1.74-2.49,8.87,8.87,0,0,1-.81-2.8,9.41,9.41,0,0,1,.87-5.26,8.12,8.12,0,0,1,3.14-3.42A8.6,8.6,0,0,1,285,288a8.14,8.14,0,0,1,2.89.28,4.17,4.17,0,0,1,1.6.91A3.73,3.73,0,0,1,289.94,289.67Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.94,289.67a5.94,5.94,0,0,1,6.47,1.11,7.45,7.45,0,0,1,2.14,6.36,10.11,10.11,0,0,1-3.26,6,11.6,11.6,0,0,1-9.52,3,10.23,10.23,0,0,1-7.79-6.07,9.14,9.14,0,0,1,1.79-9.6,8.43,8.43,0,0,1,8.07-2.17,4.27,4.27,0,0,1,2.1,1.36Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.94,289.67l-.12-.11a2.73,2.73,0,0,0-.34-.33,4.22,4.22,0,0,0-1.6-.87,8.1,8.1,0,0,0-2.86-.24,8.5,8.5,0,0,0-3.61,1.16,8,8,0,0,0-3.07,3.38,9.26,9.26,0,0,0-.84,5.17,8.64,8.64,0,0,0,.8,2.75A9.61,9.61,0,0,0,280,303a9.86,9.86,0,0,0,2.45,1.88,10.07,10.07,0,0,0,6.18,1.21,11.67,11.67,0,0,0,7.69-4.2,9.68,9.68,0,0,0,2.15-4.79,7.8,7.8,0,0,0-.77-4.49,6.18,6.18,0,0,0-2.61-2.71,6.06,6.06,0,0,0-2.76-.73,5.49,5.49,0,0,0-1.8.26c-.4.13-.6.23-.6.22l.14-.07a2.58,2.58,0,0,1,.44-.18,5.2,5.2,0,0,1,1.82-.3,6.1,6.1,0,0,1,2.81.71,6.28,6.28,0,0,1,2.68,2.74,8,8,0,0,1,.8,4.57,9.82,9.82,0,0,1-2.17,4.88,11.83,11.83,0,0,1-4.75,3.5,11.58,11.58,0,0,1-3,.77,10.25,10.25,0,0,1-6.29-1.23,10,10,0,0,1-2.49-1.92,9.56,9.56,0,0,1-1.74-2.49,8.87,8.87,0,0,1-.81-2.8,9.41,9.41,0,0,1,.87-5.26,8.12,8.12,0,0,1,3.14-3.42A8.6,8.6,0,0,1,285,288a8.14,8.14,0,0,1,2.89.28,4.17,4.17,0,0,1,1.6.91A3.73,3.73,0,0,1,289.94,289.67Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M285.54,290.64a2.11,2.11,0,0,0-2.05-.79,6.85,6.85,0,0,0-3.68,2.21,5.52,5.52,0,0,0-1.4,3.72,4,4,0,0,0,2,3.34,3.16,3.16,0,0,0,3.74-.53c.95-1,1-2.61,1.29-4,.16-.67.41-1.32.51-2A2.65,2.65,0,0,0,285.54,290.64Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M294.75,290.26a.88.88,0,0,0-.38-.14,34.14,34.14,0,0,0-4.28-.46s2.06-2.24-.49-5.36l-1.46.39c2.1,3.26,1.19,4.71,1.19,4.71-1.78-1.89-5.06-3.23-5-2.66s3.79,3.48,3.79,3.48a9.09,9.09,0,0,0-4,2.2A11,11,0,0,0,289,291a3,3,0,0,0,.23,2,8.73,8.73,0,0,0,1.1,1.73c.16.22.43.46.66.33s.17-.43.12-.65L290.2,291a12.89,12.89,0,0,0,4.38-.21.47.47,0,0,0,.25-.13A.27.27,0,0,0,294.75,290.26Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M280.77,301.59s0,0-.12-.1a4.38,4.38,0,0,1-.33-.32,7.53,7.53,0,0,1-1.78-3.76,7.37,7.37,0,0,1,.13-3.08,7.52,7.52,0,0,1,1.41-2.73,7.4,7.4,0,0,1,1.88-1.66,6.83,6.83,0,0,1,1.53-.72,4.56,4.56,0,0,1,.45-.12l.16,0a10.13,10.13,0,0,0-2.07,1,7.64,7.64,0,0,0-1.82,1.66,7.42,7.42,0,0,0-.74,8A10.07,10.07,0,0,0,280.77,301.59Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M311.05,290.24a5.94,5.94,0,0,1,6.47,1.11,7.46,7.46,0,0,1,2.14,6.36,10.11,10.11,0,0,1-3.26,6,11.6,11.6,0,0,1-9.52,3,10.21,10.21,0,0,1-7.79-6.07,9.12,9.12,0,0,1,1.79-9.59,8.38,8.38,0,0,1,8.07-2.17,4.19,4.19,0,0,1,2.1,1.35Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M311.05,290.24l-.12-.11a3.71,3.71,0,0,0-.34-.33,4.23,4.23,0,0,0-1.6-.86,7.85,7.85,0,0,0-2.86-.25,8.52,8.52,0,0,0-3.61,1.17,8,8,0,0,0-3.07,3.37,9.31,9.31,0,0,0-.84,5.18,8.59,8.59,0,0,0,.8,2.74,9.44,9.44,0,0,0,1.71,2.44,10.43,10.43,0,0,0,5.44,3,10.07,10.07,0,0,0,3.19.11,10.84,10.84,0,0,0,3-.76,11.64,11.64,0,0,0,4.69-3.44,9.55,9.55,0,0,0,2.15-4.79,7.72,7.72,0,0,0-.77-4.49,6.2,6.2,0,0,0-5.37-3.44,5.49,5.49,0,0,0-1.8.26c-.4.13-.6.24-.6.22l.14-.07a3.42,3.42,0,0,1,.45-.18,5.33,5.33,0,0,1,1.81-.3,6.1,6.1,0,0,1,2.81.71,6.28,6.28,0,0,1,2.68,2.74,7.9,7.9,0,0,1,.8,4.57,9.66,9.66,0,0,1-2.17,4.88,11.73,11.73,0,0,1-4.75,3.5,11.59,11.59,0,0,1-3.05.78,10.7,10.7,0,0,1-3.24-.12,10.42,10.42,0,0,1-5.54-3,9.56,9.56,0,0,1-1.74-2.49,9,9,0,0,1-.81-2.8,9.38,9.38,0,0,1,.87-5.26,8.15,8.15,0,0,1,3.14-3.43,8.74,8.74,0,0,1,3.67-1.16,8.12,8.12,0,0,1,2.89.29,4.05,4.05,0,0,1,1.6.9A3.73,3.73,0,0,1,311.05,290.24Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.05,290.24a5.94,5.94,0,0,1,6.47,1.11,7.46,7.46,0,0,1,2.14,6.36,10.11,10.11,0,0,1-3.26,6,11.6,11.6,0,0,1-9.52,3,10.21,10.21,0,0,1-7.79-6.07,9.12,9.12,0,0,1,1.79-9.59,8.38,8.38,0,0,1,8.07-2.17,4.19,4.19,0,0,1,2.1,1.35Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M306.65,291.21a2.11,2.11,0,0,0-2-.79,6.92,6.92,0,0,0-3.68,2.21,5.48,5.48,0,0,0-1.39,3.72,4,4,0,0,0,2,3.35,3.17,3.17,0,0,0,3.74-.54c.95-1,1-2.6,1.29-4,.16-.67.41-1.32.51-2A2.65,2.65,0,0,0,306.65,291.21Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M315.86,290.83a.72.72,0,0,0-.38-.13,30.77,30.77,0,0,0-4.28-.46s2.06-2.25-.49-5.37l-1.46.39c2.1,3.26,1.19,4.71,1.19,4.71-1.78-1.89-5.06-3.23-5-2.66s3.79,3.49,3.79,3.49a8.9,8.9,0,0,0-4,2.2,10.91,10.91,0,0,0,4.82-1.42,3,3,0,0,0,.23,2,8.8,8.8,0,0,0,1.1,1.74c.16.21.43.46.66.32s.17-.42.12-.65l-.89-3.47a12.64,12.64,0,0,0,4.38-.21.41.41,0,0,0,.25-.13A.27.27,0,0,0,315.86,290.83Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M301.88,302.17l-.12-.11a3.15,3.15,0,0,1-.32-.32,6.36,6.36,0,0,1-1-1.38,7.55,7.55,0,0,1-.81-2.38,7.32,7.32,0,0,1,.13-3.07,7.49,7.49,0,0,1,1.41-2.74,7.81,7.81,0,0,1,1.88-1.66,6.71,6.71,0,0,1,1.53-.71c.19-.07.35-.1.45-.13s.15,0,.16,0a9.11,9.11,0,0,0-2.07,1,7.64,7.64,0,0,0-1.82,1.66A7.45,7.45,0,0,0,300,295a7.28,7.28,0,0,0-.14,3,7.4,7.4,0,0,0,.76,2.34A10.43,10.43,0,0,0,301.88,302.17Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M314.46,343.25a5.94,5.94,0,0,1,4.08-5.14,7.44,7.44,0,0,1,6.61,1.17,10.17,10.17,0,0,1,3.7,5.75,11.61,11.61,0,0,1-1.94,9.79,10.25,10.25,0,0,1-9.07,3.92,9.16,9.16,0,0,1-7.56-6.19,8.43,8.43,0,0,1,2-8.12,4.2,4.2,0,0,1,2.2-1.18Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M328.42,343.46a11.67,11.67,0,0,1,.78,5.85,11,11,0,0,1-.78,3.05,10.29,10.29,0,0,1-4.1,4.92,10.22,10.22,0,0,1-2.88,1.26,9.47,9.47,0,0,1-3,.33,9,9,0,0,1-2.85-.63,9.4,9.4,0,0,1-4.19-3.3,8,8,0,0,1-1.49-4.39,8.79,8.79,0,0,1,.74-3.78,8.16,8.16,0,0,1,1.64-2.4,4.19,4.19,0,0,1,1.56-1,3.35,3.35,0,0,1,.63-.15l-.16,0a3.86,3.86,0,0,0-.45.15,4.15,4.15,0,0,0-1.53,1,8.13,8.13,0,0,0-1.59,2.39,8.6,8.6,0,0,0-.71,3.73,8,8,0,0,0,1.48,4.32,9.29,9.29,0,0,0,4.14,3.22,9.15,9.15,0,0,0,2.79.62,9.69,9.69,0,0,0,3-.33,10,10,0,0,0,2.83-1.25,10.14,10.14,0,0,0,2.4-2.09,10.46,10.46,0,0,0,1.63-2.74,11,11,0,0,0,.77-3,11.48,11.48,0,0,0-.76-5.77,9.62,9.62,0,0,0-3.17-4.18,7.74,7.74,0,0,0-4.3-1.49,6.17,6.17,0,0,0-5.6,3.06,5.69,5.69,0,0,0-.64,1.71c-.08.41-.08.63-.09.63v-.16a4.38,4.38,0,0,1,.06-.48,5.07,5.07,0,0,1,.61-1.73,6.25,6.25,0,0,1,2-2.13,6.35,6.35,0,0,1,3.69-1,7.85,7.85,0,0,1,4.4,1.5",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M313.19,347.57a2.07,2.07,0,0,0-1.67,1.42,6.78,6.78,0,0,0,.17,4.29,5.54,5.54,0,0,0,2.58,3,4,4,0,0,0,3.89-.12,3.16,3.16,0,0,0,1.32-3.53c-.45-1.34-1.82-2.1-2.87-3.05-.51-.46-1-1-1.51-1.4A2.66,2.66,0,0,0,313.19,347.57Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M311.28,341a14,14,0,0,0,2.65,2.64c-2.51.66-5.27,2.89-4.73,3.1s4.88-1.65,4.88-1.65a9.11,9.11,0,0,0,0,4.55,10.86,10.86,0,0,0,1.08-4.91,3.09,3.09,0,0,0,1.87.76,8.32,8.32,0,0,0,2-.13c.27,0,.61-.15.6-.42s-.28-.36-.51-.41l-3.46-.9a12.63,12.63,0,0,0,1.91-3.94.39.39,0,0,0,0-.28.28.28,0,0,0-.35-.1.8.8,0,0,0-.31.27,33.22,33.22,0,0,0-2.46,3.53",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M320.51,357s-.05,0-.15.06a4.32,4.32,0,0,1-.44.13,6.94,6.94,0,0,1-1.68.19,7.56,7.56,0,0,1-5.11-2,7.52,7.52,0,0,1-1.72-2.55,7.34,7.34,0,0,1-.55-2.45,6.66,6.66,0,0,1,.11-1.69c0-.19.08-.34.1-.44s.05-.16.06-.16a9.48,9.48,0,0,0-.14,2.28,7.62,7.62,0,0,0,2.27,4.88,7.64,7.64,0,0,0,5,2A9.53,9.53,0,0,0,320.51,357Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M295.86,332.76a6,6,0,0,1,6.53-.64,7.49,7.49,0,0,1,3.75,5.58,10.12,10.12,0,0,1-1.57,6.65,11.6,11.6,0,0,1-8.39,5.41,10.23,10.23,0,0,1-9.11-3.81,9.16,9.16,0,0,1-.8-9.73,8.4,8.4,0,0,1,7.21-4.22,4.31,4.31,0,0,1,2.38.76Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M295.86,332.76l-.14-.08c-.09-.05-.23-.14-.42-.23a4.28,4.28,0,0,0-1.76-.41,8,8,0,0,0-2.83.52,8.43,8.43,0,0,0-3.18,2.07,8.07,8.07,0,0,0-2.07,4.07,9.29,9.29,0,0,0,.55,5.21,8.84,8.84,0,0,0,1.49,2.44,9.44,9.44,0,0,0,2.3,1.9,10.38,10.38,0,0,0,6,1.44,10.1,10.1,0,0,0,3.1-.73,11,11,0,0,0,2.7-1.52,11.66,11.66,0,0,0,3.62-4.55,9.59,9.59,0,0,0,.81-5.19,7.82,7.82,0,0,0-1.92-4.14,6.22,6.22,0,0,0-3.23-1.92,6.06,6.06,0,0,0-2.86,0,5.34,5.34,0,0,0-1.67.72c-.35.23-.51.38-.52.37l.12-.11a3.27,3.27,0,0,1,.38-.29,5.49,5.49,0,0,1,1.67-.76,6.22,6.22,0,0,1,2.91-.06,6.38,6.38,0,0,1,3.3,1.94,7.89,7.89,0,0,1,2,4.2,9.64,9.64,0,0,1-.8,5.27,11.73,11.73,0,0,1-3.67,4.63,11.52,11.52,0,0,1-2.74,1.56,10.19,10.19,0,0,1-3.15.73,10,10,0,0,1-3.23-.27,10.55,10.55,0,0,1-2.92-1.19,9.79,9.79,0,0,1-2.33-2,8.91,8.91,0,0,1-1.52-2.49,9.42,9.42,0,0,1-.54-5.3,8.1,8.1,0,0,1,2.13-4.13,8.58,8.58,0,0,1,3.23-2.08,7.92,7.92,0,0,1,2.87-.49,4.11,4.11,0,0,1,1.78.45A3.69,3.69,0,0,1,295.86,332.76Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M291.87,334.85a2.11,2.11,0,0,0-2.18-.22,6.8,6.8,0,0,0-3,3.1,5.53,5.53,0,0,0-.37,3.95,4,4,0,0,0,2.78,2.72,3.17,3.17,0,0,0,3.47-1.5c.64-1.26.24-2.77.2-4.19,0-.68,0-1.37,0-2A2.71,2.71,0,0,0,291.87,334.85Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M297.5,324.17a9.18,9.18,0,0,0-2.29,8.48c-2.22-1.35-5.74-1.77-5.51-1.25s4.57,2.37,4.57,2.37a9.08,9.08,0,0,0-3.26,3.17,10.81,10.81,0,0,0,4.28-2.64,3.06,3.06,0,0,0,.75,1.88,9.58,9.58,0,0,0,1.52,1.39c.21.16.54.33.72.13s.06-.45-.06-.65c-.59-1-1.17-2.08-1.76-3.11a13.09,13.09,0,0,0,4.17-1.36c.08-.05.17-.1.2-.19a.27.27,0,0,0-.17-.33.77.77,0,0,0-.4,0,33.87,33.87,0,0,0-4.25.68s-.58-4.55,2.22-6.94",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M290.16,346.67l-.15-.06a4.15,4.15,0,0,1-.39-.23,6.58,6.58,0,0,1-1.31-1.08,7.41,7.41,0,0,1-1.41-2.08,7.3,7.3,0,0,1-.68-3,7.39,7.39,0,0,1,.64-3,7.65,7.65,0,0,1,1.38-2.1,7.21,7.21,0,0,1,1.29-1.1,4.15,4.15,0,0,1,.39-.23l.15-.07a9.84,9.84,0,0,0-1.73,1.49,7.69,7.69,0,0,0-1.94,5,7.67,7.67,0,0,0,2,5A9.28,9.28,0,0,0,290.16,346.67Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M307.46,313.23a6,6,0,0,1,4.73-4.55,7.47,7.47,0,0,1,6.4,2.05,10.14,10.14,0,0,1,2.9,6.19,11.59,11.59,0,0,1-3.24,9.44,10.21,10.21,0,0,1-9.51,2.67,9.16,9.16,0,0,1-6.66-7.14,8.38,8.38,0,0,1,3.05-7.78,4.13,4.13,0,0,1,2.33-.88Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M305.63,317.34a2.09,2.09,0,0,0-1.85,1.18,6.81,6.81,0,0,0-.4,4.27,5.48,5.48,0,0,0,2.16,3.33,4,4,0,0,0,3.86.41,3.17,3.17,0,0,0,1.79-3.33c-.28-1.38-1.53-2.32-2.44-3.4a20.11,20.11,0,0,0-1.31-1.59A2.64,2.64,0,0,0,305.63,317.34Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M298.41,310.13c3.87.24,8.47,3.42,8.47,3.42-2.57.31-5.6,2.16-5.1,2.43s5.06-1,5.06-1a9,9,0,0,0-.59,4.51,11,11,0,0,0,1.72-4.72,3.06,3.06,0,0,0,1.75,1,8.81,8.81,0,0,0,2,.14c.28,0,.63-.07.66-.34s-.24-.39-.46-.48l-3.31-1.34a12.9,12.9,0,0,0,2.42-3.65.4.4,0,0,0,.05-.28.28.28,0,0,0-.34-.15.74.74,0,0,0-.33.23,33.53,33.53,0,0,0-2.91,3.17s-4.56-4.58-8.58-4.37",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M311.62,327.68l-.16,0c-.1,0-.25,0-.45.07a7.07,7.07,0,0,1-1.69,0,7.77,7.77,0,0,1-2.4-.76,7.41,7.41,0,0,1-2.39-1.93,7.55,7.55,0,0,1-1.58-5.25,6.4,6.4,0,0,1,.33-1.66,3.47,3.47,0,0,1,.16-.43c0-.1.07-.15.08-.15a9.21,9.21,0,0,0-.44,2.24,7.24,7.24,0,0,0,3.92,7,7.74,7.74,0,0,0,2.34.78A10.29,10.29,0,0,0,311.62,327.68Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M290.23,311a5.94,5.94,0,0,1,5.69,3.26,7.5,7.5,0,0,1-.18,6.72,10.15,10.15,0,0,1-5.13,4.51,11.58,11.58,0,0,1-10-.46,10.19,10.19,0,0,1-5.22-8.38,9.16,9.16,0,0,1,5-8.4,8.42,8.42,0,0,1,8.33.75,4.26,4.26,0,0,1,1.5,2Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M285.77,310.35a2.13,2.13,0,0,0-1.65-1.45,6.88,6.88,0,0,0-4.22.81,5.51,5.51,0,0,0-2.59,3,4,4,0,0,0,.69,3.82,3.16,3.16,0,0,0,3.69.78c1.26-.65,1.81-2.11,2.59-3.29.38-.57.83-1.1,1.16-1.7A2.67,2.67,0,0,0,285.77,310.35Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M298.35,302.81c-7.92,1.17-8.59,7.68-8.59,7.68-1-2.38-3.65-4.77-3.77-4.22s2.36,4.59,2.36,4.59a9,9,0,0,0-4.5.69,10.94,10.94,0,0,0,5,.33,3.06,3.06,0,0,0-.48,2,9.32,9.32,0,0,0,.43,2c.08.26.25.58.52.53s.3-.34.33-.57l.36-3.56a12.87,12.87,0,0,0,4.19,1.31.36.36,0,0,0,.27,0,.26.26,0,0,0,.05-.36.79.79,0,0,0-.31-.26,35.33,35.33,0,0,0-3.85-1.91s2.93-7.15,7.73-6.13",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M277.52,319s0-.05-.08-.14a2.82,2.82,0,0,1-.2-.42,7.19,7.19,0,0,1-.44-1.63,7.6,7.6,0,0,1,1.24-5.35,7.4,7.4,0,0,1,2.27-2.08,7.7,7.7,0,0,1,2.34-.91,7,7,0,0,1,1.68-.15l.46,0,.16,0a9.67,9.67,0,0,0-2.27.21,7.31,7.31,0,0,0-2.28.93,7.44,7.44,0,0,0-2.21,2,7.56,7.56,0,0,0-1.16,2.76,7.75,7.75,0,0,0-.1,2.46A9.47,9.47,0,0,0,277.52,319Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M313.93,343.64c-32.82-18.17-10.53-50.38-10.53-50.38l2.4,1.32s-22.75,31,10.07,49.18",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M284,342.63a5.94,5.94,0,0,1,6.47,1.1,7.47,7.47,0,0,1,2.14,6.37,10.12,10.12,0,0,1-3.26,6,11.64,11.64,0,0,1-9.52,3A10.22,10.22,0,0,1,272,353a9.12,9.12,0,0,1,1.79-9.59,8.38,8.38,0,0,1,8.07-2.17,4.27,4.27,0,0,1,2.1,1.36Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M284,342.63l-.12-.12a3.71,3.71,0,0,0-.34-.33,4.23,4.23,0,0,0-1.6-.86,8.08,8.08,0,0,0-2.86-.25,8.52,8.52,0,0,0-3.61,1.17,7.93,7.93,0,0,0-3.07,3.38,9.26,9.26,0,0,0-.84,5.17,8.59,8.59,0,0,0,.8,2.74,9.44,9.44,0,0,0,1.71,2.44,10.14,10.14,0,0,0,2.45,1.89,10,10,0,0,0,3,1.09,10.37,10.37,0,0,0,3.19.12,11.32,11.32,0,0,0,3-.77,11.71,11.71,0,0,0,4.69-3.43,9.59,9.59,0,0,0,2.15-4.79,7.75,7.75,0,0,0-.77-4.5,6.15,6.15,0,0,0-2.61-2.7,6.06,6.06,0,0,0-2.76-.73,5.54,5.54,0,0,0-1.8.25c-.4.13-.6.24-.6.23l.14-.08a3.42,3.42,0,0,1,.45-.18,5.33,5.33,0,0,1,1.81-.3,6.27,6.27,0,0,1,5.49,3.45,7.91,7.91,0,0,1,.8,4.57,9.74,9.74,0,0,1-2.17,4.88,11.73,11.73,0,0,1-4.75,3.5,11.59,11.59,0,0,1-3.05.78,10.44,10.44,0,0,1-6.29-1.23,10.47,10.47,0,0,1-2.49-1.92,9.56,9.56,0,0,1-1.74-2.49,9,9,0,0,1-.81-2.8,9.38,9.38,0,0,1,.87-5.26,8.06,8.06,0,0,1,3.14-3.42,8.6,8.6,0,0,1,3.67-1.16,7.92,7.92,0,0,1,2.89.28,4.05,4.05,0,0,1,1.6.9A3.32,3.32,0,0,1,284,342.63Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M279.59,343.59a2.08,2.08,0,0,0-2-.78,6.84,6.84,0,0,0-3.68,2.2,5.48,5.48,0,0,0-1.39,3.72,4,4,0,0,0,2,3.35,3.17,3.17,0,0,0,3.74-.53c.95-1.05,1-2.61,1.29-4,.16-.67.41-1.31.51-2A2.69,2.69,0,0,0,279.59,343.59Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M288.8,343.21a.82.82,0,0,0-.38-.13,34.14,34.14,0,0,0-4.28-.46s2.06-2.24-.49-5.37l-1.46.39c2.1,3.26,1.19,4.71,1.19,4.71-1.78-1.89-5.06-3.23-5-2.66s3.79,3.49,3.79,3.49a9,9,0,0,0-4,2.2A10.91,10.91,0,0,0,283,344a3,3,0,0,0,.23,2,8.8,8.8,0,0,0,1.1,1.74c.16.22.43.46.66.32s.17-.42.12-.65c-.3-1.15-.59-2.31-.89-3.46a12.89,12.89,0,0,0,4.38-.22.45.45,0,0,0,.25-.12A.29.29,0,0,0,288.8,343.21Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M274.82,354.55l-.12-.1c-.07-.08-.2-.18-.33-.33a6.75,6.75,0,0,1-1-1.38,7.55,7.55,0,0,1-.81-2.38,7.32,7.32,0,0,1,.13-3.07,7.44,7.44,0,0,1,1.41-2.73,7.66,7.66,0,0,1,1.88-1.67,6.71,6.71,0,0,1,1.53-.71,2.81,2.81,0,0,1,.45-.12c.1,0,.15,0,.16,0a9.11,9.11,0,0,0-2.07,1,8.09,8.09,0,0,0-1.82,1.66,7.45,7.45,0,0,0-1.36,2.68,7.28,7.28,0,0,0-.14,3,7.55,7.55,0,0,0,.76,2.35A10.07,10.07,0,0,0,274.82,354.55Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M326.23,279.79a5.94,5.94,0,0,1,6.47,1.11,7.46,7.46,0,0,1,2.14,6.36,10.11,10.11,0,0,1-3.26,6,11.6,11.6,0,0,1-9.52,3,10.21,10.21,0,0,1-7.79-6.07,9.14,9.14,0,0,1,1.79-9.59,8.38,8.38,0,0,1,8.07-2.17,4.19,4.19,0,0,1,2.1,1.35Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M321.83,280.76a2.11,2.11,0,0,0-2.05-.79,6.92,6.92,0,0,0-3.68,2.21,5.48,5.48,0,0,0-1.39,3.72,4,4,0,0,0,2,3.35,3.17,3.17,0,0,0,3.74-.54c.95-1,1-2.6,1.29-4,.16-.67.41-1.32.51-2A2.65,2.65,0,0,0,321.83,280.76Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M331,280.38a.72.72,0,0,0-.38-.13,32.38,32.38,0,0,0-4.28-.47s2.06-2.24-.49-5.36l-1.46.39c2.1,3.26,1.19,4.71,1.19,4.71-1.78-1.89-5.06-3.23-5-2.66s3.79,3.49,3.79,3.49a9,9,0,0,0-4,2.2,10.91,10.91,0,0,0,4.82-1.42,3,3,0,0,0,.23,2,9.1,9.1,0,0,0,1.1,1.74c.16.21.43.46.66.32s.17-.42.12-.65l-.89-3.47a12.64,12.64,0,0,0,4.38-.21.41.41,0,0,0,.25-.13A.27.27,0,0,0,331,280.38Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M317.06,291.72l-.12-.11c-.07-.07-.19-.17-.32-.32a6.36,6.36,0,0,1-1-1.38,7.55,7.55,0,0,1-.81-2.38,7.32,7.32,0,0,1,.13-3.07,7.49,7.49,0,0,1,1.41-2.74,7.81,7.81,0,0,1,1.88-1.66,7.31,7.31,0,0,1,1.53-.72l.45-.12c.1,0,.15,0,.16,0a9.11,9.11,0,0,0-2.07,1,7.64,7.64,0,0,0-1.82,1.66,7.49,7.49,0,0,0-1.36,2.67,7.62,7.62,0,0,0,.62,5.34A10.93,10.93,0,0,0,317.06,291.72Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M304.08,343.27a5.94,5.94,0,0,1,6.47,1.11,7.5,7.5,0,0,1,2.15,6.36,10.17,10.17,0,0,1-3.26,6,11.6,11.6,0,0,1-9.52,3,10.22,10.22,0,0,1-7.79-6.07,9.16,9.16,0,0,1,1.78-9.6,8.45,8.45,0,0,1,8.08-2.17,4.2,4.2,0,0,1,2.09,1.36Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M292.48,346.26a9.22,9.22,0,0,0,0,7.92,9.87,9.87,0,0,0,1.71,2.44,10.1,10.1,0,0,0,2.46,1.88,10.32,10.32,0,0,0,3,1.1,10,10,0,0,0,3.18.11,11.71,11.71,0,0,0,7.7-4.2,9.66,9.66,0,0,0,2.14-4.79,7.8,7.8,0,0,0-.76-4.49,6.14,6.14,0,0,0-5.38-3.44,5.58,5.58,0,0,0-1.8.26c-.4.13-.59.24-.6.22l.15-.07a2.58,2.58,0,0,1,.44-.18,5.18,5.18,0,0,1,1.81-.3,6.16,6.16,0,0,1,2.82.71,6.26,6.26,0,0,1,2.67,2.74,7.8,7.8,0,0,1,.8,4.57,9.72,9.72,0,0,1-2.16,4.88,11.86,11.86,0,0,1-4.76,3.5,11.59,11.59,0,0,1-3.05.78,10.71,10.71,0,0,1-3.24-.12,10.27,10.27,0,0,1-3-1.12,10,10,0,0,1-2.5-1.92,9.81,9.81,0,0,1-1.74-2.49,9.14,9.14,0,0,1-.81-2.8,9.41,9.41,0,0,1,.88-5.26,8,8,0,0,1,3.14-3.42,8.6,8.6,0,0,1,3.66-1.16,8.23,8.23,0,0,1,2.9.28,4.17,4.17,0,0,1,1.6.91,3.09,3.09,0,0,1,.43.47l-.11-.11a4.09,4.09,0,0,0-.35-.33A4.17,4.17,0,0,0,302,342a8.14,8.14,0,0,0-2.87-.24,8.5,8.5,0,0,0-3.61,1.16",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M299.68,344.24a2.09,2.09,0,0,0-2-.79,6.82,6.82,0,0,0-3.68,2.21,5.52,5.52,0,0,0-1.4,3.72,4,4,0,0,0,2,3.35,3.16,3.16,0,0,0,3.73-.54c1-1,1-2.61,1.3-4,.16-.67.4-1.32.5-2A2.65,2.65,0,0,0,299.68,344.24Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M308.9,343.86a.87.87,0,0,0-.39-.14,34,34,0,0,0-4.27-.46s2.06-2.24-.5-5.36l-1.45.39c2.09,3.26,1.19,4.71,1.19,4.71-1.78-1.89-5.06-3.23-5-2.66s3.8,3.48,3.8,3.48a9.13,9.13,0,0,0-4,2.2,11.08,11.08,0,0,0,4.83-1.41,3.11,3.11,0,0,0,.22,2,9.21,9.21,0,0,0,1.1,1.73c.17.22.44.46.67.33s.17-.42.11-.65c-.29-1.16-.59-2.31-.88-3.47a12.9,12.9,0,0,0,4.38-.21.41.41,0,0,0,.25-.13A.28.28,0,0,0,308.9,343.86Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M294.92,355.19s-.05,0-.12-.1a3,3,0,0,1-.33-.32,7.26,7.26,0,0,1-1-1.39,7.55,7.55,0,0,1-.68-5.44,7.49,7.49,0,0,1,1.41-2.74,7.6,7.6,0,0,1,1.89-1.66,6.83,6.83,0,0,1,1.53-.72,4.53,4.53,0,0,1,.44-.12l.16,0a10.52,10.52,0,0,0-2.06,1,7.25,7.25,0,0,0-3.33,7.33,7.94,7.94,0,0,0,.76,2.34A9.77,9.77,0,0,0,294.92,355.19Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M285.33,272.9a5.94,5.94,0,0,1,6.08-2.47,7.49,7.49,0,0,1,5.17,4.29,10.14,10.14,0,0,1,.39,6.83,11.6,11.6,0,0,1-6.52,7.55,10.22,10.22,0,0,1-9.82-1.06,9.16,9.16,0,0,1-3.52-9.11,8.41,8.41,0,0,1,5.72-6.09,4.18,4.18,0,0,1,2.5.06Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M282.1,276a2.11,2.11,0,0,0-2.16.41,6.8,6.8,0,0,0-2,3.81,5.49,5.49,0,0,0,.77,3.9,4,4,0,0,0,3.43,1.81,3.17,3.17,0,0,0,2.9-2.42c.26-1.39-.55-2.72-1-4.07-.22-.65-.35-1.33-.63-2A2.66,2.66,0,0,0,282.1,276Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M289.73,270.86a1,1,0,0,0-.4.09,33.66,33.66,0,0,0-3.88,1.86s.58-3-3.24-4.3l-1,1.09c3.5,1.67,3.49,3.38,3.49,3.38-2.51-.67-6-.08-5.64.36s5.06,1,5.06,1a9,9,0,0,0-2.23,4,10.87,10.87,0,0,0,3.36-3.74,3,3,0,0,0,1.25,1.59,8.8,8.8,0,0,0,1.85.9c.25.1.6.17.73-.07s-.08-.45-.25-.61l-2.57-2.49a12.62,12.62,0,0,0,3.61-2.48.41.41,0,0,0,.15-.24A.28.28,0,0,0,289.73,270.86Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M283.8,287.85l-.16,0a4,4,0,0,1-.45-.1,7,7,0,0,1-1.55-.67,7.57,7.57,0,0,1-3.45-4.27,7.42,7.42,0,0,1-.23-3.07,7.55,7.55,0,0,1,.72-2.4,7.39,7.39,0,0,1,.93-1.42,4.07,4.07,0,0,1,.31-.34l.12-.1a10.08,10.08,0,0,0-1.24,1.91,7.82,7.82,0,0,0-.67,2.37,7.09,7.09,0,0,0,1.7,5.62A7.77,7.77,0,0,0,281.7,287,9.42,9.42,0,0,0,283.8,287.85Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M347.88,299.11a5.94,5.94,0,0,1,6.08-2.47,7.49,7.49,0,0,1,5.17,4.29,10.08,10.08,0,0,1,.38,6.83,11.59,11.59,0,0,1-6.51,7.55,10.22,10.22,0,0,1-9.82-1.06,9.15,9.15,0,0,1-3.53-9.11,8.42,8.42,0,0,1,5.73-6.09,4.18,4.18,0,0,1,2.5.06Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M344.64,302.24a2.1,2.1,0,0,0-2.15.41,6.74,6.74,0,0,0-2,3.81,5.54,5.54,0,0,0,.76,3.9,4,4,0,0,0,3.44,1.81,3.18,3.18,0,0,0,2.9-2.42c.26-1.39-.55-2.72-1-4.07-.21-.65-.35-1.33-.62-2A2.64,2.64,0,0,0,344.64,302.24Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M352.28,297.07a.93.93,0,0,0-.4.09A32.88,32.88,0,0,0,348,299s.58-3-3.24-4.3l-1,1.09c3.49,1.67,3.49,3.38,3.49,3.38-2.51-.67-6-.08-5.64.36s5.06,1,5.06,1a9,9,0,0,0-2.23,4,10.74,10.74,0,0,0,3.35-3.74,3.12,3.12,0,0,0,1.25,1.59,9,9,0,0,0,1.85.9c.26.1.61.17.74-.07s-.08-.45-.25-.61l-2.57-2.49a12.76,12.76,0,0,0,3.61-2.48.41.41,0,0,0,.15-.24A.29.29,0,0,0,352.28,297.07Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M346.35,314.06l-.16,0a3.54,3.54,0,0,1-.45-.1,7,7,0,0,1-1.55-.67,7.39,7.39,0,0,1-1.94-1.59,7.52,7.52,0,0,1-1.51-2.68,7.61,7.61,0,0,1-.24-3.07,7.81,7.81,0,0,1,.73-2.4,6.55,6.55,0,0,1,.93-1.42,4.07,4.07,0,0,1,.31-.34l.12-.1a10.08,10.08,0,0,0-1.24,1.91,8.11,8.11,0,0,0-.68,2.37,7.58,7.58,0,0,0,.25,3,7.44,7.44,0,0,0,1.46,2.63,7.77,7.77,0,0,0,1.87,1.59A9.42,9.42,0,0,0,346.35,314.06Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M300.5,279a5.94,5.94,0,0,1,6.47,1.11,7.49,7.49,0,0,1,2.15,6.36,10.17,10.17,0,0,1-3.26,6,11.6,11.6,0,0,1-9.52,3,10.22,10.22,0,0,1-7.79-6.07,9.16,9.16,0,0,1,1.78-9.6,8.45,8.45,0,0,1,8.08-2.17A4.24,4.24,0,0,1,300.5,279Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M300.5,279l-.11-.11a4.09,4.09,0,0,0-.35-.33,4.17,4.17,0,0,0-1.59-.87,8.14,8.14,0,0,0-2.87-.24,8.5,8.5,0,0,0-3.61,1.16,8.05,8.05,0,0,0-3.07,3.38,9.22,9.22,0,0,0,0,7.92,9.87,9.87,0,0,0,1.71,2.44,10.1,10.1,0,0,0,2.46,1.88,10.32,10.32,0,0,0,3,1.1,10,10,0,0,0,3.18.11,11.71,11.71,0,0,0,7.7-4.2A9.66,9.66,0,0,0,309,286.4a7.8,7.8,0,0,0-.76-4.49,6.14,6.14,0,0,0-5.38-3.44,5.58,5.58,0,0,0-1.8.26c-.4.13-.59.24-.6.22l.15-.07a2.58,2.58,0,0,1,.44-.18,5.18,5.18,0,0,1,1.81-.3,6.16,6.16,0,0,1,2.82.71,6.26,6.26,0,0,1,2.67,2.74,7.8,7.8,0,0,1,.8,4.57A9.72,9.72,0,0,1,307,291.3a11.86,11.86,0,0,1-4.76,3.5,12,12,0,0,1-3,.78,10.71,10.71,0,0,1-3.24-.12,10.27,10.27,0,0,1-3-1.12,10,10,0,0,1-2.5-1.92,9.81,9.81,0,0,1-1.74-2.49,9.14,9.14,0,0,1-.81-2.8,9.41,9.41,0,0,1,.88-5.26,8,8,0,0,1,3.14-3.42,8.6,8.6,0,0,1,3.66-1.16,8.23,8.23,0,0,1,2.9.28,4.17,4.17,0,0,1,1.6.91A3.09,3.09,0,0,1,300.5,279Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.5,279l-.11-.11a4.09,4.09,0,0,0-.35-.33,4.17,4.17,0,0,0-1.59-.87,8.14,8.14,0,0,0-2.87-.24,8.5,8.5,0,0,0-3.61,1.16,8.05,8.05,0,0,0-3.07,3.38,9.22,9.22,0,0,0,0,7.92,9.87,9.87,0,0,0,1.71,2.44,10.1,10.1,0,0,0,2.46,1.88,10.32,10.32,0,0,0,3,1.1,10,10,0,0,0,3.18.11,11.71,11.71,0,0,0,7.7-4.2A9.66,9.66,0,0,0,309,286.4a7.8,7.8,0,0,0-.76-4.49,6.14,6.14,0,0,0-5.38-3.44,5.58,5.58,0,0,0-1.8.26c-.4.13-.59.24-.6.22l.15-.07a2.58,2.58,0,0,1,.44-.18,5.18,5.18,0,0,1,1.81-.3,6.16,6.16,0,0,1,2.82.71,6.26,6.26,0,0,1,2.67,2.74,7.8,7.8,0,0,1,.8,4.57A9.72,9.72,0,0,1,307,291.3a11.86,11.86,0,0,1-4.76,3.5,12,12,0,0,1-3,.78,10.71,10.71,0,0,1-3.24-.12,10.27,10.27,0,0,1-3-1.12,10,10,0,0,1-2.5-1.92,9.81,9.81,0,0,1-1.74-2.49,9.14,9.14,0,0,1-.81-2.8,9.41,9.41,0,0,1,.88-5.26,8,8,0,0,1,3.14-3.42,8.6,8.6,0,0,1,3.66-1.16,8.23,8.23,0,0,1,2.9.28,4.17,4.17,0,0,1,1.6.91A3.09,3.09,0,0,1,300.5,279Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M296.1,279.92a2.09,2.09,0,0,0-2-.79,6.82,6.82,0,0,0-3.68,2.21,5.52,5.52,0,0,0-1.4,3.72,4,4,0,0,0,2,3.35,3.16,3.16,0,0,0,3.73-.54c1-1,1-2.61,1.3-4,.16-.67.4-1.32.5-2A2.65,2.65,0,0,0,296.1,279.92Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M305.32,279.54a.87.87,0,0,0-.39-.14,34,34,0,0,0-4.27-.46s2.06-2.24-.5-5.36l-1.45.39c2.09,3.26,1.19,4.71,1.19,4.71-1.78-1.89-5.06-3.23-5-2.66s3.8,3.48,3.8,3.48a9.13,9.13,0,0,0-4,2.2,11.08,11.08,0,0,0,4.83-1.41,3.11,3.11,0,0,0,.22,2,9.21,9.21,0,0,0,1.1,1.73c.17.22.44.46.67.33s.17-.42.11-.65c-.29-1.16-.59-2.31-.88-3.47a12.9,12.9,0,0,0,4.38-.21.41.41,0,0,0,.25-.13A.28.28,0,0,0,305.32,279.54Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M291.34,290.87s0,0-.12-.1a3,3,0,0,1-.33-.32,7.6,7.6,0,0,1-1-1.39,7.74,7.74,0,0,1-.81-2.37,7.66,7.66,0,0,1,.13-3.07,7.49,7.49,0,0,1,1.41-2.74,7.6,7.6,0,0,1,1.89-1.66,6.83,6.83,0,0,1,1.53-.72,4.53,4.53,0,0,1,.44-.12l.16,0a10.52,10.52,0,0,0-2.06,1,7.25,7.25,0,0,0-3.33,7.33A7.94,7.94,0,0,0,290,289,9.77,9.77,0,0,0,291.34,290.87Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M444,273.07a4.47,4.47,0,0,0-1.44-4.75l0,0a2.26,2.26,0,0,1-.78-2.4c.17-.67.57-1.32.79-2a2.79,2.79,0,0,0-2.21-3.84c-1.62-.21-3.48.5-5.25.89s-3.67.4-4.53-1c-.65-1-.58-2.59-1-3.81a3.2,3.2,0,0,0-1.09-1.55c-2-1.54-5.39-.1-7.43,2.94l-5,7.45-.33,10.5,7.35,4.92,11.35,1.76,8.93-6Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M444,273.07a4.47,4.47,0,0,0-1.44-4.75l0,0a2.26,2.26,0,0,1-.78-2.4c.17-.67.57-1.32.79-2a2.79,2.79,0,0,0-2.21-3.84c-1.62-.21-3.48.5-5.25.89s-3.67.4-4.53-1c-.65-1-.58-2.59-1-3.81a3.2,3.2,0,0,0-1.09-1.55c-2-1.54-5.39-.1-7.43,2.94l-5,7.45-.33,10.5,7.35,4.92,11.35,1.76,8.93-6Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M406.7,277.27c-1.87-3.22-4.4-5.39-5.56-7.12a1.63,1.63,0,0,1-.33-1.46,2,2,0,0,1,2.18-1.2c.73.17,1.4.62,2.24.28-.49-1.55-1-3.11-1.46-4.67a1.45,1.45,0,0,1,0-1.17,1.42,1.42,0,0,1,1.31-.61,16.49,16.49,0,0,1,7,1.45c.39-1.81-1.36-3.12-.28-4.79a3.32,3.32,0,0,1,2.29-1.28,16.46,16.46,0,0,1,5.37-.5,4.11,4.11,0,0,1,3.62,2.94c.58,2.23-.52,5.23-1.92,7.81a5.1,5.1,0,0,0-.89,2.5c.07.86.8,1.22,1.52,1.36a33.29,33.29,0,0,0,4.91.1c1.63.07,3.24.55,3.93,2l-2.28,12.69s-10.44,15.42-10.59,15.8-9.27,1.42-9.11,1.69-.28-14.48-.28-14.48S408.07,279.62,406.7,277.27Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.7,277.27c-1.87-3.22-4.4-5.39-5.56-7.12a1.63,1.63,0,0,1-.33-1.46,2,2,0,0,1,2.18-1.2c.73.17,1.4.62,2.24.28-.49-1.55-1-3.11-1.46-4.67a1.45,1.45,0,0,1,0-1.17,1.42,1.42,0,0,1,1.31-.61,16.49,16.49,0,0,1,7,1.45c.39-1.81-1.36-3.12-.28-4.79a3.32,3.32,0,0,1,2.29-1.28,16.46,16.46,0,0,1,5.37-.5,4.11,4.11,0,0,1,3.62,2.94c.58,2.23-.52,5.23-1.92,7.81a5.1,5.1,0,0,0-.89,2.5c.07.86.8,1.22,1.52,1.36a33.29,33.29,0,0,0,4.91.1c1.63.07,3.24.55,3.93,2l-2.28,12.69s-10.44,15.42-10.59,15.8-9.27,1.42-9.11,1.69-.28-14.48-.28-14.48S408.07,279.62,406.7,277.27Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M418.91,323c2.63-3.38,26-45.12,28.67-48.5,1.29-1.67,2.72-3.76,2.42-5.43a1.94,1.94,0,0,0-2.15-1.55,7,7,0,0,0-3.2,1.26,22.26,22.26,0,0,0-5.45,4.91,26.74,26.74,0,0,1-2.24,2.7,3.7,3.7,0,0,1-2.69,1.31c-1.88-.25-1.53-3.6-3.07-4.54-1.31-.79-3.56.59-4.77,2.47a12.77,12.77,0,0,0-1.74,6,29.44,29.44,0,0,1-.67,6,3.27,3.27,0,0,1-.77,1.5,1.29,1.29,0,0,1-2-.23c-.41-.61-.6-1.46-1.17-1.88-1-.71-2.78.21-3.85,1.64a10.4,10.4,0,0,0-1.78,4.76,38.39,38.39,0,0,1-.75,4.81l-5.14,9.5.67,14.84,5.57,1.17Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M418.91,323c2.63-3.38,26-45.12,28.67-48.5,1.29-1.67,2.72-3.76,2.42-5.43a1.94,1.94,0,0,0-2.15-1.55,7,7,0,0,0-3.2,1.26,22.26,22.26,0,0,0-5.45,4.91,26.74,26.74,0,0,1-2.24,2.7,3.7,3.7,0,0,1-2.69,1.31c-1.88-.25-1.53-3.6-3.07-4.54-1.31-.79-3.56.59-4.77,2.47a12.77,12.77,0,0,0-1.74,6,29.44,29.44,0,0,1-.67,6,3.27,3.27,0,0,1-.77,1.5,1.29,1.29,0,0,1-2-.23c-.41-.61-.6-1.46-1.17-1.88-1-.71-2.78.21-3.85,1.64a10.4,10.4,0,0,0-1.78,4.76,38.39,38.39,0,0,1-.75,4.81l-5.14,9.5.67,14.84,5.57,1.17Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M442.4,275.41c.05,0-1.26,2.12-2.93,4.65s-3.08,4.54-3.14,4.5,1.26-2.11,2.94-4.64S442.34,275.38,442.4,275.41Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M428.69,285a4.89,4.89,0,0,1-.55-1.42,5,5,0,0,1-.32-1.48,4.58,4.58,0,0,1,.55,1.42A5,5,0,0,1,428.69,285Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M413.6,280.15a.68.68,0,0,1,.08-.21c.06-.17.15-.36.25-.6.23-.51.53-1.27.9-2.21a40.09,40.09,0,0,0,2.06-7.55,30.4,30.4,0,0,0,.33-7.81q-.06-.75-.15-1.35c-.06-.39-.11-.73-.17-1l-.12-.63a.12.12,0,1,1,.05,0c0,.17.1.37.16.63a10,10,0,0,1,.21,1c.08.4.14.85.19,1.35a28,28,0,0,1-.27,7.87A36,36,0,0,1,415,277.2c-.38.93-.71,1.68-1,2.18l-.29.58C413.65,280.09,413.61,280.16,413.6,280.15Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M438,275s.13-.34.34-1a9,9,0,0,0,.43-2.75,5.59,5.59,0,0,0-.32-1.88,3.49,3.49,0,0,0-1.28-1.71,3.74,3.74,0,0,0-2.27-.62,6,6,0,0,0-2.49.7,10.15,10.15,0,0,1-2.46,1,2,2,0,0,1-1.31-.12,1.63,1.63,0,0,1-.74-1c-.23-.78-.23-1.54-.4-2.21a2.74,2.74,0,0,0-2.45-2.1,3.43,3.43,0,0,0-1.19.07c-.64.15-1,.33-1,.3a1.2,1.2,0,0,1,.23-.13,3.44,3.44,0,0,1,.73-.26,3.7,3.7,0,0,1,1.22-.12,2.92,2.92,0,0,1,2.63,2.19c.19.7.2,1.46.42,2.19a1.39,1.39,0,0,0,.63.89,1.76,1.76,0,0,0,1.16.09,10.36,10.36,0,0,0,2.41-1,6.15,6.15,0,0,1,2.58-.73,4.05,4.05,0,0,1,2.41.68,3.69,3.69,0,0,1,1.34,1.82,5.8,5.8,0,0,1,.3,1.95,8.11,8.11,0,0,1-.52,2.78,5.23,5.23,0,0,1-.29.71C438.09,274.89,438,275,438,275Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M415,322.17c-1.05-.67-1-2.22-.48-3.35s1.36-2.26,1.18-3.5-1.49-2.35-1.38-3.67c.18-2.33,4.2-2.6,4.63-4.9.27-1.47-1.16-2.72-1.35-4.21-.31-2.39,2.59-4.18,2.62-6.59s-3.11-4.47-2.62-7c.27-1.35,1.57-2.33,1.8-3.69a3.88,3.88,0,0,0-1-3c-.67-.84-1.51-1.54-2.14-2.42-1.47-2-1.63-4.67-2.28-7.08-.7-2.62-2.54-5.43-5.42-5.15a4.58,4.58,0,0,0-2.85,1.47c-1.52,1.62-2,3.8-2.29,5.92a81.53,81.53,0,0,0,.5,24.65,210.62,210.62,0,0,0,4.59,20.76,8.31,8.31,0,0,0,6.54,6.15c.23,0,.47.07.71.09,3.35.26,5.45-4,5.45-4S417.48,323.75,415,322.17Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M413.77,323c-1.06-.67-1-2.22-.49-3.35s1.36-2.26,1.18-3.5-1.48-2.36-1.38-3.68c.19-2.33,4.21-2.6,4.63-4.89.27-1.47-1.15-2.73-1.34-4.21-.31-2.39,2.59-4.18,2.62-6.59s-3.11-4.47-2.62-7c.26-1.36,1.57-2.33,1.8-3.69a3.87,3.87,0,0,0-1-3c-.68-.84-1.52-1.55-2.15-2.42-1.46-2-1.62-4.67-2.27-7.08-.71-2.63-2.55-5.43-5.43-5.15a4.53,4.53,0,0,0-2.84,1.47c-1.52,1.62-2,3.79-2.3,5.91a81.59,81.59,0,0,0,.5,24.66,211.3,211.3,0,0,0,4.6,20.76,8.3,8.3,0,0,0,6.54,6.15c.23,0,.47.07.71.09,3.34.26,5.45-4,5.45-4S416.24,324.59,413.77,323Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M441.75,276.81a7.49,7.49,0,0,0-12.84,6c.13,1.18.44,2.6-.48,3.34a6,6,0,0,1-1.22.59c-1.64.8-2,2.95-1.94,4.76s.47,3.76-.35,5.39c-.67,1.31-2,2.21-2.49,3.61-.58,1.73.42,3.6.29,5.42-.2,2.81-2.92,4.71-4.12,7.26-.91,1.91-.92,4.1-1.31,6.18s-1.35,4.3-3.31,5.1l1.26,2.24c3.67-.69,7.5-3.4,10.22-6s5.35-7.76,7.23-11c5.57-9.54,7.83-14.11,10.53-23.77C444.13,282.74,444.1,279.25,441.75,276.81Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M413,320.56a10.51,10.51,0,0,1-2.2-2.88c-.62-1.47-.4-3.14-.42-4.73a31.42,31.42,0,0,0-.8-5.7L407,294.54c-1.27,6.33,1.76,12.8,1.33,19.24-.17,2.58-.88,5.16-1,7.71a8.35,8.35,0,0,0,6.3,5.95,4.75,4.75,0,0,0,1.13-3.95,4.75,4.75,0,0,1-1-.47A2.26,2.26,0,0,1,413,320.56Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M405.24,272a1,1,0,0,1,0,.13c0,.1,0,.23-.06.38-.06.33-.12.82-.2,1.44a34,34,0,0,0-.14,5.35c.1,2.27.43,4.94.83,7.91s.82,6.24,1.28,9.67.87,6.7,1.26,9.67.68,5.66,1.07,7.89a25,25,0,0,0,1.4,5.16c.24.58.45,1,.6,1.32l.17.34.06.12s0,0-.08-.11l-.19-.33a13.19,13.19,0,0,1-.65-1.31,23.41,23.41,0,0,1-1.48-5.16c-.41-2.24-.71-4.92-1.12-7.89s-.83-6.24-1.28-9.67-.87-6.69-1.26-9.67-.7-5.66-.77-7.93a30.58,30.58,0,0,1,.21-5.37q.14-.95.24-1.44l.09-.37A.58.58,0,0,1,405.24,272Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M429.38,291.32a9.22,9.22,0,0,1,.53,1.45c.28.91.64,2.17,1,3.59s.57,2.7.72,3.64a7.88,7.88,0,0,1,.18,1.53,12,12,0,0,1-.34-1.5c-.19-.93-.47-2.21-.8-3.62s-.66-2.67-.91-3.59A12.47,12.47,0,0,1,429.38,291.32Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M440.57,282.75s0,0,0,.12l-.12.34c-.12.31-.29.74-.49,1.29-.44,1.11-1.08,2.73-1.92,4.71-1.66,4-4.08,9.37-7,15.21-1.48,2.92-2.92,5.69-4.34,8.15a59.27,59.27,0,0,1-4.13,6.31,35.19,35.19,0,0,1-3.34,3.83c-.42.43-.77.74-1,1l-.27.24-.1.07.08-.09.25-.25c.23-.22.57-.55,1-1a41,41,0,0,0,3.27-3.87,62.6,62.6,0,0,0,4.07-6.32c1.4-2.46,2.84-5.23,4.32-8.15,2.95-5.84,5.4-11.23,7.1-15.17.85-2,1.51-3.57,2-4.68.23-.54.4-1,.53-1.27l.15-.33A.61.61,0,0,1,440.57,282.75Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 409.26,
    y: 325.94,
    width: 8.46,
    height: 3.17,
    transform: "translate(21.29 -108.89) rotate(9.12)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 409.26,
    y: 325.94,
    width: 8.46,
    height: 3.17,
    transform: "translate(21.29 -108.89) rotate(9.12)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M417.38,326.55c1.47-.78,1.27-1.45,2.32-2.74.29-.35.6-.68.89-1,1-1.16,2.12-3.94,2.82-5.31-.9.45-1.84,2.69-2.61,3.34a4.34,4.34,0,0,1-2.66,1.24c-.59,0-1.25-.16-1.71.19s-.47.72-.73,1.06-.39.67-.9.58a5.1,5.1,0,0,1-.35,2.18Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M417.6,326.71a29.15,29.15,0,0,1-3.82-.49,30.37,30.37,0,0,1-3.78-.73,29.15,29.15,0,0,1,3.82.49A32.74,32.74,0,0,1,417.6,326.71Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M396.64,272.25c-1-1.87-2.63-2.8-4.19-2.65h0a2.24,2.24,0,0,1-2.16-1.31c-.31-.61-.43-1.37-.71-2a2.78,2.78,0,0,0-4.18-1.45c-1.36.89-2.3,2.64-3.39,4.1s-2.51,2.7-4.05,2.24c-1.16-.35-2.14-1.58-3.24-2.24a3.22,3.22,0,0,0-1.84-.46c-2.5.13-4.14,3.45-3.69,7.08l1.09,8.9,6.62,8.16,8.78-1.08,9.74-6.09,2.8-10.41Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.64,272.25c-1-1.87-2.63-2.8-4.19-2.65h0a2.24,2.24,0,0,1-2.16-1.31c-.31-.61-.43-1.37-.71-2a2.78,2.78,0,0,0-4.18-1.45c-1.36.89-2.3,2.64-3.39,4.1s-2.51,2.7-4.05,2.24c-1.16-.35-2.14-1.58-3.24-2.24a3.22,3.22,0,0,0-1.84-.46c-2.5.13-4.14,3.45-3.69,7.08l1.09,8.9,6.62,8.16,8.78-1.08,9.74-6.09,2.8-10.41Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M371.16,299.83c-3.52-1.21-6.85-1.2-8.86-1.75a1.65,1.65,0,0,1-1.21-.89,2,2,0,0,1,.88-2.33c.66-.35,1.46-.45,1.87-1.25L359.68,291a1.25,1.25,0,0,1-.15-2.23,16.68,16.68,0,0,1,6.25-3.48c-.89-1.62-3.08-1.47-3.35-3.44a3.33,3.33,0,0,1,.9-2.46,16.33,16.33,0,0,1,3.73-3.89,4.08,4.08,0,0,1,4.66-.14c1.9,1.3,3,4.29,3.65,7.16a5.1,5.1,0,0,0,1,2.47,1.61,1.61,0,0,0,2,0,33.28,33.28,0,0,0,3.78-3.14c1.28-1,2.81-1.7,4.3-1L393,292s2.19,18.49,2.33,18.89-6.08,7.13-5.79,7.23-9.69-10.77-9.69-10.77S373.74,300.72,371.16,299.83Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.16,299.83c-3.52-1.21-6.85-1.2-8.86-1.75a1.65,1.65,0,0,1-1.21-.89,2,2,0,0,1,.88-2.33c.66-.35,1.46-.45,1.87-1.25L359.68,291a1.25,1.25,0,0,1-.15-2.23,16.68,16.68,0,0,1,6.25-3.48c-.89-1.62-3.08-1.47-3.35-3.44a3.33,3.33,0,0,1,.9-2.46,16.33,16.33,0,0,1,3.73-3.89,4.08,4.08,0,0,1,4.66-.14c1.9,1.3,3,4.29,3.65,7.16a5.1,5.1,0,0,0,1,2.47,1.61,1.61,0,0,0,2,0,33.28,33.28,0,0,0,3.78-3.14c1.28-1,2.81-1.7,4.3-1L393,292s2.19,18.49,2.33,18.89-6.08,7.13-5.79,7.23-9.69-10.77-9.69-10.77S373.74,300.72,371.16,299.83Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M410.33,326.47c-.22-4.28-9.81-51.17-10-55.45-.11-2.11-.39-4.62-1.71-5.69a1.93,1.93,0,0,0-2.64.24,7.12,7.12,0,0,0-1.61,3,22.53,22.53,0,0,0-.9,7.28,27.51,27.51,0,0,1,.08,3.51,3.75,3.75,0,0,1-1.19,2.75c-1.58,1-3.51-1.72-5.29-1.43-1.5.26-2.31,2.78-2,5a12.71,12.71,0,0,0,2.62,5.69,29.52,29.52,0,0,1,3.4,5,3.21,3.21,0,0,1,.39,1.64,1.28,1.28,0,0,1-1.68,1.15c-.71-.2-1.41-.71-2.11-.66-1.22.11-2,2-1.85,3.76a10.52,10.52,0,0,0,1.78,4.77,38.81,38.81,0,0,1,2.57,4.13l2.33,10.54,10.21,10.8,5-2.76Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410.33,326.47c-.22-4.28-9.81-51.17-10-55.45-.11-2.11-.39-4.62-1.71-5.69a1.93,1.93,0,0,0-2.64.24,7.12,7.12,0,0,0-1.61,3,22.53,22.53,0,0,0-.9,7.28,27.51,27.51,0,0,1,.08,3.51,3.75,3.75,0,0,1-1.19,2.75c-1.58,1-3.51-1.72-5.29-1.43-1.5.26-2.31,2.78-2,5a12.71,12.71,0,0,0,2.62,5.69,29.52,29.52,0,0,1,3.4,5,3.21,3.21,0,0,1,.39,1.64,1.28,1.28,0,0,1-1.68,1.15c-.71-.2-1.41-.71-2.11-.66-1.22.11-2,2-1.85,3.76a10.52,10.52,0,0,0,1.78,4.77,38.81,38.81,0,0,1,2.57,4.13l2.33,10.54,10.21,10.8,5-2.76Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M397,275.08c.06,0,.43,2.42.81,5.43s.65,5.45.58,5.46-.43-2.42-.81-5.43S396.89,275.09,397,275.08Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M392.88,291.33a4.83,4.83,0,0,1-1.34-.71,5,5,0,0,1-1.21-.92,4.83,4.83,0,0,1,1.34.71A4.5,4.5,0,0,1,392.88,291.33Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M378.27,297.5a.61.61,0,0,1-.08-.21l-.2-.62c-.16-.54-.43-1.31-.76-2.26a40.22,40.22,0,0,0-3.39-7.06,30.68,30.68,0,0,0-4.85-6.13c-.36-.35-.69-.66-1-.91s-.56-.49-.78-.66l-.51-.4a.84.84,0,0,1-.17-.16l.2.12.53.37a9.19,9.19,0,0,1,.82.63c.31.24.66.54,1,.89a28.38,28.38,0,0,1,4.94,6.13,36.7,36.7,0,0,1,3.34,7.13c.31.95.55,1.73.69,2.28l.15.63C378.27,297.42,378.28,297.49,378.27,297.5Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M393.37,277.6s-.13-.35-.38-1a9,9,0,0,0-1.48-2.37,5.57,5.57,0,0,0-1.47-1.21,3.48,3.48,0,0,0-2.09-.46,3.76,3.76,0,0,0-2.12,1,5.86,5.86,0,0,0-1.42,2.15,10.53,10.53,0,0,1-1.19,2.4,2,2,0,0,1-1.07.77,1.61,1.61,0,0,1-1.22-.29c-.69-.45-1.18-1-1.75-1.41a2.77,2.77,0,0,0-3.23,0,3.74,3.74,0,0,0-.85.83c-.39.53-.52.89-.55.87s0-.09.1-.25A3.15,3.15,0,0,1,375,278a3.66,3.66,0,0,1,.85-.89,2.93,2.93,0,0,1,1.52-.58,3,3,0,0,1,1.9.52c.6.4,1.11,1,1.75,1.38a1.42,1.42,0,0,0,1.06.26A1.81,1.81,0,0,0,383,278a10.7,10.7,0,0,0,1.15-2.35,6.26,6.26,0,0,1,1.48-2.24,4,4,0,0,1,2.26-1.06,3.68,3.68,0,0,1,2.21.5,6,6,0,0,1,1.5,1.28,8.38,8.38,0,0,1,1.43,2.44,6.58,6.58,0,0,1,.24.73A.85.85,0,0,1,393.37,277.6Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.82,328.36c-1.24.19-2.22-1-2.56-2.22s-.45-2.59-1.4-3.41-2.66-.81-3.44-1.88c-1.39-1.88,1.48-4.72.3-6.73-.76-1.29-2.66-1.31-3.77-2.31-1.8-1.6-.78-4.85-2.33-6.7s-5.28-1.35-6.54-3.55c-.68-1.2-.33-2.79-1.05-4a3.86,3.86,0,0,0-2.71-1.58c-1.06-.19-2.16-.17-3.21-.42-2.42-.58-4.28-2.47-6.35-3.87-2.25-1.53-5.48-2.45-7.47-.35a4.58,4.58,0,0,0-1.19,3c-.09,2.22,1,4.16,2.13,6a81.74,81.74,0,0,0,16.51,18.32,211.15,211.15,0,0,0,17.05,12.7,8.33,8.33,0,0,0,9,.38c.2-.12.4-.26.59-.4,2.71-2,1.54-6.56,1.54-6.56S409.72,327.94,406.82,328.36Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M406.43,329.82c-1.23.18-2.22-1-2.56-2.22s-.45-2.6-1.39-3.42-2.67-.81-3.45-1.88c-1.38-1.88,1.48-4.71.3-6.73-.75-1.29-2.65-1.31-3.77-2.3-1.8-1.61-.77-4.86-2.33-6.7S388,305.22,386.7,303c-.69-1.2-.34-2.79-1.05-4a3.89,3.89,0,0,0-2.72-1.59c-1.06-.19-2.15-.17-3.2-.42-2.43-.57-4.29-2.47-6.35-3.87-2.25-1.52-5.48-2.44-7.48-.35a4.6,4.6,0,0,0-1.19,3c-.09,2.22,1,4.16,2.14,6a81.72,81.72,0,0,0,16.5,18.33c5.41,4.58,11.21,8.68,17,12.7a8.33,8.33,0,0,0,9,.37,7,7,0,0,0,.6-.4c2.7-2,1.53-6.56,1.53-6.56S409.33,329.39,406.43,329.82Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M397.38,276.56a7.49,7.49,0,0,0-5.78,12.94c.86.81,2,1.69,1.82,2.85a6.75,6.75,0,0,1-.54,1.24c-.72,1.67.38,3.56,1.65,4.87s2.81,2.53,3.25,4.3c.36,1.43-.08,3,.48,4.36.7,1.69,2.68,2.45,3.77,3.92,1.68,2.25.88,5.47,1.63,8.18.56,2,2,3.71,3,5.53s1.79,4.14.84,6l2.41.87c2.33-2.92,3.45-7.47,3.83-11.19s-1-9.37-1.71-13c-2-10.85-3.3-15.79-7.58-24.86C403.06,279.49,400.75,276.87,397.38,276.56Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M404.24,328.47a10.57,10.57,0,0,1-3.55-.75c-1.43-.7-2.36-2.1-3.42-3.3a30.63,30.63,0,0,0-4.33-3.78l-10.28-7.92c3.18,5.63,9.7,8.53,13.59,13.69,1.56,2.06,2.7,4.48,4.29,6.48a8.34,8.34,0,0,0,8.66.38,4.75,4.75,0,0,0-1.73-3.72,5.12,5.12,0,0,1-1,.27A2.25,2.25,0,0,1,404.24,328.47Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M366.64,296.82l.07.11.21.32c.17.29.44.7.79,1.22a33.2,33.2,0,0,0,3.39,4.14c1.56,1.65,3.55,3.46,5.8,5.45l7.29,6.47,7.28,6.5c2.24,2,4.22,3.83,6,5.26a24.65,24.65,0,0,0,4.43,3c.56.28,1,.48,1.32.6l.35.15.12.06-.12,0-.36-.12a11.79,11.79,0,0,1-1.35-.57,23.34,23.34,0,0,1-4.5-2.94c-1.77-1.42-3.76-3.25-6-5.23L384,314.71l-7.28-6.49c-2.23-2-4.22-3.82-5.77-5.49a32.54,32.54,0,0,1-3.35-4.2c-.34-.54-.6-1-.76-1.25l-.18-.34C366.65,296.87,366.63,296.83,366.64,296.82Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M397.52,295.63a8.58,8.58,0,0,1,1.34.75c.81.5,1.91,1.22,3.09,2.07s2.2,1.67,2.93,2.28a10,10,0,0,1,1.14,1,10.35,10.35,0,0,1-1.25-.9c-.75-.58-1.79-1.37-3-2.22s-2.25-1.59-3-2.13A9.87,9.87,0,0,1,397.52,295.63Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M400.37,281.82s0,0,.06.11l.12.34c.12.31.28.75.48,1.3.4,1.13,1,2.77,1.63,4.81,1.33,4.08,3,9.76,4.62,16.11.79,3.18,1.51,6.22,2.05,9a58.92,58.92,0,0,1,1,7.47,36.56,36.56,0,0,1,0,5.09c0,.6-.1,1.06-.15,1.37l-.05.36a1.13,1.13,0,0,1,0,.12s0,0,0-.12,0-.22,0-.36c0-.32.07-.78.09-1.38a39.92,39.92,0,0,0-.05-5.07,63.69,63.69,0,0,0-1.06-7.44c-.55-2.78-1.27-5.81-2.06-9-1.58-6.35-3.26-12-4.55-16.12-.64-2-1.19-3.69-1.56-4.83-.18-.56-.33-1-.43-1.31,0-.14-.08-.26-.11-.35Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 404.94,
    y: 331.83,
    width: 8.46,
    height: 3.17,
    transform: "translate(-150.05 217.47) rotate(-31.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 404.94,
    y: 331.83,
    width: 8.46,
    height: 3.17,
    transform: "translate(-150.05 217.47) rotate(-31.72)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M411.47,330.13c.61-1.56,0-1.93,0-3.6,0-.45,0-.9,0-1.34,0-1.54-1-4.36-1.34-5.86-.38.93.37,3.24.21,4.23a4.34,4.34,0,0,1-1.2,2.68c-.44.39-1.05.69-1.17,1.26a4.66,4.66,0,0,0,.14,1.28c0,.52.15.76-.3,1a4.93,4.93,0,0,1,1.16,1.88Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M411.74,330.1a61.26,61.26,0,0,1-6.54,4,28.55,28.55,0,0,1,3.21-2.12A34.2,34.2,0,0,1,411.74,330.1Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M412.11,327.77a28.87,28.87,0,0,0,1.68-7.32c.38-3.71-1-9.37-1.71-13-2-10.85-3.3-15.79-7.58-24.86a12.64,12.64,0,0,0-3-4.18c-.68-3.77-1.13-6.47-1.18-7.35-.11-2.11-.39-4.62-1.71-5.69a1.93,1.93,0,0,0-2.64.24,7.12,7.12,0,0,0-1.61,3c-.12.39-.21.81-.31,1.22a3.4,3.4,0,0,0-1.57-.23h0a2.24,2.24,0,0,1-2.16-1.31c-.31-.61-.43-1.37-.71-2a2.78,2.78,0,0,0-4.18-1.45c-1.36.89-2.3,2.64-3.39,4.1s-2.51,2.7-4.05,2.24c-1.16-.35-2.14-1.58-3.24-2.24a3.22,3.22,0,0,0-1.84-.46c-2.32.12-3.9,3-3.76,6.31a4.89,4.89,0,0,0-2,.76,16.33,16.33,0,0,0-3.73,3.89,3.33,3.33,0,0,0-.9,2.46c.27,2,2.46,1.82,3.35,3.44a16.68,16.68,0,0,0-6.25,3.48,1.25,1.25,0,0,0,.15,2.23l4.16,2.58c-.41.8-1.21.9-1.87,1.25a2,2,0,0,0-.88,2.33,1.65,1.65,0,0,0,1.21.89,25.08,25.08,0,0,0,2.88.49,16.24,16.24,0,0,0,1.67,3.2,81.72,81.72,0,0,0,16.5,18.33c5.41,4.58,11.21,8.68,17,12.7l.13.08h0l.31.17a7.51,7.51,0,0,0,.68.39l.29.12a7.61,7.61,0,0,0,.79.31l.1,0a8.27,8.27,0,0,0,2,.38h0L406.4,337l7.2-4.45-1.66-2.69-.35.21c0-.15.06-.3.08-.45A6.27,6.27,0,0,0,412.11,327.77Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M386,315.93c-2.59-.57-4.75-.08-5.87,1.15v0a3,3,0,0,1-3,.63c-.83-.2-1.64-.65-2.48-.91-2.55-.81-4.47.38-4.72,2s.64,3.52,1.15,5.32.52,3.71-1.16,4.5c-1.25.58-3.2.42-4.7.76a3.83,3.83,0,0,0-1.91,1c-1.89,1.89-.07,5.42,3.71,7.65l9.26,5.48,13,1,6-7.08,2.08-11.3-7.56-9.34Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386,315.93c-2.59-.57-4.75-.08-5.87,1.15v0a3,3,0,0,1-3,.63c-.83-.2-1.64-.65-2.48-.91-2.55-.81-4.47.38-4.72,2s.64,3.52,1.15,5.32.52,3.71-1.16,4.5c-1.25.58-3.2.42-4.7.76a3.83,3.83,0,0,0-1.91,1c-1.89,1.89-.07,5.42,3.71,7.65l9.26,5.48,13,1,6-7.08,2.08-11.3-7.56-9.34Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M391.51,353.68c-4,1.68-6.63,4.09-8.77,5.15a2.32,2.32,0,0,1-1.8.24,2,2,0,0,1-1.5-2.27c.2-.72.75-1.36.33-2.23L374,355.75a2.23,2.23,0,0,1-1.45-.1,1.46,1.46,0,0,1-.77-1.36,13.45,13.45,0,0,1,1.73-6.94c-2.23-.51-3.85,1.17-5.92,0A3.46,3.46,0,0,1,366,345a13.56,13.56,0,0,1-.67-5.42,4.1,4.1,0,0,1,3.61-3.46c2.75-.45,6.47.85,9.68,2.42a7.74,7.74,0,0,0,3.1,1,1.65,1.65,0,0,0,1.67-1.44c.37-1.53,0-3.3.09-4.93s.65-3.22,2.47-3.83l15.72,3.08s19.18,11.45,19.66,11.62,1.84,9.41,2.17,9.27-17.92-.62-17.92-.62S394.41,352.45,391.51,353.68Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.51,353.68c-4,1.68-6.63,4.09-8.77,5.15a2.32,2.32,0,0,1-1.8.24,2,2,0,0,1-1.5-2.27c.2-.72.75-1.36.33-2.23L374,355.75a2.23,2.23,0,0,1-1.45-.1,1.46,1.46,0,0,1-.77-1.36,13.45,13.45,0,0,1,1.73-6.94c-2.23-.51-3.85,1.17-5.92,0A3.46,3.46,0,0,1,366,345a13.56,13.56,0,0,1-.67-5.42,4.1,4.1,0,0,1,3.61-3.46c2.75-.45,6.47.85,9.68,2.42a7.74,7.74,0,0,0,3.1,1,1.65,1.65,0,0,0,1.67-1.44c.37-1.53,0-3.3.09-4.93s.65-3.22,2.47-3.83l15.72,3.08s19.18,11.45,19.66,11.62,1.84,9.41,2.17,9.27-17.92-.62-17.92-.62S394.41,352.45,391.51,353.68Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M448.05,344.25c-4.21-2.85-56.08-29-60.3-31.82-2.07-1.4-4.67-3-6.73-2.76a1.89,1.89,0,0,0-1.9,2.06,6.89,6.89,0,0,0,1.58,3.3,27.08,27.08,0,0,0,6.14,5.77,40.59,40.59,0,0,1,3.36,2.42c1,.88,1.77,1.95,1.64,2.79-.29,1.87-4.44,1.31-5.59,2.8-1,1.26.76,3.61,3.1,4.94a19.17,19.17,0,0,0,7.46,2.12,46.25,46.25,0,0,1,7.4,1.05,4.63,4.63,0,0,1,1.86.87,1.14,1.14,0,0,1-.27,2c-.75.37-1.8.51-2.31,1.06-.88.95.28,2.81,2.06,4a15.67,15.67,0,0,0,5.91,2.08,58,58,0,0,1,6,1.06l11.79,5.75,18.37.25,1.4-5.53Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448.05,344.25c-4.21-2.85-56.08-29-60.3-31.82-2.07-1.4-4.67-3-6.73-2.76a1.89,1.89,0,0,0-1.9,2.06,6.89,6.89,0,0,0,1.58,3.3,27.08,27.08,0,0,0,6.14,5.77,40.59,40.59,0,0,1,3.36,2.42c1,.88,1.77,1.95,1.64,2.79-.29,1.87-4.44,1.31-5.59,2.8-1,1.26.76,3.61,3.1,4.94a19.17,19.17,0,0,0,7.46,2.12,46.25,46.25,0,0,1,7.4,1.05,4.63,4.63,0,0,1,1.86.87,1.14,1.14,0,0,1-.27,2c-.75.37-1.8.51-2.31,1.06-.88.95.28,2.81,2.06,4a15.67,15.67,0,0,0,5.91,2.08,58,58,0,0,1,6,1.06l11.79,5.75,18.37.25,1.4-5.53Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M388.9,317.69c0-.05,2.63,1.4,5.77,3.24s5.65,3.37,5.61,3.42-2.63-1.39-5.77-3.23S388.85,317.75,388.9,317.69Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M400.94,332.07a6.9,6.9,0,0,1-1.75.46,7.56,7.56,0,0,1-1.84.23,6.66,6.66,0,0,1,1.75-.47A6.75,6.75,0,0,1,400.94,332.07Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M395,346.93l-.27-.09-.74-.29c-.64-.27-1.58-.62-2.74-1A61.45,61.45,0,0,0,381.9,343a46.5,46.5,0,0,0-9.67-.82c-.62,0-1.18,0-1.66.07s-.91.06-1.25.11l-.79.08a1.49,1.49,0,0,1-.28,0,1,1,0,0,1,.27-.06l.78-.13c.33-.06.75-.09,1.24-.14s1-.09,1.67-.11a43.42,43.42,0,0,1,9.74.76,56,56,0,0,1,9.4,2.61c1.15.45,2.08.82,2.71,1.11l.72.34A.84.84,0,0,1,395,346.93Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M388.39,322.05s-.43-.16-1.21-.4a13.72,13.72,0,0,0-3.41-.61,8.57,8.57,0,0,0-2.33.21,4,4,0,0,0-2.11,1.17,3.12,3.12,0,0,0-.74,2.25,5.33,5.33,0,0,0,.89,2.54,10.64,10.64,0,0,1,1.31,2.55,1.6,1.6,0,0,1-.14,1.3,1.88,1.88,0,0,1-1.26.68c-1,.18-1.91.13-2.72.27a3.34,3.34,0,0,0-1.92.92,2.39,2.39,0,0,0-.67,1.41,2.86,2.86,0,0,0,.1,1.2c.19.65.42,1,.38,1a2.21,2.21,0,0,1-.16-.25,3.51,3.51,0,0,1-.34-.74,3.15,3.15,0,0,1-.15-1.24,2.49,2.49,0,0,1,.67-1.5,3.53,3.53,0,0,1,2-1c.85-.15,1.8-.11,2.71-.28a1.65,1.65,0,0,0,1.09-.59,1.42,1.42,0,0,0,.1-1.15,10.35,10.35,0,0,0-1.28-2.49,5.52,5.52,0,0,1-.92-2.63,3.24,3.24,0,0,1,.81-2.38,4.29,4.29,0,0,1,2.25-1.24,8.71,8.71,0,0,1,2.4-.18,13.19,13.19,0,0,1,3.45.69c.39.14.69.26.89.35A1.38,1.38,0,0,1,388.39,322.05Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M447,348.11c-.82,1-2.74.88-4.15.28s-2.81-1.51-4.34-1.4-2.9,1.34-4.53,1.16c-2.89-.33-3.26-4.39-6.11-5-1.82-.36-3.36,1-5.19,1.09-3,.16-5.2-2.86-8.18-3-3.14-.19-5.51,2.85-8.6,2.2-1.68-.35-2.9-1.72-4.58-2a5.35,5.35,0,0,0-3.67.83c-1,.63-1.89,1.43-3,2-2.49,1.35-5.77,1.35-8.75,1.85-3.24.55-6.7,2.22-6.33,5.13a4.77,4.77,0,0,0,1.85,3c2,1.62,4.72,2.22,7.34,2.67a124.44,124.44,0,0,0,30.52,1c8.66-.67,17.18-2,25.66-3.33,3.87-.63,6.89-3,7.55-6.19a5.77,5.77,0,0,0,.1-.71c.3-3.35-4.94-5.73-4.94-5.73S449,345.73,447,348.11Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M448.08,349.41c-.82,1-2.74.88-4.15.28s-2.81-1.5-4.34-1.4-2.9,1.35-4.53,1.16c-2.89-.33-3.26-4.39-6.11-5-1.82-.36-3.36,1-5.19,1.09-3,.17-5.2-2.86-8.18-3-3.14-.19-5.51,2.85-8.6,2.21-1.68-.35-2.9-1.72-4.58-2a5.29,5.29,0,0,0-3.67.84c-1,.62-1.9,1.43-3,2-2.5,1.34-5.77,1.34-8.75,1.84-3.24.55-6.7,2.23-6.33,5.14a4.71,4.71,0,0,0,1.85,2.95c2,1.63,4.72,2.22,7.34,2.67a124.43,124.43,0,0,0,30.52,1c8.66-.67,17.18-1.95,25.66-3.33,3.87-.63,6.89-3,7.55-6.19a5.52,5.52,0,0,0,.1-.71c.3-3.35-4.94-5.72-4.94-5.72S450,347,448.08,349.41Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M390.64,318.43a6.49,6.49,0,0,0-1.89,8.51c1.65,2.91,5.62,4.91,9.44,4.77,1.45-.06,3.21-.28,4.14.69a6.35,6.35,0,0,1,.73,1.26c1,1.7,3.67,2.23,5.92,2.25s4.64-.25,6.66.68c1.63.75,2.76,2.17,4.49,2.73,2.16.68,4.46-.21,6.72,0,3.48.37,5.85,3.22,9,4.59,2.37,1,5.08,1.18,7.66,1.69s5.33,1.63,6.34,3.65l2.76-1.13c-.88-3.73-4.27-7.75-7.47-10.64s-9.64-5.86-13.65-7.95c-11.85-6.18-17.53-8.74-29.51-12.05C398,316.41,393.63,316.22,390.64,318.43Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M445,350a12.1,12.1,0,0,1-3.55,2c-1.81.53-3.87.21-5.85.14a45.83,45.83,0,0,0-7,.45l-15.72,1.83c7.86,1.67,15.83-1,23.82-.15,3.18.33,6.38,1.21,9.54,1.47,3.7-.66,6.58-2.94,7.31-6a7.1,7.1,0,0,0-4.9-1.37,4,4,0,0,1-.57.93A3.08,3.08,0,0,1,445,350Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M385,354.83h.16l.47.09c.41.08,1,.17,1.79.29a52.46,52.46,0,0,0,6.62.46c2.8.05,6.11-.11,9.79-.33l11.95-.69,12-.67c3.68-.21,7-.34,9.76-.59a35.29,35.29,0,0,0,6.37-1.08c.72-.21,1.27-.4,1.63-.53l.42-.15c.09,0,.14-.05.15,0l-.14.06-.4.18c-.36.14-.9.34-1.62.57a33,33,0,0,1-6.38,1.16c-2.76.28-6.08.42-9.75.65l-12,.68-12,.67c-3.67.21-7,.35-9.81.29a49.51,49.51,0,0,1-6.64-.55c-.78-.13-1.39-.24-1.79-.34l-.46-.1Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M408.71,331.76a11.76,11.76,0,0,1,1.79-.44c1.12-.23,2.68-.51,4.43-.76s3.34-.42,4.5-.51a11.64,11.64,0,0,1,1.89-.08,16.16,16.16,0,0,1-1.85.25c-1.15.14-2.73.33-4.47.58s-3.31.5-4.44.69S408.72,331.79,408.71,331.76Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M398,320l.14,0,.42.15,1.6.57c1.39.51,3.39,1.25,5.85,2.21,4.91,1.92,11.63,4.69,18.89,8,3.63,1.67,7.07,3.29,10.13,4.87a81.27,81.27,0,0,1,7.85,4.54,46.56,46.56,0,0,1,4.77,3.59c.54.45.92.82,1.19,1.07l.29.29c.07.06.1.1.09.1l-.11-.09-.32-.27c-.27-.24-.67-.6-1.22-1a51.19,51.19,0,0,0-4.82-3.52,86.66,86.66,0,0,0-7.86-4.49c-3.06-1.56-6.49-3.17-10.12-4.84-7.25-3.33-13.95-6.12-18.84-8.08l-5.81-2.28-1.58-.61-.41-.17C398,320,398,320,398,320Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "420.52 298.69 418.93 307.01 415.06 306.31 416.65 297.99 420.52 298.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "420.52 298.69 418.93 307.01 415.06 306.31 416.65 297.99 420.52 298.69"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M452.41,346c-1-1.53-1.8-1.36-3.41-2.51-.43-.3-.84-.63-1.26-.95-1.44-1.09-4.88-2.37-6.59-3.16.57.93,3.35,2,4.15,2.82a4.46,4.46,0,0,1,1.57,2.76c0,.59-.19,1.24.25,1.73s.89.51,1.31.8.83.43.73.94a7.59,7.59,0,0,1,2.7.49Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M452.61,345.79a23.06,23.06,0,0,1-.57,3.81,24.82,24.82,0,0,1-.87,3.75,25.44,25.44,0,0,1,.58-3.81A24.9,24.9,0,0,1,452.61,345.79Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M450.71,343.89a33,33,0,0,0-5.55-6.37c-3.2-2.88-9.64-5.86-13.65-7.95-11.85-6.18-17.53-8.74-29.51-12.05a19.69,19.69,0,0,0-6.39-.76c-4.09-2.16-7-3.74-7.86-4.33-2.07-1.4-4.67-3-6.73-2.76a1.89,1.89,0,0,0-1.9,2.06,6.89,6.89,0,0,0,1.58,3.3c.27.36.58.72.89,1.08a3.86,3.86,0,0,0-1.48,1v0a3,3,0,0,1-3,.63c-.83-.2-1.64-.65-2.48-.91-2.55-.81-4.47.38-4.72,2s.64,3.52,1.15,5.32.52,3.71-1.16,4.5c-1.25.58-3.2.42-4.7.76a3.83,3.83,0,0,0-1.91,1c-1.75,1.75-.31,4.91,2.92,7.15a4.12,4.12,0,0,0-.91,2A13.56,13.56,0,0,0,366,345a3.46,3.46,0,0,0,1.6,2.38c2.07,1.19,3.69-.49,5.92,0a13.52,13.52,0,0,0-1.73,7,1.46,1.46,0,0,0,.77,1.36,2.23,2.23,0,0,0,1.45.1l5.77-1.18c.42.87-.13,1.51-.33,2.23a2,2,0,0,0,1.5,2.27,2.32,2.32,0,0,0,1.8-.24,26.94,26.94,0,0,0,2.78-1.73,25.57,25.57,0,0,0,4.35,1.06,124.43,124.43,0,0,0,30.52,1c8.66-.67,17.18-1.95,25.66-3.33l.17,0h0c.14,0,.27-.06.41-.09.31-.07.61-.13.91-.22l.34-.13a9.52,9.52,0,0,0,.94-.34L449,355a10,10,0,0,0,2-1.19h0l3.87.7,1.59-8.32-3.87-.69-.08.39-.36-.37A7,7,0,0,0,450.71,343.89Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M394.65,302.72a4.47,4.47,0,0,0-4.2-2.65h0a2.25,2.25,0,0,1-2.16-1.31c-.32-.62-.44-1.37-.71-2a2.8,2.8,0,0,0-4.19-1.46c-1.36.9-2.3,2.65-3.38,4.11s-2.52,2.7-4.06,2.24c-1.15-.35-2.13-1.59-3.24-2.24a3.28,3.28,0,0,0-1.83-.47c-2.5.13-4.15,3.46-3.7,7.09l1.1,8.9,6.61,8.16,8.78-1.08,9.74-6.09,2.8-10.41Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.65,302.72a4.47,4.47,0,0,0-4.2-2.65h0a2.25,2.25,0,0,1-2.16-1.31c-.32-.62-.44-1.37-.71-2a2.8,2.8,0,0,0-4.19-1.46c-1.36.9-2.3,2.65-3.38,4.11s-2.52,2.7-4.06,2.24c-1.15-.35-2.13-1.59-3.24-2.24a3.28,3.28,0,0,0-1.83-.47c-2.5.13-4.15,3.46-3.7,7.09l1.1,8.9,6.61,8.16,8.78-1.08,9.74-6.09,2.8-10.41Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M369.17,330.3c-3.52-1.22-6.85-1.2-8.86-1.76a1.64,1.64,0,0,1-1.21-.88,1.94,1.94,0,0,1,.87-2.33c.66-.35,1.46-.45,1.88-1.25l-4.16-2.59a1.36,1.36,0,0,1-.74-.9,1.42,1.42,0,0,1,.58-1.32,16.56,16.56,0,0,1,6.25-3.48c-.88-1.62-3.07-1.47-3.34-3.44a3.32,3.32,0,0,1,.89-2.46,16.77,16.77,0,0,1,3.73-3.9,4.11,4.11,0,0,1,4.67-.13c1.9,1.3,3,4.29,3.65,7.16a5.19,5.19,0,0,0,1,2.47,1.6,1.6,0,0,0,2,0,33.27,33.27,0,0,0,3.79-3.13c1.27-1,2.81-1.7,4.29-1L391,322.44s2.18,18.49,2.32,18.88-6.08,7.14-5.79,7.24-9.68-10.77-9.68-10.77S371.74,331.19,369.17,330.3Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.17,330.3c-3.52-1.22-6.85-1.2-8.86-1.76a1.64,1.64,0,0,1-1.21-.88,1.94,1.94,0,0,1,.87-2.33c.66-.35,1.46-.45,1.88-1.25l-4.16-2.59a1.36,1.36,0,0,1-.74-.9,1.42,1.42,0,0,1,.58-1.32,16.56,16.56,0,0,1,6.25-3.48c-.88-1.62-3.07-1.47-3.34-3.44a3.32,3.32,0,0,1,.89-2.46,16.77,16.77,0,0,1,3.73-3.9,4.11,4.11,0,0,1,4.67-.13c1.9,1.3,3,4.29,3.65,7.16a5.19,5.19,0,0,0,1,2.47,1.6,1.6,0,0,0,2,0,33.27,33.27,0,0,0,3.79-3.13c1.27-1,2.81-1.7,4.29-1L391,322.44s2.18,18.49,2.32,18.88-6.08,7.14-5.79,7.24-9.68-10.77-9.68-10.77S371.74,331.19,369.17,330.3Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M408.33,356.94c-.22-4.28-9.81-51.17-10-55.45-.11-2.11-.4-4.62-1.72-5.69a1.94,1.94,0,0,0-2.64.23,7,7,0,0,0-1.6,3.05,22,22,0,0,0-.9,7.28,29.46,29.46,0,0,1,.07,3.51,3.74,3.74,0,0,1-1.18,2.75c-1.59,1-3.52-1.72-5.29-1.43-1.51.25-2.31,2.78-2,5a12.65,12.65,0,0,0,2.62,5.69,29.8,29.8,0,0,1,3.39,4.95,3.28,3.28,0,0,1,.4,1.65,1.28,1.28,0,0,1-1.68,1.14c-.71-.19-1.41-.71-2.12-.65-1.21.1-2,2-1.84,3.75a10.36,10.36,0,0,0,1.77,4.77,37.4,37.4,0,0,1,2.57,4.14l2.33,10.54L400.7,363l5-2.76Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408.33,356.94c-.22-4.28-9.81-51.17-10-55.45-.11-2.11-.4-4.62-1.72-5.69a1.94,1.94,0,0,0-2.64.23,7,7,0,0,0-1.6,3.05,22,22,0,0,0-.9,7.28,29.46,29.46,0,0,1,.07,3.51,3.74,3.74,0,0,1-1.18,2.75c-1.59,1-3.52-1.72-5.29-1.43-1.51.25-2.31,2.78-2,5a12.65,12.65,0,0,0,2.62,5.69,29.8,29.8,0,0,1,3.39,4.95,3.28,3.28,0,0,1,.4,1.65,1.28,1.28,0,0,1-1.68,1.14c-.71-.19-1.41-.71-2.12-.65-1.21.1-2,2-1.84,3.75a10.36,10.36,0,0,0,1.77,4.77,37.4,37.4,0,0,1,2.57,4.14l2.33,10.54L400.7,363l5-2.76Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M395,305.55c.07,0,.43,2.42.82,5.43s.64,5.45.58,5.46-.43-2.43-.82-5.43S394.89,305.56,395,305.55Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M390.89,321.8a5.21,5.21,0,0,1-1.35-.72,5.38,5.38,0,0,1-1.21-.91,4.55,4.55,0,0,1,1.34.71A4.88,4.88,0,0,1,390.89,321.8Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M376.28,328a.94.94,0,0,1-.09-.22l-.2-.61c-.16-.54-.42-1.31-.76-2.26a40.08,40.08,0,0,0-3.38-7.06,30.33,30.33,0,0,0-4.86-6.13c-.36-.35-.69-.66-1-.91s-.55-.49-.78-.66l-.51-.4c-.11-.1-.17-.15-.16-.16s.07,0,.19.12l.54.37c.23.15.5.37.81.62s.66.55,1,.9a28.29,28.29,0,0,1,4.94,6.12,36.43,36.43,0,0,1,3.34,7.14c.32.95.56,1.73.69,2.28.06.25.11.46.16.63S376.28,328,376.28,328Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M391.37,308.06s-.12-.34-.38-.95a9,9,0,0,0-1.47-2.37,5.65,5.65,0,0,0-1.48-1.22,3.54,3.54,0,0,0-2.08-.46,3.89,3.89,0,0,0-2.13,1,6,6,0,0,0-1.41,2.16,10.53,10.53,0,0,1-1.19,2.4,2,2,0,0,1-1.07.77,1.63,1.63,0,0,1-1.23-.29c-.68-.45-1.18-1-1.74-1.41a2.84,2.84,0,0,0-1.78-.51,2.87,2.87,0,0,0-1.46.52,3.54,3.54,0,0,0-.85.83,9.11,9.11,0,0,0-.54.87.84.84,0,0,1,.09-.25,4.28,4.28,0,0,1,.38-.68,3.46,3.46,0,0,1,.85-.88,2.9,2.9,0,0,1,3.42-.06c.6.39,1.1,1,1.75,1.38a1.39,1.39,0,0,0,1.06.25,1.76,1.76,0,0,0,.93-.68,10.72,10.72,0,0,0,1.16-2.35,6,6,0,0,1,1.47-2.24,4,4,0,0,1,2.27-1.06,3.67,3.67,0,0,1,2.2.5,5.45,5.45,0,0,1,1.5,1.28,8.45,8.45,0,0,1,1.44,2.44c.11.31.19.56.23.73A.88.88,0,0,1,391.37,308.06Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M404.83,358.83c-1.24.19-2.23-1-2.56-2.22s-.46-2.6-1.4-3.42-2.66-.81-3.45-1.87c-1.38-1.89,1.48-4.72.3-6.74-.75-1.29-2.65-1.3-3.77-2.3-1.79-1.6-.77-4.85-2.33-6.7s-5.27-1.35-6.53-3.55c-.69-1.2-.34-2.79-1-4a3.88,3.88,0,0,0-2.71-1.58c-1.07-.19-2.16-.18-3.21-.42-2.43-.58-4.28-2.47-6.35-3.87-2.25-1.53-5.48-2.45-7.48-.35a4.49,4.49,0,0,0-1.18,3c-.1,2.22,1,4.17,2.13,6a81.46,81.46,0,0,0,16.5,18.32c5.41,4.58,11.21,8.68,17.05,12.7a8.33,8.33,0,0,0,9,.38c.21-.13.41-.26.6-.4,2.7-2,1.54-6.56,1.54-6.56S407.72,358.41,404.83,358.83Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M404.44,360.29c-1.24.18-2.22-1-2.56-2.23s-.45-2.59-1.4-3.41-2.66-.81-3.45-1.88c-1.38-1.88,1.49-4.72.3-6.73-.75-1.29-2.65-1.31-3.76-2.3-1.8-1.61-.78-4.86-2.33-6.71s-5.28-1.34-6.54-3.55c-.68-1.19-.34-2.79-1.05-4a3.92,3.92,0,0,0-2.71-1.58c-1.06-.19-2.16-.17-3.21-.42-2.43-.58-4.28-2.47-6.35-3.87-2.25-1.52-5.48-2.44-7.47-.35a4.55,4.55,0,0,0-1.19,3c-.09,2.22,1,4.16,2.13,6a81.46,81.46,0,0,0,16.5,18.32,209.68,209.68,0,0,0,17.06,12.71,8.31,8.31,0,0,0,9,.37,4.81,4.81,0,0,0,.6-.4c2.7-2,1.54-6.56,1.54-6.56S407.33,359.86,404.44,360.29Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M395.39,307A7.49,7.49,0,0,0,389.6,320c.86.81,2,1.68,1.82,2.85a6.14,6.14,0,0,1-.54,1.24c-.72,1.67.39,3.56,1.65,4.87s2.82,2.53,3.26,4.3c.35,1.43-.09,3,.47,4.36.7,1.69,2.68,2.45,3.77,3.91,1.69,2.26.88,5.47,1.63,8.19.57,2,2,3.7,3.06,5.53s1.78,4.14.83,6l2.42.87c2.33-2.92,3.44-7.48,3.82-11.19s-1-9.37-1.7-13c-2-10.85-3.31-15.79-7.58-24.86C401.06,310,398.76,307.33,395.39,307Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M402.24,358.93a10.56,10.56,0,0,1-3.55-.74c-1.43-.71-2.35-2.11-3.41-3.3A32,32,0,0,0,391,351.1l-10.29-7.91c3.18,5.63,9.7,8.53,13.6,13.69,1.55,2.06,2.7,4.48,4.29,6.48a8.29,8.29,0,0,0,8.65.37,4.73,4.73,0,0,0-1.73-3.71,6,6,0,0,1-1,.27A2.28,2.28,0,0,1,402.24,358.93Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M364.64,327.29s0,0,.08.11l.2.32c.17.29.44.7.79,1.22a35,35,0,0,0,3.4,4.14c1.55,1.65,3.55,3.46,5.8,5.44l7.28,6.48,7.28,6.5c2.25,2,4.22,3.83,6,5.26a25,25,0,0,0,4.43,3c.57.28,1,.48,1.33.6l.35.15.12.05s-.05,0-.13,0l-.36-.12q-.48-.16-1.35-.57a23.5,23.5,0,0,1-4.49-2.94c-1.78-1.42-3.76-3.25-6-5.23L382,345.18l-7.28-6.49c-2.24-2-4.23-3.83-5.77-5.49a30.87,30.87,0,0,1-3.35-4.2c-.35-.54-.6-1-.76-1.26l-.18-.33Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M395.52,326.09a9.31,9.31,0,0,1,1.34.76c.81.5,1.91,1.22,3.09,2.07s2.21,1.67,2.93,2.28a9,9,0,0,1,1.14,1,10.36,10.36,0,0,1-1.24-.91c-.75-.57-1.8-1.37-3-2.21s-2.25-1.59-3-2.13A10.15,10.15,0,0,1,395.52,326.09Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M398.38,312.29l.05.11.13.34L399,314c.4,1.13,1,2.77,1.63,4.81,1.34,4.08,3,9.76,4.63,16.11.79,3.18,1.5,6.22,2,9a58.87,58.87,0,0,1,1,7.47,36.27,36.27,0,0,1,0,5.09c0,.59-.1,1.06-.14,1.37l-.05.36q0,.12,0,.12v-.13l0-.35c0-.32.07-.78.1-1.38a42.29,42.29,0,0,0-.06-5.07,63.47,63.47,0,0,0-1.05-7.44c-.55-2.78-1.28-5.81-2.06-9-1.59-6.35-3.27-12-4.56-16.12-.64-2-1.19-3.69-1.56-4.83-.18-.56-.32-1-.43-1.32l-.1-.34Q398.37,312.29,398.38,312.29Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 402.94,
    y: 362.29,
    width: 8.46,
    height: 3.17,
    transform: "translate(-166.37 220.98) rotate(-31.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 402.94,
    y: 362.29,
    width: 8.46,
    height: 3.17,
    transform: "translate(-166.37 220.98) rotate(-31.72)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M409.47,360.59c.62-1.55,0-1.92,0-3.59,0-.45,0-.9,0-1.35,0-1.53-1-4.36-1.34-5.85-.38.93.37,3.24.22,4.23a4.43,4.43,0,0,1-1.21,2.68c-.43.39-1,.69-1.17,1.26a5.12,5.12,0,0,0,.14,1.28c0,.52.15.76-.3,1a5,5,0,0,1,1.16,1.87Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M409.75,360.57a30.65,30.65,0,0,1-3.21,2.13,31.09,31.09,0,0,1-3.34,1.92,30.65,30.65,0,0,1,3.21-2.13A33.3,33.3,0,0,1,409.75,360.57Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M458.15,308.5c.76-2,.45-3.82-.67-4.92v0a2.24,2.24,0,0,1-.39-2.5c.27-.63.77-1.21,1.09-1.84a2.79,2.79,0,0,0-1.58-4.14c-1.55-.46-3.5-.06-5.32.05s-3.68-.19-4.32-1.67c-.48-1.1-.16-2.65-.37-3.91a3.28,3.28,0,0,0-.83-1.71c-1.7-1.83-5.31-.95-7.8,1.73l-6.11,6.56-2,10.31,6.47,6L447.25,316l9.78-4.55Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M458.15,308.5c.76-2,.45-3.82-.67-4.92v0a2.24,2.24,0,0,1-.39-2.5c.27-.63.77-1.21,1.09-1.84a2.79,2.79,0,0,0-1.58-4.14c-1.55-.46-3.5-.06-5.32.05s-3.68-.19-4.32-1.67c-.48-1.1-.16-2.65-.37-3.91a3.28,3.28,0,0,0-.83-1.71c-1.7-1.83-5.31-.95-7.8,1.73l-6.11,6.56-2,10.31,6.47,6L447.25,316l9.78-4.55Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M420.65,306.73c-1.34-3.48-3.49-6-4.36-7.92a1.64,1.64,0,0,1-.1-1.49,2,2,0,0,1,2.35-.83c.69.28,1.28.83,2.16.63-.23-1.61-.46-3.23-.7-4.84a1.39,1.39,0,0,1,.22-1.15,1.42,1.42,0,0,1,1.39-.4,16.5,16.5,0,0,1,6.68,2.54c.67-1.72-.85-3.3.48-4.77a3.3,3.3,0,0,1,2.46-.9,16.44,16.44,0,0,1,5.39.35,4.1,4.1,0,0,1,3.1,3.49c.23,2.29-1.34,5.07-3.13,7.4a5.22,5.22,0,0,0-1.28,2.33c-.07.85.6,1.32,1.29,1.58a33.81,33.81,0,0,0,4.83.88c1.6.33,3.12,1.06,3.56,2.62l-4.26,12.17S428,332,427.77,332.35s-9.38-.07-9.27.22,2-14.35,2-14.35S421.62,309.27,420.65,306.73Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.65,306.73c-1.34-3.48-3.49-6-4.36-7.92a1.64,1.64,0,0,1-.1-1.49,2,2,0,0,1,2.35-.83c.69.28,1.28.83,2.16.63-.23-1.61-.46-3.23-.7-4.84a1.39,1.39,0,0,1,.22-1.15,1.42,1.42,0,0,1,1.39-.4,16.5,16.5,0,0,1,6.68,2.54c.67-1.72-.85-3.3.48-4.77a3.3,3.3,0,0,1,2.46-.9,16.44,16.44,0,0,1,5.39.35,4.1,4.1,0,0,1,3.1,3.49c.23,2.29-1.34,5.07-3.13,7.4a5.22,5.22,0,0,0-1.28,2.33c-.07.85.6,1.32,1.29,1.58a33.81,33.81,0,0,0,4.83.88c1.6.33,3.12,1.06,3.56,2.62l-4.26,12.17S428,332,427.77,332.35s-9.38-.07-9.27.22,2-14.35,2-14.35S421.62,309.27,420.65,306.73Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M425.44,353.85c3.14-2.92,32.87-40.42,36-43.35,1.55-1.44,3.29-3.27,3.25-5a1.93,1.93,0,0,0-1.87-1.87,7,7,0,0,0-3.37.73,22.27,22.27,0,0,0-6.15,4,28.52,28.52,0,0,1-2.64,2.31,3.71,3.71,0,0,1-2.87.87c-1.82-.55-.94-3.8-2.31-5-1.16-1-3.6,0-5.1,1.68a12.75,12.75,0,0,0-2.67,5.67,29,29,0,0,1-1.61,5.78,3.16,3.16,0,0,1-1,1.36,1.28,1.28,0,0,1-2-.54c-.31-.67-.36-1.54-.86-2-.86-.87-2.78-.24-4.06,1a10.47,10.47,0,0,0-2.51,4.42,36.75,36.75,0,0,1-1.51,4.63l-6.57,8.56-1.71,14.77,5.32,2Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425.44,353.85c3.14-2.92,32.87-40.42,36-43.35,1.55-1.44,3.29-3.27,3.25-5a1.93,1.93,0,0,0-1.87-1.87,7,7,0,0,0-3.37.73,22.27,22.27,0,0,0-6.15,4,28.52,28.52,0,0,1-2.64,2.31,3.71,3.71,0,0,1-2.87.87c-1.82-.55-.94-3.8-2.31-5-1.16-1-3.6,0-5.1,1.68a12.75,12.75,0,0,0-2.67,5.67,29,29,0,0,1-1.61,5.78,3.16,3.16,0,0,1-1,1.36,1.28,1.28,0,0,1-2-.54c-.31-.67-.36-1.54-.86-2-.86-.87-2.78-.24-4.06,1a10.47,10.47,0,0,0-2.51,4.42,36.75,36.75,0,0,1-1.51,4.63l-6.57,8.56-1.71,14.77,5.32,2Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M456.19,310.56c.05,0-1.58,1.89-3.63,4.12s-3.76,4-3.81,3.95,1.58-1.89,3.63-4.12S456.14,310.51,456.19,310.56Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M441.13,317.89a9.59,9.59,0,0,1-.4-3,4.83,4.83,0,0,1,.32,1.49A5.12,5.12,0,0,1,441.13,317.89Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M427,310.67a1.1,1.1,0,0,1,.11-.2l.35-.55c.31-.47.72-1.17,1.23-2a40.19,40.19,0,0,0,3.23-7.14,30.24,30.24,0,0,0,1.58-7.66c0-.5.06-.95.05-1.35s0-.74,0-1,0-.47,0-.65a.6.6,0,0,1,0-.23,1.45,1.45,0,0,1,0,.23c0,.17,0,.39.06.64a9.84,9.84,0,0,1,.05,1c0,.4,0,.86,0,1.36a28.61,28.61,0,0,1-1.52,7.73,36.65,36.65,0,0,1-3.31,7.14c-.53.86-1,1.55-1.31,2l-.38.53A1.07,1.07,0,0,1,427,310.67Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M452,309.43s.19-.32.49-.91a9,9,0,0,0,.87-2.65,5.85,5.85,0,0,0,0-1.91,3.48,3.48,0,0,0-1-1.89,3.75,3.75,0,0,0-2.15-1,5.82,5.82,0,0,0-2.56.3,10.49,10.49,0,0,1-2.6.63,2.06,2.06,0,0,1-1.28-.32,1.67,1.67,0,0,1-.57-1.13c-.09-.81,0-1.56,0-2.24a2.76,2.76,0,0,0-2.09-2.47,3.66,3.66,0,0,0-1.18-.12,7.81,7.81,0,0,0-1,.15l.26-.1a3.73,3.73,0,0,1,.75-.14,3.59,3.59,0,0,1,1.23.08,2.87,2.87,0,0,1,1.42.79,3,3,0,0,1,.83,1.79c.08.71,0,1.47.06,2.23a1.41,1.41,0,0,0,.49,1,1.79,1.79,0,0,0,1.13.28,11.36,11.36,0,0,0,2.54-.63,6.09,6.09,0,0,1,2.66-.31,4,4,0,0,1,2.27,1.05,3.58,3.58,0,0,1,1,2,5.41,5.41,0,0,1,0,2,8.23,8.23,0,0,1-1,2.67c-.16.29-.3.51-.4.66A1.06,1.06,0,0,1,452,309.43Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M421.73,352.38c-.93-.83-.65-2.35.06-3.38s1.7-2,1.72-3.27-1.1-2.56-.78-3.85c.55-2.27,4.56-1.9,5.35-4.1.5-1.41-.71-2.87-.67-4.36.08-2.42,3.22-3.72,3.64-6.1s-2.37-4.91-1.49-7.29c.48-1.29,1.92-2,2.37-3.36a3.89,3.89,0,0,0-.54-3.09c-.53-.94-1.25-1.76-1.74-2.73-1.12-2.23-.86-4.86-1.12-7.35-.28-2.7-1.65-5.77-4.54-5.95a4.51,4.51,0,0,0-3,1c-1.76,1.36-2.56,3.43-3.21,5.47a81.89,81.89,0,0,0-3.41,24.42,212.12,212.12,0,0,0,1.24,21.23,8.33,8.33,0,0,0,5.48,7.11c.23.08.46.14.69.2,3.27.79,6-3,6-3S423.92,354.33,421.73,352.38Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M420.37,353c-.93-.83-.65-2.35.06-3.39s1.69-2,1.71-3.26-1.09-2.56-.78-3.85c.56-2.27,4.57-1.9,5.35-4.1.5-1.41-.71-2.87-.66-4.37.07-2.41,3.22-3.71,3.63-6.09s-2.36-4.91-1.48-7.29c.48-1.29,1.92-2.05,2.36-3.36a3.88,3.88,0,0,0-.53-3.09c-.54-.94-1.25-1.77-1.74-2.73-1.12-2.23-.86-4.87-1.12-7.35-.28-2.7-1.65-5.77-4.54-5.95a4.55,4.55,0,0,0-3.05,1c-1.75,1.35-2.55,3.43-3.2,5.47A81.52,81.52,0,0,0,413,329.09a212.3,212.3,0,0,0,1.24,21.23,8.33,8.33,0,0,0,5.48,7.11l.69.2c3.26.79,6-3,6-3S422.56,355,420.37,353Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M455.33,311.84a7.49,7.49,0,0,0-13.63,3.89c-.07,1.18,0,2.64-1,3.23a6.28,6.28,0,0,1-1.3.38c-1.74.53-2.48,2.59-2.67,4.4s-.13,3.78-1.2,5.26c-.86,1.18-2.35,1.86-3,3.17-.84,1.62-.15,3.62-.57,5.4-.64,2.74-3.62,4.19-5.22,6.51-1.2,1.74-1.56,3.91-2.27,5.9s-2,4-4.08,4.51l.9,2.41c3.73-.1,7.94-2.17,11-4.27s6.52-6.81,8.89-9.69c7-8.53,10-12.69,14.16-21.8C456.73,318.07,457.26,314.61,455.33,311.84Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M420,350.47a10.84,10.84,0,0,1-1.71-3.19c-.38-1.55.1-3.16.33-4.74a29.86,29.86,0,0,0,.11-5.75q-.27-6.5-.55-13c-2.26,6.05-.3,12.92-1.74,19.21-.58,2.52-1.69,5-2.2,7.46a8.33,8.33,0,0,0,5.28,6.87,4.74,4.74,0,0,0,1.73-3.72,4.76,4.76,0,0,1-.87-.62A2.27,2.27,0,0,1,420,350.47Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M420,301.33l0,.13c0,.09-.06.21-.11.36-.11.31-.25.78-.43,1.39a35.05,35.05,0,0,0-1,5.26c-.26,2.25-.37,4.95-.44,7.94s-.18,6.29-.27,9.75-.2,6.75-.29,9.75-.22,5.69-.19,8a24.82,24.82,0,0,0,.56,5.31,12.65,12.65,0,0,0,.39,1.4c0,.15.08.27.11.37s0,.12,0,.12l-.05-.12-.14-.35a13.22,13.22,0,0,1-.43-1.4,23.51,23.51,0,0,1-.64-5.33c-.05-2.27.07-5,.14-8s.17-6.29.27-9.75.2-6.75.29-9.74.21-5.7.49-8a32.49,32.49,0,0,1,1.06-5.27c.19-.6.35-1.07.47-1.38l.14-.35Q420,301.33,420,301.33Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M440.82,324.2a10.15,10.15,0,0,1,.28,1.52c.14.94.29,2.24.4,3.69s.14,2.76.14,3.71a9.22,9.22,0,0,1-.06,1.54,10.61,10.61,0,0,1-.11-1.53c0-.95-.1-2.26-.21-3.7s-.23-2.75-.33-3.69A10,10,0,0,1,440.82,324.2Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M453.22,317.51s0,0-.05.11l-.17.32-.69,1.19c-.61,1-1.5,2.53-2.64,4.35-2.26,3.64-5.52,8.6-9.36,13.9-1.93,2.65-3.79,5.15-5.58,7.36a58.84,58.84,0,0,1-5.08,5.58,36.32,36.32,0,0,1-3.9,3.26c-.49.35-.88.6-1.15.77l-.3.19-.11.06.1-.08.29-.21c.25-.18.64-.44,1.11-.81a40.61,40.61,0,0,0,3.85-3.3,63.77,63.77,0,0,0,5-5.6c1.77-2.21,3.63-4.71,5.56-7.36,3.84-5.29,7.11-10.23,9.41-13.85,1.15-1.81,2.06-3.29,2.7-4.3l.73-1.18.19-.3Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 415.15,
    y: 355.84,
    width: 8.46,
    height: 3.17,
    transform: "translate(97.12 -160.81) rotate(18.25)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 415.15,
    y: 355.84,
    width: 8.46,
    height: 3.17,
    transform: "translate(97.12 -160.81) rotate(18.25)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M423.37,357.08c1.59-.53,1.49-1.23,2.74-2.34.33-.3.69-.57,1-.86,1.19-1,2.72-3.54,3.62-4.79-.95.31-2.24,2.36-3.09,2.88a4.37,4.37,0,0,1-2.83.81c-.58-.09-1.2-.36-1.72-.09s-.57.64-.89.93-.48.6-1,.44a5.14,5.14,0,0,1-.69,2.09Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M423.57,357.27a28.09,28.09,0,0,1-3.69-1.09,28.45,28.45,0,0,1-3.62-1.32A33,33,0,0,1,420,356,32.65,32.65,0,0,1,423.57,357.27Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M452.19,278.31A37.08,37.08,0,0,0,483,299.49c6,.36,12.32-.89,17.11-4.55s7.74-10,6.38-15.88a13.29,13.29,0,0,0-16.63-9.79c-3.47,1-6.4,3.36-9.79,4.61a16.45,16.45,0,0,1-14.2-1.45s-6.46-3.93-10.18-1.27A8.85,8.85,0,0,0,452.19,278.31Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M452.19,278.31A37.08,37.08,0,0,0,483,299.49c6,.36,12.32-.89,17.11-4.55s7.74-10,6.38-15.88a13.29,13.29,0,0,0-16.63-9.79c-3.47,1-6.4,3.36-9.79,4.61a16.45,16.45,0,0,1-14.2-1.45s-6.46-3.93-10.18-1.27A8.85,8.85,0,0,0,452.19,278.31Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454,281.5a13,13,0,0,1-1.66-4.72l7.66-6.62,4,1.13a18.85,18.85,0,0,1-4.54,1.71,42.19,42.19,0,0,1,4.58,3.63,7,7,0,0,1-7.35.52,8.75,8.75,0,0,1-.63,4.52,1.25,1.25,0,0,1-.57.72C454.87,282.66,454.27,282.05,454,281.5Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M447.43,267.85l1.31-1.39c.33-.35.74-.74,1.22-.67a1.52,1.52,0,0,1,.9.72,39.3,39.3,0,0,1,3.59,5.79l-.83.9a8.33,8.33,0,0,0-5.93-4.58A.46.46,0,0,1,447.43,267.85Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M488.25,273.36c-.08-.43.28-.74.71-1h0a8.89,8.89,0,0,1,6.36-1.17.88.88,0,0,1,.54.25.66.66,0,0,1,0,.75,1.63,1.63,0,0,1-.61.52,12.68,12.68,0,0,1-5.47,1.37,2.64,2.64,0,0,1-.93-.05A.88.88,0,0,1,488.25,273.36Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M484.51,275.48a1.19,1.19,0,1,0,.47-1.34A1,1,0,0,0,484.51,275.48Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M484.73,297.12c6.08-1.34,12.52-4.55,16.26-9.53,2.89-3.84,4.82-9.12,3.17-13.51a13.41,13.41,0,0,1,2.34,5c1.36,5.87-1.59,12.21-6.38,15.88S489,299.85,483,299.49a35.13,35.13,0,0,1-8.25-1.54A40.17,40.17,0,0,0,484.73,297.12Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M457.48,272.22l.12,0,.34.19,1.3.72c1.12.63,2.75,1.56,4.81,2.58a37.6,37.6,0,0,0,7.55,2.85,24.08,24.08,0,0,0,4.7.68,20.08,20.08,0,0,0,5.08-.44,98.8,98.8,0,0,0,9.45-3,25.18,25.18,0,0,1,8-1.45,15.12,15.12,0,0,1,3.1.31,11.28,11.28,0,0,1,2.24.74c.3.12.55.27.77.38s.39.24.54.33l.32.22.1.08-.12-.06-.33-.2a5.7,5.7,0,0,0-.54-.31c-.23-.1-.47-.25-.78-.36a11.5,11.5,0,0,0-2.22-.69,15.11,15.11,0,0,0-3.08-.28,25.62,25.62,0,0,0-7.91,1.49,92.84,92.84,0,0,1-9.46,3,20.51,20.51,0,0,1-5.13.44,23.73,23.73,0,0,1-4.75-.7A37,37,0,0,1,464,275.9c-2.06-1-3.67-2-4.79-2.64l-1.27-.76-.33-.21Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M454.32,273.72s0,0,.11.09l.29.3c.26.25.61.67,1.12,1.14a40.68,40.68,0,0,0,4.49,3.8,45.69,45.69,0,0,0,7.51,4.44A54.49,54.49,0,0,0,477.91,287a75.47,75.47,0,0,0,19.3,1.85c2.48-.06,4.5-.18,5.88-.28l1.6-.11.42,0h.14l-.14,0-.41,0-1.6.16c-1.39.13-3.4.27-5.89.35a73.35,73.35,0,0,1-19.35-1.79,53.24,53.24,0,0,1-10.11-3.56,44.14,44.14,0,0,1-7.51-4.5,36.54,36.54,0,0,1-4.46-3.87c-.5-.48-.84-.9-1.09-1.17l-.28-.31Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M455,276.65l0,.11.13.32c.1.28.27.69.51,1.21a20.56,20.56,0,0,0,2.56,4.12,26.62,26.62,0,0,0,5.23,4.91,42.21,42.21,0,0,0,7.7,4.29c2.87,1.26,5.68,2.28,8.23,3.22s4.87,1.73,6.84,2.31,3.59,1,4.71,1.22l1.3.27.33.07q.12,0,.12,0h-.12l-.34-.05c-.3,0-.74-.12-1.31-.22-1.13-.21-2.76-.58-4.74-1.15s-4.3-1.35-6.86-2.27-5.37-1.95-8.25-3.21a41.1,41.1,0,0,1-7.73-4.33,26,26,0,0,1-5.23-5,19.4,19.4,0,0,1-2.52-4.18,13.11,13.11,0,0,1-.48-1.24c0-.13-.08-.24-.11-.32S455,276.65,455,276.65Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M454.11,271.74a6.13,6.13,0,0,1,5.1-3.21,15.18,15.18,0,0,1,6.35,1.16l-6.92,2a15.27,15.27,0,0,1,5.66,4.82,12.56,12.56,0,0,1-8.43-1.34,18,18,0,0,1,.49,7.42,7.72,7.72,0,0,1-2.88-5.38,16.81,16.81,0,0,1-3.2,4,10.46,10.46,0,0,1,3.83-9.42",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M457,299.73a37.07,37.07,0,0,0,30.82,21.18c6,.36,12.32-.89,17.1-4.55s7.74-10,6.38-15.88a13.29,13.29,0,0,0-16.62-9.79c-3.47,1-6.4,3.36-9.79,4.61a16.45,16.45,0,0,1-14.2-1.45s-6.47-3.93-10.19-1.27A8.86,8.86,0,0,0,457,299.73Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M458.79,302.93a13.1,13.1,0,0,1-1.66-4.73l7.65-6.62,4,1.13a19.09,19.09,0,0,1-4.55,1.71,43.56,43.56,0,0,1,4.59,3.63,7,7,0,0,1-7.36.52,8.74,8.74,0,0,1-.62,4.52,1.34,1.34,0,0,1-.57.72C459.7,304.08,459.11,303.48,458.79,302.93Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M452.27,289.27l1.3-1.39c.34-.35.75-.74,1.23-.66a1.45,1.45,0,0,1,.89.71,39.46,39.46,0,0,1,3.6,5.8l-.84.89a8.31,8.31,0,0,0-5.92-4.58A.46.46,0,0,1,452.27,289.27Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M493.08,294.78c-.08-.43.28-.74.72-1h0a8.89,8.89,0,0,1,6.36-1.17.94.94,0,0,1,.54.25.65.65,0,0,1,0,.75,1.68,1.68,0,0,1-.6.52,12.69,12.69,0,0,1-5.48,1.37,2.36,2.36,0,0,1-.92-.05A.87.87,0,0,1,493.08,294.78Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M489.35,296.9a1.19,1.19,0,1,0,.47-1.34A1,1,0,0,0,489.35,296.9Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M489.57,318.54c6.07-1.34,12.52-4.55,16.25-9.53,2.89-3.84,4.83-9.12,3.18-13.51a13.39,13.39,0,0,1,2.33,5c1.36,5.87-1.59,12.21-6.38,15.88s-11.09,4.91-17.1,4.55a34.92,34.92,0,0,1-8.25-1.53A40.66,40.66,0,0,0,489.57,318.54Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M462.32,293.64l.12.06.34.18,1.29.73c1.13.62,2.75,1.55,4.82,2.57a37.37,37.37,0,0,0,7.55,2.85,24.08,24.08,0,0,0,4.7.68,20.12,20.12,0,0,0,5.08-.44,96.9,96.9,0,0,0,9.45-3,25.08,25.08,0,0,1,8-1.45,15.15,15.15,0,0,1,3.11.31,11.5,11.5,0,0,1,2.24.74,6.64,6.64,0,0,1,.76.39,4.54,4.54,0,0,1,.54.32l.32.22.11.08-.12-.06-.33-.2a4.4,4.4,0,0,0-.55-.3,7,7,0,0,0-.77-.37,11.62,11.62,0,0,0-2.23-.69,15,15,0,0,0-3.08-.28,25.51,25.51,0,0,0-7.9,1.49,93.05,93.05,0,0,1-9.47,3,21,21,0,0,1-5.13.45,23.62,23.62,0,0,1-4.74-.71,35.88,35.88,0,0,1-7.57-2.91c-2.06-1-3.68-2-4.79-2.64l-1.28-.76-.32-.2Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M459.16,295.14l.1.09.3.3c.26.26.61.67,1.12,1.14a39.75,39.75,0,0,0,4.49,3.8,44.59,44.59,0,0,0,7.51,4.44,53.52,53.52,0,0,0,10.07,3.53A75.44,75.44,0,0,0,502,310.29c2.49-.05,4.5-.18,5.89-.28l1.6-.11.42,0h.14l-.14,0-.42,0c-.36,0-.9.11-1.59.16-1.39.13-3.4.28-5.89.36a73.52,73.52,0,0,1-19.36-1.8,52.89,52.89,0,0,1-10.1-3.56,44.26,44.26,0,0,1-7.52-4.5,36.3,36.3,0,0,1-4.45-3.87c-.5-.48-.85-.9-1.1-1.17l-.28-.31C459.18,295.18,459.15,295.14,459.16,295.14Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M459.81,298.07s0,0,.05.11l.13.32c.1.28.28.69.52,1.22a20.36,20.36,0,0,0,2.56,4.11,26.66,26.66,0,0,0,5.23,4.92A42.7,42.7,0,0,0,476,313c2.87,1.26,5.69,2.28,8.24,3.22s4.87,1.73,6.84,2.32,3.58,1,4.71,1.21l1.29.27.34.07c.08,0,.12,0,.11,0h-.11l-.34-.05c-.3,0-.74-.11-1.31-.22-1.13-.21-2.76-.58-4.74-1.15s-4.31-1.35-6.86-2.27-5.38-1.95-8.26-3.21a42.31,42.31,0,0,1-7.73-4.32,26.53,26.53,0,0,1-5.23-5,19.7,19.7,0,0,1-2.51-4.18,13.11,13.11,0,0,1-.48-1.24l-.11-.32Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M459,293.16a6.11,6.11,0,0,1,5.1-3.21,15,15,0,0,1,6.34,1.17l-6.92,2a15.39,15.39,0,0,1,5.67,4.82,12.56,12.56,0,0,1-8.43-1.34,18.14,18.14,0,0,1,.49,7.42,7.69,7.69,0,0,1-2.89-5.38,16.57,16.57,0,0,1-3.19,4,10.45,10.45,0,0,1,3.82-9.42",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M522.17,266.76a37.06,37.06,0,0,0-20.67,31.16c-.26,6,1.09,12.31,4.84,17s10.13,7.57,16,6.11a13.3,13.3,0,0,0,9.51-16.78c-1.06-3.46-3.47-6.35-4.77-9.71a16.49,16.49,0,0,1,1.21-14.23s3.82-6.53,1.11-10.2A8.87,8.87,0,0,0,522.17,266.76Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M519,268.57a13.22,13.22,0,0,1,4.7-1.74l6.74,7.55-1.06,4a19.29,19.29,0,0,1-1.79-4.51,41,41,0,0,1-3.55,4.64,7,7,0,0,1-.64-7.34,8.77,8.77,0,0,1-4.53-.55,1.3,1.3,0,0,1-.73-.56C517.87,269.51,518.46,268.91,519,268.57Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M532.55,261.83l1.41,1.28c.36.33.75.74.68,1.22a1.45,1.45,0,0,1-.7.9,39.36,39.36,0,0,1-5.73,3.69l-.91-.82a8.32,8.32,0,0,0,4.48-6A.46.46,0,0,1,532.55,261.83Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M527.71,302.73c.43-.09.75.27,1,.7h0a8.86,8.86,0,0,1,1.28,6.34.93.93,0,0,1-.24.54.65.65,0,0,1-.75,0,1.76,1.76,0,0,1-.53-.59,12.69,12.69,0,0,1-1.46-5.46,2.42,2.42,0,0,1,0-.93A.88.88,0,0,1,527.71,302.73Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M525.53,299a1,1,0,0,0,0,1.42.88.88,0,1,0,1.39-1A1,1,0,0,0,525.53,299Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M503.9,299.61c1.44,6.05,4.76,12.44,9.79,16.09,3.9,2.83,9.2,4.68,13.56,2.95a13.07,13.07,0,0,1-4.93,2.42c-5.85,1.46-12.24-1.39-16-6.11s-5.1-11-4.84-17a35.17,35.17,0,0,1,1.4-8.27A40.6,40.6,0,0,0,503.9,299.61Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M528.34,272s0,0-.05.12l-.18.34-.7,1.31c-.61,1.14-1.51,2.78-2.49,4.86a37.1,37.1,0,0,0-2.73,7.59,24.45,24.45,0,0,0-.61,4.72,20.63,20.63,0,0,0,.53,5.07,93.79,93.79,0,0,0,3.14,9.39,25.4,25.4,0,0,1,1.58,7.94,15.54,15.54,0,0,1-.26,3.12,12.84,12.84,0,0,1-.7,2.25c-.12.3-.27.55-.38.77a2.85,2.85,0,0,1-.32.54l-.21.33c-.05.07-.07.11-.08.1l.06-.12.2-.33c.08-.15.19-.32.29-.55s.25-.47.36-.78a12,12,0,0,0,.65-2.24,14.63,14.63,0,0,0,.23-3.08,25.86,25.86,0,0,0-1.62-7.88,93.23,93.23,0,0,1-3.16-9.41,20.62,20.62,0,0,1-.53-5.13,24.09,24.09,0,0,1,.63-4.76,36.41,36.41,0,0,1,2.78-7.61c1-2.08,1.93-3.71,2.56-4.83l.74-1.29.2-.33Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M526.8,268.81l-.1.11-.29.3c-.25.26-.66.62-1.12,1.14a40,40,0,0,0-3.73,4.55,45,45,0,0,0-4.31,7.58,53.25,53.25,0,0,0-3.36,10.13,75.49,75.49,0,0,0-1.54,19.32c.1,2.49.25,4.5.38,5.89.06.68.11,1.21.14,1.59,0,.18,0,.31,0,.42s0,.14,0,.14,0,0,0-.14,0-.24-.06-.41c0-.36-.11-.9-.18-1.59-.15-1.39-.33-3.4-.45-5.89a73.37,73.37,0,0,1,1.47-19.38,53.32,53.32,0,0,1,3.4-10.16,43.93,43.93,0,0,1,4.37-7.59,37.9,37.9,0,0,1,3.79-4.52c.48-.51.9-.86,1.16-1.11l.31-.29Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M523.87,269.52l-.1.05-.32.13c-.28.11-.69.29-1.21.54a20.46,20.46,0,0,0-4.07,2.63,26.5,26.5,0,0,0-4.83,5.31,42.32,42.32,0,0,0-4.16,7.76c-1.21,2.89-2.18,5.72-3.08,8.29s-1.65,4.9-2.2,6.88-.92,3.6-1.14,4.73c-.11.56-.19,1-.24,1.3l-.07.34c0,.07,0,.11,0,.11a1.09,1.09,0,0,1,0-.12l0-.34c0-.3.1-.74.2-1.31.2-1.13.54-2.77,1.07-4.76s1.28-4.32,2.16-6.9,1.86-5.4,3.07-8.3a41.87,41.87,0,0,1,4.2-7.8,26.17,26.17,0,0,1,4.9-5.32,19.51,19.51,0,0,1,4.13-2.58c.53-.23.94-.4,1.23-.5l.33-.11C523.83,269.52,523.87,269.51,523.87,269.52Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M528.77,268.57a6.13,6.13,0,0,1,3.29,5.05A15,15,0,0,1,531,280c-.69-2.29-1.39-4.59-2.08-6.89a15.26,15.26,0,0,1-4.72,5.75,12.51,12.51,0,0,1,1.2-8.45A18,18,0,0,1,518,271a7.69,7.69,0,0,1,5.33-3,16.85,16.85,0,0,1-4-3.13,10.46,10.46,0,0,1,9.49,3.67",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M490.32,289.94a37.07,37.07,0,0,0,20.73,31.12c5.45,2.57,11.77,3.76,17.57,2.14s10.91-6.41,11.83-12.37a13.29,13.29,0,0,0-11.79-15.27c-3.6-.36-7.19.74-10.8.64a16.43,16.43,0,0,1-12.64-6.63s-4.54-6.05-9-5A8.87,8.87,0,0,0,490.32,289.94Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M490.77,293.56a13,13,0,0,1,.21-5l9.57-3.29,3.31,2.53a18.83,18.83,0,0,1-4.86-.09,41.8,41.8,0,0,1,2.91,5.07,6.94,6.94,0,0,1-7-2.25,8.84,8.84,0,0,1-2.26,4,1.37,1.37,0,0,1-.8.46C491.19,295,490.86,294.19,490.77,293.56Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M489.79,278.46l1.73-.81a1.58,1.58,0,0,1,1.39-.16,1.49,1.49,0,0,1,.56,1,39.29,39.29,0,0,1,1.18,6.71l-1.1.52a8.34,8.34,0,0,0-3.8-6.45A.46.46,0,0,1,489.79,278.46Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M525.63,298.76c.08-.44.54-.59,1-.7h0a8.91,8.91,0,0,1,6.34,1.28.86.86,0,0,1,.4.44.62.62,0,0,1-.27.69,1.64,1.64,0,0,1-.75.26,12.8,12.8,0,0,1-5.6-.76,2.6,2.6,0,0,1-.84-.4A.86.86,0,0,1,525.63,298.76Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M521.37,299.33a1,1,0,0,0,1.3.59c.61-.13,1-.61.93-1.07a1,1,0,0,0-1.29-.58C521.69,298.4,521.28,298.88,521.37,299.33Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M513.53,319.5c6.14,1,13.31.43,18.63-2.8,4.12-2.49,7.87-6.67,8-11.36a13.22,13.22,0,0,1,.32,5.49c-.92,6-6,10.75-11.83,12.37s-12.12.43-17.57-2.14a35,35,0,0,1-7.08-4.49A40.52,40.52,0,0,0,513.53,319.5Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M497.5,286.25l.09.1.24.29.94,1.16c.81,1,2,2.46,3.51,4.18a36.68,36.68,0,0,0,6,5.45,23.43,23.43,0,0,0,4.11,2.39,20.2,20.2,0,0,0,4.88,1.47,94.05,94.05,0,0,0,9.87.75,25.33,25.33,0,0,1,7.94,1.62,14.47,14.47,0,0,1,2.76,1.45,11.06,11.06,0,0,1,1.81,1.51,7.56,7.56,0,0,1,.57.65,5.55,5.55,0,0,1,.38.5l.21.32.07.11-.09-.1-.23-.3a4.35,4.35,0,0,0-.39-.49c-.17-.18-.35-.41-.58-.63a12.25,12.25,0,0,0-1.82-1.47,15,15,0,0,0-2.75-1.4,25.65,25.65,0,0,0-7.89-1.56,92.25,92.25,0,0,1-9.9-.73,20.64,20.64,0,0,1-4.93-1.5,23.91,23.91,0,0,1-4.15-2.42,37.18,37.18,0,0,1-5.94-5.51c-1.53-1.74-2.67-3.22-3.46-4.24-.39-.5-.69-.89-.9-1.18l-.23-.31C497.52,286.29,497.49,286.25,497.5,286.25Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M494,286.46l.06.13.16.39c.15.33.32.84.62,1.47a40.56,40.56,0,0,0,2.75,5.21,45.12,45.12,0,0,0,5.32,6.9,53.51,53.51,0,0,0,8,7,76,76,0,0,0,17.23,8.9c2.33.87,4.24,1.5,5.57,1.93l1.52.48.4.13c.09,0,.13.05.13.06l-.14,0-.4-.11c-.35-.1-.88-.24-1.54-.45-1.34-.4-3.26-1-5.6-1.86a73.69,73.69,0,0,1-17.3-8.87,53.93,53.93,0,0,1-8.06-7.06,45.63,45.63,0,0,1-5.3-7,37.69,37.69,0,0,1-2.69-5.25c-.29-.64-.45-1.16-.58-1.5-.06-.16-.11-.29-.14-.39S494,286.46,494,286.46Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M493.52,289.43s0,0,0,.12v.34c0,.31,0,.75,0,1.33a21,21,0,0,0,.85,4.77,26.83,26.83,0,0,0,3,6.51,42.19,42.19,0,0,0,5.55,6.84c2.19,2.23,4.43,4.23,6.44,6.05s3.88,3.41,5.49,4.69,3,2.24,3.92,2.88c.48.32.85.57,1.11.73l.28.19.1.07s0,0-.11-.05l-.3-.17c-.26-.15-.64-.38-1.13-.69-1-.62-2.34-1.57-4-2.83s-3.5-2.85-5.53-4.67-4.26-3.8-6.46-6.05a40.82,40.82,0,0,1-5.57-6.88,26.1,26.1,0,0,1-3-6.58,19.47,19.47,0,0,1-.78-4.81c0-.58,0-1,0-1.33l0-.34A.55.55,0,0,1,493.52,289.43Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M490.32,289.94a37.07,37.07,0,0,0,20.73,31.12c5.45,2.57,11.77,3.76,17.57,2.14s10.91-6.41,11.83-12.37a13.29,13.29,0,0,0-11.79-15.27c-3.6-.36-7.19.74-10.8.64a16.43,16.43,0,0,1-12.64-6.63s-4.54-6.05-9-5A8.87,8.87,0,0,0,490.32,289.94Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M494.55,284.55a6.11,6.11,0,0,1,5.92-1.08,15,15,0,0,1,5.46,3.44l-7.16-.75a15.16,15.16,0,0,1,3.47,6.58,12.57,12.57,0,0,1-7.33-4.38,17.81,17.81,0,0,1-2.3,7.07,7.71,7.71,0,0,1-.68-6.06,17.14,17.14,0,0,1-4.43,2.49,10.46,10.46,0,0,1,7.05-7.33",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M461.1,319.14a37.08,37.08,0,0,0,30.82,21.18c6,.36,12.32-.89,17.11-4.55s7.74-10,6.38-15.88a13.29,13.29,0,0,0-16.63-9.79c-3.47,1-6.4,3.36-9.79,4.61a16.45,16.45,0,0,1-14.2-1.45s-6.46-3.93-10.19-1.27A8.86,8.86,0,0,0,461.1,319.14Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M462.86,322.34a13.1,13.1,0,0,1-1.66-4.73l7.66-6.62,4,1.13a18.85,18.85,0,0,1-4.54,1.71,42.28,42.28,0,0,1,4.58,3.64,7,7,0,0,1-7.35.51,8.84,8.84,0,0,1-.63,4.52,1.25,1.25,0,0,1-.57.72C463.78,323.49,463.18,322.89,462.86,322.34Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M456.34,308.68l1.31-1.39c.33-.35.74-.73,1.22-.66a1.48,1.48,0,0,1,.9.72,39.3,39.3,0,0,1,3.59,5.79l-.83.89a8.35,8.35,0,0,0-5.93-4.58A.46.46,0,0,1,456.34,308.68Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M497.15,314.2c-.07-.44.29-.75.72-1h0a8.89,8.89,0,0,1,6.36-1.17.94.94,0,0,1,.54.25.66.66,0,0,1,0,.75,1.63,1.63,0,0,1-.61.52,12.68,12.68,0,0,1-5.47,1.37,2.24,2.24,0,0,1-.93-.05A.88.88,0,0,1,497.15,314.2Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M493.42,316.31a1.19,1.19,0,1,0,.47-1.34A1,1,0,0,0,493.42,316.31Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M493.64,338c6.08-1.34,12.52-4.55,16.26-9.53,2.89-3.84,4.82-9.12,3.17-13.51a13.41,13.41,0,0,1,2.34,5c1.36,5.87-1.59,12.22-6.38,15.88s-11.09,4.91-17.11,4.55a35,35,0,0,1-8.25-1.53A40.66,40.66,0,0,0,493.64,338Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M466.39,313.05l.12.06.34.18,1.3.73c1.12.62,2.75,1.55,4.81,2.57a37.6,37.6,0,0,0,7.55,2.85,23.35,23.35,0,0,0,4.7.68,20.08,20.08,0,0,0,5.08-.44,96.9,96.9,0,0,0,9.45-3,25.46,25.46,0,0,1,8-1.45,15.15,15.15,0,0,1,3.11.31,12,12,0,0,1,2.24.74c.3.12.55.28.77.39s.39.23.54.32l.32.22.1.08-.12-.06-.33-.2a5.9,5.9,0,0,0-.54-.3,7.22,7.22,0,0,0-.78-.37,12.12,12.12,0,0,0-2.23-.69,15,15,0,0,0-3.08-.28,25.61,25.61,0,0,0-7.9,1.49,92.84,92.84,0,0,1-9.46,3,20.11,20.11,0,0,1-5.14.45,23.73,23.73,0,0,1-4.74-.71,35.88,35.88,0,0,1-7.57-2.91c-2.06-1-3.67-2-4.79-2.64l-1.27-.76-.33-.2Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M463.23,314.55l.11.09.29.3c.26.26.61.67,1.12,1.14a41.69,41.69,0,0,0,4.49,3.81,45.7,45.7,0,0,0,7.51,4.43,53.77,53.77,0,0,0,10.07,3.53,75,75,0,0,0,19.3,1.85c2.48-.05,4.5-.17,5.88-.27l1.6-.12.42,0h.14s0,0-.14,0l-.41,0c-.37,0-.9.11-1.6.16-1.39.13-3.4.28-5.89.36a73.42,73.42,0,0,1-19.35-1.8,52.56,52.56,0,0,1-10.11-3.56,44.15,44.15,0,0,1-7.51-4.49,38.37,38.37,0,0,1-4.46-3.87c-.5-.49-.84-.91-1.1-1.18l-.27-.31Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M463.88,317.48s0,0,.06.11l.12.32c.11.28.28.69.52,1.22a20.83,20.83,0,0,0,2.56,4.11,26.94,26.94,0,0,0,5.23,4.92,41.86,41.86,0,0,0,7.7,4.28c2.87,1.26,5.68,2.28,8.23,3.22s4.87,1.73,6.84,2.32,3.59,1,4.71,1.21l1.3.27.33.07.12,0h-.12l-.34-.05c-.3,0-.74-.11-1.31-.22-1.13-.21-2.76-.58-4.74-1.15s-4.3-1.34-6.86-2.27-5.37-1.94-8.25-3.21a41.65,41.65,0,0,1-7.73-4.32,26,26,0,0,1-5.23-5,19.16,19.16,0,0,1-2.52-4.18,13.14,13.14,0,0,1-.48-1.23l-.11-.33Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M461.1,319.14a37.08,37.08,0,0,0,30.82,21.18c6,.36,12.32-.89,17.11-4.55s7.74-10,6.38-15.88a13.29,13.29,0,0,0-16.63-9.79c-3.47,1-6.4,3.36-9.79,4.61a16.45,16.45,0,0,1-14.2-1.45s-6.46-3.93-10.19-1.27A8.86,8.86,0,0,0,461.1,319.14Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M463,312.57a6.1,6.1,0,0,1,5.1-3.2,14.89,14.89,0,0,1,6.35,1.16l-6.93,2a15.32,15.32,0,0,1,5.67,4.82,12.51,12.51,0,0,1-8.43-1.34,18,18,0,0,1,.49,7.42,7.71,7.71,0,0,1-2.88-5.37,17.27,17.27,0,0,1-3.2,4,10.47,10.47,0,0,1,3.83-9.43",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M465,338.84A37.09,37.09,0,0,0,495.82,360c6,.37,12.32-.89,17.11-4.55s7.73-10,6.38-15.88a13.3,13.3,0,0,0-16.63-9.78c-3.47,1-6.4,3.36-9.79,4.61a16.52,16.52,0,0,1-14.2-1.45s-6.46-3.93-10.19-1.28A8.88,8.88,0,0,0,465,338.84Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M466.76,342a13,13,0,0,1-1.66-4.73l7.66-6.62,4,1.13a19.31,19.31,0,0,1-4.54,1.72,41,41,0,0,1,4.58,3.63,7,7,0,0,1-7.35.52,8.82,8.82,0,0,1-.63,4.51,1.31,1.31,0,0,1-.57.73C467.68,343.18,467.08,342.58,466.76,342Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M460.24,328.37l1.31-1.39c.33-.35.74-.73,1.22-.66a1.52,1.52,0,0,1,.9.72,40.17,40.17,0,0,1,3.59,5.79l-.84.89a8.34,8.34,0,0,0-5.92-4.58A.46.46,0,0,1,460.24,328.37Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M501.05,333.89c-.08-.44.28-.75.72-1h0a8.84,8.84,0,0,1,6.36-1.18.94.94,0,0,1,.54.25.66.66,0,0,1,0,.75,1.62,1.62,0,0,1-.61.52,12.7,12.7,0,0,1-5.48,1.38,2.38,2.38,0,0,1-.92-.06A.88.88,0,0,1,501.05,333.89Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M497.32,336a1.19,1.19,0,1,0,.47-1.34A1,1,0,0,0,497.32,336Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M497.54,357.64c6.08-1.34,12.52-4.55,16.26-9.52,2.89-3.85,4.82-9.12,3.17-13.51a13.29,13.29,0,0,1,2.34,5c1.35,5.87-1.6,12.22-6.38,15.88s-11.1,4.92-17.11,4.55a35,35,0,0,1-8.25-1.53A40.66,40.66,0,0,0,497.54,357.64Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M470.29,332.74l.12.06.34.18,1.3.73c1.12.63,2.75,1.55,4.81,2.57a37.6,37.6,0,0,0,7.55,2.85,24.07,24.07,0,0,0,4.7.69,20.61,20.61,0,0,0,5.08-.45,94.24,94.24,0,0,0,9.45-3,25.36,25.36,0,0,1,8-1.45,14.44,14.44,0,0,1,3.11.32A12,12,0,0,1,517,336c.3.12.54.28.77.39a3.82,3.82,0,0,1,.53.33l.32.21.11.08-.12-.06-.33-.19a3.71,3.71,0,0,0-.55-.31,6.22,6.22,0,0,0-.77-.37,12.12,12.12,0,0,0-2.23-.69,15,15,0,0,0-3.08-.28,25.81,25.81,0,0,0-7.9,1.49,90.4,90.4,0,0,1-9.46,3,20.11,20.11,0,0,1-5.14.45,23.73,23.73,0,0,1-4.74-.71,35.88,35.88,0,0,1-7.57-2.91c-2.06-1-3.67-2-4.79-2.63l-1.27-.77-.33-.2Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M467.13,334.24a.72.72,0,0,1,.1.1l.3.29c.26.26.61.67,1.12,1.15a41.81,41.81,0,0,0,4.49,3.8,44.6,44.6,0,0,0,7.51,4.43,53.07,53.07,0,0,0,10.07,3.53A75.51,75.51,0,0,0,510,349.4c2.49-.06,4.5-.18,5.89-.28l1.6-.12.42,0h.14l-.14,0-.41.05-1.6.16c-1.39.12-3.4.27-5.89.35a73.42,73.42,0,0,1-19.35-1.8,52.56,52.56,0,0,1-10.11-3.56,44.15,44.15,0,0,1-7.51-4.49,38.37,38.37,0,0,1-4.46-3.87c-.5-.49-.85-.91-1.1-1.18l-.27-.31Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M467.78,337.18s0,0,.06.1l.12.32c.11.29.28.7.52,1.22a20.83,20.83,0,0,0,2.56,4.11,26.94,26.94,0,0,0,5.23,4.92,41.86,41.86,0,0,0,7.7,4.28c2.87,1.26,5.68,2.28,8.23,3.22s4.87,1.73,6.84,2.32,3.58,1,4.71,1.22c.56.12,1,.21,1.3.26l.33.07.12,0h-.12l-.34,0-1.31-.23c-1.13-.21-2.76-.58-4.74-1.15s-4.3-1.34-6.86-2.27-5.38-1.94-8.26-3.21a41.88,41.88,0,0,1-7.72-4.32,26.33,26.33,0,0,1-5.24-5,19.68,19.68,0,0,1-2.51-4.17c-.23-.54-.39-.95-.48-1.24l-.11-.33Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M466.92,332.26a6.08,6.08,0,0,1,5.1-3.2,14.82,14.82,0,0,1,6.34,1.16l-6.92,2a15.2,15.2,0,0,1,5.67,4.81,12.51,12.51,0,0,1-8.43-1.34,18,18,0,0,1,.49,7.42,7.69,7.69,0,0,1-2.88-5.37,17.06,17.06,0,0,1-3.2,4,10.48,10.48,0,0,1,3.82-9.43",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M530,300.56a37.07,37.07,0,0,0-20.66,31.16c-.27,6,1.09,12.31,4.83,17s10.13,7.57,16,6.11a13.28,13.28,0,0,0,9.5-16.78c-1.05-3.46-3.46-6.35-4.77-9.71a16.49,16.49,0,0,1,1.22-14.23s3.82-6.53,1.1-10.2A8.87,8.87,0,0,0,530,300.56Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M526.87,302.37a13.15,13.15,0,0,1,4.7-1.74l6.74,7.55-1.06,4a18.86,18.86,0,0,1-1.79-4.51,42.26,42.26,0,0,1-3.56,4.64,6.94,6.94,0,0,1-.63-7.34,8.75,8.75,0,0,1-4.53-.55,1.3,1.3,0,0,1-.73-.56C525.73,303.31,526.32,302.71,526.87,302.37Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M540.42,295.63l1.41,1.28c.35.33.74.74.68,1.22a1.48,1.48,0,0,1-.7.9,39.36,39.36,0,0,1-5.73,3.69l-.91-.82a8.32,8.32,0,0,0,4.48-6A.46.46,0,0,1,540.42,295.63Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M535.58,336.53c.43-.09.75.27,1,.7h0a8.86,8.86,0,0,1,1.28,6.34.88.88,0,0,1-.25.54.65.65,0,0,1-.75,0,1.73,1.73,0,0,1-.52-.59,12.7,12.7,0,0,1-1.47-5.46,2.42,2.42,0,0,1,0-.93A.88.88,0,0,1,535.58,336.53Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M533.4,332.83a1.19,1.19,0,0,0,1.3,1.87,1,1,0,0,0,0-1.42A1,1,0,0,0,533.4,332.83Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M511.77,333.41c1.44,6,4.75,12.44,9.79,16.09,3.89,2.83,9.2,4.68,13.56,2.95a13.14,13.14,0,0,1-4.93,2.42c-5.86,1.46-12.25-1.39-16-6.11s-5.1-11-4.83-17a34.65,34.65,0,0,1,1.39-8.27A40.6,40.6,0,0,0,511.77,333.41Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M536.21,305.75a.67.67,0,0,1-.05.12l-.18.34-.71,1.31c-.6,1.14-1.5,2.78-2.49,4.86a37.34,37.34,0,0,0-2.72,7.59,24.45,24.45,0,0,0-.61,4.72,20.16,20.16,0,0,0,.53,5.07,96.47,96.47,0,0,0,3.13,9.39,25.44,25.44,0,0,1,1.59,7.94,15.33,15.33,0,0,1-.27,3.11,11.25,11.25,0,0,1-.7,2.26,7,7,0,0,1-.37.77,5.52,5.52,0,0,1-.32.54l-.21.33-.08.1.06-.12.19-.33a4.4,4.4,0,0,0,.3-.55,7.41,7.41,0,0,0,.35-.78,11.9,11.9,0,0,0,.66-2.24,16.1,16.1,0,0,0,.23-3.08,25.6,25.6,0,0,0-1.63-7.88,93.29,93.29,0,0,1-3.15-9.41,20.16,20.16,0,0,1-.53-5.13,24.09,24.09,0,0,1,.62-4.76,37,37,0,0,1,2.79-7.61c1-2.08,1.92-3.71,2.56-4.83l.74-1.29.2-.33Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M534.66,302.61l-.09.11-.29.3c-.26.26-.66.62-1.13,1.14a42.31,42.31,0,0,0-3.73,4.55,46.47,46.47,0,0,0-4.31,7.58,54,54,0,0,0-3.36,10.13,75.43,75.43,0,0,0-1.53,19.32c.1,2.49.25,4.5.37,5.89q.09,1,.15,1.59c0,.18,0,.31,0,.42s0,.14,0,.14a1.13,1.13,0,0,1,0-.14l-.06-.41c0-.36-.12-.9-.19-1.59-.15-1.39-.32-3.4-.44-5.89a73.37,73.37,0,0,1,1.47-19.38,53,53,0,0,1,3.39-10.17,44.86,44.86,0,0,1,4.37-7.58,37.81,37.81,0,0,1,3.8-4.52c.48-.51.89-.86,1.15-1.11l.31-.29Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M531.74,303.32l-.11.05-.32.13c-.28.11-.69.29-1.2.54a19.9,19.9,0,0,0-4.07,2.63,26.21,26.21,0,0,0-4.83,5.31,42.32,42.32,0,0,0-4.16,7.76c-1.21,2.89-2.18,5.72-3.08,8.29s-1.65,4.9-2.21,6.88-.91,3.6-1.14,4.73c-.1.56-.19,1-.24,1.3l-.06.34,0,.11s0,0,0-.12l0-.34c0-.3.1-.74.2-1.31.19-1.13.53-2.77,1.07-4.76s1.27-4.32,2.16-6.9,1.85-5.4,3.07-8.3a41.85,41.85,0,0,1,4.19-7.8,26.2,26.2,0,0,1,4.91-5.32,19.51,19.51,0,0,1,4.13-2.58c.53-.23.94-.4,1.23-.5l.32-.11Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M536.64,302.37a6.12,6.12,0,0,1,3.28,5.05,14.85,14.85,0,0,1-1,6.36q-1.05-3.43-2.08-6.89a15.29,15.29,0,0,1-4.73,5.75,12.57,12.57,0,0,1,1.2-8.45,17.94,17.94,0,0,1-7.41.61,7.71,7.71,0,0,1,5.33-3,17,17,0,0,1-4-3.13,10.43,10.43,0,0,1,9.48,3.67",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M500.35,333.6a37.07,37.07,0,0,0,20.73,31.12c5.45,2.58,11.77,3.76,17.57,2.14s10.91-6.41,11.83-12.37a13.29,13.29,0,0,0-11.79-15.27c-3.6-.36-7.19.74-10.8.64a16.43,16.43,0,0,1-12.64-6.63s-4.54-6.05-9-5A8.87,8.87,0,0,0,500.35,333.6Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500.8,337.22a13,13,0,0,1,.21-5l9.57-3.29,3.31,2.53a18.83,18.83,0,0,1-4.86-.09,41.8,41.8,0,0,1,2.91,5.07,6.94,6.94,0,0,1-7-2.25,8.84,8.84,0,0,1-2.26,4,1.37,1.37,0,0,1-.8.46C501.22,338.63,500.89,337.85,500.8,337.22Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M499.82,322.12l1.73-.81a1.58,1.58,0,0,1,1.39-.16,1.49,1.49,0,0,1,.56,1,39.29,39.29,0,0,1,1.18,6.71l-1.1.52a8.34,8.34,0,0,0-3.8-6.45A.46.46,0,0,1,499.82,322.12Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M535.66,342.42c.08-.43.53-.59,1.05-.7h0a8.91,8.91,0,0,1,6.34,1.28.86.86,0,0,1,.4.44.62.62,0,0,1-.27.69,1.64,1.64,0,0,1-.75.26,12.8,12.8,0,0,1-5.6-.76,2.69,2.69,0,0,1-.84-.39A.88.88,0,0,1,535.66,342.42Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M531.4,343a1,1,0,0,0,1.3.59c.61-.13,1-.61.93-1.07a1,1,0,0,0-1.29-.58C531.72,342.06,531.31,342.54,531.4,343Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M523.56,363.16c6.14,1,13.31.43,18.63-2.8,4.12-2.49,7.87-6.67,8-11.36a13.22,13.22,0,0,1,.32,5.49c-.92,6-6,10.75-11.83,12.37s-12.12.44-17.57-2.14a34.61,34.61,0,0,1-7.08-4.49A40.52,40.52,0,0,0,523.56,363.16Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M507.53,329.91l.09.1.24.29.94,1.16c.81,1,2,2.46,3.51,4.18a36.68,36.68,0,0,0,6,5.45,23.43,23.43,0,0,0,4.11,2.39,20.2,20.2,0,0,0,4.88,1.47,94.05,94.05,0,0,0,9.87.75,25.33,25.33,0,0,1,7.94,1.62,14.47,14.47,0,0,1,2.76,1.45,11.59,11.59,0,0,1,1.81,1.51,7.56,7.56,0,0,1,.57.65,4,4,0,0,1,.37.5l.22.32a.41.41,0,0,1,.07.12l-.09-.11-.23-.3a4.35,4.35,0,0,0-.39-.49,8.11,8.11,0,0,0-.59-.62,11.06,11.06,0,0,0-1.81-1.48,15,15,0,0,0-2.75-1.4,25.65,25.65,0,0,0-7.89-1.56,92.25,92.25,0,0,1-9.9-.73,20.64,20.64,0,0,1-4.93-1.5,23.91,23.91,0,0,1-4.15-2.42,37.18,37.18,0,0,1-5.94-5.51c-1.53-1.74-2.67-3.22-3.46-4.24-.39-.5-.69-.89-.9-1.18l-.23-.31C507.55,330,507.52,329.91,507.53,329.91Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M504,330.12s0,.05.07.13l.16.39c.15.33.32.85.62,1.48a41.24,41.24,0,0,0,2.75,5.2,45.12,45.12,0,0,0,5.32,6.9,53.51,53.51,0,0,0,8,7,76,76,0,0,0,17.23,8.9c2.33.87,4.24,1.5,5.57,1.93l1.52.48.4.13.13.06-.14,0-.4-.11c-.35-.1-.88-.24-1.54-.45-1.34-.4-3.26-1-5.6-1.86a73.69,73.69,0,0,1-17.3-8.87,53.37,53.37,0,0,1-8.06-7.06,45.63,45.63,0,0,1-5.3-7,37.69,37.69,0,0,1-2.69-5.25c-.29-.64-.45-1.16-.58-1.5l-.14-.39A.55.55,0,0,1,504,330.12Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M503.55,333.09s0,0,0,.12v.35c0,.3,0,.74,0,1.32a21,21,0,0,0,.85,4.77,26.83,26.83,0,0,0,3,6.51A42.19,42.19,0,0,0,513,353c2.19,2.23,4.43,4.23,6.44,6.05s3.88,3.41,5.49,4.69,3,2.24,3.92,2.88c.48.32.85.57,1.11.73l.28.19.1.07s0,0-.11-.05l-.3-.17c-.26-.15-.64-.38-1.13-.69-1-.62-2.34-1.57-4-2.83s-3.5-2.85-5.53-4.67-4.26-3.8-6.46-6a41.27,41.27,0,0,1-5.57-6.89,26.1,26.1,0,0,1-3-6.58,19.47,19.47,0,0,1-.78-4.81c0-.58,0-1,0-1.33l0-.34A.55.55,0,0,1,503.55,333.09Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M500.35,333.6a37.07,37.07,0,0,0,20.73,31.12c5.45,2.58,11.77,3.76,17.57,2.14s10.91-6.41,11.83-12.37a13.29,13.29,0,0,0-11.79-15.27c-3.6-.36-7.19.74-10.8.64a16.43,16.43,0,0,1-12.64-6.63s-4.54-6.05-9-5A8.87,8.87,0,0,0,500.35,333.6Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M504.58,328.21a6.11,6.11,0,0,1,5.92-1.08,15,15,0,0,1,5.46,3.44l-7.16-.75a15.27,15.27,0,0,1,3.47,6.58,12.57,12.57,0,0,1-7.33-4.38,17.81,17.81,0,0,1-2.3,7.07A7.71,7.71,0,0,1,502,333a17,17,0,0,1-4.44,2.49,10.49,10.49,0,0,1,7.06-7.33",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 347.91,
    y: 312.24,
    width: 173.11,
    height: 7.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M498.92,241.39l1.52-6.5a8.57,8.57,0,0,0-6.33-2.91c-3.77.17-3.77,1.62-3.77,1.62L489,239.23a1.49,1.49,0,0,0,.67,1.63,14.23,14.23,0,0,0,6,2C499.38,243,498.92,241.39,498.92,241.39Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M499.51,235.39c.33,0,.43,1.33.08,2.86s-1.06,2.66-1.38,2.52-.12-1.33.2-2.79S499.17,235.34,499.51,235.39Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M490,240.09c.09-.14.57-.13,1.31.07s1.73.63,2.79,1a14.32,14.32,0,0,0,1.49.45,8.82,8.82,0,0,0,1.24.18c.69,0,1.16-.08,1.29.11s-.35.53-1.16.77a4.58,4.58,0,0,1-1.48.09,8.58,8.58,0,0,1-1.72-.4,14,14,0,0,1-2.74-1.37C490.35,240.57,490,240.27,490,240.09Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M489.32,237.85s6.66,2.61,10,1.58l.3-1.18-9.87-2Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M500,239s5.18-.16,5.53-3.92-1-9.92-10-11.36c-6.66-1.07-9,4.78-9.85,7.89a3.77,3.77,0,0,0,1,3.65C488.41,236.91,492.26,239.19,500,239Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M496.14,228.07a2,2,0,0,0-1.85-3.14,6.81,6.81,0,0,0-2.88,1,6.93,6.93,0,0,0-3.11,3.69,1.48,1.48,0,0,0,1.39,2.16,3.73,3.73,0,0,0,3.41-.66c.47-.44.76-1,1.21-1.49s1.18-.8,1.66-1.32A1.84,1.84,0,0,0,496.14,228.07Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M475.76,228.25l-.62,6.66a8.55,8.55,0,0,0,6.66,2c3.72-.68,3.52-2.12,3.52-2.12l.58-5.75a1.5,1.5,0,0,0-.89-1.52,14.19,14.19,0,0,0-6.27-1.18C475.09,226.74,475.76,228.25,475.76,228.25Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M476,234.29c-.33,0-.6-1.27-.47-2.83s.69-2.78,1-2.68.31,1.3.19,2.79S476.34,234.29,476,234.29Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M484.74,228.34c-.07.14-.55.21-1.31.1s-1.81-.38-2.91-.61a14.27,14.27,0,0,0-1.53-.23,5.9,5.9,0,0,0-1.26,0c-.68.06-1.14.23-1.28.06s.26-.57,1-.92a4.31,4.31,0,0,1,1.46-.29,8.67,8.67,0,0,1,1.76.16,14.15,14.15,0,0,1,2.9,1C484.36,227.9,484.79,228.15,484.74,228.34Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M485.75,230.45s-6.95-1.67-10.09-.2l-.14,1.21,10,.6Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M475.07,230.81s-5.11.87-4.95,4.64,2.37,9.69,11.48,9.89c6.74.15,8.32-6,8.68-9.16a3.77,3.77,0,0,0-1.5-3.47C486.78,231.26,482.66,229.53,475.07,230.81Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M480.33,241.07a2,2,0,0,0,2.26,2.87,7.36,7.36,0,0,0,5.29-5.45,1.48,1.48,0,0,0-1.66-2,3.72,3.72,0,0,0-3.29,1.12c-.41.5-.61,1.13-1,1.64s-1.06.95-1.46,1.53C480.42,240.91,480.37,241,480.33,241.07Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M473.66,246.57l1.52-6.5a8.57,8.57,0,0,0-6.32-2.91c-3.78.17-3.77,1.63-3.77,1.63l-1.36,5.62a1.51,1.51,0,0,0,.67,1.63,14.14,14.14,0,0,0,6.05,2C474.12,248.16,473.66,246.57,473.66,246.57Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M474.26,240.57c.32,0,.42,1.33.08,2.86s-1.07,2.66-1.38,2.52-.13-1.33.19-2.79S473.91,240.52,474.26,240.57Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M464.78,245.27c.09-.14.58-.13,1.31.07s1.74.63,2.8,1c.53.18,1,.33,1.49.44a6.39,6.39,0,0,0,1.24.18c.69,0,1.16-.08,1.28.11s-.34.53-1.15.77a4.62,4.62,0,0,1-1.48.09,8.28,8.28,0,0,1-1.72-.4,14,14,0,0,1-2.74-1.36C465.09,245.75,464.71,245.45,464.78,245.27Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M464.06,243s6.66,2.6,10,1.57l.3-1.18-9.87-2Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M474.69,244.14s5.18-.17,5.54-3.93-1-9.92-10-11.36c-6.65-1.06-9.05,4.78-9.84,7.89a3.77,3.77,0,0,0,1,3.65C463.16,242.09,467,244.37,474.69,244.14Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M470.89,233.26a2,2,0,0,0-1.85-3.15,7.32,7.32,0,0,0-6,4.67,1.88,1.88,0,0,0-.13,1c.14.66.86,1,1.51,1.17a3.74,3.74,0,0,0,3.42-.66c.46-.44.75-1,1.21-1.49s1.17-.8,1.65-1.32Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M500.33,248.72l1.52-6.51a8.56,8.56,0,0,0-6.33-2.9c-3.77.17-3.77,1.62-3.77,1.62l-1.35,5.63a1.49,1.49,0,0,0,.67,1.62,14.24,14.24,0,0,0,6.05,2C500.79,250.31,500.33,248.72,500.33,248.72Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M500.93,242.71c.32,0,.42,1.34.08,2.87s-1.07,2.66-1.39,2.52-.12-1.33.2-2.79S500.58,242.66,500.93,242.71Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M491.45,247.41c.09-.13.57-.13,1.31.08s1.73.63,2.79,1a15,15,0,0,0,1.5.44,6.41,6.41,0,0,0,1.23.18c.69,0,1.17-.07,1.29.12s-.34.52-1.15.77a4.35,4.35,0,0,1-1.48.08,7.9,7.9,0,0,1-1.73-.4,13.46,13.46,0,0,1-2.74-1.36C491.76,247.9,491.37,247.59,491.45,247.41Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M490.73,245.18s6.66,2.61,10,1.57l.31-1.17-9.87-2Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M501.36,246.28s5.18-.16,5.54-3.92-1-9.92-10-11.36c-6.66-1.07-9.05,4.77-9.84,7.89a3.72,3.72,0,0,0,1,3.64C489.83,244.24,493.67,246.52,501.36,246.28Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M497.55,235.4a2,2,0,0,0-1.84-3.15,7.31,7.31,0,0,0-6,4.68,1.67,1.67,0,0,0-.13,1c.14.66.85,1,1.51,1.18a3.75,3.75,0,0,0,3.41-.66c.47-.44.76-1,1.21-1.49s1.18-.8,1.66-1.32A1.84,1.84,0,0,0,497.55,235.4Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M507.8,230.94l-.07,5.71a7.25,7.25,0,0,0,5.81,1.26c3.12-.83,2.85-2,2.85-2l.09-5a1.26,1.26,0,0,0-.86-1.23,12,12,0,0,0-5.41-.57C507.12,229.7,507.8,230.94,507.8,230.94Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M508.41,236.07c-.28,0-.6-1-.6-2.38s.4-2.41.69-2.36.35,1.09.35,2.37S508.7,236,508.41,236.07Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M515.45,230.4c-.05.13-.46.21-1.11.18s-1.56-.21-2.51-.32c-.48-.06-.93-.09-1.33-.1a5.45,5.45,0,0,0-1.07.08c-.58.1-.95.27-1.09.14s.19-.5.82-.86a4,4,0,0,1,1.22-.34,6.93,6.93,0,0,1,1.51,0,12.26,12.26,0,0,1,2.54.63C515.1,230.05,515.48,230.24,515.45,230.4Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M516.46,232.13s-6-.95-8.61.52l0,1,8.6-.18Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M507.39,233.17s-4.3,1.09-3.9,4.29,2.68,8.09,10.46,7.64c5.75-.34,6.67-5.65,6.76-8.4a3.19,3.19,0,0,0-1.52-2.85C517.39,232.75,513.76,231.56,507.39,233.17Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M512.56,241.55a1.74,1.74,0,0,0,2.13,2.29,5.88,5.88,0,0,0,2.22-1.35,6,6,0,0,0,1.92-3.66,1.64,1.64,0,0,0-.08-.85,1.58,1.58,0,0,0-1.48-.69,3.15,3.15,0,0,0-2.72,1.18c-.31.45-.44,1-.74,1.46s-.84.88-1.14,1.4Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M497.18,259.52,498.7,253a8.52,8.52,0,0,0-6.33-2.9c-3.77.16-3.77,1.62-3.77,1.62l-1.35,5.62a1.51,1.51,0,0,0,.67,1.63,14.24,14.24,0,0,0,6.05,2C497.64,261.11,497.18,259.52,497.18,259.52Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M497.78,253.51c.32.05.42,1.33.08,2.86s-1.07,2.66-1.39,2.52-.12-1.33.2-2.78S497.43,253.46,497.78,253.51Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M488.3,258.21c.09-.13.57-.13,1.31.08s1.74.62,2.79,1c.54.18,1,.33,1.5.44a6.39,6.39,0,0,0,1.24.18c.68,0,1.16-.07,1.28.12s-.34.52-1.15.77a4.35,4.35,0,0,1-1.48.08,7.9,7.9,0,0,1-1.73-.4,14.27,14.27,0,0,1-2.74-1.36C488.61,258.7,488.22,258.39,488.3,258.21Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M487.58,256s6.66,2.6,10,1.57l.31-1.18-9.87-2Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M498.21,257.08s5.18-.16,5.54-3.92-1-9.93-10-11.37c-6.66-1.06-9.05,4.78-9.84,7.9a3.73,3.73,0,0,0,1,3.64C486.68,255,490.52,257.32,498.21,257.08Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M494.4,246.2a2,2,0,0,0-1.84-3.15,7,7,0,0,0-2.89,1,6.87,6.87,0,0,0-3.1,3.69,1.7,1.7,0,0,0-.13,1,1.82,1.82,0,0,0,1.51,1.17,3.73,3.73,0,0,0,3.41-.66c.47-.44.76-1,1.21-1.49s1.18-.79,1.66-1.31A1.84,1.84,0,0,0,494.4,246.2Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M484.68,252.92l1.51-6.51a8.56,8.56,0,0,0-6.32-2.9c-3.78.17-3.77,1.62-3.77,1.62l-1.36,5.63a1.49,1.49,0,0,0,.67,1.62,14.29,14.29,0,0,0,6,2C485.14,254.51,484.68,252.92,484.68,252.92Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M485.27,246.91c.32.05.42,1.34.08,2.87s-1.06,2.66-1.38,2.52-.13-1.33.2-2.79S484.92,246.86,485.27,246.91Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M475.79,251.61c.09-.13.58-.13,1.31.08s1.74.63,2.8,1a14.12,14.12,0,0,0,1.49.44,6.51,6.51,0,0,0,1.24.18c.69,0,1.16-.07,1.28.12s-.34.52-1.15.77a4.35,4.35,0,0,1-1.48.08,7.82,7.82,0,0,1-1.72-.4,13.46,13.46,0,0,1-2.74-1.36C476.1,252.1,475.72,251.79,475.79,251.61Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M475.07,249.38s6.66,2.61,10,1.57l.3-1.17-9.87-2Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M485.71,250.48s5.18-.16,5.53-3.92-1-9.92-10-11.36c-6.65-1.07-9,4.77-9.84,7.89a3.75,3.75,0,0,0,1,3.64C474.17,248.44,478,250.72,485.71,250.48Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M481.9,239.6a2,2,0,0,0-1.85-3.15,7.32,7.32,0,0,0-6,4.67,1.9,1.9,0,0,0-.13,1c.14.66.86,1,1.51,1.18a3.77,3.77,0,0,0,3.42-.66c.46-.44.75-1,1.21-1.49s1.18-.8,1.65-1.32A1.92,1.92,0,0,0,481.9,239.6Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M459.06,238.85v28.43h61V238.85Zm40,14.06H480.13a3.69,3.69,0,1,1,0-7.34H499a3.69,3.69,0,1,1,0,7.34Z",
    transform: "translate(-35.87 -47.47)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Boxes"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M609.13,417.86a13.18,13.18,0,0,0-1.34,1.89q-2.53,4.14-5.06,8.29l1.38-1a50.43,50.43,0,0,0,6.77-8C610.85,418.31,609.23,417.76,609.13,417.86Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M603.06,429.72a68.69,68.69,0,0,1,14-7.46l-1.41-2.9A27,27,0,0,0,603,429.69",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M620.82,415c-7.37,3.62-14.78,8.8-19.28,15.67l.3.56c5.09-6.66,12.55-11.17,20.46-13.92Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M615.87,415.2c-5.61,3.24-9.62,8.58-13.48,13.77l15-11.46C616.87,416.74,616.37,416,615.87,415.2Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M588.07,447.44l-2.2,1.11c-.13.06-.27.15-.29.3s.33.33.58.31c.59-.06,1.18-.14,1.76-.25l-.38,1.27a.38.38,0,0,0,0,.33c.1.12.3.06.43,0a5.73,5.73,0,0,0,1.25-.93,1.8,1.8,0,0,1-.17,1,1.37,1.37,0,0,0-.08,1c.13.31.57.48.79.24a.75.75,0,0,0,.13-.25l1.05-2.82Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M607.59,427.17a5.32,5.32,0,0,0-3,6.33,22.35,22.35,0,0,0,2,3.64,9.72,9.72,0,0,1-.21,9.26,10.15,10.15,0,0,1-7.88,4.92,14.52,14.52,0,0,1-5.86-.94,15.58,15.58,0,0,1-5.17-2.85,12.29,12.29,0,0,1-3.68-12,8.51,8.51,0,0,1,4-5.62A11.17,11.17,0,0,1,593,429a19.4,19.4,0,0,0,5.28-.39,5.52,5.52,0,0,0,3.67-2.93.09.09,0,0,1,.18,0l.13,1.95s2.74-3.27,3.12-3-1.14,3.2-1.14,3.2Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M607.59,427.17l-3.39.77h-.06l0-.05c.22-.42.45-.89.68-1.4.11-.26.22-.53.32-.82a3.22,3.22,0,0,0,.14-.44.78.78,0,0,0,0-.45c0-.07-.08-.06-.16,0a1.13,1.13,0,0,0-.21.12l-.39.33c-.26.23-.51.49-.77.75-.51.54-1,1.13-1.55,1.75l-.08.1v-.12c0-.52-.07-1.06-.11-1.61v-.2c0-.07,0-.17,0-.18s-.06,0-.08,0l-.09.2a4.78,4.78,0,0,1-.46.74,6.11,6.11,0,0,1-3.06,2,14.13,14.13,0,0,1-4,.43,24.8,24.8,0,0,0-4.28.19,7.41,7.41,0,0,0-2.13.66,6.33,6.33,0,0,0-1.84,1.35,9.33,9.33,0,0,0-2.22,4.16,12.36,12.36,0,0,0,1.61,9.7A11.39,11.39,0,0,0,587,447a12.12,12.12,0,0,0,1.81,1.47,18,18,0,0,0,4.11,1.95,15.58,15.58,0,0,0,4.31.87,10.09,10.09,0,0,0,9.62-5.92,9.85,9.85,0,0,0,.34-6.65c-.59-2-2-3.4-2.57-5a4.75,4.75,0,0,1-.23-2.3,5.75,5.75,0,0,1,.6-1.85,5.07,5.07,0,0,1,.92-1.25,5.67,5.67,0,0,1,.46-.42,4.23,4.23,0,0,1,.42-.3l.35-.21.26-.11.23-.1-.21.1-.27.13-.35.21-.41.3a6,6,0,0,0-.45.43,5,5,0,0,0-.9,1.25,5.39,5.39,0,0,0-.58,1.83,4.72,4.72,0,0,0,.24,2.26,11.36,11.36,0,0,0,1.27,2.32,11.08,11.08,0,0,1,1.32,2.67,9.73,9.73,0,0,1-5.89,12,10.28,10.28,0,0,1-4.18.7,15.64,15.64,0,0,1-4.34-.87,18.11,18.11,0,0,1-4.15-2,11.29,11.29,0,0,1-1.83-1.48,11.75,11.75,0,0,1-1.5-1.86,12.48,12.48,0,0,1-1.63-9.82,9.56,9.56,0,0,1,2.26-4.22,6.66,6.66,0,0,1,1.88-1.38,7.7,7.7,0,0,1,2.16-.66,25.32,25.32,0,0,1,4.31-.19,13.74,13.74,0,0,0,3.95-.41,5.92,5.92,0,0,0,3-1.94,4.19,4.19,0,0,0,.46-.72l.08-.19a.16.16,0,0,1,.1-.1.15.15,0,0,1,.16,0c0,.05,0,.11,0,.13v.11l0,.21c0,.55.07,1.08.1,1.6l-.09,0c.54-.62,1.06-1.21,1.57-1.75.26-.26.51-.52.77-.76s.27-.23.41-.32a1.64,1.64,0,0,1,.22-.14.34.34,0,0,1,.14,0,.13.13,0,0,1,.12.1.85.85,0,0,1,0,.5,2.25,2.25,0,0,1-.14.44c-.1.29-.22.57-.33.82q-.36.78-.69,1.41l0-.05Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M598.42,441.41a7,7,0,0,1-2.56,2.56,8.51,8.51,0,0,1-4.53,1.3,7,7,0,0,1-5.75-3.53,7.38,7.38,0,0,1-.1-6.78A7.81,7.81,0,0,1,591,430.9a7.5,7.5,0,0,1,1-.12,7.08,7.08,0,0,1,6.42,10.63Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M603.19,430l-.14.18-.42.51-1.56,1.86-5.13,6.12c-2,2.41-3.78,4.6-5,6.21-.63.8-1.13,1.46-1.48,1.92l-.39.52a.94.94,0,0,1-.15.18l.12-.19.38-.55c.33-.46.82-1.13,1.44-1.95,1.24-1.62,3-3.83,5-6.23s3.83-4.55,5.16-6.1l1.6-1.83.44-.49C603.13,430.05,603.18,430,603.19,430Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M603.54,432.37a.72.72,0,0,1,0,.23c0,.16,0,.37,0,.64,0,.56,0,1.37,0,2.37a14.9,14.9,0,0,1-.63,3.46,10.76,10.76,0,0,1-2.06,3.76,12.49,12.49,0,0,1-3.35,2.71,25.89,25.89,0,0,1-3.17,1.51l-2.19.88-.6.24-.21.08.2-.11.59-.26,2.17-.93a27.76,27.76,0,0,0,3.15-1.53,12.93,12.93,0,0,0,3.3-2.68,10.71,10.71,0,0,0,2-3.72,14.14,14.14,0,0,0,.65-3.42c.08-1,.08-1.8.07-2.36,0-.27,0-.48,0-.64Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M606.05,440.92s0,.05,0,.16,0,.26-.12.46a7.45,7.45,0,0,1-.68,1.59,9.09,9.09,0,0,1-1.59,2,12.17,12.17,0,0,1-2.52,1.88,21.82,21.82,0,0,1-5.35,2c-.71.18-1.29.31-1.69.39l-.46.09-.16,0,.16-.05.45-.12,1.67-.43a23.51,23.51,0,0,0,5.31-2,12.57,12.57,0,0,0,2.5-1.85,9.32,9.32,0,0,0,1.59-2,8.21,8.21,0,0,0,.72-1.55C606,441.13,606,440.91,606.05,440.92Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M601.17,429.38l-.2.12-.57.31-.9.49-1.16.69c-.43.26-.88.58-1.38.9s-1,.71-1.52,1.11a30,30,0,0,0-3.19,2.91,22.38,22.38,0,0,0-2.6,3.44,17.65,17.65,0,0,0-1.53,3.16,17.41,17.41,0,0,0-.63,2.29l-.11.64c0,.15,0,.22,0,.22a.73.73,0,0,1,0-.22l.08-.65a15.31,15.31,0,0,1,.59-2.31,17.75,17.75,0,0,1,1.51-3.21,22.43,22.43,0,0,1,2.61-3.46,29.17,29.17,0,0,1,3.21-2.92c.54-.39,1-.77,1.54-1.1s1-.64,1.39-.89l1.18-.68c.36-.19.67-.33.92-.46l.58-.29Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M592.54,431.05l-.16.07-.44.17c-.39.15-1,.35-1.63.65a9.83,9.83,0,0,0-2.23,1.31,5.6,5.6,0,0,0-1.85,2.5,9.18,9.18,0,0,0-.42,3.13c0,1,.11,1.86.14,2.6a13.74,13.74,0,0,1,0,1.76,3.74,3.74,0,0,1,0,.48l0,.16s0-.05,0-.16,0-.27,0-.48c0-.41,0-1,0-1.75s-.14-1.62-.16-2.61a9,9,0,0,1,.41-3.18,5.76,5.76,0,0,1,1.9-2.56,10,10,0,0,1,2.27-1.3c.69-.29,1.26-.47,1.66-.6l.46-.15Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M630.39,420.26a13.77,13.77,0,0,0-1.34,1.89q-2.53,4.16-5.06,8.3l1.38-1a50,50,0,0,0,6.77-8C632.11,420.72,630.49,420.17,630.39,420.26Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M624.32,432.13a68.73,68.73,0,0,1,14-7.47l-1.41-2.89a26.91,26.91,0,0,0-12.63,10.33",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M642.08,417.39c-7.37,3.62-14.78,8.81-19.28,15.67l.3.56c5.09-6.65,12.55-11.16,20.46-13.91Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M637.13,417.61c-5.61,3.23-9.62,8.57-13.48,13.77l15-11.46Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M609.33,449.85l-2.2,1.1c-.13.07-.27.16-.29.3s.33.33.58.31a17.31,17.31,0,0,0,1.76-.24l-.38,1.27a.36.36,0,0,0,0,.32c.1.12.3.06.43,0a5.93,5.93,0,0,0,1.25-.92,1.75,1.75,0,0,1-.17.95,1.4,1.4,0,0,0-.08,1c.13.3.57.48.79.23a.8.8,0,0,0,.13-.24l1.05-2.83Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M628.85,429.58a5.31,5.31,0,0,0-3,6.33,22.77,22.77,0,0,0,2,3.64,9.72,9.72,0,0,1-.21,9.26,10.16,10.16,0,0,1-7.88,4.91,14.34,14.34,0,0,1-5.86-.93,15.76,15.76,0,0,1-5.17-2.85A12.31,12.31,0,0,1,605,438a8.51,8.51,0,0,1,4-5.62,11.3,11.3,0,0,1,5.19-.92,19,19,0,0,0,5.28-.39,5.48,5.48,0,0,0,3.67-2.92.09.09,0,0,1,.18,0l.13,2s2.74-3.27,3.12-3-1.14,3.2-1.14,3.2Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M628.85,429.58l-3.39.77h-.06l0-.06c.22-.41.45-.88.68-1.4.11-.26.22-.53.32-.81a3.36,3.36,0,0,0,.14-.45.78.78,0,0,0,0-.45c0-.07-.08-.05-.16,0l-.21.13a3.66,3.66,0,0,0-.39.32c-.26.24-.51.49-.77.76-.51.54-1,1.12-1.55,1.75l-.08.09v-.12c0-.52-.07-1-.11-1.6v-.21c0-.06,0-.16,0-.17s-.06,0-.08,0l-.09.19a4.35,4.35,0,0,1-.46.74,6.06,6.06,0,0,1-3.06,2,14.13,14.13,0,0,1-4,.42,27,27,0,0,0-4.28.19,8.09,8.09,0,0,0-2.13.66,6.72,6.72,0,0,0-1.84,1.35,9.43,9.43,0,0,0-2.22,4.16,12.37,12.37,0,0,0,1.61,9.71,11.06,11.06,0,0,0,3.29,3.29,17.55,17.55,0,0,0,4.11,1.95,15.58,15.58,0,0,0,4.31.87,10,10,0,0,0,9.62-5.91,9.85,9.85,0,0,0,.34-6.65c-.59-2-2-3.4-2.57-5a4.72,4.72,0,0,1-.23-2.29,5.75,5.75,0,0,1,.6-1.85,5.13,5.13,0,0,1,.92-1.26,5.67,5.67,0,0,1,.46-.42l.42-.3.35-.2a1.85,1.85,0,0,1,.26-.12l.23-.09-.21.1a2.12,2.12,0,0,0-.27.13L628,430l-.41.3a4.32,4.32,0,0,0-.45.42,5.1,5.1,0,0,0-.9,1.26,5.39,5.39,0,0,0-.58,1.83,4.73,4.73,0,0,0,.24,2.26,11.56,11.56,0,0,0,1.27,2.31,11.16,11.16,0,0,1,1.32,2.68,9.93,9.93,0,0,1-.33,6.72,10.14,10.14,0,0,1-9.74,6,15.64,15.64,0,0,1-4.34-.87,17.67,17.67,0,0,1-4.15-2,11.35,11.35,0,0,1-1.83-1.49,11.23,11.23,0,0,1-1.5-1.85,12.49,12.49,0,0,1-1.63-9.82,9.59,9.59,0,0,1,2.26-4.23,6.63,6.63,0,0,1,1.88-1.37,8.06,8.06,0,0,1,2.16-.67,26.36,26.36,0,0,1,4.31-.18,14.09,14.09,0,0,0,3.95-.42,5.84,5.84,0,0,0,3-1.93,4.61,4.61,0,0,0,.46-.72l.08-.19s0-.1.1-.11a.16.16,0,0,1,.16,0s0,.1,0,.13v.1l0,.21c0,.55.07,1.09.1,1.61l-.09,0c.54-.63,1.06-1.21,1.57-1.75.26-.27.51-.53.77-.76a4.23,4.23,0,0,1,.41-.33l.22-.13a.7.7,0,0,1,.14,0,.16.16,0,0,1,.12.1.84.84,0,0,1,0,.5,3,3,0,0,1-.14.45c-.1.29-.22.56-.33.82-.24.52-.47,1-.69,1.4l0,0Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M619.68,443.81a6.91,6.91,0,0,1-2.56,2.56,8.52,8.52,0,0,1-4.53,1.31,7,7,0,0,1-5.75-3.54,7.36,7.36,0,0,1-.1-6.77,7.81,7.81,0,0,1,5.47-4.06,7.53,7.53,0,0,1,1-.13,7.08,7.08,0,0,1,6.42,10.63Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M624.45,432.4l-.14.19q-.16.18-.42.51L622.33,435l-5.13,6.13c-2,2.4-3.78,4.59-5,6.2l-1.48,1.92-.39.53a.94.94,0,0,1-.15.18,2.08,2.08,0,0,1,.12-.2l.38-.54c.33-.47.82-1.14,1.44-1.95,1.24-1.63,3-3.83,5-6.24s3.83-4.55,5.16-6.1l1.6-1.82.44-.49A1.46,1.46,0,0,1,624.45,432.4Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M624.8,434.78a.68.68,0,0,1,0,.22c0,.16,0,.38,0,.64,0,.56,0,1.37,0,2.37a14.9,14.9,0,0,1-.63,3.46,10.89,10.89,0,0,1-2.06,3.77,12.64,12.64,0,0,1-3.35,2.7,27.68,27.68,0,0,1-3.17,1.52l-2.19.88-.6.24a1,1,0,0,1-.21.07l.2-.1.59-.27,2.17-.92a28,28,0,0,0,3.15-1.54,12.52,12.52,0,0,0,3.3-2.68,10.67,10.67,0,0,0,2-3.71,14.14,14.14,0,0,0,.65-3.42c.08-1,.08-1.81.07-2.36,0-.27,0-.49,0-.65Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M627.31,443.32s0,.06,0,.16a4,4,0,0,1-.12.46,7.24,7.24,0,0,1-.68,1.59,9.12,9.12,0,0,1-1.59,2,12.14,12.14,0,0,1-2.52,1.87,21.91,21.91,0,0,1-5.35,2c-.71.17-1.29.3-1.69.38l-.46.1c-.1,0-.16,0-.16,0l.16,0,.45-.12,1.67-.43a23.6,23.6,0,0,0,5.31-2,12.55,12.55,0,0,0,2.5-1.84,9.84,9.84,0,0,0,1.59-2,8,8,0,0,0,.72-1.56C627.25,443.54,627.3,443.32,627.31,443.32Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M622.43,431.79l-.2.11-.57.31-.9.49-1.16.7c-.43.26-.88.57-1.38.89s-1,.72-1.52,1.11a30,30,0,0,0-3.19,2.91,23.39,23.39,0,0,0-2.6,3.44,18,18,0,0,0-1.53,3.17,17.41,17.41,0,0,0-.63,2.29c0,.27-.08.48-.11.64l0,.22a.8.8,0,0,1,0-.23l.08-.64a14.74,14.74,0,0,1,.59-2.31,17.75,17.75,0,0,1,1.51-3.21,22.49,22.49,0,0,1,2.61-3.47,29,29,0,0,1,3.21-2.91c.54-.4,1-.78,1.54-1.11s1-.63,1.39-.88l1.18-.68.92-.47.58-.28A.59.59,0,0,1,622.43,431.79Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M613.8,433.46s0,0-.16.07l-.44.17c-.39.14-1,.35-1.63.65a9.76,9.76,0,0,0-2.23,1.3,5.68,5.68,0,0,0-1.85,2.51,9.12,9.12,0,0,0-.42,3.12c0,1,.11,1.86.14,2.61a13.78,13.78,0,0,1,0,1.76,3.74,3.74,0,0,1-.05.48l0,.16s0-.06,0-.17,0-.27,0-.47c0-.42,0-1,0-1.76s-.14-1.62-.16-2.6a9,9,0,0,1,.41-3.18,5.7,5.7,0,0,1,1.9-2.56,9.63,9.63,0,0,1,2.27-1.3c.69-.29,1.26-.48,1.66-.61l.46-.14Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M578.53,367.87c-.46.08-7.06,2.12-7,7.76s7.73,39.66,11.69,38.86c5.77-1.17,3.29-35.33,2.81-41.21S582.18,367.25,578.53,367.87Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M588.79,351.68a7.52,7.52,0,0,0-9.18,8.95l.08-.05a11.86,11.86,0,0,0,5-1.47l-1.38-.36a7.12,7.12,0,0,0,4.23-3.13l-2,.34A9.43,9.43,0,0,0,588.79,351.68Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M576.35,350.38A2.45,2.45,0,0,1,576,352a12,12,0,0,0-5.4-2.81,7.05,7.05,0,0,0,1,5.83l-2,.08c1.47,2.37,5.12,4.09,7.82,3.41a5.92,5.92,0,0,0-1.11-8.08Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M578.26,368.05a63.48,63.48,0,0,0,1.17-7,12.35,12.35,0,0,1,2.74-6.46l.4.26a15.41,15.41,0,0,0-2.31,6.24,37.25,37.25,0,0,0-.31,6.68",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M575.39,353.18l-1.36.62c2.63,4.37,4.34,9.18,4.05,14.27l1-.16C579.72,362.82,577.76,357.72,575.39,353.18Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M578.65,378c0,.06-1.12.48-2.5,1.06s-2.48,1.11-2.51,1.06a11.67,11.67,0,0,1,2.42-1.26A11.16,11.16,0,0,1,578.65,378Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M582.77,383.53a18.26,18.26,0,0,1-1.87.76A17.25,17.25,0,0,1,579,385a6.51,6.51,0,0,1,1.8-1A6.39,6.39,0,0,1,582.77,383.53Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M581.29,390.91a15.91,15.91,0,0,1-1.87.76,19.2,19.2,0,0,1-1.87.76,6.4,6.4,0,0,1,1.79-1A6.83,6.83,0,0,1,581.29,390.91Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M586.48,400.53a6.46,6.46,0,0,0-.81-.48,2,2,0,0,0-.45-.13,3.08,3.08,0,0,0-.54-.06,5.44,5.44,0,0,0-1.24.11,22.67,22.67,0,0,0-3.09,1,3,3,0,0,1,.83-.5,9.87,9.87,0,0,1,2.21-.76,4.91,4.91,0,0,1,1.3-.1,2.61,2.61,0,0,1,.57.09,2.29,2.29,0,0,1,.83.37,1.18,1.18,0,0,1,.23.2C586.44,400.45,586.49,400.52,586.48,400.53Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M577.52,370.67c-.58-.71-1.75-.36-2.43.25a4.36,4.36,0,0,0-1.54,3.88c.1,6.24,1.38,11.93,2.42,17.73a2.57,2.57,0,0,0,.3,1,.84.84,0,0,0,.91.41c.56-.17.59-.94.51-1.52-.92-6.57-2-13.38-.13-19.75A2.23,2.23,0,0,0,577.52,370.67Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M585.05,372.78a11.53,11.53,0,0,0-2.91,0,11.68,11.68,0,0,0-2.75.92,2.66,2.66,0,0,1,.72-.48,7,7,0,0,1,2-.66,7.06,7.06,0,0,1,2.1,0A2.37,2.37,0,0,1,585.05,372.78Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M587.57,355.62l-2,.34a9.43,9.43,0,0,0,3.19-4.28,7.51,7.51,0,0,0-9.23,8.66c0,.23-.09.47-.13.71-.14.86-.25,1.73-.37,2.6a25,25,0,0,0-1.42-5.5,5.92,5.92,0,0,0,.88-3.95,6,6,0,0,0-2.17-3.82A2.45,2.45,0,0,1,576,352a12,12,0,0,0-5.4-2.81,7.05,7.05,0,0,0,1,5.83l-2,.08a8.26,8.26,0,0,0,6.78,3.55,22.3,22.3,0,0,1,1.66,9.4c-1.57.52-6.6,2.7-6.52,7.63.09,5.63,7.73,39.66,11.69,38.86,5.77-1.17,3.29-35.33,2.81-41.21-.41-5.12-3-5.89-6.11-5.6a36.26,36.26,0,0,1,.31-6.59c0-.2.08-.39.12-.59a12.07,12.07,0,0,0,4.34-1.39l-1.38-.37A7.06,7.06,0,0,0,587.57,355.62Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M605.16,396.86c.46,0,7.36-.42,8.59-5.92s1.73-40.37-2.31-40.51c-5.88-.21-11.44,33.58-12.34,39.42S601.47,396.61,605.16,396.86Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M591.41,410.21a7.52,7.52,0,0,0,11-6.57l-.09,0a11.9,11.9,0,0,0-5.24.25l1.26.68a7,7,0,0,0-4.84,2.06l2,.12A9.36,9.36,0,0,0,591.41,410.21Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M603.19,414.37a2.53,2.53,0,0,1,.71-1.45,12,12,0,0,0,4.59,4,7,7,0,0,0,.35-5.91l2,.38c-.88-2.64-4-5.16-6.81-5.13a5.93,5.93,0,0,0-.81,8.11Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M605.46,396.74a66.07,66.07,0,0,0-2.77,6.54,12.3,12.3,0,0,1-4.17,5.64l-.32-.35a15.36,15.36,0,0,0,3.69-5.52,36.58,36.58,0,0,0,1.86-6.42",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M604.79,411.88l1.46-.29c-1.54-4.86-2.07-9.94-.61-14.82l-1-.09C602.82,401.49,603.54,406.91,604.79,411.88Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M607.41,387c0-.06,1.2-.2,2.68-.45s2.67-.5,2.68-.44a12.08,12.08,0,0,1-2.65.66A11.19,11.19,0,0,1,607.41,387Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M604.69,380.64c0-.06.9-.13,2-.3a18.1,18.1,0,0,1,2-.29,6.82,6.82,0,0,1-2,.5A6.37,6.37,0,0,1,604.69,380.64Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M607.85,373.81a16,16,0,0,1,2-.31,18.45,18.45,0,0,1,2-.29,9.67,9.67,0,0,1-4,.6Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M605.05,363.24a5.23,5.23,0,0,0,.67.66,2,2,0,0,0,.41.23,3.38,3.38,0,0,0,.51.19,5.78,5.78,0,0,0,1.24.18,23.67,23.67,0,0,0,3.24-.3,3,3,0,0,1-.92.29,10,10,0,0,1-2.33.23,5.19,5.19,0,0,1-1.29-.21,2.81,2.81,0,0,1-.53-.22,1.78,1.78,0,0,1-.42-.27,2.06,2.06,0,0,1-.3-.28,1.15,1.15,0,0,1-.17-.26C605.07,363.34,605,363.25,605.05,363.24Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M606.79,394.37c.4.82,1.62.76,2.43.33a4.33,4.33,0,0,0,2.39-3.42c1.36-6.09,1.45-11.92,1.79-17.81a2.51,2.51,0,0,0,0-1.06.86.86,0,0,0-.79-.62c-.58,0-.79.78-.85,1.36-.64,6.61-1.18,13.48-4.49,19.23C606.87,393,606.48,393.73,606.79,394.37Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M600,390.57a12.2,12.2,0,0,0,2.83.66,11.85,11.85,0,0,0,2.89-.25,2.43,2.43,0,0,1-.81.3,6.83,6.83,0,0,1-2.09.17,6.67,6.67,0,0,1-2-.47A2.79,2.79,0,0,1,600,390.57Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M593.51,406.67l2,.12a9.36,9.36,0,0,0-4.1,3.42,7.5,7.5,0,0,0,11-6.27q.17-.33.3-.66c.34-.8.65-1.62,1-2.44a25.13,25.13,0,0,0,.09,5.68,5.88,5.88,0,0,0-.56,7.85,2.53,2.53,0,0,1,.71-1.45,12,12,0,0,0,4.59,4,7,7,0,0,0,.35-5.91l2,.38a8.3,8.3,0,0,0-5.76-5,22.38,22.38,0,0,1,.57-9.52c1.66-.14,7.06-1.09,8.13-5.9,1.22-5.5,1.73-40.37-2.31-40.51-5.88-.21-11.44,33.58-12.34,39.42-.79,5.06,1.58,6.43,4.63,6.86a35.44,35.44,0,0,1-1.84,6.34c-.07.19-.17.36-.25.54a12,12,0,0,0-4.55.34l1.26.68A7,7,0,0,0,593.51,406.67Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M624.91,377.66c-.45.12-6.85,2.73-6.26,8.34s11.19,38.82,15.06,37.68c5.65-1.67.17-35.48-.82-41.3S628.49,376.72,624.91,377.66Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M633.7,360.63a7.53,7.53,0,0,0-8.35,9.73l.07-.06a12,12,0,0,0,4.89-1.91l-1.41-.24a7,7,0,0,0,3.93-3.49l-1.93.52A9.38,9.38,0,0,0,633.7,360.63Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M621.21,360.43A2.52,2.52,0,0,1,621,362a11.93,11.93,0,0,0-5.63-2.33,7,7,0,0,0,1.56,5.71l-2,.26c1.67,2.23,5.46,3.62,8.09,2.71a5.92,5.92,0,0,0-1.81-7.95Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M624.66,377.87a64.5,64.5,0,0,0,.55-7.09,12.31,12.31,0,0,1,2.16-6.67l.42.23a15.34,15.34,0,0,0-1.75,6.41,36.41,36.41,0,0,0,.28,6.68",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M620.49,363.3l-1.3.74c3,4.12,5.13,8.76,5.29,13.86l1-.25C625.65,372.52,623.25,367.61,620.49,363.3Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M625.92,387.75c0,.05-1.07.57-2.4,1.28s-2.37,1.32-2.4,1.27a11.74,11.74,0,0,1,2.3-1.47A11,11,0,0,1,625.92,387.75Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M630.51,392.89c0,.05-.81.41-1.8.92a18.19,18.19,0,0,1-1.8.91,6.46,6.46,0,0,1,1.7-1.11A6.29,6.29,0,0,1,630.51,392.89Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M629.69,400.37a16.75,16.75,0,0,1-1.8.92,19.83,19.83,0,0,1-1.8.92,6.46,6.46,0,0,1,1.7-1.11A6.86,6.86,0,0,1,629.69,400.37Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M635.7,409.49a6.56,6.56,0,0,0-.85-.4,2.08,2.08,0,0,0-.46-.09,3.17,3.17,0,0,0-.54,0,5.81,5.81,0,0,0-1.23.22,22.93,22.93,0,0,0-3,1.32,3.29,3.29,0,0,1,.79-.57,9.72,9.72,0,0,1,2.14-.95,5.06,5.06,0,0,1,1.28-.22,2.6,2.6,0,0,1,.57,0,2.2,2.2,0,0,1,.49.12,1.59,1.59,0,0,1,.37.18.85.85,0,0,1,.25.18C635.65,409.42,635.71,409.48,635.7,409.49Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M624.16,380.54c-.64-.66-1.78-.21-2.41.46a4.36,4.36,0,0,0-1.19,4c.65,6.21,2.42,11.76,4,17.45a2.63,2.63,0,0,0,.38,1,.86.86,0,0,0,1,.33c.54-.22.51-1,.38-1.56-1.5-6.47-3.17-13.15-1.87-19.66C624.51,381.87,624.65,381,624.16,380.54Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M631.84,382a12.2,12.2,0,0,0-2.9.27,12.06,12.06,0,0,0-2.66,1.16,2.69,2.69,0,0,1,.68-.54,6.89,6.89,0,0,1,4-1A2.76,2.76,0,0,1,631.84,382Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M632.83,364.66l-1.93.52a9.38,9.38,0,0,0,2.8-4.55,7.51,7.51,0,0,0-8.42,9.43c0,.24,0,.48-.07.72-.07.87-.1,1.75-.14,2.63a24.73,24.73,0,0,0-1.9-5.35,5.87,5.87,0,0,0-2-7.63A2.52,2.52,0,0,1,621,362a11.93,11.93,0,0,0-5.63-2.33,7,7,0,0,0,1.56,5.71l-2,.26a8.28,8.28,0,0,0,7.06,2.94,22.35,22.35,0,0,1,2.49,9.21c-1.53.67-6.35,3.28-5.83,8.18.59,5.6,11.19,38.82,15.06,37.68,5.65-1.67.17-35.48-.82-41.3-.86-5.05-3.55-5.59-6.58-5a36.32,36.32,0,0,1-.27-6.59c0-.2.05-.4.07-.6a11.78,11.78,0,0,0,4.2-1.76l-1.41-.24A7,7,0,0,0,632.83,364.66Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M644.55,373.36c-.42-.19-7-2.22-10.12,2.49S618.5,413,622.22,414.55c5.43,2.28,22.6-27.35,25.52-32.48S647.92,374.9,644.55,373.36Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M662.15,365.75A7.53,7.53,0,0,0,649.52,368h.1a11.89,11.89,0,0,0,5,1.62l-.94-1.08a7.06,7.06,0,0,0,5.25-.21l-1.82-.82A9.4,9.4,0,0,0,662.15,365.75Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M652.6,357.68a2.47,2.47,0,0,1-1.17,1.11,12,12,0,0,0-2.88-5.37,7.05,7.05,0,0,0-2.42,5.41l-1.71-1.06c-.11,2.78,1.94,6.25,4.55,7.21a5.92,5.92,0,0,0,3.63-7.3Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M644.23,373.36a62.69,62.69,0,0,0,4.91-5.13,12.32,12.32,0,0,1,5.9-3.79l.18.43a15.44,15.44,0,0,0-5.41,3.86,36.31,36.31,0,0,0-4,5.35",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M650.23,359.45l-1.48-.25c-.28,5.09-1.57,10-4.67,14.08l.94.44C648.38,369.85,649.64,364.54,650.23,359.45Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M639,381.81c0,.06-1.19-.24-2.67-.53s-2.67-.47-2.66-.54a12.24,12.24,0,0,1,2.71.33A11.61,11.61,0,0,1,639,381.81Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M639.25,388.69a18.44,18.44,0,0,1-2-.42,15.8,15.8,0,0,1-2-.44,6.76,6.76,0,0,1,2,.22A6.68,6.68,0,0,1,639.25,388.69Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M633.87,394a17.34,17.34,0,0,1-2-.43,19.14,19.14,0,0,1-2-.43,6.4,6.4,0,0,1,2,.22A6.21,6.21,0,0,1,633.87,394Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M632.75,404.83a6.62,6.62,0,0,0-.4-.85,1.64,1.64,0,0,0-.3-.36,2.93,2.93,0,0,0-.41-.36,5.62,5.62,0,0,0-1.09-.6,24.23,24.23,0,0,0-3.14-.88,3.64,3.64,0,0,1,1,.07,9.4,9.4,0,0,1,2.26.61,4.9,4.9,0,0,1,1.13.64,2.69,2.69,0,0,1,.42.4,1.82,1.82,0,0,1,.3.4,1.34,1.34,0,0,1,.17.37.79.79,0,0,1,.08.3A.64.64,0,0,1,632.75,404.83Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M642.15,375.11c-.08-.91-1.25-1.28-2.15-1.17a4.38,4.38,0,0,0-3.46,2.35c-3.42,5.21-5.57,10.63-8,16a2.67,2.67,0,0,0-.33,1,.87.87,0,0,0,.52.86c.56.17,1-.45,1.28-1,2.94-5.95,5.88-12.18,11-16.39C641.59,376.37,642.21,375.82,642.15,375.11Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M647.19,381.09a9.14,9.14,0,0,0-5.21-2.42,2.72,2.72,0,0,1,.87,0,6.94,6.94,0,0,1,2,.58,6.79,6.79,0,0,1,1.75,1.17A2.75,2.75,0,0,1,647.19,381.09Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M593.64,369.08c-.46.08-7.06,2.13-7,7.76s7.74,39.66,11.69,38.86c5.78-1.17,3.3-35.32,2.82-41.21S597.29,368.47,593.64,369.08Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M603.9,352.9a7.52,7.52,0,0,0-9.17,9l.07-.05a12,12,0,0,0,5-1.47l-1.38-.37a7,7,0,0,0,4.22-3.13l-2,.35A9.41,9.41,0,0,0,603.9,352.9Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M591.47,351.6a2.47,2.47,0,0,1-.35,1.57,12.12,12.12,0,0,0-5.4-2.82,7.09,7.09,0,0,0,1,5.84l-2,.08c1.47,2.36,5.12,4.08,7.82,3.4a5.9,5.9,0,0,0-1.11-8.07Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M593.38,369.27a65.7,65.7,0,0,0,1.17-7,12.27,12.27,0,0,1,2.73-6.45l.4.26a15.41,15.41,0,0,0-2.3,6.23,37.3,37.3,0,0,0-.32,6.68",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M590.5,354.39l-1.36.63c2.63,4.36,4.34,9.17,4.06,14.27l1-.17C594.83,364,592.88,358.93,590.5,354.39Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M593.77,379.22c0,.06-1.13.48-2.51,1.07s-2.48,1.11-2.5,1a11.38,11.38,0,0,1,2.42-1.25A12.16,12.16,0,0,1,593.77,379.22Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M597.88,384.75a17,17,0,0,1-1.87.75,19.2,19.2,0,0,1-1.87.76,6.4,6.4,0,0,1,1.79-1A6.26,6.26,0,0,1,597.88,384.75Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M596.41,392.13a18.26,18.26,0,0,1-1.87.76,17.25,17.25,0,0,1-1.88.75,9.88,9.88,0,0,1,3.75-1.51Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M601.6,401.75a5.55,5.55,0,0,0-.81-.48,2.06,2.06,0,0,0-.46-.13,2.83,2.83,0,0,0-.53-.07,5.56,5.56,0,0,0-1.25.12,23.54,23.54,0,0,0-3.09,1,3.58,3.58,0,0,1,.84-.49,9.19,9.19,0,0,1,2.21-.77,5.33,5.33,0,0,1,1.3-.1,3.12,3.12,0,0,1,.56.09,1.7,1.7,0,0,1,.48.17,1.48,1.48,0,0,1,.35.21.66.66,0,0,1,.23.2C601.55,401.66,601.61,401.74,601.6,401.75Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M592.64,371.89c-.58-.71-1.75-.37-2.44.24a4.34,4.34,0,0,0-1.53,3.88c.1,6.24,1.37,11.93,2.41,17.74a3.06,3.06,0,0,0,.3,1,.87.87,0,0,0,.92.41c.55-.17.59-.94.51-1.52-.92-6.58-2-13.38-.13-19.75C592.88,373.24,593.09,372.43,592.64,371.89Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M600.16,374a9.12,9.12,0,0,0-5.65.93,2.28,2.28,0,0,1,.72-.48,6.62,6.62,0,0,1,2-.65,6.74,6.74,0,0,1,2.1,0A2.42,2.42,0,0,1,600.16,374Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M611.6,398.25c.42.19,7,2.21,10.12-2.49s15.93-37.14,12.21-38.71c-5.43-2.28-22.6,27.35-25.52,32.49S608.23,396.7,611.6,398.25Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M594,405.85a7.51,7.51,0,0,0,12.62-2.23h-.09a12.15,12.15,0,0,0-5-1.63l.93,1.09a7,7,0,0,0-5.25.21l1.82.82A9.41,9.41,0,0,0,594,405.85Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M603.55,413.92a2.45,2.45,0,0,1,1.17-1.1,12.07,12.07,0,0,0,2.88,5.37,7.05,7.05,0,0,0,2.42-5.41l1.71,1.06c.12-2.78-1.94-6.26-4.55-7.22a5.93,5.93,0,0,0-3.63,7.3Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M611.92,398.24a64.48,64.48,0,0,0-4.91,5.14,12.25,12.25,0,0,1-5.89,3.79l-.19-.44a15.58,15.58,0,0,0,5.42-3.85,37.33,37.33,0,0,0,4-5.35",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M605.92,412.16l1.48.25c.28-5.1,1.58-10,4.68-14.08l-1-.45C607.77,401.75,606.52,407.07,605.92,412.16Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M617.2,389.79c0-.06,1.2.24,2.67.53s2.67.48,2.67.54a11.17,11.17,0,0,1-2.71-.32A11.29,11.29,0,0,1,617.2,389.79Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M616.9,382.91a17.23,17.23,0,0,1,2,.43,19.93,19.93,0,0,1,2,.43,9.62,9.62,0,0,1-4-.86Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M622.28,377.64a18,18,0,0,1,2,.42,18.84,18.84,0,0,1,2,.44,6.39,6.39,0,0,1-2-.22A6.68,6.68,0,0,1,622.28,377.64Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M623.4,366.77a6.62,6.62,0,0,0,.4.85,3.25,3.25,0,0,0,.3.37,5,5,0,0,0,.41.35,5.44,5.44,0,0,0,1.1.61,24.11,24.11,0,0,0,3.14.87,3.41,3.41,0,0,1-1-.06,9.4,9.4,0,0,1-2.26-.61,5.31,5.31,0,0,1-1.13-.65,4,4,0,0,1-.42-.39,2.09,2.09,0,0,1-.3-.4,2,2,0,0,1-.17-.38,1,1,0,0,1-.08-.3A.64.64,0,0,1,623.4,366.77Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M614,396.49c.08.91,1.25,1.29,2.15,1.17a4.37,4.37,0,0,0,3.46-2.34c3.43-5.22,5.58-10.64,8-16a2.55,2.55,0,0,0,.33-1,.84.84,0,0,0-.52-.85c-.56-.18-1,.44-1.28,1-2.94,6-5.88,12.18-11,16.39C614.57,395.24,613.94,395.79,614,396.49Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M609,390.52a11.82,11.82,0,0,0,2.4,1.62,12.09,12.09,0,0,0,2.8.79,2.13,2.13,0,0,1-.87,0,6.72,6.72,0,0,1-2-.58,7,7,0,0,1-1.74-1.16A2.42,2.42,0,0,1,609,390.52Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M573.93,399.85c.43-.17,6.42-3.63,5.09-9.1s-16.28-37-20-35.33c-5.37,2.41,4.58,35.18,6.34,40.82S570.51,401.26,573.93,399.85Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M567.49,417.9a7.52,7.52,0,0,0,7-10.75l-.06.07a11.85,11.85,0,0,0-4.59,2.54l1.43.05a7,7,0,0,0-3.43,4l1.84-.78A9.43,9.43,0,0,0,567.49,417.9Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M579.91,416.43a2.4,2.4,0,0,1,0-1.61,12.11,12.11,0,0,0,5.89,1.56,7.07,7.07,0,0,0-2.31-5.46l1.94-.53c-1.95-2-5.89-2.85-8.38-1.59a5.92,5.92,0,0,0,2.87,7.63Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M574.15,399.61a67.58,67.58,0,0,0,.4,7.1,12.3,12.3,0,0,1-1.24,6.89l-.45-.16a15.5,15.5,0,0,0,.88-6.59,37.93,37.93,0,0,0-1.17-6.59",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M580.23,413.49c.4-.3.8-.6,1.19-.91-3.53-3.68-6.25-8-7.1-13l-1,.38C573.88,405,576.92,409.59,580.23,413.49Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M571.58,390c0-.05,1-.71,2.2-1.59s2.18-1.63,2.22-1.58a11.78,11.78,0,0,1-2.09,1.76A11.47,11.47,0,0,1,571.58,390Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M566.34,385.51a109549635026997.1,109549635026997.1,0,0,0,3.32-2.3,9.3,9.3,0,0,1-3.32,2.3Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M566.15,378a19.34,19.34,0,0,1,1.66-1.15,19.62,19.62,0,0,1,1.67-1.15,6.65,6.65,0,0,1-1.54,1.33A6.49,6.49,0,0,1,566.15,378Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M559,369.75a8.33,8.33,0,0,0,.89.29,1.81,1.81,0,0,0,.47,0,2.59,2.59,0,0,0,.54-.05,5.68,5.68,0,0,0,1.19-.39,21.31,21.31,0,0,0,2.78-1.7,3.28,3.28,0,0,1-.7.66,9.72,9.72,0,0,1-2,1.24,5.24,5.24,0,0,1-1.25.38,2.25,2.25,0,0,1-.57,0,2.06,2.06,0,0,1-.89-.18,1.13,1.13,0,0,1-.27-.15C559,369.82,559,369.76,559,369.75Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M574.29,396.9c.73.56,1.79,0,2.33-.78a4.36,4.36,0,0,0,.64-4.12c-1.48-6.07-4-11.34-6.27-16.77a3,3,0,0,0-.51-.94.87.87,0,0,0-1-.2c-.5.29-.37,1.05-.16,1.6,2.34,6.21,4.89,12.61,4.48,19.23C573.76,395.63,573.73,396.46,574.29,396.9Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M566.49,396.5a11.73,11.73,0,0,0,2.83-.65,12.23,12.23,0,0,0,2.48-1.5,2.47,2.47,0,0,1-.6.62,6.66,6.66,0,0,1-1.8,1.08,7,7,0,0,1-2,.49A2.37,2.37,0,0,1,566.49,396.5Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M556.15,379.49V424.3h96.19V379.49Zm63,22.17H589.36c-3.57,0-6.47-2.59-6.47-5.79s2.9-5.79,6.47-5.79h29.77c3.57,0,6.47,2.59,6.47,5.79S622.7,401.66,619.13,401.66Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M559.42,424.08v44.81h96.19V424.08Zm63,22.17H592.63c-3.57,0-6.47-2.59-6.47-5.79s2.9-5.78,6.47-5.78H622.4c3.57,0,6.47,2.59,6.47,5.78S626,446.25,622.4,446.25Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M653.57,424.26c0,.14-21.86.26-48.83.26s-48.83-.12-48.83-.26,21.86-.26,48.83-.26S653.57,424.12,653.57,424.26Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M157.29,428.35a8.1,8.1,0,0,0-.9-3.75c-2.75-6-8.92-10-15.41-11.1l-11.38.22a2.93,2.93,0,0,0-.38,5.08,5.62,5.62,0,0,0,6.66,7.38,4.5,4.5,0,0,0,7.46,2.9,6.35,6.35,0,0,0,3.87,3.67A4.28,4.28,0,0,0,152,431a2.68,2.68,0,0,0,3.47.62A4,4,0,0,0,157.29,428.35Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.29,428.35a8.1,8.1,0,0,0-.9-3.75c-2.75-6-8.92-10-15.41-11.1l-11.38.22a2.93,2.93,0,0,0-.38,5.08,5.62,5.62,0,0,0,6.66,7.38,4.5,4.5,0,0,0,7.46,2.9,6.35,6.35,0,0,0,3.87,3.67A4.28,4.28,0,0,0,152,431a2.68,2.68,0,0,0,3.47.62A4,4,0,0,0,157.29,428.35Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M160.23,424.33c0-2.31-1.64-4.55-3.95-4.72a3.82,3.82,0,0,0,1.49-3.71,5.67,5.67,0,0,0-8.54-4.07c.24-2.17-2.43-4.73-4.59-5.07s-4.15,1.1-5.53,2.81a5.55,5.55,0,1,0-6.1,7.87c-.69,2.22.91,4.71,3.08,5.53a8,8,0,0,0,6.68-.91,6.86,6.86,0,0,0,3.21,4.23,4,4,0,0,0,5-.9,4.7,4.7,0,0,0,9.3-1.06Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M134.72,422.17c.21.17.59,4.84-.62,9.22s-2.24,5.43-2.24,5.43l6.91,3.13s1.65-5.42,3.54-7,8.87-6.59,8.87-6.59l-2.65-1.62s-4.52,4.11-5.5,3.41,2.84-5.75,2.84-5.75L143,419.61s-4.16,11.77-5.59,11.3,1.19-10.18,1.19-10.18Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M153.7,415.3a1.82,1.82,0,1,1,.51-2.52A1.82,1.82,0,0,1,153.7,415.3Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M145.87,411.69a.61.61,0,0,1-.85-.17.62.62,0,0,1,.18-.85.61.61,0,0,1,.67,1Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M147.91,411.57a.61.61,0,1,1,.18-.85A.62.62,0,0,1,147.91,411.57Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M145.94,409.69a.39.39,0,1,1,.11-.54A.39.39,0,0,1,145.94,409.69Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M148.91,420.24a.6.6,0,0,1,0,.86.61.61,0,0,1-.86,0,.63.63,0,0,1,0-.87A.62.62,0,0,1,148.91,420.24Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M148.36,418.26a.63.63,0,0,1,0,.87.62.62,0,0,1-.87,0,.6.6,0,0,1,0-.86A.61.61,0,0,1,148.36,418.26Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M146.93,420.58a.39.39,0,1,1-.55,0A.38.38,0,0,1,146.93,420.58Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.06,429.09a4.87,4.87,0,0,0,4.17-4.76c0-2.31-1.64-4.55-3.95-4.72a3.83,3.83,0,0,0,1.49-3.71,5.82,5.82,0,0,0-2-3.59c2.55,4.58-2.46,5.41-2.46,5.41a8.64,8.64,0,0,1,2.35,2.06,2.57,2.57,0,0,1-2.1,4.09,3.06,3.06,0,0,1-2.61-2.4,3.47,3.47,0,0,1-4.52,1.24,5.46,5.46,0,0,1-2.74-4.17,3.86,3.86,0,0,1-6.64-3.87,3.49,3.49,0,0,1-3.86,1.16,5.06,5.06,0,0,1-3-3,9.21,9.21,0,0,1-.49-4.14,5.48,5.48,0,0,0-1.13,3.23,5.71,5.71,0,0,0,4.43,5.48c-.69,2.22.91,4.71,3.08,5.53a8,8,0,0,0,6.68-.91,6.86,6.86,0,0,0,3.21,4.23,4,4,0,0,0,5-.9A4.85,4.85,0,0,0,156.06,429.09Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M130.83,408.56s.08-.09.25-.22a4.15,4.15,0,0,1,.78-.45,5.06,5.06,0,0,1,5.59.91,4.47,4.47,0,0,1,.6.67c.12.18.17.28.16.29s-.29-.37-.86-.86a5.4,5.4,0,0,0-2.59-1.21,5.46,5.46,0,0,0-2.85.33C131.22,408.3,130.85,408.59,130.83,408.56Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M139.05,410.86a.86.86,0,0,1,.12-.27,5,5,0,0,1,.43-.66,6.63,6.63,0,0,1,2-1.71,6.21,6.21,0,0,1,1.33-.56,4.27,4.27,0,0,1,1.17-.14,2.08,2.08,0,0,1,.45,0,2.24,2.24,0,0,1,.34.07.86.86,0,0,1,.27.1s-.41-.08-1.06-.06a5.16,5.16,0,0,0-1.12.18,6.65,6.65,0,0,0-1.28.56,7.53,7.53,0,0,0-1.94,1.62C139.29,410.52,139.08,410.87,139.05,410.86Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M155.48,413.2s-.3-.23-.81-.53a5.2,5.2,0,0,0-4.44-.42c-.56.2-.87.4-.89.37a2.68,2.68,0,0,1,.84-.5,4.86,4.86,0,0,1,2.34-.37,4.94,4.94,0,0,1,2.23.8A2.73,2.73,0,0,1,155.48,413.2Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M131.55,431.69a8.17,8.17,0,0,0-.89-3.74c-2.76-6-8.93-10-15.42-11.1l-11.38.21a3,3,0,0,0-1.67,2.44,3,3,0,0,0,1.3,2.64,5.61,5.61,0,0,0,6.65,7.38,4.51,4.51,0,0,0,7.46,2.91,6.38,6.38,0,0,0,3.88,3.66,4.28,4.28,0,0,0,4.8-1.74,2.68,2.68,0,0,0,3.48.61A4,4,0,0,0,131.55,431.69Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.55,431.69a8.17,8.17,0,0,0-.89-3.74c-2.76-6-8.93-10-15.42-11.1l-11.38.21a3,3,0,0,0-1.67,2.44,3,3,0,0,0,1.3,2.64,5.61,5.61,0,0,0,6.65,7.38,4.51,4.51,0,0,0,7.46,2.91,6.38,6.38,0,0,0,3.88,3.66,4.28,4.28,0,0,0,4.8-1.74,2.68,2.68,0,0,0,3.48.61A4,4,0,0,0,131.55,431.69Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M134.49,427.67c0-2.31-1.64-4.55-4-4.72a3.82,3.82,0,0,0,1.49-3.71,5.68,5.68,0,0,0-8.54-4.06c.24-2.17-2.43-4.74-4.59-5.08s-4.15,1.1-5.52,2.82a5.55,5.55,0,1,0-6.11,7.87c-.69,2.22.91,4.7,3.08,5.52a8,8,0,0,0,6.69-.9,6.8,6.8,0,0,0,3.21,4.23,4,4,0,0,0,4.94-.91,4.7,4.7,0,0,0,9.3-1.06Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M109,425.51c.22.17.6,4.85-.62,9.23s-2.23,5.43-2.23,5.43l6.9,3.12s1.65-5.41,3.54-7,8.87-6.59,8.87-6.59l-2.64-1.61s-4.53,4.1-5.51,3.41,2.84-5.76,2.84-5.76L117.3,423s-4.17,11.77-5.6,11.29,1.19-10.18,1.19-10.18Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M128,418.65a1.83,1.83,0,1,1,.52-2.53A1.83,1.83,0,0,1,128,418.65Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M120.13,415a.6.6,0,0,1-.84-.17.61.61,0,1,1,1-.67A.6.6,0,0,1,120.13,415Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M122.18,414.91a.61.61,0,0,1-.68-1,.62.62,0,0,1,.85.18A.61.61,0,0,1,122.18,414.91Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M120.2,413a.37.37,0,0,1-.53-.11.39.39,0,0,1,.11-.54.38.38,0,0,1,.53.11A.39.39,0,0,1,120.2,413Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M123.17,423.58a.61.61,0,0,1-.86.87.61.61,0,1,1,.86-.87Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M122.62,421.61a.6.6,0,0,1,0,.86.61.61,0,1,1-.87-.86A.6.6,0,0,1,122.62,421.61Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M121.2,423.93a.39.39,0,1,1-.55.55.38.38,0,0,1,0-.55A.39.39,0,0,1,121.2,423.93Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.32,432.44a4.87,4.87,0,0,0,4.17-4.77c0-2.31-1.64-4.55-4-4.72a3.81,3.81,0,0,0,1.49-3.71,5.8,5.8,0,0,0-2-3.58c2.54,4.57-2.47,5.4-2.47,5.4a8.64,8.64,0,0,1,2.35,2.06,2.57,2.57,0,0,1-2.1,4.09,3,3,0,0,1-2.61-2.4,3.48,3.48,0,0,1-4.52,1.25,5.52,5.52,0,0,1-2.74-4.18,3.86,3.86,0,0,1-6.64-3.87,3.47,3.47,0,0,1-3.86,1.16,5,5,0,0,1-3-3,9.18,9.18,0,0,1-.49-4.13,5.47,5.47,0,0,0-1.13,3.22,5.74,5.74,0,0,0,4.43,5.49c-.69,2.22.91,4.7,3.08,5.52a8,8,0,0,0,6.69-.9,6.8,6.8,0,0,0,3.21,4.23,4,4,0,0,0,4.94-.91A4.86,4.86,0,0,0,130.32,432.44Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M105.09,411.9s.08-.09.25-.22a4.79,4.79,0,0,1,.78-.45,5.06,5.06,0,0,1,5.59.91,4,4,0,0,1,.6.68,1.2,1.2,0,0,1,.17.28s-.29-.37-.86-.85a5.24,5.24,0,0,0-5.44-.89C105.48,411.64,105.11,411.94,105.09,411.9Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M113.31,414.2s0-.1.12-.26a4,4,0,0,1,.43-.66,6.64,6.64,0,0,1,2-1.72,5.69,5.69,0,0,1,1.33-.55,4.41,4.41,0,0,1,1.17-.15,2.89,2.89,0,0,1,.45,0,1.39,1.39,0,0,1,.34.06.86.86,0,0,1,.27.1s-.41-.08-1.06-.05a4.62,4.62,0,0,0-1.12.18,6.26,6.26,0,0,0-1.27.55,7.41,7.41,0,0,0-2,1.63C113.55,413.86,113.34,414.22,113.31,414.2Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M129.74,416.55s-.3-.23-.81-.54a5.22,5.22,0,0,0-2.17-.71,5.29,5.29,0,0,0-2.27.29c-.55.21-.87.41-.89.38a2.39,2.39,0,0,1,.84-.51,4.85,4.85,0,0,1,4.57.43A2.65,2.65,0,0,1,129.74,416.55Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M108.33,416a8,8,0,0,0-3.34-1.9c-6.26-2.07-13.4-.31-18.64,3.69l-7.61,8.47A2.93,2.93,0,0,0,82.2,430a5.62,5.62,0,0,0,9.94.16,4.5,4.5,0,0,0,7.21-3.47,6.3,6.3,0,0,0,5.32-.33,4.27,4.27,0,0,0,2-4.7,2.67,2.67,0,0,0,2.82-2.12A4,4,0,0,0,108.33,416Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.33,416a8,8,0,0,0-3.34-1.9c-6.26-2.07-13.4-.31-18.64,3.69l-7.61,8.47A2.93,2.93,0,0,0,82.2,430a5.62,5.62,0,0,0,9.94.16,4.5,4.5,0,0,0,7.21-3.47,6.3,6.3,0,0,0,5.32-.33,4.27,4.27,0,0,0,2-4.7,2.67,2.67,0,0,0,2.82-2.12A4,4,0,0,0,108.33,416Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M107.41,411.06c-1.73-1.55-4.45-1.91-6.15-.34a3.82,3.82,0,0,0-1.7-3.62,5.67,5.67,0,0,0-8.8,3.47c-1.42-1.66-5.12-1.46-6.84-.11s-2,3.78-1.71,6a5.55,5.55,0,1,0,1.58,9.83c1.15,2,4.06,2.55,6.14,1.52a8,8,0,0,0,3.9-5.5,6.86,6.86,0,0,0,5.29.54,4.05,4.05,0,0,0,2.71-4.23,4.7,4.7,0,0,0,5.58-7.52Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M88.41,428.23c.27,0,4,2.87,6.33,6.74s2.44,5.34,2.44,5.34l7-2.91s-2.83-4.9-2.67-7.34,1.24-11,1.24-11l-3,.84s-.09,6.1-1.26,6.35-2.27-6-2.27-6l-4,.14s5.76,11.08,4.44,11.81S90,424.39,90,424.39Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M96.35,409.67a1.83,1.83,0,1,1-1.5-2.1A1.83,1.83,0,0,1,96.35,409.67Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M88.36,412.93a.61.61,0,0,1-.7.5.61.61,0,0,1,.2-1.21A.61.61,0,0,1,88.36,412.93Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M89.67,411.35a.61.61,0,0,1-.7.5.61.61,0,1,1,.7-.5Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M87,411.51a.39.39,0,1,1-.76-.13.39.39,0,1,1,.76.13Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M96.68,416.54a.61.61,0,1,1,0,1.22.61.61,0,0,1,0-1.22Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M94.87,415.59a.61.61,0,0,1,.63.59.6.6,0,0,1-.58.63.61.61,0,1,1,0-1.22Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M95.59,418.22a.39.39,0,1,1,0,.77.38.38,0,0,1-.4-.37A.39.39,0,0,1,95.59,418.22Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108,417.36a4.87,4.87,0,0,0-.63-6.3c-1.73-1.55-4.45-1.91-6.15-.34a3.84,3.84,0,0,0-1.7-3.62,5.79,5.79,0,0,0-4-1c5.08,1.27,2.27,5.49,2.27,5.49a8.83,8.83,0,0,1,3.11-.31,2.57,2.57,0,0,1,1.55,4.33,3,3,0,0,1-3.53.27,3.47,3.47,0,0,1-2.18,4.15,5.44,5.44,0,0,1-4.92-.85,3.86,3.86,0,0,1-7.36,2.21A3.48,3.48,0,0,1,82.71,425a5,5,0,0,1-4.18.14,9.12,9.12,0,0,1-3.36-2.46,5.52,5.52,0,0,0,1.59,3,5.72,5.72,0,0,0,7,.5c1.15,2,4.06,2.55,6.14,1.52a8,8,0,0,0,3.9-5.5,6.86,6.86,0,0,0,5.29.54,4.05,4.05,0,0,0,2.71-4.23A4.87,4.87,0,0,0,108,417.36Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M75.81,421.78a1.19,1.19,0,0,1,0-.33,4.29,4.29,0,0,1,.2-.88,5.18,5.18,0,0,1,1.72-2.41,5,5,0,0,1,2.76-1.05,4.24,4.24,0,0,1,.91,0c.21,0,.32.06.32.08a10.86,10.86,0,0,0-1.21,0,5.26,5.26,0,0,0-4.36,3.37C75.89,421.32,75.85,421.79,75.81,421.78Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M83.1,417.34a1,1,0,0,1-.11-.27,4.14,4.14,0,0,1-.19-.76,6.84,6.84,0,0,1,.08-2.6,6.51,6.51,0,0,1,.5-1.35,4.4,4.4,0,0,1,.69-.95,3.09,3.09,0,0,1,.34-.31,1.85,1.85,0,0,1,.27-.2l.26-.13s-.33.24-.76.73a4.6,4.6,0,0,0-.63.95,6.49,6.49,0,0,0-.47,1.31,7.57,7.57,0,0,0-.14,2.53C83,416.94,83.14,417.33,83.1,417.34Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M96,406.94s-.37.06-.94.22a5.14,5.14,0,0,0-3.34,3c-.23.55-.3.91-.33.91a2.32,2.32,0,0,1,.2-1,4.77,4.77,0,0,1,1.33-2,5,5,0,0,1,2.1-1.09A2.54,2.54,0,0,1,96,406.94Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M92.3,454.82a8,8,0,0,0,3.22,2.11c6.12,2.45,13.35,1.12,18.83-2.55l8.11-8a2.94,2.94,0,0,0-3.23-3.95,5.61,5.61,0,0,0-9.9-.77,4.5,4.5,0,0,0-7.42,3,6.36,6.36,0,0,0-5.33,0,4.28,4.28,0,0,0-2.29,4.57,2.68,2.68,0,0,0-2.94,2A4,4,0,0,0,92.3,454.82Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.3,454.82a8,8,0,0,0,3.22,2.11c6.12,2.45,13.35,1.12,18.83-2.55l8.11-8a2.94,2.94,0,0,0-3.23-3.95,5.61,5.61,0,0,0-9.9-.77,4.5,4.5,0,0,0-7.42,3,6.36,6.36,0,0,0-5.33,0,4.28,4.28,0,0,0-2.29,4.57,2.68,2.68,0,0,0-2.94,2A4,4,0,0,0,92.3,454.82Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M92.92,459.76c1.63,1.65,4.32,2.18,6.12.72a3.81,3.81,0,0,0,1.47,3.72,5.68,5.68,0,0,0,9-2.93c1.31,1.74,5,1.77,6.81.53s2.26-3.66,2.08-5.85a5.55,5.55,0,1,0-1-9.91c-1-2.08-3.89-2.79-6-1.89a8,8,0,0,0-4.22,5.26,6.88,6.88,0,0,0-5.25-.87,4,4,0,0,0-3,4.06,4.7,4.7,0,0,0-6,7.16Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M112.93,443.79c-.27,0-3.77-3.11-5.9-7.12s-2.11-5.48-2.11-5.48l-7.16,2.48s2.52,5.07,2.21,7.49S98.07,452,98.07,452l3-.65s.46-6.09,1.65-6.26,1.9,6.13,1.9,6.13l4,.1s-5.07-11.41-3.71-12.05,6.14,8.21,6.14,8.21Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M103.87,461.83a1.83,1.83,0,1,1,1.37,2.18A1.83,1.83,0,0,1,103.87,461.83Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M112,459.06a.61.61,0,0,1,.73-.45.6.6,0,0,1,.46.73.61.61,0,1,1-1.19-.28Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M110.64,460.56a.61.61,0,1,1,.46.73A.61.61,0,0,1,110.64,460.56Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M113.36,460.57a.39.39,0,0,1,.47-.29.38.38,0,0,1,.29.46.39.39,0,0,1-.47.29A.38.38,0,0,1,113.36,460.57Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M104,455a.61.61,0,1,1,0-1.22.6.6,0,0,1,.6.62A.61.61,0,0,1,104,455Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M105.71,456a.63.63,0,0,1-.6-.63.61.61,0,0,1,.63-.59.6.6,0,0,1,.59.62A.61.61,0,0,1,105.71,456Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M105.15,453.34a.39.39,0,0,1,0-.78.39.39,0,1,1,0,.78Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.67,453.44a4.87,4.87,0,0,0,.25,6.32c1.63,1.65,4.32,2.18,6.12.72a3.82,3.82,0,0,0,1.47,3.72,5.78,5.78,0,0,0,3.93,1.2c-5-1.57-1.92-5.62-1.92-5.62a8.61,8.61,0,0,1-3.13.13,2.57,2.57,0,0,1-1.28-4.42,3,3,0,0,1,3.54-.05,3.47,3.47,0,0,1,2.42-4,5.45,5.45,0,0,1,4.86,1.15,3.86,3.86,0,0,1,7.49-1.76,3.45,3.45,0,0,1,2-3.5,5,5,0,0,1,4.19.11,9.23,9.23,0,0,1,3.2,2.66,5.55,5.55,0,0,0-1.4-3.11,5.73,5.73,0,0,0-7-.94c-1-2.08-3.89-2.79-6-1.89a8,8,0,0,0-4.22,5.26,6.88,6.88,0,0,0-5.25-.87,4,4,0,0,0-3,4.06A4.88,4.88,0,0,0,92.67,453.44Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M125.11,451a.92.92,0,0,1,0,.33,4.17,4.17,0,0,1-.25.87,5.18,5.18,0,0,1-1.86,2.3,5.07,5.07,0,0,1-2.83.88,3.58,3.58,0,0,1-.9-.08c-.21,0-.32-.08-.31-.09s.46.07,1.21,0a5.23,5.23,0,0,0,4.56-3.1C125,451.45,125.07,451,125.11,451Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M117.56,455s0,.09.1.27a5.66,5.66,0,0,1,.14.78,6.6,6.6,0,0,1-.24,2.58,5.91,5.91,0,0,1-.58,1.32,4.49,4.49,0,0,1-.75.91,2.82,2.82,0,0,1-.35.29,1.65,1.65,0,0,1-.29.18c-.17.08-.26.13-.27.11s.35-.22.81-.68a4.92,4.92,0,0,0,.69-.9,7.15,7.15,0,0,0,.55-1.28,7.84,7.84,0,0,0,.29-2.52C117.62,455.39,117.53,455,117.56,455Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M104,464.57s.37,0,1-.16a5.33,5.33,0,0,0,2.07-1,5.17,5.17,0,0,0,1.44-1.77c.26-.53.36-.9.39-.89a2.46,2.46,0,0,1-.26,1,4.9,4.9,0,0,1-1.45,1.87,5,5,0,0,1-2.16,1A2.57,2.57,0,0,1,104,464.57Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M139.35,434.4a8.11,8.11,0,0,0-3.76.82c-6,2.66-10.15,8.76-11.36,15.23l0,11.39a2.93,2.93,0,0,0,5.07.45,5.62,5.62,0,0,0,7.49-6.53,4.5,4.5,0,0,0,3-7.41,6.35,6.35,0,0,0,3.73-3.81,4.27,4.27,0,0,0-1.67-4.83,2.68,2.68,0,0,0,.68-3.47A4,4,0,0,0,139.35,434.4Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.35,434.4a8.11,8.11,0,0,0-3.76.82c-6,2.66-10.15,8.76-11.36,15.23l0,11.39a2.93,2.93,0,0,0,5.07.45,5.62,5.62,0,0,0,7.49-6.53,4.5,4.5,0,0,0,3-7.41,6.35,6.35,0,0,0,3.73-3.81,4.27,4.27,0,0,0-1.67-4.83,2.68,2.68,0,0,0,.68-3.47A4,4,0,0,0,139.35,434.4Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M135.38,431.38c-2.31,0-4.58,1.57-4.79,3.88a3.81,3.81,0,0,0-3.68-1.56,5.68,5.68,0,0,0-4.21,8.48c-2.16-.28-4.78,2.34-5.15,4.49s1,4.17,2.72,5.58a5.55,5.55,0,1,0,7.77,6.24c2.2.72,4.71-.83,5.57-3a8,8,0,0,0-.79-6.7,6.82,6.82,0,0,0,4.28-3.14,4,4,0,0,0-.82-5,4.71,4.71,0,0,0-.9-9.33Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M132.79,456.86c.17-.22,4.86-.52,9.21.77s5.39,2.33,5.39,2.33l3.24-6.86s-5.38-1.74-6.89-3.65-6.45-9-6.45-9l-1.65,2.62s4,4.59,3.31,5.56-5.7-2.94-5.7-2.94l-2.88,2.79s11.7,4.36,11.21,5.79-10.16-1.37-10.16-1.37Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M126.24,437.77a1.82,1.82,0,1,1-2.51-.56A1.82,1.82,0,0,1,126.24,437.77Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M122.5,445.53a.6.6,0,0,1-.19.84.61.61,0,1,1,.19-.84Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M122.41,443.49a.6.6,0,0,1-.18.84.62.62,0,0,1-.85-.19.61.61,0,0,1,.19-.84A.6.6,0,0,1,122.41,443.49Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M120.5,445.42a.39.39,0,0,1-.12.54.38.38,0,0,1-.53-.12.39.39,0,0,1,.11-.54A.4.4,0,0,1,120.5,445.42Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M131.1,442.64a.61.61,0,1,1,0,.86A.6.6,0,0,1,131.1,442.64Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M129.11,443.15a.61.61,0,1,1,.86.87.61.61,0,0,1-.86-.87Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M131.41,444.62a.39.39,0,1,1,.55.55.4.4,0,0,1-.56,0A.39.39,0,0,1,131.41,444.62Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.07,435.63a4.87,4.87,0,0,0-4.69-4.25c-2.31,0-4.58,1.57-4.79,3.88a3.81,3.81,0,0,0-3.68-1.56,5.84,5.84,0,0,0-3.62,2c4.62-2.47,5.36,2.55,5.36,2.55a8.88,8.88,0,0,1,2.1-2.31,2.56,2.56,0,0,1,4.05,2.17,3,3,0,0,1-2.43,2.56,3.48,3.48,0,0,1,1.16,4.54,5.43,5.43,0,0,1-4.22,2.67,3.86,3.86,0,0,1-4,6.58,3.47,3.47,0,0,1,1.09,3.88,5,5,0,0,1-3,2.91,9.18,9.18,0,0,1-4.14.42,5.53,5.53,0,0,0,3.21,1.19,5.75,5.75,0,0,0,5.56-4.34c2.2.72,4.71-.83,5.57-3a8,8,0,0,0-.79-6.7,6.82,6.82,0,0,0,4.28-3.14,4,4,0,0,0-.82-5A4.86,4.86,0,0,0,140.07,435.63Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M119.12,460.52a1.22,1.22,0,0,1-.22-.26,4.89,4.89,0,0,1-.44-.78,5.18,5.18,0,0,1-.34-2.94,5.1,5.1,0,0,1,1.35-2.64,4.89,4.89,0,0,1,.68-.59,1.54,1.54,0,0,1,.29-.16s-.37.29-.87.85a5.38,5.38,0,0,0-1.25,2.57,5.31,5.31,0,0,0,.28,2.85C118.86,460.12,119.15,460.5,119.12,460.52Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M121.55,452.33s-.1,0-.26-.12a4.13,4.13,0,0,1-.65-.44,6.61,6.61,0,0,1-1.68-2,5.26,5.26,0,0,1-.53-1.34,4.23,4.23,0,0,1-.13-1.17,2.89,2.89,0,0,1,0-.45,1.87,1.87,0,0,1,.07-.33c.06-.18.09-.28.11-.28s-.09.41-.08,1.06a5,5,0,0,0,.17,1.12,5.58,5.58,0,0,0,.53,1.29,7.3,7.3,0,0,0,1.59,2C121.22,452.09,121.57,452.3,121.55,452.33Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M124.18,436s-.24.29-.55.8a5.3,5.3,0,0,0-.75,2.16,5.37,5.37,0,0,0,.25,2.27c.2.56.39.88.36.9a2.71,2.71,0,0,1-.49-.85,4.85,4.85,0,0,1-.32-2.35,4.8,4.8,0,0,1,.83-2.21A2.44,2.44,0,0,1,124.18,436Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M76.65,429.69v39.4h84.59v-39.4ZM132,449.19H105.86c-3.15,0-5.69-2.28-5.69-5.09s2.54-5.09,5.69-5.09H132c3.14,0,5.69,2.28,5.69,5.09S135.17,449.19,132,449.19Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M203.41,402.47a9.26,9.26,0,0,0-4.38-.09c-7.38,1.33-13.56,7-16.62,13.81l-3,12.59a3.32,3.32,0,0,0,5.48,1.86,6.39,6.39,0,0,0,10-5.23,5.11,5.11,0,0,0,5.33-7.38,7.22,7.22,0,0,0,5.13-3.22,4.85,4.85,0,0,0-.54-5.78,3.08,3.08,0,0,0,1.67-3.66A4.58,4.58,0,0,0,203.41,402.47Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.41,402.47a9.26,9.26,0,0,0-4.38-.09c-7.38,1.33-13.56,7-16.62,13.81l-3,12.59a3.32,3.32,0,0,0,5.48,1.86,6.39,6.39,0,0,0,10-5.23,5.11,5.11,0,0,0,5.33-7.38,7.22,7.22,0,0,0,5.13-3.22,4.85,4.85,0,0,0-.54-5.78,3.08,3.08,0,0,0,1.67-3.66A4.58,4.58,0,0,0,203.41,402.47Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M199.82,398.08c-2.56-.61-5.48.51-6.32,3a4.35,4.35,0,0,0-3.66-2.7,6.46,6.46,0,0,0-6.91,8.25c-2.32-.88-5.91,1.32-6.9,3.6s0,4.89,1.53,6.89a6.31,6.31,0,1,0,6.92,9c2.24,1.4,5.43.35,7-1.81a9.14,9.14,0,0,0,.91-7.62,7.78,7.78,0,0,0,5.57-2.32,4.6,4.6,0,0,0,.42-5.7,5.35,5.35,0,0,0,1.48-10.55Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M190.16,425.55c.25-.19,5.51.73,10,3.31s5.34,4,5.34,4l5.41-6.71s-5.49-3.36-6.65-5.88-4.73-11.64-4.73-11.64L197,411.09s3.22,6.15,2.18,7-5.52-4.77-5.52-4.77l-3.93,2.32s11.77,7.94,10.85,9.38-10.87-4.21-10.87-4.21Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M188,402.7a2.07,2.07,0,1,1-2.63-1.29A2.07,2.07,0,0,1,188,402.7Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M181.81,410.29a.69.69,0,1,1-.88-.44A.69.69,0,0,1,181.81,410.29Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M182.26,408a.69.69,0,1,1-.88-.43A.69.69,0,0,1,182.26,408Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M179.63,409.64a.44.44,0,0,1-.28.56.44.44,0,1,1-.28-.84A.44.44,0,0,1,179.63,409.64Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M192.09,409.38a.69.69,0,1,1-.24.95A.69.69,0,0,1,192.09,409.38Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M189.76,409.42a.69.69,0,1,1-.24.95A.69.69,0,0,1,189.76,409.42Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M191.9,411.65a.44.44,0,1,1,.46.76.44.44,0,1,1-.46-.76Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.88,404a5.54,5.54,0,0,0-4.06-5.95c-2.56-.61-5.48.51-6.32,3a4.37,4.37,0,0,0-3.66-2.7,6.61,6.61,0,0,0-4.52,1.21c5.76-1.5,5.24,4.26,5.24,4.26a9.64,9.64,0,0,1,2.94-2,2.92,2.92,0,0,1,3.9,3.48,3.45,3.45,0,0,1-3.38,2.18,4,4,0,0,1,.08,5.34,6.23,6.23,0,0,1-5.38,1.82,4.39,4.39,0,0,1-6.15,6.21,4,4,0,0,1,.17,4.58,5.71,5.71,0,0,1-4.1,2.41,10.18,10.18,0,0,1-4.69-.64,6.16,6.16,0,0,0,3.22,2.17,6.52,6.52,0,0,0,7.31-3.32c2.24,1.4,5.43.35,7-1.81a9.14,9.14,0,0,0,.91-7.62,7.78,7.78,0,0,0,5.57-2.32,4.6,4.6,0,0,0,.42-5.7A5.54,5.54,0,0,0,203.88,404Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M174.08,426s-.08-.11-.17-.33a4.71,4.71,0,0,1-.28-1,5.78,5.78,0,0,1,2.59-5.9,4.85,4.85,0,0,1,.92-.46,1.26,1.26,0,0,1,.36-.11s-.49.22-1.18.71a6,6,0,0,0-2.08,2.51,6.17,6.17,0,0,0-.45,3.22C173.9,425.44,174.12,425.94,174.08,426Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M179,417.55s-.1-.06-.26-.2a5.31,5.31,0,0,1-.6-.66,7.63,7.63,0,0,1-1.33-2.64,6.39,6.39,0,0,1-.23-1.62,4.67,4.67,0,0,1,.17-1.33,2.54,2.54,0,0,1,.17-.49,1.63,1.63,0,0,1,.17-.35c.1-.18.17-.28.18-.27s-.2.43-.36,1.15a5.46,5.46,0,0,0-.12,1.28A7.69,7.69,0,0,0,177,414a8.52,8.52,0,0,0,1.24,2.6C178.65,417.2,179,417.53,179,417.55Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M186.22,400.14s-.34.26-.82.74a6,6,0,0,0-1.41,2.18,6.12,6.12,0,0,0-.32,2.58c.07.68.2,1.08.16,1.09a2.87,2.87,0,0,1-.32-1.07,5.49,5.49,0,0,1,1.78-4.9A2.84,2.84,0,0,1,186.22,400.14Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M246.36,426.8a9.22,9.22,0,0,0-4.37-.09c-7.38,1.33-13.56,7-16.62,13.81l-3,12.59a3.34,3.34,0,0,0,5.49,1.86,6.39,6.39,0,0,0,10-5.23,5.11,5.11,0,0,0,5.32-7.38,7.22,7.22,0,0,0,5.14-3.22,4.85,4.85,0,0,0-.55-5.79,3,3,0,0,0,1.67-3.65A4.52,4.52,0,0,0,246.36,426.8Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.36,426.8a9.22,9.22,0,0,0-4.37-.09c-7.38,1.33-13.56,7-16.62,13.81l-3,12.59a3.34,3.34,0,0,0,5.49,1.86,6.39,6.39,0,0,0,10-5.23,5.11,5.11,0,0,0,5.32-7.38,7.22,7.22,0,0,0,5.14-3.22,4.85,4.85,0,0,0-.55-5.79,3,3,0,0,0,1.67-3.65A4.52,4.52,0,0,0,246.36,426.8Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M242.78,422.41c-2.56-.61-5.48.51-6.33,3a4.34,4.34,0,0,0-3.66-2.7,6.46,6.46,0,0,0-6.91,8.25c-2.32-.89-5.91,1.32-6.89,3.6s0,4.88,1.52,6.89a6.31,6.31,0,1,0,6.92,9c2.25,1.39,5.44.35,7-1.81a9.11,9.11,0,0,0,.91-7.62,7.8,7.8,0,0,0,5.58-2.33,4.58,4.58,0,0,0,.41-5.69,5.35,5.35,0,0,0,1.49-10.55Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M233.12,449.88c.25-.19,5.51.72,10,3.31s5.34,4,5.34,4l5.41-6.71s-5.49-3.36-6.65-5.89S242.47,433,242.47,433l-2.53,2.46s3.23,6.15,2.19,7-5.53-4.77-5.53-4.77L232.68,440s11.77,7.95,10.84,9.39-10.87-4.21-10.87-4.21Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M231,427a2.08,2.08,0,1,1-2.64-1.29A2.07,2.07,0,0,1,231,427Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M224.77,434.61a.7.7,0,1,1-1.32.45.7.7,0,0,1,1.32-.45Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M225.22,432.33a.7.7,0,1,1-.88-.43A.7.7,0,0,1,225.22,432.33Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M222.59,434a.44.44,0,1,1-.84.29.44.44,0,0,1,.27-.56A.45.45,0,0,1,222.59,434Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M235,433.71a.7.7,0,1,1-.24,1A.7.7,0,0,1,235,433.71Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M232.71,433.75a.7.7,0,1,1,.72,1.19.7.7,0,0,1-.72-1.19Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M234.86,436a.44.44,0,0,1,.61.15.44.44,0,0,1-.76.46A.44.44,0,0,1,234.86,436Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.84,428.36a5.55,5.55,0,0,0-4.06-5.95c-2.56-.61-5.48.51-6.33,3a4.36,4.36,0,0,0-3.66-2.7,6.59,6.59,0,0,0-4.52,1.21c5.76-1.5,5.25,4.26,5.25,4.26a9.88,9.88,0,0,1,2.93-2,2.93,2.93,0,0,1,3.91,3.49,3.46,3.46,0,0,1-3.38,2.18,4,4,0,0,1,.08,5.33,6.22,6.22,0,0,1-5.38,1.83,4.39,4.39,0,0,1-6.16,6.2,4,4,0,0,1,.18,4.59,5.71,5.71,0,0,1-4.1,2.41,10.45,10.45,0,0,1-4.69-.64,6.22,6.22,0,0,0,3.22,2.17,6.51,6.51,0,0,0,7.3-3.32c2.25,1.39,5.44.35,7-1.81a9.11,9.11,0,0,0,.91-7.62,7.8,7.8,0,0,0,5.58-2.33,4.58,4.58,0,0,0,.41-5.69A5.55,5.55,0,0,0,246.84,428.36Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M217,450.28a1,1,0,0,1-.17-.34,4.62,4.62,0,0,1-.27-1,5.78,5.78,0,0,1,2.59-5.89,5.74,5.74,0,0,1,.92-.47,1.3,1.3,0,0,1,.36-.1s-.49.22-1.19.7a6,6,0,0,0-2.52,5.74C216.86,449.77,217.07,450.27,217,450.28Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M221.91,441.88s-.11-.06-.26-.2a4.86,4.86,0,0,1-.6-.67,7.41,7.41,0,0,1-1.33-2.63,7,7,0,0,1-.24-1.63,5,5,0,0,1,.18-1.32,3.53,3.53,0,0,1,.16-.49,2.3,2.3,0,0,1,.17-.35c.11-.18.18-.28.19-.27s-.2.42-.36,1.15a4.93,4.93,0,0,0-.12,1.28,6.52,6.52,0,0,0,.24,1.57,8.52,8.52,0,0,0,1.24,2.6C221.6,441.53,221.94,441.85,221.91,441.88Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M229.17,424.47s-.33.26-.81.74a5.81,5.81,0,0,0-1.73,4.76c.06.67.19,1.08.16,1.09a2.66,2.66,0,0,1-.32-1.07,5.4,5.4,0,0,1,1.78-4.9A2.87,2.87,0,0,1,229.17,424.47Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M235.62,428.55a9.37,9.37,0,0,0-1-4.26c-3.14-6.81-10.15-11.37-17.54-12.63l-12.94.25a3.44,3.44,0,0,0-1.89,2.77,3.39,3.39,0,0,0,1.47,3,6.38,6.38,0,0,0,7.57,8.39,5.11,5.11,0,0,0,8.48,3.3,7.24,7.24,0,0,0,4.41,4.17,4.86,4.86,0,0,0,5.46-2,3.07,3.07,0,0,0,4,.7A4.54,4.54,0,0,0,235.62,428.55Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.62,428.55a9.37,9.37,0,0,0-1-4.26c-3.14-6.81-10.15-11.37-17.54-12.63l-12.94.25a3.44,3.44,0,0,0-1.89,2.77,3.39,3.39,0,0,0,1.47,3,6.38,6.38,0,0,0,7.57,8.39,5.11,5.11,0,0,0,8.48,3.3,7.24,7.24,0,0,0,4.41,4.17,4.86,4.86,0,0,0,5.46-2,3.07,3.07,0,0,0,4,.7A4.54,4.54,0,0,0,235.62,428.55Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M239,424c-.05-2.63-1.87-5.18-4.49-5.37a4.33,4.33,0,0,0,1.69-4.22,6.45,6.45,0,0,0-9.71-4.62c.27-2.47-2.76-5.39-5.22-5.78s-4.72,1.26-6.28,3.21a6.31,6.31,0,1,0-7,8.95c-.78,2.52,1,5.34,3.51,6.28a9.12,9.12,0,0,0,7.6-1,7.76,7.76,0,0,0,3.65,4.81,4.59,4.59,0,0,0,5.62-1A5.35,5.35,0,0,0,239,424Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M210,421.52c.24.19.68,5.51-.7,10.49s-2.55,6.17-2.55,6.17l7.86,3.56s1.87-6.16,4-7.91,10.09-7.5,10.09-7.5l-3-1.83s-5.15,4.66-6.26,3.87,3.23-6.54,3.23-6.54l-3.23-3.22s-4.73,13.39-6.36,12.85,1.35-11.58,1.35-11.58Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M231.54,413.71a2.07,2.07,0,1,1,.59-2.87A2.07,2.07,0,0,1,231.54,413.71Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M222.64,409.6a.69.69,0,0,1-1-.19.7.7,0,1,1,1.16-.77A.69.69,0,0,1,222.64,409.6Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M225,409.47a.69.69,0,1,1,.2-1A.71.71,0,0,1,225,409.47Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M222.72,407.33a.44.44,0,0,1-.49-.74.45.45,0,0,1,.62.13A.44.44,0,0,1,222.72,407.33Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M226.09,419.32a.69.69,0,0,1,0,1,.69.69,0,0,1-1-1A.69.69,0,0,1,226.09,419.32Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M225.47,417.08a.69.69,0,0,1,0,1,.69.69,0,0,1-1,0,.69.69,0,0,1,1-1Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M223.85,419.72a.44.44,0,0,1-.62.63.44.44,0,1,1,.62-.63Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.23,429.4A5.55,5.55,0,0,0,239,424c-.05-2.63-1.87-5.18-4.49-5.37a4.34,4.34,0,0,0,1.69-4.22,6.59,6.59,0,0,0-2.3-4.08c2.9,5.21-2.8,6.15-2.8,6.15a10,10,0,0,1,2.67,2.34,2.92,2.92,0,0,1-2.39,4.65,3.43,3.43,0,0,1-3-2.72,4,4,0,0,1-5.15,1.41,6.24,6.24,0,0,1-3.11-4.75,4.38,4.38,0,0,1-7.55-4.4,4,4,0,0,1-4.4,1.32,5.73,5.73,0,0,1-3.36-3.37,10.4,10.4,0,0,1-.56-4.7,6.27,6.27,0,0,0-1.29,3.67,6.54,6.54,0,0,0,5,6.24c-.78,2.52,1,5.34,3.51,6.28a9.12,9.12,0,0,0,7.6-1,7.76,7.76,0,0,0,3.65,4.81,4.59,4.59,0,0,0,5.62-1A5.55,5.55,0,0,0,234.23,429.4Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M205.53,406a1.55,1.55,0,0,1,.29-.25,5.16,5.16,0,0,1,.88-.51,5.83,5.83,0,0,1,3.34-.45,5.91,5.91,0,0,1,3,1.48,4.53,4.53,0,0,1,.68.77,1.08,1.08,0,0,1,.19.33s-.33-.42-1-1a6.19,6.19,0,0,0-3-1.37,6.1,6.1,0,0,0-3.23.37C206,405.75,205.56,406.08,205.53,406Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M214.88,408.66a1.17,1.17,0,0,1,.14-.31,5.08,5.08,0,0,1,.49-.75,7.68,7.68,0,0,1,2.22-1.94,6.9,6.9,0,0,1,1.51-.64,5.16,5.16,0,0,1,1.33-.16,2.64,2.64,0,0,1,.51,0,1.27,1.27,0,0,1,.38.08c.21,0,.32.09.31.11s-.46-.09-1.2-.07a5.4,5.4,0,0,0-1.27.21,7.24,7.24,0,0,0-1.46.63,8.34,8.34,0,0,0-2.2,1.85C215.16,408.27,214.92,408.68,214.88,408.66Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M233.56,411.33s-.33-.27-.91-.61a5.88,5.88,0,0,0-2.47-.81,6,6,0,0,0-2.58.33c-.63.23-1,.46-1,.43a2.67,2.67,0,0,1,.95-.58,5.49,5.49,0,0,1,5.19.49A2.6,2.6,0,0,1,233.56,411.33Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M262.24,422.75a9.21,9.21,0,0,0-1-4.25c-3.13-6.81-10.14-11.38-17.53-12.63l-12.94.25a3.33,3.33,0,0,0-.43,5.78,6.39,6.39,0,0,0,7.57,8.39,5.12,5.12,0,0,0,8.49,3.3,7.23,7.23,0,0,0,4.4,4.17,4.85,4.85,0,0,0,5.46-2,3.06,3.06,0,0,0,4,.69A4.55,4.55,0,0,0,262.24,422.75Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.24,422.75a9.21,9.21,0,0,0-1-4.25c-3.13-6.81-10.14-11.38-17.53-12.63l-12.94.25a3.33,3.33,0,0,0-.43,5.78,6.39,6.39,0,0,0,7.57,8.39,5.12,5.12,0,0,0,8.49,3.3,7.23,7.23,0,0,0,4.4,4.17,4.85,4.85,0,0,0,5.46-2,3.06,3.06,0,0,0,4,.69A4.55,4.55,0,0,0,262.24,422.75Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M265.58,418.19c-.05-2.63-1.86-5.18-4.49-5.38a4.33,4.33,0,0,0,1.7-4.22,6.47,6.47,0,0,0-9.72-4.62c.27-2.46-2.76-5.38-5.21-5.77s-4.72,1.26-6.29,3.21a6.31,6.31,0,1,0-6.94,8.94c-.79,2.53,1,5.35,3.5,6.28a9.08,9.08,0,0,0,7.6-1,7.79,7.79,0,0,0,3.65,4.81,4.59,4.59,0,0,0,5.62-1,5.35,5.35,0,0,0,10.58-1.2Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M236.57,415.73c.25.19.68,5.51-.7,10.49s-2.54,6.17-2.54,6.17l7.85,3.56s1.88-6.16,4-7.92,10.08-7.49,10.08-7.49l-3-1.84s-5.15,4.67-6.26,3.88,3.23-6.54,3.23-6.54L246,412.82s-4.74,13.39-6.37,12.85S241,414.09,241,414.09Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M258.15,407.92a2.07,2.07,0,1,1,.59-2.87A2.07,2.07,0,0,1,258.15,407.92Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M249.25,403.81a.69.69,0,1,1,.2-1A.69.69,0,0,1,249.25,403.81Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M251.58,403.67a.7.7,0,1,1-.77-1.16.69.69,0,0,1,1,.2A.68.68,0,0,1,251.58,403.67Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M249.33,401.54a.45.45,0,0,1-.61-.13.44.44,0,1,1,.61.13Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M252.7,413.53a.69.69,0,1,1-1,1,.69.69,0,0,1,0-1A.69.69,0,0,1,252.7,413.53Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M252.09,411.29a.69.69,0,0,1,0,1,.7.7,0,1,1,0-1Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M250.46,413.92a.44.44,0,1,1-.62,0A.43.43,0,0,1,250.46,413.92Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.84,423.6a5.52,5.52,0,0,0,4.74-5.41c-.05-2.63-1.86-5.18-4.49-5.38a4.33,4.33,0,0,0,1.7-4.22,6.58,6.58,0,0,0-2.31-4.07c2.9,5.2-2.8,6.15-2.8,6.15a9.65,9.65,0,0,1,2.67,2.34,2.92,2.92,0,0,1-2.39,4.65,3.46,3.46,0,0,1-3-2.73,4,4,0,0,1-5.14,1.42,6.23,6.23,0,0,1-3.12-4.75,4.39,4.39,0,0,1-7.55-4.4,3.93,3.93,0,0,1-4.39,1.31,5.68,5.68,0,0,1-3.37-3.36,10.53,10.53,0,0,1-.56-4.7,6.25,6.25,0,0,0-1.28,3.66,6.5,6.5,0,0,0,5,6.24c-.79,2.53,1,5.35,3.5,6.28a9.08,9.08,0,0,0,7.6-1,7.79,7.79,0,0,0,3.65,4.81,4.59,4.59,0,0,0,5.62-1A5.54,5.54,0,0,0,260.84,423.6Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M232.15,400.25s.08-.1.28-.25a4.94,4.94,0,0,1,.89-.51,5.8,5.8,0,0,1,6.36,1,5.65,5.65,0,0,1,.68.77c.14.2.2.32.18.33a12.64,12.64,0,0,0-1-1,6,6,0,0,0-6.19-1C232.59,400,232.17,400.29,232.15,400.25Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M241.5,402.86s0-.11.13-.3a5.4,5.4,0,0,1,.49-.75,7.69,7.69,0,0,1,2.22-1.95,7,7,0,0,1,1.51-.63,5.21,5.21,0,0,1,1.33-.16,2.68,2.68,0,0,1,.52,0,1.85,1.85,0,0,1,.38.07,1.43,1.43,0,0,1,.31.11s-.47-.09-1.2-.06a5.48,5.48,0,0,0-1.28.21,7.44,7.44,0,0,0-1.45.62,8.81,8.81,0,0,0-2.21,1.85C241.77,402.48,241.53,402.88,241.5,402.86Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M260.18,405.53s-.34-.26-.92-.6a6,6,0,0,0-2.47-.82,6.14,6.14,0,0,0-2.58.34c-.63.23-1,.46-1,.42a2.84,2.84,0,0,1,1-.57,5.44,5.44,0,0,1,5.2.49A3.2,3.2,0,0,1,260.18,405.53Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M182.5,437.33a9.21,9.21,0,0,0,2.23,3.76c5,5.58,13.05,7.87,20.48,6.88l12.29-4.06a3.43,3.43,0,0,0,1-3.21,3.4,3.4,0,0,0-2.29-2.44,6.39,6.39,0,0,0-9.72-5.77,5.11,5.11,0,0,0-9.08-.65,7.24,7.24,0,0,0-5.44-2.68,4.86,4.86,0,0,0-4.63,3.51,3.05,3.05,0,0,0-4,.5A4.52,4.52,0,0,0,182.5,437.33Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.5,437.33a9.21,9.21,0,0,0,2.23,3.76c5,5.58,13.05,7.87,20.48,6.88l12.29-4.06a3.43,3.43,0,0,0,1-3.21,3.4,3.4,0,0,0-2.29-2.44,6.39,6.39,0,0,0-9.72-5.77,5.11,5.11,0,0,0-9.08-.65,7.24,7.24,0,0,0-5.44-2.68,4.86,4.86,0,0,0-4.63,3.51,3.05,3.05,0,0,0-4,.5A4.52,4.52,0,0,0,182.5,437.33Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M180.65,442.68c.83,2.5,3.32,4.39,5.88,3.8a4.37,4.37,0,0,0-.37,4.54,6.47,6.47,0,0,0,10.65,1.54c.47,2.44,4.23,4.33,6.69,4s4.13-2.6,5.06-4.92a6.31,6.31,0,1,0,4-10.6c0-2.64-2.57-4.81-5.2-5a9.14,9.14,0,0,0-7,3.22,7.77,7.77,0,0,0-4.91-3.51,4.59,4.59,0,0,0-5.07,2.64,5.35,5.35,0,0,0-9.75,4.28Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M209.1,436.45c-.3-.11-2.28-5.06-2.44-10.23s.61-6.65.61-6.65l-8.56-1.07s0,6.43-1.5,8.75-7.42,10.14-7.42,10.14l3.42.86s3.53-6,4.83-5.55-1.15,7.2-1.15,7.2l4,2.12s.57-14.19,2.28-14.15,2.13,11.46,2.13,11.46Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M190.79,450.29a2.07,2.07,0,1,1,.28,2.92A2.06,2.06,0,0,1,190.79,450.29Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M200.5,451.58a.7.7,0,0,1,1.08.89.71.71,0,0,1-1,.09A.7.7,0,0,1,200.5,451.58Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M198.32,452.4a.7.7,0,0,1,1-.09.69.69,0,0,1,.1,1,.7.7,0,1,1-1.08-.88Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M201.1,453.78a.44.44,0,0,1,.62-.06.44.44,0,1,1-.62.06Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M194.33,443.32a.7.7,0,0,1-.3-.94.7.7,0,1,1,.3.94Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M195.59,445.28a.69.69,0,1,1,.93-.3A.68.68,0,0,1,195.59,445.28Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M196.36,442.28a.44.44,0,0,1,.4-.79.44.44,0,0,1-.4.79Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.58,436.1a5.55,5.55,0,0,0-2.93,6.58c.83,2.5,3.32,4.39,5.88,3.8a4.36,4.36,0,0,0-.37,4.54,6.6,6.6,0,0,0,3.41,3.21c-4.31-4.12.86-6.7.86-6.7a9.88,9.88,0,0,1-3.25-1.45,2.92,2.92,0,0,1,.91-5.15,3.47,3.47,0,0,1,3.64,1.73,3.94,3.94,0,0,1,4.49-2.87,6.2,6.2,0,0,1,4.38,3.61,4.38,4.38,0,0,1,8.51,2,4,4,0,0,1,3.81-2.55,5.66,5.66,0,0,1,4.21,2.22,10.44,10.44,0,0,1,1.93,4.32,6.28,6.28,0,0,0,.14-3.88,6.51,6.51,0,0,0-6.66-4.47c0-2.64-2.57-4.81-5.2-5a9.14,9.14,0,0,0-7,3.22,7.77,7.77,0,0,0-4.91-3.51,4.59,4.59,0,0,0-5.07,2.64A5.54,5.54,0,0,0,183.58,436.1Z",
    transform: "translate(-35.87 -47.47)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M217.9,449.93a1.7,1.7,0,0,1-.2.32,4.87,4.87,0,0,1-.7.75,5.78,5.78,0,0,1-6.38.9,5.45,5.45,0,0,1-.87-.54c-.19-.15-.29-.24-.28-.25s.44.3,1.22.64a6,6,0,0,0,6.21-.87C217.56,450.34,217.86,449.9,217.9,449.93Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M208.19,450.2s0,.12,0,.32a5.69,5.69,0,0,1-.24.87,7.51,7.51,0,0,1-1.55,2.51A6.33,6.33,0,0,1,205.1,455a4.45,4.45,0,0,1-1.22.55,2.76,2.76,0,0,1-.5.12,2,2,0,0,1-.38,0c-.22,0-.33,0-.33,0s.46-.05,1.16-.29a5,5,0,0,0,1.16-.58,6.93,6.93,0,0,0,1.2-1,8.84,8.84,0,0,0,1.57-2.42C208.05,450.64,208.15,450.19,208.19,450.2Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M189.56,453.17s.4.15,1.05.31a6,6,0,0,0,2.6,0,5.88,5.88,0,0,0,2.37-1.08c.53-.41.81-.73.84-.7a2.77,2.77,0,0,1-.74.83,5.5,5.5,0,0,1-5.11,1.07A3,3,0,0,1,189.56,453.17Z",
    transform: "translate(-35.87 -47.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M170.53,424.29v44.8h96.2v-44.8Zm63,22.16H203.75c-3.58,0-6.47-2.59-6.47-5.78s2.89-5.79,6.47-5.79h29.76c3.58,0,6.47,2.59,6.47,5.79S237.09,446.45,233.51,446.45Z",
    transform: "translate(-35.87 -47.47)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCity);
export default __webpack_public_path__ + "static/media/city.7cbda5fc7b9952235ed1165e570b5841.svg";
export { ForwardRef as ReactComponent };